<template>
  <div
    class="px-2"
    :class="{
      'trash-view-page': isTrashView,
      'archive-view-page': isArchiveView,
    }"
  >
    <div v-if="selectedModel">
      <!-- Teléfono: barra propia (components/mobile). El encabezado de escritorio de abajo
           no se toca: con useMobileList solo deja de renderizarse. -->
      <!-- Teléfono: arrastrar hacia abajo recarga el listado (mismo refresh que el botón). -->
      <MobilePullToRefresh
        v-if="useMobileList"
        :refreshing="isLoading || isFetchingItems"
        @refresh="refreshList"
      />
      <MobileAppBar
        v-if="useMobileList && selectedModelData"
        :title="listPageTitle"
        :subtitle="mobileListSubtitle"
      >
        <template #actions>
          <MobileIconButton
            v-if="modelFields.length > 0 && showListSearchAndFilters"
            icon="search"
            :label="$t('KeywordSearch')"
            :active="mobileSearchOpen || !!listKeywordSearch"
            @click="toggleMobileSearch"
          />
          <MobileIconButton
            v-if="modelFields.length > 0 && showListSearchAndFilters"
            icon="sliders-h"
            :label="$t('Filters')"
            :active="listMoreFiltersOpen || hasAppliedFilters"
            @click="toggleListMoreFilters"
          />
          <MobileIconButton
            icon="ellipsis-v"
            :label="$t('mobile.actions')"
            @click="mobileActionsOpen = true"
          />
        </template>
        <div
          v-if="(mobileSearchOpen || listKeywordSearch) && showListSearchAndFilters"
          class="m-list-search"
        >
          <i class="fas fa-search" aria-hidden="true"></i>
          <input
            ref="mobileSearchInput"
            v-model="listKeywordSearch"
            type="search"
            :placeholder="$t('KeywordSearch')"
            @input="onListKeywordSearchInput"
            @keyup.enter="applyListKeywordSearch"
          />
          <button
            v-if="listKeywordSearch"
            type="button"
            :aria-label="$t('Clear')"
            @click="clearListKeywordSearch"
          >
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <MobileChips
          v-if="showReportTabsBar && mobileReportChips.length > 1"
          :items="mobileReportChips"
          @select="onMobileReportChip"
        />
      </MobileAppBar>
      <div
        v-if="!useMobileList"
        class="clearfix model-list-header gt-model-list-header"
      >
        <div
          v-if="selectedModelData"
          class="d-flex flex-wrap align-items-center w-100 gt-model-title-toolbar-row"
        >
          <div
            class="d-flex flex-wrap align-items-center flex-grow-1 min-w-0 gt-model-title-group"
          >
            <h4 v-if="!minimal" class="flex-shrink-0">
              {{ listPageTitle }}
            </h4>
            <span
              v-if="currentLoadedReport && !isAlternateListView && !minimal"
              class="text-muted flex-shrink-0"
              style="font-weight: normal"
            >
              - {{ currentLoadedReport.name }}
            </span>
            <span
              v-if="isMyItemsFilterActive"
              class="gt-my-items-badge flex-shrink-0 ms-1"
            >
              <i class="fas fa-filter me-1"></i>{{ $t("listTitleMyItems") }}
            </span>
            <div
              v-if="modelFields.length > 0 && showListSearchAndFilters"
              class="gt-model-keyword-search flex-shrink-0 ms-md-2"
            >
              <div class="input-group">
                <span class="input-group-text py-1 px-2"
                  ><i class="fas fa-search text-muted"></i
                ></span>
                <input
                  type="text"
                  class="form-control py-1"
                  v-model="listKeywordSearch"
                  :placeholder="$t('KeywordSearch')"
                  @input="onListKeywordSearchInput"
                  @keyup.enter="applyListKeywordSearch"
                />
                <button
                  v-if="listKeywordSearch"
                  class="btn btn-outline-secondary py-1 px-2"
                  type="button"
                  @click="clearListKeywordSearch"
                  :title="$t('Clear')"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <button
              v-if="modelFields.length > 0 && showListSearchAndFilters"
              type="button"
              class="btn btn-sm btn-outline-primary flex-shrink-0 ms-md-1 gt-model-more-filters-btn"
              @click="toggleListMoreFilters"
            >
              <i class="fas fa-sliders-h me-1"></i>{{ $t("MoreFilters") }}
              <i
                class="fas ms-1"
                :class="
                  listMoreFiltersOpen ? 'fa-chevron-up' : 'fa-chevron-down'
                "
              ></i>
            </button>
            <MyItemsButton
              v-if="canUseMyItemsFilter && modelFields.length > 0 && showListSearchAndFilters"
              class="flex-shrink-0 ms-md-1"
              :active="isMyItemsFilterActive"
              @toggle="toggleMyItemsFilter"
            />
            <button
              class="btn btn-sm btn-primary newbutton flex-shrink-0 ms-md-1"
              data-focus-id="add"
              @click="goToAdd"
              v-if="
                selectedModelData.name !== 'shipping' &&
                canEditModel &&
                !isAlternateListView &&
                !minimal
              "
            >
              <i class="fas fa-plus"></i> {{ $t("Add new") }}
            </button>
          </div>

          <div
            class="gt-model-actions-toolbar ms-auto d-flex flex-wrap align-items-center justify-content-end"
            :class="selectedModel.toLowerCase()"
          >
          <button
            class="btn btn-sm text-primary mx-1 btn-outline-primary gt-more-actions-toggle"
            data-focus-id="more-actions"
            @click="morebuttons = true"
            v-if="!morebuttons && !isAlternateListView && !minimal"
          >
            <i class="fas fa-plus"></i> {{ $t("More actions") }}
          </button>
          <button
            class="btn btn-sm bg-white text-primary mx-1 gt-more-actions-toggle"
            @click="morebuttons = false"
            v-if="morebuttons && !isAlternateListView && !minimal"
          >
            <i class="fas fa-minus"></i> {{ $t("Hide actions") }}
          </button>
          <button
            class="btn btn-sm btn-outline-info mx-1"
            @click="showReportsListModal = true"
            v-if="selectedModel && morebuttons && !isAlternateListView"
          >
            <i class="fas fa-list"></i> {{ $t("Reports") }}
          </button>
          <button
            class="btn btn-sm btn-outline-success mx-1"
            @click="exportToExcel"
            v-if="
              selectedModel &&
              items.length > 0 &&
              (morebuttons || minimal) &&
              !isAlternateListView
            "
            :disabled="isExporting"
          >
            <i class="fas fa-file-excel" v-if="!isExporting"></i>
            <i class="fas fa-spinner fa-spin" v-else></i>
            {{ $t("Export to Excel") || "Export to Excel" }} ({{
              itemsToExportCount
            }})
          </button>
          <button
            class="btn btn-sm btn-outline-primary mx-1"
            @click="sendExportByEmail"
            v-if="
              smartEmailEnabled &&
              selectedModel &&
              !isGroupModel() &&
              items.length > 0 &&
              morebuttons &&
              !isAlternateListView
            "
            :disabled="isExporting"
          >
            <i class="fas fa-envelope" v-if="!isExporting"></i>
            <i class="fas fa-spinner fa-spin" v-else></i>
            {{ $t("Send by email") || "Send by email" }}
          </button>
          <button
            :class="[
              'btn btn-sm mx-1',
              hasUnsavedPreferences ? 'btn-warning' : 'btn-outline-secondary',
            ]"
            @click="saveAllPreferences"
            v-if="hasUnsavedPreferences && !minimal"
            :disabled="isSavingPreferences"
            :title="
              currentLoadedReport
                ? $t('updateReportTooltip')
                : $t('savePreferencesTooltip')
            "
          >
            <i class="fas fa-save" v-if="!isSavingPreferences"></i>
            <i class="fas fa-spinner fa-spin" v-else></i>
            {{
              currentLoadedReport ? $t("updateReport") : $t("savePreferences")
            }}
          </button>

          <CustomLinks
            :model-name="selectedModelData.modelName"
            section="list_content"
          />
          <template v-if="morebuttons && !isAlternateListView">
            <button
              v-for="view in reportViews"
              :key="view._id"
              class="btn btn-sm btn-outline-primary mx-1"
              @click="goToReport(view._id, view.type)"
            >
              <i class="fas fa-file-alt me-1"></i>{{ view.name }}
            </button>
          </template>

          <button
            class="btn btn-sm btn-outline-success mx-1"
            @click="showSaveReportModal = true"
            v-if="
              selectedModel &&
              (hasUnsavedPreferences || hasAppliedFilters) &&
              !isAlternateListView
            "
          >
            <i class="fas fa-save"></i> {{ $t("SaveAsReport") }}
          </button>

          <button
            class="btn btn-sm mx-1 btn-outline-warning"
            @click="goToTrashView"
            v-if="
              selectedModel &&
              morebuttons &&
              !isAlternateListView
            "
            :title="$t('View recycle bin')"
          >
            <i class="fas fa-trash-alt me-1"></i>
            {{ $t("Trash") }}
          </button>
          <button
            class="btn btn-sm mx-1 btn-outline-secondary"
            @click="goToArchiveView"
            v-if="
              selectedModel &&
              morebuttons &&
              !isAlternateListView &&
              canUseArchive
            "
            :title="$t('View archived')"
          >
            <i class="fas fa-archive me-1"></i>
            {{ $t("Archive") }}
          </button>
          <button
            class="btn btn-sm mx-1 btn-outline-danger"
            @click="confirmDeleteAllRecords"
            v-if="morebuttons && canDeleteAllRecords"
            :disabled="isLoading || isFetchingItems"
            :title="$t('Permanently delete the full collection')"
          >
            <i class="fas fa-trash me-1"></i>
            {{ $t("Delete all") }}
            ({{ pagination.total || items.length || 0 }})
          </button>
          <div class="gt-model-fixed-actions">
            <button
              v-if="!isAlternateListView"
              class="btn btn-sm btn-outline-primary mx-1"
              data-focus-id="columns"
              @click="showColumnSelector = !showColumnSelector"
            >
              <i class="fas fa-columns"></i>
            </button>
            <button
              v-if="currentLoadedReport && !isAlternateListView"
              class="btn btn-sm btn-outline-primary mx-1"
              :title="$t('reportColumnLayoutTitle')"
              @click="showColumnLayoutEditor = true"
            >
              <i class="fas fa-object-group"></i>
            </button>
            <button
              v-if="showListSearchAndFilters"
              class="btn btn-sm btn-outline-primary mx-1"
              data-focus-id="filter"
              @click="handleFilterButtonClick"
              :disabled="isLoadingFilterPreferences"
            >
              <i class="fas fa-filter" v-if="!isLoadingFilterPreferences"></i>
              <i class="fas fa-spinner fa-spin" v-else></i>
            </button>
            <button
              class="btn btn-sm btn-outline-primary mx-1"
              data-focus-id="refresh"
              @click="refreshList"
              :disabled="isLoading || isFetchingItems"
              :title="$t('Refresh list')"
            >
              <i
                class="fas fa-sync-alt"
                :class="{ 'fa-spin': isLoading || isFetchingItems }"
              ></i>
            </button>
          </div>
          </div>
        </div>

        <div
          v-if="selectedModelData && selectedModelData.description && !minimal"
          class="text-muted small gt-model-description w-100"
        >
          {{ selectedModelData.description }}
        </div>
      </div>

      <div
        v-if="selectedItems.length > 0"
        class="d-flex flex-wrap align-items-center gt-model-actions-toolbar"
      >
        <template v-if="canEditModel || isTrashView || isArchiveView">
        <button
          v-if="!isGroupModel() && false"
          class="btn btn-sm btn-warning mx-1"
          @click="selectAllItems"
        >
          <i class="fas fa-check-square"></i> {{ $t("SelectAll") }}
        </button>
        <button
          class="btn btn-sm btn-info mx-1"
          @click="showBulkEdit = true"
          v-if="selectedItems.length > 0 && canEditModel && !isAlternateListView"
        >
          <i class="fas fa-edit"></i> {{ $t("BulkEdit") }} ({{
            selectedItems.length
          }})
        </button>
        <button
          class="btn btn-sm btn-secondary mx-1"
          @click="archiveSelected"
          v-if="selectedItems.length > 0 && canEditModel && canUseArchive && !isAlternateListView"
        >
          <i class="fas fa-archive"></i> {{ $t("ArchiveSelected") }} ({{
            selectedItems.length
          }})
        </button>
        <button
          class="btn btn-sm btn-success mx-1"
          @click="confirmRestoreAll"
          v-if="selectedItems.length > 0 && isTrashView"
        >
          <i class="fas fa-undo"></i> {{ $t("RestoreSelected") }} ({{
            selectedItems.length
          }})
        </button>
        <button
          class="btn btn-sm btn-success mx-1"
          @click="unarchiveSelected"
          v-if="selectedItems.length > 0 && isArchiveView"
        >
          <i class="fas fa-box-open"></i> {{ $t("UnarchiveSelected") }} ({{
            selectedItems.length
          }})
        </button>
        <button
          class="btn btn-sm btn-danger mx-1"
          @click="confirmDeleteAll"
          v-if="selectedItems.length > 0 && canEditModel && !isArchiveView"
        >
          <i class="fas fa-trash"></i>
          {{
            isTrashView
              ? $t("Permanently delete selected")
              : $t("DeleteSelected")
          }}
          ({{ selectedItems.length }})
        </button>
        </template>
        <button
          class="btn btn-sm mx-1"
          :class="isHiddenRowsView ? 'btn-secondary' : 'btn-outline-secondary'"
          @click="hideOrShowSelected"
          v-if="canUseReportRowHide && selectedItems.length > 0"
          :disabled="rowHideBusy"
        >
          <i
            class="fas me-1"
            :class="isHiddenRowsView ? 'fa-eye' : 'fa-eye-slash'"
          ></i>
          {{
            isHiddenRowsView ? $t("ShowSelected") : $t("HideSelected")
          }}
          ({{ selectedItems.length }})
        </button>
        <DynamicListSelectionToolbarExtensions
          v-if="!isAlternateListView"
          :selected-item-ids="selectedItems"
          :model-name="listToolbarModelName"
          :items="items"
          :is-trash-view="isTrashView"
          :is-archive-view="isArchiveView"
        />
      </div>
      <!-- Notificación de columna removida con undo -->
      <div
        v-if="showUndoNotification"
        class="alert alert-secondary alert-dismissible fade show mb-2 p-0 px-2 py-1"
        role="alert"
        style="position: relative; z-index: 1000"
      >
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <button
              type="button"
              class="btn btn-sm btn-primary me-2"
              @click="undoColumn"
            >
              <i class="fas fa-undo me-1"></i>{{ $t("Undo") }}
            </button>
            <i class="fas fa-columns me-2"></i>
            <span
              >{{ $t("ColumnRemoved") }} "{{
                lastRemovedColumn?.fieldLabel
              }}"</span
            >
          </div>
          <button
            type="button"
            class="btn-close"
            @click="dismissUndoNotification"
            aria-label="Close"
          ></button>

          <div></div>
        </div>
      </div>

      <div
        class="gt-list-hscroll-wrap mb-0 float-left mt-2 w-100"
        :class="{ 'm-no-float': useMobileList }"
      >
        <div
          ref="listTopHScroll"
          class="gt-list-top-hscroll"
          :class="{
            'gt-list-top-hscroll--no-overflow': !listHasHorizontalOverflow,
          }"
          @scroll.passive="onListTopHScroll"
        >
          <div
            ref="listTopHScrollSpacer"
            class="gt-list-top-hscroll-spacer"
            aria-hidden="true"
          ></div>
        </div>
        <!-- Barra de reportes accesibles al usuario: tabs para cargar cada reporte -->
        <div
          v-if="showReportTabsBar && !minimal && !useMobileList"
          class="gt-report-tabs-bar w-100"
          :style="reportTabsAccentStyle"
        >
          <div class="gt-report-tabs-title">
            <i class="fas fa-folder-open me-1"></i>{{ $t("Reports") }}
          </div>
          <div ref="reportTabsScroll" class="gt-report-tabs">
            <div class="gt-report-tabs-inner" role="tablist">
              <div
                class="gt-report-tab"
                :class="{ 'gt-report-tab--active': !activeReportTabId }"
                role="presentation"
              >
                <button
                  type="button"
                  role="tab"
                  class="gt-report-tab-btn"
                  :aria-selected="!activeReportTabId"
                  @click="clearReportTab"
                >
                  <i class="fas fa-list-ul me-1"></i>{{ $t("All") }}
                </button>
              </div>
              <div
                v-for="report in orderedReportTabs"
                :key="report._id"
                class="gt-report-tab"
                :class="{ 'gt-report-tab--active': isActiveReportTab(report) }"
                role="presentation"
              >
                <button
                  type="button"
                  role="tab"
                  class="gt-report-tab-btn"
                  :aria-selected="isActiveReportTab(report)"
                  :title="report.description || report.name"
                  @click="selectReportTab(report)"
                >
                  <i
                    class="me-1"
                    :class="'fas fa-' + (report.icon || 'file-alt')"
                  ></i>
                  {{ report.name }}
                  <i
                    v-if="!report.isPublic"
                    class="fas fa-lock gt-report-tab-private"
                    :title="$t('Private')"
                  ></i>
                </button>
                <button
                  v-if="canEditReportTab(report)"
                  type="button"
                  class="gt-report-tab-edit"
                  :title="$t('EditReport')"
                  :aria-label="$t('EditReport')"
                  @click.stop="editReportTab(report)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showListSearchAndFilters"
          class="model-list-filters w-100 mt-1"
          :class="{ 'm-filters-screen': useMobileList && listMoreFiltersOpen }"
        >
          <!-- Teléfono: los mismos filtros, en pantalla completa con cerrar y «Ver resultados». -->
          <div
            v-if="useMobileList && listMoreFiltersOpen"
            class="m-filters-screen__head"
          >
            <button
              type="button"
              class="m-filters-screen__close"
              :aria-label="$t('Close')"
              @click="listMoreFiltersOpen = false"
            >
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
            <h2>{{ $t("Filters") }}</h2>
          </div>
          <Filters
            ref="filtersComponent"
            v-if="modelFields.length > 0"
            :modelFields="modelFields"
            :referenceOptions="referenceItems"
            :modelName="selectedModel"
            :selectedFilterFields.sync="selectedFilterFields"
            :isReportMode="!!currentLoadedReport || !!$route.query.reportId"
            :hide-keyword-toolbar="true"
            :hide-more-filters-toolbar="true"
            :keyword-query.sync="listKeywordSearch"
            :synced-more-filters-open.sync="listMoreFiltersOpen"
            :key="`filters-${currentLoadedReport?._id || 'normal'}-${
              $route.query.reportId || 'none'
            }`"
            @filter="handleFilter"
          />
          <div
            v-if="useMobileList && listMoreFiltersOpen"
            class="m-filters-screen__foot"
          >
            <button
              type="button"
              class="btn btn-primary w-100 mb-0"
              @click="listMoreFiltersOpen = false"
            >
              {{ $t("mobile.showResults", { n: pagination.total || 0 }) }}
            </button>
          </div>
        </div>

        <div
          ref="listBottomHScroll"
          class="table-responsive mb-0 w-100 gt-list-bottom-hscroll"
          :class="{
            'trash-view-container': isTrashView,
            'archive-view-container': isArchiveView,
            'gt-list-sticky-header-active': listStickyHeaderActive && !useMobileList,
            'm-list-host': useMobileList,
            'gt-list-sticky-header-scrolled-gutter':
              listStickyHeaderGutterScrollFix,
            'gt-list-sticky-header-scrolled-groups':
              listStickyHeaderGroupScrollFix,
          }"
          @scroll.passive="onListBottomHScroll"
        >
        <ColumnSelector
          :show="showColumnSelector"
          :tableFields="tableFields"
          :selectedColumns.sync="selectedColumns"
          @close="showColumnSelector = false"
          @columns-changed="handleColumnsChanged"
          :key="columnSelectorKey"
        />

        <ReportColumnLayoutEditor
          :show="showColumnLayoutEditor"
          :visible-fields="visibleTableFields"
          :layout="reportColumnLayout"
          :column-label-resolver="tableColumnHeaderText"
          @close="showColumnLayoutEditor = false"
          @layout-changed="handleReportColumnLayoutChanged"
        />

        <FilterColumnSelector
          :show="showFilterColumnSelector"
          :tableFields="modelFields"
          :selectedColumns="filterSelectorSelection"
          @close="showFilterColumnSelector = false"
          @columns-changed="handleFilterColumnsChanged"
          @popup-opened="handleFilterPopupOpened"
          @save-preferences="handleFilterSavePreferences"
        />

        <!-- Teléfono: tarjetas con los mismos datos y el mismo FieldRenderer que la tabla. -->
        <div v-if="useMobileList" class="m-list">
          <ContentSkeleton
            v-if="isLoading || loading"
            variant="cards"
            :rows="5"
            :label="$t('LoadingData')"
          />
          <template v-else>
            <p v-if="items.length === 0" class="m-list-empty">
              {{ $t("NoRecordsAvailable") }}
            </p>
            <p v-else-if="displayTableColumns.length === 0" class="m-list-empty">
              {{ $t("PleaseSelectColumns") }}
            </p>
            <template v-else>
              <template v-for="(item, index) in groupedItems">
                <div
                  v-if="listGroupHeaders[index]"
                  :key="`m-group-${index}`"
                  class="m-list-group"
                >
                  {{ listGroupHeaders[index].label }}
                  <span>({{ listGroupHeaders[index].count }})</span>
                </div>
                <MobileRecordCard
                  :key="`m-card-${item._id || index}`"
                  :muted="isRowHiddenInView(item)"
                  :more-label="$t('mobile.recordActions')"
                  @open="viewItem(item)"
                  @more="mobileRowItem = item"
                >
                  <template #title>
                    <FieldRenderer
                      v-if="mobileTitleCol"
                      :field="mobileTitleCol.field"
                      :value="getFieldValue(item, mobileTitleCol.field)"
                      :item="item"
                      :modelField="modelFields"
                      :reference-items="referenceItems"
                      :lists="lists"
                      :modelName="selectedModel"
                      :hide-reference-add-button="true"
                      :compact-textarea="true"
                      @go-to-reference="handleGoToReference"
                      @field-updated="handleFieldUpdated"
                    />
                    <span v-else>{{ item.name || item._id }}</span>
                  </template>
                  <template v-if="mobileBadgeCols(item).length" #badges>
                    <template v-for="col in mobileBadgeCols(item)">
                      <FlagBadge
                        v-if="isListFlagCol(col)"
                        :key="'mb-' + col.key"
                        :name="getListCategoryFirst(listFlagValueOf(item))"
                        :catalog="categoryCatalog"
                        :label="getListCategoryLabel(listFlagValueOf(item))"
                      />
                      <FieldRenderer
                        v-else
                        :key="'mb-' + col.key"
                        :field="col.field"
                        :value="getFieldValue(item, col.field)"
                        :item="item"
                        :modelField="modelFields"
                        :reference-items="referenceItems"
                        :lists="lists"
                        :modelName="selectedModel"
                        :hide-reference-add-button="true"
                        :compact-textarea="true"
                      />
                    </template>
                  </template>
                  <div
                    v-for="col in mobileLineCols(item)"
                    :key="'ml-' + col.key"
                    class="m-list-line"
                  >
                    <span class="m-list-line__label">{{
                      tableColumnHeaderTextForCol(col)
                    }}</span>
                    <span class="m-list-line__value">
                      <FieldRenderer
                        :field="col.field"
                        :value="getFieldValue(item, col.field)"
                        :item="item"
                        :modelField="modelFields"
                        :reference-items="referenceItems"
                        :lists="lists"
                        :modelName="selectedModel"
                        :hide-reference-add-button="true"
                        :compact-textarea="true"
                        @go-to-reference="handleGoToReference"
                        @field-updated="handleFieldUpdated"
                      />
                    </span>
                  </div>
                </MobileRecordCard>
              </template>
            </template>
          </template>
        </div>

        <table
          v-if="!useMobileList"
          class="table table-bordered table-hover gt-list-table"
          :style="dynamicListTableStyle"
        >
          <colgroup v-if="!isLoadingColumnPreferences">
            <col :style="listLeadColStyle" />
            <col v-if="chooseItem" style="width: 100px; min-width: 100px" />
            <col
              v-for="col in displayTableColumns"
              :key="'list-col-' + col.key"
              :style="listTableColStyle(col.key)"
            />
            <col style="width: 24px; min-width: 24px" />
          </colgroup>
          <!-- Loading state para columnas -->
          <thead v-if="isLoadingColumnPreferences">
            <tr>
              <th class="gt-list-actions-col">
                <span class="gt-skel-bar" style="width: 1rem"></span>
              </th>
              <th v-if="chooseItem">
                <span class="gt-skel-bar"></span>
              </th>
              <th v-for="i in listSkeletonCols" :key="`placeholder-${i}`">
                <span
                  class="gt-skel-bar"
                  :style="{ width: listSkeletonBarWidth(0, i, 45) }"
                ></span>
              </th>
              <th v-if="!isGroupModel()"></th>
            </tr>
          </thead>

          <thead v-else>
            <tr
              v-if="reportGroupHeaderCells"
              class="report-column-group-row"
            >
              <th :colspan="listLeadingColspan"></th>
              <th
                v-for="(cell, gi) in reportGroupHeaderCells"
                :key="'grp-' + gi"
                :colspan="cell.colspan"
                class="report-column-group-header text-center"
                :class="{
                  'report-column-group-header--filled':
                    !!cell.title && !!cell.color,
                }"
                :style="
                  cell.title && cell.color
                    ? reportColumnGroupStyle(cell.color)
                    : {}
                "
              >
                <span v-if="cell.title" class="report-column-group-title">{{
                  cell.title
                }}</span>
              </th>
              <th></th>
            </tr>
            <tr :class="'headerlist ' + selectedModel.toLowerCase()">
              <th
                class="gt-list-actions-col"
                :style="listStickyHeaderLeadingThStyle()"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="isAllFilteredSelected"
                  :indeterminate.prop="isHeaderCheckboxIndeterminate"
                  :disabled="selectingAllItems || isLoading"
                  @change="toggleSelectAll"
                />
                <!-- Formato de todas las columnas: control aparte del checkbox,
                     que es de las filas. -->
                <button
                  v-if="displayTableColumns.length > 0"
                  ref="allColumnsWidthMenuBtn"
                  type="button"
                  class="btn btn-link btn-sm p-0 ms-1 gt-all-columns-width-btn"
                  :class="{
                    'gt-all-columns-width-btn--active':
                      allColumnsWidthMenu.show,
                  }"
                  :title="$t('ColumnsFormatAll')"
                  :aria-label="$t('ColumnsFormatAll')"
                  aria-haspopup="menu"
                  :aria-expanded="String(allColumnsWidthMenu.show)"
                  @click.stop="toggleAllColumnsWidthMenu"
                >
                  <i class="fas fa-text-width"></i>
                  <i class="fas fa-caret-down gt-all-columns-width-btn__caret"></i>
                </button>
                <span class="visually-hidden">{{
                  $t("financialSummary.actionsColumn")
                }}</span>
              </th>
              <th v-if="chooseItem" :style="listStickyHeaderLeadingThStyle()">
                {{ $t("Choose") }}
              </th>
              <th
                v-for="(col, index) in displayTableColumns"
                :key="col.key + index"
                class="sortable-header"
                :class="{
                  'sorted-asc':
                    getSortKeyForDisplayCol(col) &&
                    sortField === getSortKeyForDisplayCol(col) &&
                    sortOrder === 'asc',
                  'sorted-desc':
                    getSortKeyForDisplayCol(col) &&
                    sortField === getSortKeyForDisplayCol(col) &&
                    sortOrder === 'desc',
                  'not-sortable': !isDisplayColSortable(col),
                  'report-merged-header': col.displayType === 'merged',
                  'report-column-in-group': !!getReportColumnGroupForCol(col),
                  'list-col-pinned': isColumnPinned(col.key),
                  'list-col-pinned-boundary': isDataColPinnedBoundary(
                    col,
                    index
                  ),
                }"
                :draggable="!isResizing"
                @dragstart="onDragStart($event, index)"
                @dragover="onDragOver($event)"
                @drop="onDrop($event, index)"
                @dragenter="onDragEnter($event)"
                @dragleave="onDragLeave($event)"
                :style="[
                  reportColumnHeaderThStyle(col),
                  listDataColHeaderStickyStyle(col, index),
                ]"
              >
                <div class="column-header-hover-toolbar" @click.stop>
                  <button
                    type="button"
                    class="btn btn-link btn-sm py-0 px-1 column-header-toolbar-pin-btn"
                    :class="{
                      'column-header-toolbar-pin-btn--active':
                        isColumnPinned(col.key),
                    }"
                    :title="
                      isColumnPinned(col.key)
                        ? $t('UnpinColumn')
                        : $t('PinColumn')
                    "
                    :aria-label="
                      isColumnPinned(col.key)
                        ? $t('UnpinColumn')
                        : $t('PinColumn')
                    "
                    @click.stop="togglePinColumn(col.key)"
                  >
                    <i class="fas fa-thumbtack" style="font-size: 0.8rem"></i>
                  </button>
                  <!-- Ancho de la columna: recortar a una línea con «+» o partir
                       el texto en renglones. Encender uno apaga el otro. -->
                  <button
                    type="button"
                    class="btn btn-link btn-sm py-0 px-1 column-header-toolbar-clip-btn"
                    :class="{
                      'column-header-toolbar-clip-btn--active':
                        isColumnClipViewMoreEnabled(col.key),
                    }"
                    :title="
                      isColumnClipViewMoreEnabled(col.key)
                        ? $t('ClipViewMoreColumnOff')
                        : $t('ClipViewMoreColumnOn')
                    "
                    :aria-label="
                      isColumnClipViewMoreEnabled(col.key)
                        ? $t('ClipViewMoreColumnOff')
                        : $t('ClipViewMoreColumnOn')
                    "
                    @click.stop="toggleColumnClipViewMore(col.key)"
                  >
                    <i class="fas fa-compress" style="font-size: 0.8rem"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-link btn-sm py-0 px-1 column-header-toolbar-clip-btn"
                    :class="{
                      'column-header-toolbar-clip-btn--active':
                        isColumnTextWrapEnabled(col.key),
                    }"
                    :title="
                      isColumnTextWrapEnabled(col.key)
                        ? $t('WrapTextColumnOff')
                        : $t('WrapTextColumnOn')
                    "
                    :aria-label="
                      isColumnTextWrapEnabled(col.key)
                        ? $t('WrapTextColumnOff')
                        : $t('WrapTextColumnOn')
                    "
                    @click.stop="toggleColumnTextWrap(col.key)"
                  >
                    <i class="fas fa-text-width" style="font-size: 0.8rem"></i>
                  </button>
                  <template v-if="col.displayType === 'field'">
                    <button
                      v-if="
                        showListSearchAndFilters &&
                        col.field.type !== 'group' &&
                        col.field.type !== 'image' &&
                        modelFields.length > 0
                      "
                      type="button"
                      class="btn btn-link btn-sm py-0 px-1 column-header-toolbar-filter-btn"
                      :class="{
                        'column-header-toolbar-filter-btn--active':
                          columnHeaderFilterActive(col.field.key),
                      }"
                      :title="$t('Filters')"
                      :aria-label="$t('Filters')"
                      @click.stop="openColumnFilterFromHeader(col.field)"
                    >
                      <i class="fas fa-filter" style="font-size: 0.8rem"></i>
                    </button>
                    <!-- En el listado se guarda con «Guardar preferencias», que el
                         popup minimal no muestra: ahí solo se edita en un reporte. -->
                    <button
                      v-if="currentLoadedReport || !minimal"
                      type="button"
                      class="btn btn-sm btn-link column-header-toolbar-btn"
                      :title="$t('editColumnDisplayNameTooltip')"
                      :aria-label="$t('editColumnDisplayNameTooltip')"
                      @click.stop="openEditReportColumnLabel(col.field)"
                    >
                      <i
                        class="fas fa-pencil-alt p-1 m-0"
                        style="font-size: 0.75rem"
                      ></i>
                    </button>
                  </template>
                  <button
                    v-if="currentLoadedReport || !minimal"
                    type="button"
                    class="btn btn-sm btn-link column-header-toolbar-btn"
                    :class="{
                      'column-header-toolbar-btn--active':
                        !!reportColumnDescriptionFor(col),
                    }"
                    :title="$t('editColumnDescriptionTooltip')"
                    :aria-label="$t('editColumnDescriptionTooltip')"
                    @click.stop="openEditReportColumnDescription(col)"
                  >
                    <i
                      class="fas fa-question p-1 m-0"
                      style="font-size: 0.75rem"
                    ></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger hide-column-btn column-header-toolbar-btn"
                    @click.stop="hideDisplayColumn(col)"
                    :title="$t('HideColumn')"
                  >
                    <i class="fas fa-times p-1 m-0"></i>
                  </button>
                </div>
                <div class="column-header-inner">
                  <div class="column-header-content">
                    <i
                      v-if="
                        getSortKeyForDisplayCol(col) &&
                        sortField === getSortKeyForDisplayCol(col)
                      "
                      class="cursor-pointer column-header-sort-icon"
                      :class="
                        sortOrder === 'asc'
                          ? 'fas fa-sort-up'
                          : 'fas fa-sort-down'
                      "
                      @click="
                        isDisplayColSortable(col)
                          ? handleSort(getSortKeyForDisplayCol(col))
                          : null
                      "
                    >
                    </i>
                    <i
                      v-else-if="isDisplayColSortable(col)"
                      class="cursor-pointer fas fa-sort column-header-sort-icon"
                      @click="handleSort(getSortKeyForDisplayCol(col))"
                    ></i>
                    <i
                      v-if="col.displayType === 'merged'"
                      class="fas fa-compress-arrows-alt column-header-merge-icon me-1"
                      :title="$t('reportColumnMerge')"
                      aria-hidden="true"
                    ></i>
                    <!-- El título sigue el ancho de su columna: en renglones,
                         o en una línea con «+» si la columna recorta. -->
                    <span
                      class="column-header-label"
                      :class="{
                        'is-wrapped':
                          isColumnWrapActive(col.key) ||
                          isClipHeaderExpanded(col),
                      }"
                      :data-clip-view-more-body="
                        isColumnClipActive(col.key) ? '1' : null
                      "
                      :data-clip-view-more-key="
                        isColumnClipActive(col.key)
                          ? clipViewMoreHeaderKey(col)
                          : null
                      "
                      >{{ tableColumnHeaderTextForCol(col) }}</span
                    >
                    <button
                      v-if="
                        isColumnClipActive(col.key) &&
                        (hasClipViewMoreHeaderOverflow(col) ||
                          isClipHeaderExpanded(col))
                      "
                      type="button"
                      class="btn btn-sm list-td-clip-view-more__btn column-header-clip-btn"
                      :class="
                        isClipHeaderExpanded(col) ? 'btn-danger' : 'btn-primary'
                      "
                      :title="
                        isClipHeaderExpanded(col)
                          ? $t('See less')
                          : $t('See more')
                      "
                      :aria-expanded="String(isClipHeaderExpanded(col))"
                      @mousedown.stop
                      @click.stop="toggleClipHeaderExpanded(col)"
                    >
                      {{ isClipHeaderExpanded(col) ? "−" : "+" }}
                    </button>
                    <!-- Ayuda de la columna: al lado del título y siempre visible, no
                         dentro de la toolbar, que solo aparece al pasar el mouse. -->
                    <ColumnFieldHelpIcon
                      v-if="columnHelpTooltip(col)"
                      :tooltip="columnHelpTooltip(col)"
                      :aria-label="$t('ColumnFieldHelpAria')"
                      popover-prefer-right
                    />
                  </div>
                </div>
                <div
                  class="resize-handle"
                  @mousedown.stop="startResize($event, col.key)"
                  :title="$t('ResizeColumn')"
                ></div>
              </th>
              <th :style="listStickyHeaderLeadingThStyle()"></th>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !loading" class="gt-list-fade-in">
            <tr v-if="items.length === 0">
              <td
                :colspan="displayTableColumns.length + listLeadingColspan"
                class="text-center py-4"
              >
                {{ $t("NoRecordsAvailable") }}
              </td>
            </tr>
            <tr v-else-if="displayTableColumns.length === 0">
              <td :colspan="3" class="text-center">
                <i class="fas fa-warning"></i>
                {{ $t("PleaseSelectColumns") }}
              </td>
            </tr>
            <template v-else-if="displayTableColumns.length > 0">
              <!-- Vista desktop -->
              <template v-for="(item, index) in groupedItems">
                <!-- Encabezado de grupo (estilo planilla): una fila por cada
                     cambio de valor en la columna de agrupación -->
                <tr
                  v-if="listGroupHeaders[index]"
                  :key="`group-${index}`"
                  class="list-group-header-row"
                >
                  <td :colspan="listHeaderFullColspan">
                    <div class="list-group-header-row__inner">
                      <span class="list-group-header-row__label">{{
                        listGroupHeaders[index].label
                      }}</span>
                      <span class="list-group-header-row__count"
                        >({{ listGroupHeaders[index].count }})</span
                      >
                    </div>
                  </td>
                </tr>
                <tr
                  :key="`desktop-${item._id || `row-${index}`}`"
                  class="d-md-table-row"
                  :class="{
                    'clickable-row': !view,
                    'per-view-row-hidden': isRowHiddenInView(item),
                  }"
                >
                  <td class="gt-list-row-actions align-middle" @click.stop>
                    <div class="gt-list-lead-inner">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :checked="isItemSelected(item._id)"
                        @change="toggleItemSelection(item._id)"
                      />
                      <div class="gt-list-actions-hover">
                        <span class="gt-list-actions-dots" aria-hidden="true">
                          <i class="gt-list-actions-dot is-primary"></i>
                          <i class="gt-list-actions-dot is-secondary"></i>
                          <i class="gt-list-actions-dot is-danger"></i>
                        </span>
                        <div class="gt-list-actions-pop">
                          <div
                            v-if="!isAlternateListView"
                            class="gt-list-actions-wrap"
                          >
                            <div
                              class="btn-group btn-group-sm gt-list-actions-group"
                              role="group"
                              :aria-label="$t('financialSummary.actionsColumn')"
                            >
                              <button
                                type="button"
                                class="btn btn-outline-primary"
                                :title="$t('ListOpenView')"
                                :aria-label="$t('ListOpenView')"
                                @click="viewItem(item)"
                              >
                                <i class="fas fa-eye" aria-hidden="true"></i>
                              </button>
                              <button
                                v-if="showFobOperacionRowAction(item)"
                                type="button"
                                class="btn btn-outline-info"
                                :title="$t('fobtrading.listOpenOperacionView')"
                                :aria-label="$t('fobtrading.listOpenOperacionView')"
                                @click="openFobOperacionView(item)"
                              >
                                <i class="fas fa-anchor" aria-hidden="true"></i>
                              </button>
                              <button
                                v-if="canEditModel"
                                type="button"
                                class="btn btn-outline-secondary"
                                data-focus-id="edit-list-row"
                                :title="$t('Edit')"
                                :aria-label="$t('Edit')"
                                @click="goEditItem(item)"
                              >
                                <i class="fas fa-edit" aria-hidden="true"></i>
                              </button>
                              <button
                                v-if="canEditModel"
                                type="button"
                                class="btn btn-outline-danger"
                                :title="$t('Delete')"
                                :aria-label="$t('Delete')"
                                @click="confirmDelete(item)"
                              >
                                <i class="fas fa-trash-alt" aria-hidden="true"></i>
                              </button>
                              <button
                                v-if="canUseReportRowHide"
                                type="button"
                                class="btn btn-outline-secondary"
                                :disabled="rowHideBusy"
                                :title="
                                  isRowHiddenInView(item)
                                    ? $t('showInThisView')
                                    : $t('hideInThisView')
                                "
                                :aria-label="
                                  isRowHiddenInView(item)
                                    ? $t('showInThisView')
                                    : $t('hideInThisView')
                                "
                                @click="toggleReportRowHide(item)"
                              >
                                <i
                                  class="fas"
                                  :class="
                                    isRowHiddenInView(item) ? 'fa-eye' : 'fa-eye-slash'
                                  "
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>
                          </div>
                          <div
                            v-else-if="isTrashView"
                            class="btn-group btn-group-sm gt-list-actions-group"
                            role="group"
                            :aria-label="$t('financialSummary.actionsColumn')"
                          >
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              :title="$t('ListOpenView')"
                              :aria-label="$t('ListOpenView')"
                              @click="viewItem(item)"
                            >
                              <i class="fas fa-eye" aria-hidden="true"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-success"
                              :title="$t('Restore')"
                              :aria-label="$t('Restore')"
                              @click="restoreItem(item)"
                            >
                              <i class="fas fa-undo" aria-hidden="true"></i>
                            </button>
                            <button
                              v-if="canEditModel"
                              type="button"
                              class="btn btn-outline-danger"
                              :title="$t('Permanently delete')"
                              :aria-label="$t('Permanently delete')"
                              @click="permanentDelete(item)"
                            >
                              <i class="fas fa-trash-alt" aria-hidden="true"></i>
                            </button>
                          </div>
                          <div
                            v-else
                            class="btn-group btn-group-sm gt-list-actions-group"
                            role="group"
                            :aria-label="$t('financialSummary.actionsColumn')"
                          >
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              :title="$t('ListOpenView')"
                              :aria-label="$t('ListOpenView')"
                              @click="viewItem(item)"
                            >
                              <i class="fas fa-eye" aria-hidden="true"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-success"
                              :title="$t('Unarchive')"
                              :aria-label="$t('Unarchive')"
                              @click="unarchiveItem(item)"
                            >
                              <i class="fas fa-box-open" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td
                    v-for="(col, index) in displayTableColumns"
                    :key="col.key + index"
                    :data-label="tableColumnHeaderTextForCol(col)"
                    :class="[
                      {
                        'report-merged-cell': col.displayType === 'merged',
                        'report-column-cell-in-group':
                          !!getReportColumnGroupForCol(col),
                        'list-col-pinned': isColumnPinned(col.key),
                        'list-col-pinned-boundary': isDataColPinnedBoundary(
                          col,
                          index
                        ),
                        'list-td-clip-expanded': isClipCellExpanded(item, col),
                        'list-td-wrapped': isColumnWrapActive(col.key),
                      },
                      reportColumnBodyEmphasisClass(col),
                    ]"
                    :style="[
                      reportColumnBodyTdStyle(col),
                      listDataColStickyStyle(col, index),
                    ]"
                  >
                    <div
                      class="list-td-clip-view-more__row"
                      :class="{
                        'is-clipped':
                          isColumnClipActive(col.key) &&
                          !isClipCellExpanded(item, col),
                        'is-expanded': isClipCellExpanded(item, col),
                        'is-wrapped': isColumnWrapActive(col.key),
                      }"
                    >
                      <div
                        class="list-td-clip-view-more__body"
                        :data-clip-view-more-body="
                          isColumnClipActive(col.key) ? '1' : null
                        "
                        :data-clip-view-more-key="
                          isColumnClipActive(col.key)
                            ? clipViewMoreCellKey(item, col)
                            : null
                        "
                      >
                        <template v-if="col.displayType === 'merged'">
                          <div
                            v-if="col.mode === 'sum'"
                            class="report-merged-sum"
                          >
                            {{
                              formatTotal(
                                getMergedSumValue(item, col),
                                "number",
                                col.fields[0]
                              )
                            }}
                          </div>
                          <div v-else class="report-merged-stack">
                            <div
                              v-for="(mf, mi) in col.fields"
                              :key="col.key + '-mf-' + mi"
                              class="report-merged-stack-line"
                              :class="{
                                'report-column-emphasis':
                                  isReportColumnEmphasized(mf.key),
                              }"
                            >
                              <FieldRenderer
                                :field="mf"
                                :value="getFieldValue(item, mf)"
                                :item="item"
                                :modelField="modelFields"
                                :reference-items="referenceItems"
                                :lists="lists"
                                :modelName="selectedModel"
                                :hide-reference-add-button="true"
                                :compact-textarea="true"
                                @go-to-reference="handleGoToReference"
                                @field-updated="handleFieldUpdated"
                              />
                            </div>
                          </div>
                        </template>
                        <button
                          v-else-if="isListFlagCol(col)"
                          type="button"
                          class="btn btn-link p-0 border-0 gt-list-category-flag"
                          :disabled="!canEditModel"
                          :aria-label="$t('Category')"
                          @click.stop="openListCategoryPopup(item)"
                        >
                          <!-- Mismo badge que la tarjeta de banderas de la operación. -->
                          <FlagBadge
                            :name="getListCategoryFirst(listFlagValueOf(item))"
                            :catalog="categoryCatalog"
                            :label="getListCategoryLabel(listFlagValueOf(item))"
                            :title="
                              getListCategoryLabel(listFlagValueOf(item)) || $t('Category')
                            "
                          />
                        </button>
                        <span v-else-if="col.field.key === 'modelId'">{{
                          formatListIdCell(getFieldValue(item, col.field))
                        }}</span>
                        <FieldRenderer
                          v-else
                          :field="col.field"
                          :value="getFieldValue(item, col.field)"
                          :item="item"
                          :modelField="modelFields"
                          :reference-items="referenceItems"
                          :lists="lists"
                          :modelName="selectedModel"
                          :hide-reference-add-button="true"
                          :compact-textarea="true"
                          @go-to-reference="handleGoToReference"
                          @field-updated="handleFieldUpdated"
                        />
                        <!-- Gasto con notas comerciales colgadas: el efecto y el neto al
                             lado del importe, sin ocupar una columna. Sin notas con
                             efecto el componente no dibuja nada. -->
                        <NotaComercialAmountNet
                          v-if="expenseNoteIdsForCell(item, col)"
                          class="ms-1"
                          :note-ids="expenseNoteIdsForCell(item, col)"
                          :amount="getFieldValue(item, col.field)"
                        />
                      </div>
                      <!-- Expandir la celda en el lugar. Mientras está abierta el
                           botón sigue visible aunque ya no desborde: si no, no
                           habría con qué volver a cerrarla. -->
                      <button
                        v-if="
                          isColumnClipActive(col.key) &&
                          (hasClipViewMoreOverflow(item, col) ||
                            isClipCellExpanded(item, col))
                        "
                        type="button"
                        class="btn btn-sm list-td-clip-view-more__btn"
                        :class="
                          isClipCellExpanded(item, col)
                            ? 'btn-danger'
                            : 'btn-primary'
                        "
                        :title="
                          isClipCellExpanded(item, col)
                            ? $t('See less')
                            : $t('See more')
                        "
                        :aria-expanded="String(isClipCellExpanded(item, col))"
                        @click.stop="toggleClipCellExpanded(item, col)"
                      >
                        {{ isClipCellExpanded(item, col) ? "−" : "+" }}
                      </button>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
            <!-- Agregar fila de totales -->
            <tr
              v-if="
                displayTableColumns.length > 0 &&
                totals &&
                Object.keys(totals).length > 0
              "
              class="totals-row"
            >
              <td :colspan="listLeadingColspan" class="fw-bold text-end pe-2">
                {{ $t("Total") }}
              </td>
              <td
                v-for="(col, index) in displayTableColumns"
                :key="'tot-' + col.key + index"
                :data-label="tableColumnHeaderTextForCol(col)"
                :class="{
                  'list-col-pinned': isColumnPinned(col.key),
                  'list-col-pinned-boundary': isDataColPinnedBoundary(
                    col,
                    index
                  ),
                }"
                :style="listDataColStickyStyle(col, index)"
              >
                <template v-if="col.displayType === 'merged'">
                  <template v-if="col.mode === 'sum'">
                    <span
                      v-if="getMergedTotalsSum(col) !== null"
                      :class="
                        getMergedTotalsSum(col) < 0
                          ? 'text-danger'
                          : 'text-success'
                      "
                    >
                      {{
                        formatTotal(
                          getMergedTotalsSum(col),
                          "number",
                          col.fields[0]
                        )
                      }}
                    </span>
                  </template>
                  <div v-else class="report-merged-stack">
                    <div
                      v-for="(mf, mi) in col.fields"
                      :key="'tot-mf-' + mi"
                      class="report-merged-stack-line"
                    >
                      <span
                        v-if="totals[mf.key] !== undefined"
                        :class="
                          totals[mf.key] < 0 ? 'text-danger' : 'text-success'
                        "
                      >
                        {{ formatTotal(totals[mf.key], mf.type, mf) }}
                      </span>
                    </div>
                  </div>
                </template>
                <template
                  v-else-if="totals[col.field.key] !== undefined"
                >
                  <span
                    :class="
                      totals[col.field.key] < 0
                        ? 'text-danger'
                        : 'text-success'
                    "
                    >{{
                      formatTotal(
                        totals[col.field.key],
                        col.field.type,
                        col.field
                      )
                    }}</span
                  >
                </template>
              </td>
              <td></td>
            </tr>
          </tbody>
          <!-- Cargando: la silueta borrosa de las filas, con las columnas reales. -->
          <tbody
            v-else
            class="gt-skel-tbody"
            role="status"
            aria-busy="true"
            :aria-label="$t('LoadingData')"
          >
            <tr
              v-for="r in listSkeletonRows"
              :key="'skel-row-' + r"
              class="gt-skel-row"
            >
              <td class="gt-list-actions-col">
                <span class="gt-skel-bar" style="width: 1rem"></span>
              </td>
              <td v-if="chooseItem">
                <span class="gt-skel-bar" style="width: 50%"></span>
              </td>
              <td v-for="c in listSkeletonCols" :key="'skel-' + r + '-' + c">
                <span
                  class="gt-skel-bar"
                  :style="{ width: listSkeletonBarWidth(r, c) }"
                ></span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
    <!-- Antes de saber qué modelo es: barra, pestañas y tabla borrosas. -->
    <ContentSkeleton
      v-else
      :variant="useMobileList ? 'cards' : 'page'"
      :rows="useMobileList ? 5 : 8"
      :label="$t('LoadingData')"
    />

    <!-- Modal de importación CSV -->
    <div
      class="modal fade"
      :class="{ show: showImport }"
      tabindex="-1"
      v-if="showImport"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t("ImportCSV") }} - {{ $t(selectedModelData.label) }}
            </h5>
            <button
              type="button"
              class="btn-close"
              @click="showImport = false"
            ></button>
          </div>
          <div class="modal-body">
            <Import
              :modelName="selectedModelData.label"
              :modelId="selectedModel"
              :modelFields="modelFields"
              :lists="referenceItems"
              @close="showImport = false"
              @import-success="handleImportSuccess"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Menú «formato de todas las columnas»: fuera de la tabla y con posición
         fija, para que el scroll del listado no lo recorte. -->
    <div
      v-if="allColumnsWidthMenu.show"
      ref="allColumnsWidthMenu"
      class="dropdown-menu show gt-all-columns-width-menu"
      role="menu"
      :style="{
        top: allColumnsWidthMenu.top + 'px',
        left: allColumnsWidthMenu.left + 'px',
      }"
      @click.stop
    >
      <h6 class="dropdown-header">{{ $t("ColumnsFormatAll") }}</h6>
      <button
        v-for="option in allColumnsWidthOptions"
        :key="option.mode"
        type="button"
        class="dropdown-item"
        role="menuitemradio"
        :aria-checked="String(allColumnsWidthMode() === option.mode)"
        @click="applyAllColumnsWidthMode(option.mode)"
      >
        <i class="fas fa-fw me-2" :class="option.icon"></i>
        {{ $t(option.label) }}
        <i
          v-if="allColumnsWidthMode() === option.mode"
          class="fas fa-check ms-2 text-primary"
        ></i>
      </button>
    </div>

    <!-- Popup view more: mismo FieldRenderer que la celda -->
    <div
      v-if="clipViewMorePopup.show"
      class="modal fade show d-block dynamic-model-clip-view-more-modal"
      tabindex="-1"
      role="dialog"
      @click.self="closeColumnClipViewMorePopup"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ clipViewMorePopup.title }}</h5>
            <button
              type="button"
              class="btn-close"
              :aria-label="$t('Close')"
              @click="closeColumnClipViewMorePopup"
            ></button>
          </div>
          <div class="modal-body dynamic-model-clip-view-more-body">
            <template v-if="clipViewMorePopup.col">
              <template v-if="clipViewMorePopup.col.displayType === 'merged'">
                <div
                  v-if="clipViewMorePopup.col.mode === 'sum'"
                  class="report-merged-sum"
                >
                  {{
                    formatTotal(
                      getMergedSumValue(
                        clipViewMorePopup.item,
                        clipViewMorePopup.col
                      ),
                      "number",
                      clipViewMorePopup.col.fields[0]
                    )
                  }}
                </div>
                <div v-else class="report-merged-stack">
                  <div
                    v-for="(mf, mi) in clipViewMorePopup.col.fields"
                    :key="'clip-mf-' + mi"
                    class="report-merged-stack-line mb-2"
                    :class="{
                      'report-column-emphasis': isReportColumnEmphasized(mf.key),
                    }"
                  >
                    <FieldRenderer
                      :field="mf"
                      :value="getFieldValue(clipViewMorePopup.item, mf)"
                      :item="clipViewMorePopup.item"
                      :modelField="modelFields"
                      :reference-items="referenceItems"
                      :lists="lists"
                      :modelName="selectedModel"
                      :hide-reference-add-button="true"
                      :compact-textarea="false"
                      @go-to-reference="handleGoToReference"
                      @field-updated="handleFieldUpdated"
                    />
                  </div>
                </div>
              </template>
              <span
                v-else-if="
                  clipViewMorePopup.col.field &&
                  clipViewMorePopup.col.field.key === 'modelId'
                "
              >{{
                formatListIdCell(
                  getFieldValue(
                    clipViewMorePopup.item,
                    clipViewMorePopup.col.field
                  )
                )
              }}</span>
              <FieldRenderer
                v-else-if="clipViewMorePopup.col.field"
                :field="clipViewMorePopup.col.field"
                :value="
                  getFieldValue(
                    clipViewMorePopup.item,
                    clipViewMorePopup.col.field
                  )
                "
                :item="clipViewMorePopup.item"
                :modelField="modelFields"
                :reference-items="referenceItems"
                :lists="lists"
                :modelName="selectedModel"
                :hide-reference-add-button="true"
                :compact-textarea="false"
                @go-to-reference="handleGoToReference"
                @field-updated="handleFieldUpdated"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="clipViewMorePopup.show"
      class="modal-backdrop fade show"
      @click="closeColumnClipViewMorePopup"
    ></div>

    <!-- Modal de edición masiva -->
    <BulkEditModal
      :isVisible="showBulkEdit"
      :selectedItems="selectedItems"
      :modelFields="modelFields"
      :referenceItems="referenceItems"
      :modelName="selectedModel"
      @close="showBulkEdit = false"
      @bulk-edit-success="handleBulkEditSuccess"
    />

    <DeleteBlockedFinancialModal
      :isVisible="showDeleteBlockedFinancialModal"
      :entities="deleteBlockedFinancialEntities"
      :summaryText="deleteBlockedFinancialSummary"
      @close="closeDeleteBlockedFinancialModal"
    />

    <!-- Modal para guardar reporte -->
    <SaveReportModal
      :isVisible="showSaveReportModal"
      :modelName="selectedModel"
      :viewId="effectiveViewId"
      :reportData="currentReportData"
      @close="showSaveReportModal = false"
      @saved="handleReportSaved"
    />

    <!-- Modal para listar reportes -->
    <ReportsListModal
      :isVisible="showReportsListModal"
      :modelName="selectedModel"
      :currentUserId="currentUserId"
      :isAdmin="isCurrentUserAdmin"
      @close="showReportsListModal = false"
      @load-report="handleLoadReport"
    />

    <!-- Modal enviar export por email (mismo modal que documento/PDF, con plantillas) -->
    <EmailTemplateSender
      v-if="showEmailExportModal"
      document-type="export"
      :document-id="''"
      :model-name="selectedModel"
      :excel-blob="emailExportBlob"
      :excel-file-name="emailExportFileName"
      @close="onCloseEmailExportModal"
    />

    <button
      class="btn btn-primary"
      v-if="chooseItem"
      @click="emitItems()"
      :disabled="selectedItems.length === 0"
    >
      {{ $t("Choose") }}
    </button>

    <Pagination
      v-if="!useMobileList && selectedModel"
      :total="pagination.total"
      :per-page="pagination.perPage"
      :current-page="pagination.page"
      @page-changed="handlePageChange"
      @per-page-changed="handlePerPageChange"
    />

    <!-- Teléfono: paginado compacto, botón de crear y hojas de acciones. Las condiciones
         de cada acción son las mismas que las de la barra de escritorio. -->
    <template v-if="useMobileList">
      <MobilePager
        :page="pagination.page"
        :per-page="pagination.perPage"
        :total="pagination.total"
        :loading="isLoading || isFetchingItems"
        :of-label="$t('mobile.of')"
        :prev-label="$t('mobile.previous')"
        :next-label="$t('mobile.next')"
        @change="onMobilePageChange"
      />
      <MobileFab
        v-if="mobileCanAdd"
        :label="$t('Add new')"
        @click="mobileGoToAdd"
      />

      <MobileBottomSheet
        v-model="mobileActionsOpen"
        :title="$t('mobile.actions')"
        :close-label="$t('Close')"
      >
        <MobileSheetItem
          v-if="canUseMyItemsFilter && modelFields.length > 0 && showListSearchAndFilters"
          icon="user"
          :label="$t('MyItems')"
          :hint="isMyItemsFilterActive ? '✓' : ''"
          @click="runMobileAction(toggleMyItemsFilter)"
        />
        <MobileSheetItem
          v-if="!isAlternateListView"
          icon="columns"
          :label="$t('mobile.columns')"
          @click="runMobileAction(() => (showColumnSelector = true))"
        />
        <MobileSheetItem
          v-if="currentLoadedReport && !isAlternateListView"
          icon="object-group"
          :label="$t('reportColumnLayoutTitle')"
          @click="runMobileAction(() => (showColumnLayoutEditor = true))"
        />
        <MobileSheetItem
          v-if="showListSearchAndFilters"
          icon="filter"
          :label="$t('mobile.filterFields')"
          :disabled="isLoadingFilterPreferences"
          @click="runMobileAction(handleFilterButtonClick)"
        />
        <MobileSheetItem
          icon="sync-alt"
          :label="$t('Refresh list')"
          :spin="isLoading || isFetchingItems"
          :disabled="isLoading || isFetchingItems"
          @click="runMobileAction(refreshList)"
        />
        <MobileSheetItem
          v-if="hasUnsavedPreferences"
          icon="save"
          :label="currentLoadedReport ? $t('updateReport') : $t('savePreferences')"
          :disabled="isSavingPreferences"
          @click="runMobileAction(saveAllPreferences)"
        />
        <MobileSheetItem
          v-if="selectedModel && (hasUnsavedPreferences || hasAppliedFilters) && !isAlternateListView"
          icon="save"
          :label="$t('SaveAsReport')"
          @click="runMobileAction(() => (showSaveReportModal = true))"
        />
        <MobileSheetItem
          v-if="selectedModel && !isAlternateListView"
          icon="list"
          :label="$t('Reports')"
          @click="runMobileAction(() => (showReportsListModal = true))"
        />
        <template v-if="!isAlternateListView">
          <MobileSheetItem
            v-for="rv in reportViews"
            :key="'m-rv-' + rv._id"
            icon="file-alt"
            :label="rv.name"
            @click="runMobileAction(() => goToReport(rv._id, rv.type))"
          />
        </template>
        <MobileSheetItem
          v-if="selectedModel && items.length > 0 && !isAlternateListView"
          icon="file-excel"
          :label="$t('Export to Excel')"
          :hint="itemsToExportCount"
          :spin="isExporting"
          :disabled="isExporting"
          @click="runMobileAction(exportToExcel)"
        />
        <MobileSheetItem
          v-if="smartEmailEnabled && selectedModel && !isGroupModel() && items.length > 0 && !isAlternateListView"
          icon="envelope"
          :label="$t('Send by email')"
          :disabled="isExporting"
          @click="runMobileAction(sendExportByEmail)"
        />
        <div
          v-if="selectedModelData"
          class="m-sheet-custom-links m-sheet-embed"
          @click="mobileActionsOpen = false"
        >
          <CustomLinks
            :model-name="selectedModelData.modelName"
            section="list_content"
          />
        </div>
        <MobileSheetItem
          v-if="selectedModel && !isAlternateListView"
          icon="trash-alt"
          :label="$t('Trash')"
          @click="runMobileAction(goToTrashView)"
        />
        <MobileSheetItem
          v-if="selectedModel && !isAlternateListView && canUseArchive"
          icon="archive"
          :label="$t('Archive')"
          @click="runMobileAction(goToArchiveView)"
        />
        <MobileSheetItem
          v-if="canDeleteAllRecords"
          icon="trash"
          :label="$t('Delete all')"
          :hint="pagination.total || items.length || 0"
          danger
          separated
          :disabled="isLoading || isFetchingItems"
          @click="runMobileAction(confirmDeleteAllRecords)"
        />
      </MobileBottomSheet>

      <MobileBottomSheet
        :value="!!mobileRowItem"
        :title="mobileRowTitle"
        :close-label="$t('Close')"
        @input="(open) => !open && (mobileRowItem = null)"
      >
        <template v-if="mobileRowItem">
          <MobileSheetItem
            icon="eye"
            :label="$t('ListOpenView')"
            @click="runMobileRowAction(viewItem)"
          />
          <template v-if="!isAlternateListView">
            <MobileSheetItem
              v-if="showFobOperacionRowAction(mobileRowItem)"
              icon="anchor"
              :label="$t('fobtrading.listOpenOperacionView')"
              @click="runMobileRowAction(openFobOperacionView)"
            />
            <MobileSheetItem
              v-if="canEditModel"
              icon="edit"
              :label="$t('Edit')"
              @click="runMobileRowAction(goEditItem)"
            />
            <MobileSheetItem
              v-if="canUseReportRowHide"
              :icon="isRowHiddenInView(mobileRowItem) ? 'eye' : 'eye-slash'"
              :label="
                isRowHiddenInView(mobileRowItem)
                  ? $t('showInThisView')
                  : $t('hideInThisView')
              "
              :disabled="rowHideBusy"
              @click="runMobileRowAction(toggleReportRowHide)"
            />
            <MobileSheetItem
              v-if="canEditModel"
              icon="trash-alt"
              :label="$t('Delete')"
              danger
              separated
              @click="runMobileRowAction(confirmDelete)"
            />
          </template>
          <template v-else-if="isTrashView">
            <MobileSheetItem
              icon="undo"
              :label="$t('Restore')"
              @click="runMobileRowAction(restoreItem)"
            />
            <MobileSheetItem
              v-if="canEditModel"
              icon="trash-alt"
              :label="$t('Permanently delete')"
              danger
              separated
              @click="runMobileRowAction(permanentDelete)"
            />
          </template>
          <MobileSheetItem
            v-else
            icon="box-open"
            :label="$t('Unarchive')"
            @click="runMobileRowAction(unarchiveItem)"
          />
        </template>
      </MobileBottomSheet>
    </template>
  </div>
</template>

<script>
import CustomLinks from "@/components/gotrading/common/CustomLinks.vue";
import MyItemsButton from "@/components/gotrading/common/MyItemsButton.vue";
import Form from "@/components/gotrading/common/Form.vue";
import Filters from "@/components/gotrading/Filters.vue";
import Pagination from "@/components/gotrading/common/Pagination.vue";
import ColumnSelector from "@/components/gotrading/common/ColumnSelector.vue";
import ReportColumnLayoutEditor from "@/components/gotrading/common/ReportColumnLayoutEditor.vue";
import FilterColumnSelector from "@/components/gotrading/common/FilterColumnSelector.vue";
import { defaultFilterFieldSelection } from "@/utils/defaultFilterFields";
import FieldRenderer from "@/components/gotrading/fields/FieldRenderer.vue";
import BulkEditModal from "@/components/gotrading/common/BulkEditModal.vue";
import DeleteBlockedFinancialModal from "@/components/gotrading/common/DeleteBlockedFinancialModal.vue";
import DynamicListSelectionToolbarExtensions from "@/components/gotrading/common/DynamicListSelectionToolbarExtensions.vue";
import SaveReportModal from "@/components/gotrading/common/SaveReportModal.vue";
import ReportsListModal from "@/components/gotrading/common/ReportsListModal.vue";
import {
  canEditReport,
  openEditReportDialog,
} from "@/utils/reportEditPrompt";
import {
  SCOPE_REPORT,
  fetchPerViewRowHideStatus,
  hidePerViewRow,
  unhidePerViewRow,
  bulkPerViewRowHide,
} from "@/modules/per_view_row_hide_module/perViewRowHideApi";
import { wencesApi } from "@/api/wencesApi";
import { resolveValidUserOwnerFieldKeys } from "@/utils/userOwnerField";
import Swal from "sweetalert2";
import Import from "./import.vue";
import FileDisplay from "@/components/gotrading/common/FileDisplay.vue";
import { formatNumberSync, getDisplayDecimalsOverrideForFieldKey } from "@/utils/numberFormatter";
import { formatDateSync, formatDateTimeSync } from "@/utils/dateFormatter";
import {
  buildDynamicModelItemViewPath,
  MONGODB_OBJECT_ID_RE,
} from "@/utils/dynamicModelPaths";
import { getStatusLabel } from "@/utils/shippingStatus";
import {
  appendExcelMarker,
  appendExcelMarkers,
  collectExcelVisualMarkers,
  formatExcelLabelWithVisualStatus,
  isPaymentRefField,
  wrapExcelIconName,
} from "@/utils/excelVisualStatus";
import {
  hasMissingAssociatedPrepayment,
  isProformOrShippingModelName,
} from "@/utils/missingPrepaymentWarning";
import {
  extractItemIds,
  isAllFilteredSelected as areAllFilteredSelected,
  isHeaderCheckboxIndeterminate as isListHeaderCheckboxIndeterminate,
  isItemIdSelected,
  normalizeItemId,
  normalizeListResponseItems,
} from "@/utils/listSelectAllHelpers";
import {
  resolveReferenceSubfieldFilterField,
  resolveGroupSubfieldFilterField,
} from "@/utils/resolveReferenceSubfieldPath";
import { coerceBooleanFilterValue } from "@/utils/coerceBooleanFilterValue";
import {
  LEGACY_DATE_RANGE_SEPARATOR,
  legacyDateRangeFromValue,
  stripLegacyBetweenPrefix,
} from "@/utils/columnFilterSpec";
import { getTranslatedListLabel } from "@/utils/listItemI18n";
import {
  getFieldTranslatableLocales,
  getTranslatedFieldValueFromItem,
  isFieldTranslatable,
  copyTranslatableSiblingsInto,
} from "@/utils/fieldValueI18n";
import ModelDefinition, {
  modelName,
} from "../../../../back/models/gotrading/ModelDefinition";
import ContentSkeleton, {
  skeletonBarWidth,
} from "@/components/common/ContentSkeleton.vue";
import ColumnFieldHelpIcon from "@/components/gotrading/common/ColumnFieldHelpIcon.vue";
import NotaComercialAmountNet from "@/modules/nota_comercial_module/components/NotaComercialAmountNet.vue";
import { isNotaComercialModuleActive } from "@/modules/nota_comercial_module/utils/notaComercialPendingContacts";
import ExportService from "@/services/exportService";
import { findReferenceSystemSubField } from "@/utils/referenceSystemSubFields";
import permissionsMixin from "@/mixins/permissionsMixin";
import columnPreferencesMixin, {
  DEFAULT_COLUMN_WIDTH_PX,
} from "@/components/gotrading/mixins/columnPreferencesMixin";
import {
  buildGroupHeaderRow,
  normalizeColumnLayout,
} from "@/utils/reportColumnLayout";
import {
  isSummableListField,
  activeColumnTotalKeys,
} from "@/utils/listSummableField";
import {
  getTrashCommentField,
  deleteCommentFieldHtml,
  buildSoftDeleteRequestConfig,
  buildTrashDeleteConfirmHtml,
  getTrashDeleteCommentSwalOptions,
  trashDeleteCommentPreConfirm,
  trashDeleteCommentFromSwalResult,
  showTrashDeleteLoadingSwal,
  closeTrashDeleteLoadingSwal,
  resolveTrashDeletePreConfirm,
  buildTrashCommentFieldHtml,
  shouldShowTrashDeleteComment,
  deletePermanentlyCheckboxHtml,
  bindDeletePermanentlyCheckbox,
} from "@/utils/dynamicModelSoftDeleteConfirm";
import {
  getApiErrorData,
  getApiErrorMessage,
  isDuntowerTenant,
} from "@/utils/dynamicModelValidationSwal";
import FlagBadge from "@/components/gotrading/common/FlagBadge.vue";
import mobileLayoutMixin from "@/mixins/mobileLayoutMixin";
import MobileAppBar from "@/components/mobile/MobileAppBar.vue";
import MobileIconButton from "@/components/mobile/MobileIconButton.vue";
import MobileChips from "@/components/mobile/MobileChips.vue";
import MobileRecordCard from "@/components/mobile/MobileRecordCard.vue";
import MobileBottomSheet from "@/components/mobile/MobileBottomSheet.vue";
import MobileSheetItem from "@/components/mobile/MobileSheetItem.vue";
import MobilePager from "@/components/mobile/MobilePager.vue";
import MobilePullToRefresh from "@/components/mobile/MobilePullToRefresh.vue";
import MobileFab from "@/components/mobile/MobileFab.vue";

/** Tarjeta mobile: cuántas etiquetas y líneas de datos muestra como máximo. */
const MOBILE_CARD_MAX_BADGES = 3;
const MOBILE_CARD_MAX_LINES = 3;
import {
  fetchFinancialMovementCategories,
  normalizeFinancialCategories,
  openFinancialCategoryPopup,
} from "@/utils/financialMovementCategory";

/** Fondo de la fila de grupo en el Excel (ARGB). Espejo del #eef2f7 que usa
 *  `.list-group-header-row td` en pantalla. */
const EXCEL_GROUP_ROW_FILL_ARGB = "FFEEF2F7";

/** Ids por petición al resolver nombres de grupos (largo de URL). */
const GROUP_REF_LABEL_BATCH_SIZE = 100;
/** Tope de ids distintos a resolver de una vez. */
const GROUP_REF_LABEL_MAX_IDS = 2000;

/**
 * Ancho (px) de la primera columna: checkbox + tres puntos. Los botones de
 * acciones se abren encima de las columnas vecinas al pasar el mouse.
 */
const LIST_LEAD_COL_WIDTH_PX = 60;

/** Ancho mínimo (px) de la columna de banderas: solo el icono. */
const LIST_FLAGS_MIN_WIDTH_PX = 64;
/** Ancho máximo (px) que se autoasigna antes de que el texto empiece a envolver. */
const LIST_FLAGS_AUTO_MAX_WIDTH_PX = 180;

const REPORT_LIST_STICKY_HEADER_GROUP_PX = 35;
/** z-index cabecera/cuerpo con columna fijada + cabecera vertical sticky. */

/** Filtro especial (modulo per_view_row_hide): ver filas ocultas del reporte. */
const HIDDEN_ROWS_FILTER_KEY = "hidden";
const HIDDEN_ROWS_FILTER_FIELD = {
  key: HIDDEN_ROWS_FILTER_KEY,
  label: "listTitleHidden",
  type: "boolean",
  isSystemField: true,
  isSpecialFilter: true,
};

export default {
  mixins: [
    permissionsMixin,
    columnPreferencesMixin,
    mobileLayoutMixin,
  ],
  name: "DynamicModel",
  components: {
    Form,
    MyItemsButton,
    Filters,
    Import,
    Pagination,
    FileDisplay,
    ColumnSelector,
    ReportColumnLayoutEditor,
    FilterColumnSelector,
    FieldRenderer,
    CustomLinks,
    BulkEditModal,
    DeleteBlockedFinancialModal,
    DynamicListSelectionToolbarExtensions,
    SaveReportModal,
    ReportsListModal,
    ContentSkeleton,
    ColumnFieldHelpIcon,
    NotaComercialAmountNet,
    FlagBadge,
    MobileAppBar,
    MobileIconButton,
    MobileChips,
    MobileRecordCard,
    MobileBottomSheet,
    MobileSheetItem,
    MobilePager,
    MobilePullToRefresh,
    MobileFab,
    EmailTemplateSender: () =>
      import("@/components/email/EmailTemplateSender.vue"),
  },
  props: {
    formData: {
      type: Object,
      required: false,
    },
    paramViewId: {
      type: String,
      required: false,
    },
    chooseItem: {
      type: Boolean,
      required: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * Listado embebido (popup, formulario): qué modelo listar, sin depender de la ruta.
     * Con esta prop el componente ignora la URL: ni lee filtros de ella ni la reescribe.
     */
    paramModelName: {
      type: String,
      required: false,
      default: "",
    },
    /**
     * Filtros fijos del listado embebido: van en cada consulta y mandan sobre lo que
     * filtre el usuario. Mismo contrato que los query params del listado
     * (p. ej. { _id: "id1,id2", shipping_date: "2026-01-01 - 2026-01-31" }).
     */
    paramFilters: {
      type: Object,
      required: false,
      default: null,
    },
    /** Reporte con el que arranca el listado embebido. */
    paramReportId: {
      type: String,
      required: false,
      default: "",
    },
    /**
     * Reporte fijo de este popup: el armado del listado (columnas, orden, anchos,
     * agrupaciones, qué filtros se ofrecen) se guarda solo bajo esta clave y es el
     * mismo para todos los usuarios. No aparece en el listado de Reportes.
     */
    paramPinnedReportKey: {
      type: String,
      required: false,
      default: "",
    },
    /** Versión minimalista: sin título, alta, reportes ni acciones de colección. */
    minimal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      // Teléfono (useMobileList): buscador abierto, hoja de acciones y registro del «⋮».
      mobileSearchOpen: false,
      mobileActionsOpen: false,
      mobileRowItem: null,
      labelFields: [],
      morebuttons: false,
      loading: false,
      view: null,
      totals: {},
      /**
       * Columnas cuyo valor ajustó un filtro de módulo en la última carga
       * (p. ej. `{ current_balance: { asOf: "2026-09-30" } }` con "Saldo al").
       */
      columnOverrides: {},
      nonGroupFields: [],
      groupFields: [],
      models: [],
      isOpen: false,
      showActions: false,
      selectedModel: "",
      selectedModelData: null,
      /** El reporte fijo del popup ya se cargó: recién ahí se empieza a autoguardar. */
      pinnedPopupReportReady: false,
      pinnedPopupReportSaveTimer: null,
      modelFields: [],
      items: [],
      tableFields: [],
      editingId: null,
      form: {},
      lists: [],
      referenceItems: {},
      showColumnSelector: false,
      showFilterColumnSelector: false,
      selectedFilterFields: {},
      isLoadingFilterPreferences: false,
      hoveredRow: null,
      reportViews: [],
      // Reportes guardados accesibles al usuario (propios + publicos) del modelo actual
      accessibleReports: [],
      // Color de la cabecera de la tabla, para pintar el tab activo igual
      reportTabsAccentColor: null,
      reportTabsAccentModel: null,
      showImport: false,
      clipViewMorePopup: {
        show: false,
        item: null,
        col: null,
        title: "",
      },
      clipViewMoreOverflowMap: {},
      /**
       * Celda expandida en el listado (`itemId|colKey`). Es una sola: abrir otra
       * cierra la anterior, así la tabla no queda con varias filas altas.
       */
      expandedClipCellKey: "",
      /** Cabecera abierta con su «+» (`header|colKey`); va aparte de las celdas. */
      expandedClipHeaderKey: "",
      /** Menú de formato de todas las columnas (posición fija, en px). */
      allColumnsWidthMenu: { show: false, top: 0, left: 0 },
      allColumnsWidthOptions: [
        { mode: "wrap", icon: "fa-text-width", label: "WrapTextAllColumns" },
        { mode: "clip", icon: "fa-compress", label: "ClipViewMoreAllColumns" },
        { mode: "none", icon: "fa-ban", label: "ClearFormatAllColumns" },
      ],
      _clipViewMoreMeasureTimer: null,
      _clipViewMoreResizeObserver: null,
      /**
       * Pantalla sin hover (teléfono): las acciones se ven completas y la
       * columna toma el ancho medido de sus botones.
       */
      listActionsHoverless: false,
      listLeadColMeasuredPx: null,
      showBulkEdit: false,
      showDeleteBlockedFinancialModal: false,
      deleteBlockedFinancialEntities: [],
      deleteBlockedFinancialSummary: "",
      showSaveReportModal: false,
      showReportsListModal: false,
      selectedItems: [],
      selectingAllItems: false,
      isLoading: false,
      isModelsLoaded: false,
      pagination: {
        page: 1,
        perPage: 20,
        total: 0,
        totalPages: 0,
      },
      sortField: "",
      sortOrder: "asc",
      // Cache for model definitions (for reference subfields)
      modelDefinitionsCache: {},
      // Undo functionality for column removal
      lastRemovedColumn: null,
      showUndoNotification: false,
      undoTimeout: null,
      // Saved state for comparison (to detect unsaved changes)
      savedSelectedFilterFields: {},
      savedFilters: {},
      // Current loaded report (if any)
      currentLoadedReport: null,
      // Export state
      isExporting: false,
      /** Catalog {name,color} for list category flags / row tint. */
      categoryCatalog: [],
      showEmailExportModal: false,
      emailExportBlob: null,
      emailExportFileName: null,
      smartEmailEnabled: false,
      // Pending URL filters (to apply after component is mounted)
      pendingUrlFilters: null,
      // Cache para lists y referencias para evitar llamadas redundantes
      listsCache: null,
      listsCacheTimestamp: null,
      listsCacheMaxAge: 5 * 60 * 1000, // 5 minutos
      // Flag para prevenir múltiples llamadas simultáneas a fetchItems
      isFetchingItems: false,
      // Flag para prevenir actualizaciones de ruta cuando estamos procesando cambios programáticos
      isUpdatingRoute: false,
      // Cache para referencias buscadas
      referenceSearchCache: {},
      // Cache para preferencias de filtros
      filterPreferencesCache: {},
      filterPreferencesCacheTimestamp: {},
      filterPreferencesCacheMaxAge: 2 * 60 * 1000, // 2 minutos
      // Vista de papelera / archivados (derivado de la URL)
      isSavingPreferences: false,
      isCurrentUserAdmin: false,
      listKeywordSearch: "",
      listMoreFiltersOpen: false,
      /** Archivados: true tras confirmar que hay registros (sin filtros activos). */
      archiveHasRecords: false,
      rowHideModuleActive: false,
      /** Reportes donde se pueden ocultar filas (config del módulo). */
      rowHideReportIds: [],
      rowHideBusy: false,
      // Títulos de columna personalizados. Con reporte cargado se persisten en el
      // reporte; en el listado, en las preferencias del usuario (ticket #434).
      // Lo mismo vale para la ayuda, la negrita y los totales de abajo.
      reportColumnLabels: {},
      savedReportColumnLabels: {},
      // Ayuda por columna escrita por el usuario (clave de columna → texto del tooltip «?»)
      reportColumnDescriptions: {},
      savedReportColumnDescriptions: {},
      reportColumnEmphasis: {},
      savedReportColumnEmphasis: {},
      reportColumnTotals: {},
      savedReportColumnTotals: {},
      reportColumnLayout: { groups: [], merges: [] },
      savedReportColumnLayout: { groups: [], merges: [] },
      // Agrupación de filas por columna (estilo planilla). "" = sin agrupar.
      reportGroupByField: "",
      /** Nombres de referencias del agrupado: `${refModel}:${id}` → nombre. */
      groupRefLabelCache: {},
      groupRefLabelsLoading: false,
      savedReportGroupByField: "",
      /** Baseline de items-por-página para detectar cambios sin guardar. */
      savedPerPage: 20,
      /** Baseline del orden del listado para detectar cambios sin guardar. */
      savedSortField: "",
      savedSortOrder: "asc",
      showColumnLayoutEditor: false,
      /** Scroll horizontal duplicado arriba del listado (sincronizado con la tabla) */
      listHasHorizontalOverflow: false,
      /** Claves de columnas de datos fijadas (reporte → BD; listado normal → localStorage) */
      /** Evita auto-guardar el reporte mientras se aplica su configuración (F5 / carga). */
      _applyingReport: false,
      /** True cuando el listado con cabecera sticky tiene scroll vertical > 0. */
      listStickyHeaderScrolled: false,
    };
  },
  watch: {
    "selectedColumns._clipViewMore": {
      deep: true,
      handler() {
        this.scheduleClipViewMoreOverflowMeasure();
      },
    },
    "selectedColumns._wrapText": {
      deep: true,
      handler() {
        this.scheduleClipViewMoreOverflowMeasure();
      },
    },

    // Cargar reportes de forma lazy cuando se abre el modal
    showReportsListModal(newVal) {
      if (newVal && this.selectedModel && this.reportViews.length === 0) {
        this.fetchReportViews();
      }
      // Al cerrar el modal pueden haberse creado/editado/borrado reportes
      if (!newVal && this.selectedModel) {
        this.fetchAccessibleReports();
      }
    },
    // Al cambiar de reporte, el tab activo pasa al frente: volver el scroll al inicio
    activeReportTabId() {
      this.$nextTick(() => {
        const el = this.$refs.reportTabsScroll;
        if (el) el.scrollLeft = 0;
      });
    },
    // Tabs de reportes accesibles: recargar cuando cambia el modelo del listado
    selectedModel(newVal, oldVal) {
      if (!newVal) {
        this.accessibleReports = [];
        return;
      }
      if (newVal !== oldVal) {
        this.fetchAccessibleReports();
      }
    },
    selectedFilterFields: {
      handler(newVal, oldVal) {
        const newKeys = newVal ? Object.keys(newVal).length : 0;
        const oldKeys = oldVal ? Object.keys(oldVal).length : 0;

        // Si estamos en modo reporte y el nuevo valor tiene muchos más campos que el anterior,
        // probablemente es una restauración incorrecta - bloquearla
        if (this.currentLoadedReport && newKeys > oldKeys + 5 && oldKeys > 0) {
          // Restaurar el valor anterior
          this.$nextTick(() => {
            this.selectedFilterFields = { ...oldVal };
          });
          return;
        }
      },
      deep: true,
      immediate: false,
    },
    canUseReportRowHide() {
      this.syncHiddenFilterField();
    },
    // Popup con reporte fijo: lo que el usuario acomoda se guarda solo
    pinnedPopupLayoutSignature() {
      if (!this.pinnedPopupReportKey || !this.pinnedPopupReportReady) return;
      this.schedulePinnedPopupReportSave();
    },
    // Watcher simple para cambios de ruta
    $route: {
      handler(newRoute, oldRoute) {
        // Ignorar cambios de ruta si estamos actualizando la ruta programáticamente
        if (this.isUpdatingRoute) {
          return;
        }

        // Embebido: la ruta es de la pantalla que lo contiene, no describe este listado
        if (this.isEmbeddedList) {
          return;
        }

        const pathChanged = newRoute.path !== oldRoute?.path;
        const modelNameChanged =
          newRoute.params?.modelName !== oldRoute?.params?.modelName;
        const viewIdChanged =
          newRoute.params?.viewId !== oldRoute?.params?.viewId;
        const itemIdChanged =
          newRoute.params?.itemId !== oldRoute?.params?.itemId;
        const queryChanged =
          JSON.stringify(newRoute.query) !== JSON.stringify(oldRoute?.query);
        const hadQueryParams =
          oldRoute?.query && Object.keys(oldRoute.query).length > 0;
        const hasQueryParams =
          newRoute.query && Object.keys(newRoute.query).length > 0;

        // Si cambió el reportId a un nuevo reporte, cargar ese reporte
        if (
          !pathChanged &&
          !modelNameChanged &&
          newRoute.query?.reportId &&
          newRoute.query?.reportId !== oldRoute?.query?.reportId
        ) {
          // Establecer estado de carga para evitar mostrar datos anteriores
          this.isLoading = true;
          this.loadReportById(newRoute.query.reportId);
          return;
        }

        if (
          !pathChanged &&
          !modelNameChanged &&
          String(newRoute.query?.reportId || "") ===
            String(oldRoute?.query?.reportId || "") &&
          String(newRoute.query?.hidden || "") !==
            String(oldRoute?.query?.hidden || "")
        ) {
          this.pagination.page = 1;
          this.selectedItems = [];
          // `hidden` viaja como filtro: refrescar tambien el panel de filtros.
          this.applyFiltersFromUrl(this.getFilterQueryParams(newRoute.query));
          return;
        }

        // Si cambiaron los query params pero estamos en el mismo modelo y modo de listado
        if (
          !pathChanged &&
          !modelNameChanged &&
          !viewIdChanged &&
          !itemIdChanged &&
          queryChanged
        ) {
          const filtersOnly = this.getFilterQueryParams(newRoute.query);
          const ownerScopeChanged =
            String(newRoute.query?.ownerScope || "") !==
            String(oldRoute?.query?.ownerScope || "");

          if (Object.keys(filtersOnly).length > 0) {
            // Hay filtros en la URL, aplicarlos
            this.applyFiltersFromUrl(filtersOnly);
          } else if (ownerScopeChanged) {
            this.pagination.page = 1;
            this.selectedItems = [];
            this.fetchItems(this.getCurrentFiltersQueryString());
          } else if (hadQueryParams && !hasQueryParams) {
            // Pasamos de tener query params a no tener ninguno (click en "All")
            this.clearFiltersAndReload();
          }
          return;
        }

        // Mismo modelo: solo cambió normal / trash / archive (p. ej. botón Atrás del navegador)
        if (
          this.isListModePathChange(newRoute, oldRoute) &&
          !modelNameChanged &&
          !viewIdChanged &&
          !itemIdChanged
        ) {
          this.reloadListForRouteListModeChange();
          return;
        }

        // Si cambió el path o el modelo, recargar todo
        if (pathChanged || modelNameChanged || viewIdChanged || itemIdChanged) {
          this.handleRouteChange();
        }
      },
    },
    // Watcher para paramViewId
    paramViewId: {
      handler(newVal) {
        if (newVal) {
          this.handleRouteChange();
        }
      },
    },
    // Watcher para aplicar filtros pendientes de la URL cuando el componente esté listo
    loading: {
      async handler(newVal) {
        if (!newVal && this.pendingUrlFilters) {
          await this.applyPendingUrlFiltersWhenReady();
        }
      },
    },
    archiveHasRecords: {
      async handler(newVal) {
        if (newVal && this.pendingUrlFilters) {
          await this.applyPendingUrlFiltersWhenReady();
        }
      },
    },
    visibleTableFields: {
      handler() {
        this.scheduleUpdateListHorizontalScroll();
      },
      deep: true,
    },
    reportColumnLayout: {
      handler() {
        this.scheduleUpdateListHorizontalScroll();
      },
      deep: true,
    },
    /** Nombres de los grupos: al cambiar la columna de agrupación o la página. */
    reportGroupByField: {
      immediate: true,
      handler() {
        this.$nextTick(() => this.ensureGroupRefLabels());
      },
    },
    items() {
      this.scheduleUpdateListHorizontalScroll();
      // Estaba en una segunda clave `items` del mismo watch, que JS descarta.
      this.scheduleClipViewMoreOverflowMeasure();
      this.ensureGroupRefLabels();
    },
    isLoadingColumnPreferences() {
      this.scheduleUpdateListHorizontalScroll();
    },
    listStickyHeaderActive(val) {
      if (!val) {
        this.listStickyHeaderScrolled = false;
      } else {
        this.$nextTick(() => {
          this.updateListStickyHeaderScrollState(this.$refs.listBottomHScroll);
        });
      }
    },
  },
  updated() {
    this.scheduleClipViewMoreOverflowMeasure();
    this.scheduleListLeadColMeasure();
    this.syncReportTabsAccentColor();
  },


  methods: {
    listSkeletonBarWidth: skeletonBarWidth,
    isMobileEmptyValue(value) {
      if (value === null || value === undefined || value === "") return true;
      // Subcampos de grupo llegan como [null, …]: vacío si no hay ningún valor adentro.
      if (Array.isArray(value)) return value.every((v) => this.isMobileEmptyValue(v));
      if (typeof value === "object") return Object.keys(value).length === 0;
      return false;
    },
    /** Columnas que FieldRenderer dibuja como etiqueta: listas y el status de shipping. */
    isMobileBadgeCol(col) {
      return (
        col.field.type === "list" ||
        (this.selectedModel === "shipping" && col.field.key === "status")
      );
    },
    /** Etiquetas de la tarjeta: bandera y campos de etiqueta con valor. */
    mobileBadgeCols(item) {
      const title = this.mobileTitleCol;
      return this.mobileCardColumns
        .filter((col) => col !== title)
        .filter((col) =>
          this.isListFlagCol(col)
            ? !!this.getListCategoryFirst(this.listFlagValueOf(item))
            : this.isMobileBadgeCol(col) &&
              !this.isMobileEmptyValue(this.getFieldValue(item, col.field))
        )
        .slice(0, MOBILE_CARD_MAX_BADGES);
    },
    /** Líneas de datos de la tarjeta: las siguientes columnas con valor (sin repetir el título). */
    mobileLineCols(item) {
      const title = this.mobileTitleCol;
      const titleValue = title ? this.getFieldValue(item, title.field) : null;
      const titleText =
        titleValue !== null && typeof titleValue !== "object" ? String(titleValue) : null;
      return this.mobileCardColumns
        .filter((col) => {
          if (col === title || this.isListFlagCol(col) || this.isMobileBadgeCol(col)) {
            return false;
          }
          const value = this.getFieldValue(item, col.field);
          if (this.isMobileEmptyValue(value)) return false;
          return titleText === null || typeof value === "object" || String(value) !== titleText;
        })
        .slice(0, MOBILE_CARD_MAX_LINES);
    },
    toggleMobileSearch() {
      if (this.mobileSearchOpen && this.listKeywordSearch) {
        this.clearListKeywordSearch();
      }
      this.mobileSearchOpen = !this.mobileSearchOpen;
      if (this.mobileSearchOpen) {
        this.$nextTick(
          () => this.$refs.mobileSearchInput && this.$refs.mobileSearchInput.focus()
        );
      }
    },
    /** En escritorio el alta abre otra pestaña; en el teléfono (y la app instalada) va en la misma. */
    mobileGoToAdd() {
      this.$router.push({
        name: "DynamicModelAdd",
        params: { modelName: this.selectedModel },
      });
    },
    onMobileReportChip(chip) {
      if (chip.key === "__all") this.clearReportTab();
      else this.selectReportTab(chip.report);
    },
    onMobilePageChange(page) {
      this.handlePageChange(page);
      // En el layout el que scrollea es <body> (overflow: auto), no la ventana.
      [document.body, document.scrollingElement].forEach((el) => {
        if (el && el.scrollTo) el.scrollTo({ top: 0, behavior: "smooth" });
      });
    },
    /** Cierra la hoja y después corre la acción (algunas abren modales encima). */
    runMobileAction(fn) {
      this.mobileActionsOpen = false;
      this.$nextTick(() => fn.call(this));
    },
    runMobileRowAction(fn) {
      const item = this.mobileRowItem;
      this.mobileRowItem = null;
      if (item) this.$nextTick(() => fn.call(this, item));
    },
    /** Seam del mixin: remedir el scroll horizontal al cambiar las columnas. */
    onColumnLayoutChanged() {
      this.scheduleUpdateListHorizontalScroll();
    },
    /**
     * Seam del mixin: cambió el recorte o los renglones de una columna. Se
     * remide qué celdas desbordan y se guarda solo, como el pineo.
     */
    onColumnClipViewMoreChanged() {
      this.scheduleClipViewMoreOverflowMeasure();
      this.persistColumnTextWrap();
    },
    /** ¿Esta columna parte el texto en renglones? */
    isColumnWrapActive(colKey) {
      return this.isColumnTextWrapEnabled(colKey);
    },
    /**
     * ¿Esta columna recorta a una línea con «+»? Los renglones mandan: una
     * columna que quedó con las dos marcas no recorta.
     */
    isColumnClipActive(colKey) {
      return (
        this.isColumnClipViewMoreEnabled(colKey) &&
        !this.isColumnTextWrapEnabled(colKey)
      );
    },
    async persistColumnTextWrap() {
      if (this._applyingReport) return;
      if (this.currentLoadedReport?._id) {
        await this.saveCurrentLoadedReport({ showSuccess: false });
        return;
      }
      try {
        await this.saveColumnPreferences(true, false);
      } catch (error) {
        console.error("Error persisting column text wrap:", error);
      }
    },
    /**
     * Seam del mixin: un campo de grupo visible arrastra sus subcampos, que
     * pueden no existir todavía en las preferencias guardadas.
     */
    columnPreferencesHydrate(preferences) {
      // El flag de listado se dibujaba dentro de la columna Actions, así que
      // en las preferencias viejas quedó guardado como columna oculta. Se
      // enciende una única vez al migrarlo a columna propia; después el
      // usuario puede ocultarlo como cualquier otra.
      if (this.modelHasCategoryField && preferences._listFlagColumn !== true) {
        preferences[this.listFlagFieldKey] = true;
        preferences._listFlagColumn = true;
      }
      // El flag se mudó de `category` a `flag_category`: la columna vieja quedaría
      // mostrando el texto crudo al lado de la nueva de banderas.
      if (
        this.listFlagFieldKey === "flag_category" &&
        preferences._listFlagFieldMigrated !== true
      ) {
        if (preferences.category === true) preferences.category = false;
        preferences._listFlagFieldMigrated = true;
      }
      this.groupFields.forEach((field) => {
        if (preferences[field.key] !== undefined) {
          field.fields.forEach((subField) => {
            if (preferences[`${field.key}.${subField.key}`] === undefined) {
              preferences[`${field.key}.${subField.key}`] =
                preferences[field.key];
            }
          });
        }
      });
      return preferences;
    },
    /**
     * Seam del mixin (ticket #434): el listado personaliza las cabeceras igual que
     * un reporte (título, ayuda, negrita, total) y lo guarda en las preferencias del
     * usuario. Con un reporte cargado eso va al reporte, así que acá no viaja nada.
     */
    columnPreferencesExtras() {
      if (this.currentLoadedReport) return {};
      return {
        columnLabels: this.reportColumnLabels || {},
        columnDescriptions: this.reportColumnDescriptions || {},
        columnEmphasis: this.reportColumnEmphasis || {},
        columnTotals: this.reportColumnTotals || {},
      };
    },
    /** Seam del mixin: toma la personalización de cabeceras guardada del listado. */
    onColumnPreferencesLoaded(record) {
      if (this.currentLoadedReport) return;
      const copyMap = (value) =>
        value && typeof value === "object" && !Array.isArray(value)
          ? JSON.parse(JSON.stringify(value))
          : {};
      this.reportColumnLabels = copyMap(record?.columnLabels);
      this.savedReportColumnLabels = copyMap(record?.columnLabels);
      this.reportColumnDescriptions = copyMap(record?.columnDescriptions);
      this.savedReportColumnDescriptions = copyMap(record?.columnDescriptions);
      this.reportColumnEmphasis = copyMap(record?.columnEmphasis);
      this.savedReportColumnEmphasis = copyMap(record?.columnEmphasis);
      this.reportColumnTotals = copyMap(record?.columnTotals);
      this.savedReportColumnTotals = copyMap(record?.columnTotals);
    },
    scheduleUpdateListHorizontalScroll() {
      if (this._listHScrollMetricsRaf != null) {
        cancelAnimationFrame(this._listHScrollMetricsRaf);
      }
      this._listHScrollMetricsRaf = requestAnimationFrame(() => {
        this._listHScrollMetricsRaf = null;
        this.updateListHorizontalScrollMetrics();
      });
    },
    async loadCategoryCatalogIfNeeded() {
      if (!this.modelHasCategoryField || !this.selectedModel) {
        this.categoryCatalog = [];
        return;
      }
      try {
        this.categoryCatalog = await fetchFinancialMovementCategories(
          this.selectedModel
        );
      } catch (err) {
        console.error("Error loading list category catalog:", err);
        this.categoryCatalog = [];
      }
    },
    /** ¿Esta clave de campo es la del flag de listado (no el `category` propio del modelo)? */
    isListFlagFieldKey(fieldKey) {
      return !!this.listFlagFieldKey && fieldKey === this.listFlagFieldKey;
    },
    /** ¿Esta columna de datos es la columna de banderas? */
    isListFlagCol(col) {
      return !!(
        col &&
        col.displayType === "field" &&
        col.field &&
        this.isListFlagFieldKey(col.field.key)
      );
    },
    /**
     * Ancho por defecto de una columna. La de banderas arranca lo más angosta
     * posible: sin ninguna bandera cargada ocupa solo el icono, y con banderas
     * crece hasta lo que necesite la etiqueta más larga.
     */
    getColumnWidth(fieldKey) {
      const stored = (this.columnWidths || {})[fieldKey];
      if (stored) return stored;
      if (this.isListFlagFieldKey(fieldKey)) return this.listFlagsAutoWidthPx;
      return DEFAULT_COLUMN_WIDTH_PX;
    },
    /** Valor del flag de una fila: campo propio y, si está vacío, el `category` viejo. */
    listFlagValueOf(item) {
      if (!item) return "";
      const key = this.listFlagFieldKey;
      const current = key ? item[key] : "";
      if (current !== undefined && current !== null && current !== "") return current;
      return this.modelCategoryIsFlagField ? item.category : "";
    },
    getListCategoryLabel(category) {
      // El valor puede venir poblado como objeto (`{_id,label}`), como el _id del valor
      // de la lista de flags, o como un arreglo de ids desde que se pueden poner varias:
      // se resuelve contra el catálogo para no imprimir ids, y se muestran todas.
      return normalizeFinancialCategories(category, this.categoryCatalog).join(", ");
    },
    /** Primera bandera del valor guardado: de ahí sale el color del badge. */
    getListCategoryFirst(category) {
      return normalizeFinancialCategories(category, this.categoryCatalog)[0] || "";
    },
    async openListCategoryPopup(item) {
      if (!item || !item._id || !this.selectedModel) return;
      try {
        let savedIds = null;
        const picked = await openFinancialCategoryPopup({
          t: (key) => this.$t(key),
          modelName: this.selectedModel,
          currentCategory: this.listFlagValueOf(item),
          catalog: this.categoryCatalog,
          saveFn: async ({ categories }) => {
            const list = (Array.isArray(categories) ? categories : []).filter(Boolean);
            const body = {
              categories: list,
              category: list[0] || "",
              modelName: this.selectedModel,
            };
            // Desde el listado solo se clasifica: la bandera ya existe en el catálogo,
            // no se da de alta ninguna acá (se administran en /lists).
            const { data } = await wencesApi.put(
              `/api/financial/categories/assign/${encodeURIComponent(
                this.selectedModel
              )}/${encodeURIComponent(item._id)}`,
              body
            );
            if (!data?.success) {
              throw new Error(data?.error || "Failed to save category");
            }
            savedIds = data.data?.categoryIds || [];
            return data.data?.assignedCategories ?? list;
          },
        });
        if (picked === null) return;
        // La fila guarda los ids; la etiqueta se resuelve contra el catálogo al dibujar.
        this.$set(
          item,
          this.listFlagFieldKey || "category",
          this.listFlagFieldKey ? savedIds || picked : picked[0] || ""
        );
        await this.loadCategoryCatalogIfNeeded();
      } catch (err) {
        console.error("Error saving list category:", err);
        Swal.fire({
          icon: "error",
          title: this.$tn("Error"),
          text: err.response?.data?.error || err.message,
        });
      }
    },
    computeListTableMinWidthPx() {
      const fields = this.displayTableColumns;
      if (!fields || fields.length === 0) return 0;
      let w = this.listLeadColWidthPx;
      if (this.chooseItem) w += 100;
      fields.forEach((col) => {
        w += this.getColumnWidth(col.key);
      });
      w += 24;
      return Math.ceil(w);
    },
    updateListHorizontalScrollMetrics() {
      const bottom = this.$refs.listBottomHScroll;
      const spacer = this.$refs.listTopHScrollSpacer;
      const top = this.$refs.listTopHScroll;
      if (!bottom || !spacer) return;
      const cw = bottom.clientWidth;
      const sw = Math.max(bottom.scrollWidth, this.computeListTableMinWidthPx());
      spacer.style.width = `${sw}px`;
      this.listHasHorizontalOverflow = sw > cw + 2;
      if (top && !this._listHScrollSyncing) {
        if (Math.abs(top.scrollLeft - bottom.scrollLeft) > 1) {
          top.scrollLeft = bottom.scrollLeft;
        }
      }
    },
    onListTopHScroll(event) {
      if (this._listHScrollSyncing) return;
      this._listHScrollSyncing = true;
      const el = this.$refs.listBottomHScroll;
      if (el) el.scrollLeft = event.target.scrollLeft;
      requestAnimationFrame(() => {
        this._listHScrollSyncing = false;
      });
    },
    onListBottomHScroll(event) {
      this.updateListStickyHeaderScrollState(event.target);
      if (this._listHScrollSyncing) return;
      this._listHScrollSyncing = true;
      const el = this.$refs.listTopHScroll;
      if (el) el.scrollLeft = event.target.scrollLeft;
      requestAnimationFrame(() => {
        this._listHScrollSyncing = false;
      });
    },
    updateListStickyHeaderScrollState(scrollEl) {
      if (!this.listStickyHeaderActive) {
        if (this.listStickyHeaderScrolled) {
          this.listStickyHeaderScrolled = false;
        }
        return;
      }
      const top = scrollEl?.scrollTop ?? this.$refs.listBottomHScroll?.scrollTop ?? 0;
      const scrolled = top > 0;
      if (this.listStickyHeaderScrolled !== scrolled) {
        this.listStickyHeaderScrolled = scrolled;
      }
    },
    setupListHorizontalScrollObservers() {
      this.teardownListHorizontalScrollObservers();
      this._onListHScrollWindowResize = () => {
        this.scheduleUpdateListHorizontalScroll();
      };
      window.addEventListener("resize", this._onListHScrollWindowResize);
      this.$nextTick(() => {
        const bottom = this.$refs.listBottomHScroll;
        if (bottom && typeof ResizeObserver !== "undefined") {
          this._listHScrollResizeObserver = new ResizeObserver(() => {
            this.scheduleUpdateListHorizontalScroll();
          });
          this._listHScrollResizeObserver.observe(bottom);
        }
        this.scheduleUpdateListHorizontalScroll();
      });
    },
    teardownListHorizontalScrollObservers() {
      if (this._onListHScrollWindowResize) {
        window.removeEventListener("resize", this._onListHScrollWindowResize);
        this._onListHScrollWindowResize = null;
      }
      if (this._listHScrollResizeObserver) {
        this._listHScrollResizeObserver.disconnect();
        this._listHScrollResizeObserver = null;
      }
      if (this._listHScrollMetricsRaf != null) {
        cancelAnimationFrame(this._listHScrollMetricsRaf);
        this._listHScrollMetricsRaf = null;
      }
    },
    isSystemQueryParam(key) {
      return [
        "reportId",
        "focusON",
        "message",
        "openVisualGroup",
        "ownerScope",
      ].includes(String(key || ""));
    },
    appendOwnerScopeParam(params) {
      if (!params || !this.canUseMyItemsFilter || !this.isMyItemsFilterActive) {
        return;
      }
      params.set("ownerScope", "mine");
    },
    async toggleMyItemsFilter() {
      if (!this.canUseMyItemsFilter) return;
      const query = { ...(this.$route.query || {}) };
      if (this.isMyItemsFilterActive) {
        delete query.ownerScope;
      } else {
        query.ownerScope = "mine";
      }
      this.isUpdatingRoute = true;
      this.pagination.page = 1;
      this.selectedItems = [];
      try {
        await this.$router
          .replace({ path: this.$route.path, query })
          .catch(() => {});
      } finally {
        await this.$nextTick();
        this.isUpdatingRoute = false;
      }
      await this.fetchItems(this.getCurrentFiltersQueryString());
    },
    getListModeFromRoute(route = this.$route) {
      const path = route?.path || "";
      if (path.endsWith("/trash")) return "trash";
      if (path.endsWith("/archive")) return "archive";
      return "normal";
    },
    isListModePathChange(newRoute, oldRoute) {
      const newModel = newRoute?.params?.modelName;
      const oldModel = oldRoute?.params?.modelName;
      if (!newModel || newModel !== oldModel) return false;
      return (
        this.getListModeFromRoute(newRoute) !==
        this.getListModeFromRoute(oldRoute)
      );
    },
    getModelListPath(modelName, listMode = "normal") {
      const base = `/dynamic-model/${modelName}`;
      if (listMode === "trash") return `${base}/trash`;
      if (listMode === "archive") return `${base}/archive`;
      return base;
    },
    navigateToListMode(listMode) {
      if (!this.selectedModel) return;
      const path = this.getModelListPath(this.selectedModel, listMode);
      const query =
        this.$route.query && Object.keys(this.$route.query).length > 0
          ? { ...this.$route.query }
          : undefined;
      this.pagination.page = 1;
      this.selectedItems = [];
      this.isUpdatingRoute = true;
      this.$router
        .push({ path, query })
        .then(() => {
          this.reloadListForRouteListModeChange();
        })
        .catch(() => {})
        .finally(() => {
          this.$nextTick(() => {
            this.isUpdatingRoute = false;
          });
        });
    },
    goToTrashView() {
      this.navigateToListMode("trash");
    },
    goToArchiveView() {
      if (!this.canUseArchive) return;
      this.navigateToListMode("archive");
    },
    /**
     * Publica/retira `hidden` como campo filtrable: solo tiene sentido dentro de
     * un reporte con el modulo de ocultar filas activo.
     */
    syncHiddenFilterField() {
      const index = this.modelFields.findIndex(
        (field) => field && field.key === HIDDEN_ROWS_FILTER_KEY
      );
      if (this.canUseReportRowHide) {
        if (index === -1) {
          this.modelFields.push({ ...HIDDEN_ROWS_FILTER_FIELD });
        }
        return;
      }
      // Solo retirar el campo especial (un modelo podria tener su propio `hidden`).
      if (index >= 0 && this.modelFields[index].isSpecialFilter) {
        this.modelFields.splice(index, 1);
        if (this.selectedFilterFields[HIDDEN_ROWS_FILTER_KEY]) {
          this.$delete(this.selectedFilterFields, HIDDEN_ROWS_FILTER_KEY);
        }
      }
    },
    appendReportHideListParams(params) {
      if (!this.canUseReportRowHide || !this.currentLoadedReport?._id) return;
      params.set("reportId", String(this.currentLoadedReport._id));
      // El filtro manda sobre la ruta: al aplicarlo la URL todavia no cambio.
      const fromFilters = params.get("hidden");
      const hidden =
        fromFilters != null
          ? fromFilters === "true" || fromFilters === "1"
          : this.isHiddenRowsView;
      if (hidden) {
        params.set("hidden", "true");
      } else {
        params.delete("hidden");
      }
    },
    reportRowShippingId(rowKey) {
      if (String(this.selectedModel || "").toLowerCase() !== "shipping") {
        return "";
      }
      return rowKey || "";
    },
    /**
     * ¿Esta fila está oculta en el reporte? En la vista de ocultas lo están todas; con
     * una búsqueda de texto el backend devuelve mezcladas y marca `hiddenInView`.
     */
    isRowHiddenInView(item) {
      if (!this.canUseReportRowHide) return false;
      if (this.isHiddenRowsView) return true;
      return !!(item && item.hiddenInView);
    },
    async toggleReportRowHide(item) {
      const rowKey = item && item._id != null ? String(item._id) : "";
      const reportId = this.currentLoadedReport && this.currentLoadedReport._id
        ? String(this.currentLoadedReport._id)
        : "";
      if (!this.canUseReportRowHide || !rowKey || !reportId || this.rowHideBusy) {
        return;
      }
      this.rowHideBusy = true;
      try {
        const payload = {
          scopeType: SCOPE_REPORT,
          scopeId: reportId,
          rowKey,
          modelName: this.selectedModel || "",
          shipping: this.reportRowShippingId(rowKey),
        };
        if (this.isRowHiddenInView(item)) {
          await unhidePerViewRow(payload);
        } else {
          await hidePerViewRow(payload);
        }
        await this.refreshList();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: this.$tn("Error"),
          text: error.response?.data?.error || this.$tn("Error"),
        });
      } finally {
        this.rowHideBusy = false;
      }
    },
    async hideOrShowSelected() {
      const reportId = this.currentLoadedReport && this.currentLoadedReport._id
        ? String(this.currentLoadedReport._id)
        : "";
      if (
        !this.canUseReportRowHide ||
        !reportId ||
        !this.selectedItems.length ||
        this.rowHideBusy
      ) {
        return;
      }
      this.rowHideBusy = true;
      try {
        const rows = this.selectedItems.map((id) => {
          const rowKey = String(id);
          return {
            scopeType: SCOPE_REPORT,
            scopeId: reportId,
            rowKey,
            modelName: this.selectedModel || "",
            shipping: this.reportRowShippingId(rowKey),
          };
        });
        const action = this.isHiddenRowsView ? "unhide" : "hide";
        for (let i = 0; i < rows.length; i += 200) {
          await bulkPerViewRowHide({
            action,
            rows: rows.slice(i, i + 200),
          });
        }
        this.selectedItems = [];
        await this.refreshList();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: this.$tn("Error"),
          text: error.response?.data?.error || this.$tn("Error"),
        });
      } finally {
        this.rowHideBusy = false;
      }
    },
    ensureArchiveRouteAllowed() {
      if (this.isArchiveView && this.selectedModelData && !this.canUseArchive) {
        this.navigateToListMode("normal");
      }
    },
    reloadListForRouteListModeChange() {
      this.pagination.page = 1;
      this.selectedItems = [];
      this.showColumnSelector = false;
      this.showFilterColumnSelector = false;
      this.ensureArchiveRouteAllowed();
      this.runListReloadForCurrentRoute();
    },
    async runListReloadForCurrentRoute() {
      if (this.isArchiveView) {
        await this.refreshArchiveHasRecords();
      } else {
        this.archiveHasRecords = false;
      }
      const queryString = this.getCurrentFiltersQueryString();
      if (this.view) {
        await this.fetchViewItems(queryString);
      } else {
        await this.fetchItems(queryString);
      }
    },
    async refreshArchiveHasRecords() {
      if (!this.isArchiveView || !this.selectedModel) {
        this.archiveHasRecords = false;
        return;
      }
      try {
        const params = new URLSearchParams({
          page: "1",
          perPage: "1",
          archived: "true",
        });
        const { data } = await wencesApi.get(
          `/api/gotrading/dynamic/${this.selectedModel}?${params.toString()}`
        );
        this.archiveHasRecords = (data.pagination?.total || 0) > 0;
      } catch (error) {
        console.error("[refreshArchiveHasRecords]", error);
        this.archiveHasRecords = false;
      }
    },
    async applyPendingUrlFiltersWhenReady() {
      if (!this.pendingUrlFilters) return;
      if (this.isArchiveView && !this.archiveHasRecords) return;
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 100));
      if (this.$refs.filtersComponent) {
        await this.applyFiltersToComponent(this.pendingUrlFilters);
        this.pendingUrlFilters = null;
      }
    },
    onListKeywordSearchInput() {
      const fc = this.$refs.filtersComponent;
      if (fc) {
        fc.textSearchQuery = this.listKeywordSearch;
        fc.onTextSearchChange();
      }
    },
    applyListKeywordSearch() {
      const fc = this.$refs.filtersComponent;
      if (fc) {
        fc.textSearchQuery = this.listKeywordSearch;
        fc.applyTextSearch();
      }
    },
    clearListKeywordSearch() {
      this.listKeywordSearch = "";
      const fc = this.$refs.filtersComponent;
      if (fc) {
        fc.clearTextSearch();
      }
    },
    toggleListMoreFilters() {
      const fc = this.$refs.filtersComponent;
      if (fc && typeof fc.toggleMoreFilters === "function") {
        fc.toggleMoreFilters();
      }
    },
    async resolveCurrentUserAdminStatus() {
      try {
        if (this.userPermissions.includes("all_access")) {
          this.isCurrentUserAdmin = true;
          return;
        }

        const profileResponse = await wencesApi.get("/api/users/myprofile");
        if (!profileResponse.data?.ok || !profileResponse.data?.data) {
          this.isCurrentUserAdmin = false;
          return;
        }

        const userData = profileResponse.data.data;
        let roleId;
        if (typeof userData.role === "string") {
          roleId = userData.role;
        } else if (userData.role && userData.role._id) {
          roleId = userData.role._id;
        }

        if (!roleId) {
          this.isCurrentUserAdmin = false;
          return;
        }

        const roleResponse = await wencesApi.get(`/api/roles/${roleId}`);
        const permissions = roleResponse.data?.data?.permissions || [];
        this.isCurrentUserAdmin =
          Array.isArray(permissions) && permissions.includes("all_access");
      } catch (error) {
        console.error("Error resolving admin status:", error);
        this.isCurrentUserAdmin = false;
      }
    },
    getFilterQueryParams(query = {}) {
      const filters = {};
      Object.entries(query || {}).forEach(([key, value]) => {
        if (!this.isSystemQueryParam(key)) {
          filters[key] = value;
        }
      });
      return filters;
    },
    emitItems() {
      this.$emit("chooseItems", this.selectedItems);
    },
    resetState() {
      this.groupFields = [];
      this.selectedModel = "";
      this.selectedModelData = null;
      this.modelFields = [];
      this.items = [];
      this.tableFields = [];
      this.editingId = null;
      this.form = {};
      this.referenceItems = {};
      this.showColumnSelector = false;
      this.selectedColumns = {};
      this.hoveredRow = null;
      this.reportViews = [];
      this.accessibleReports = [];
      this.showImport = false;
      this.showBulkEdit = false;
      this.selectedItems = [];
      this.isLoading = false;
      this.pagination = {
        page: 1,
        perPage: 20,
        total: 0,
        totalPages: 0,
      };
      this.saveTimeout = null;
      this.sortField = "";
      this.sortOrder = "asc";
      this.visibleTableFields = [];
      this.draggedIndex = null;
      this.savedColumnOrder = [];
      this.columnSelectorKey = 0;
      this.currentLoadedReport = null;
      this.pendingUrlFilters = null;
      this.isFetchingItems = false;
      this.isUpdatingRoute = false;
      this.isSavingPreferences = false;
      this.reportColumnLabels = {};
      this.savedReportColumnLabels = {};
      this.reportColumnDescriptions = {};
      this.savedReportColumnDescriptions = {};
      this.reportColumnEmphasis = {};
      this.savedReportColumnEmphasis = {};
      this.reportColumnTotals = {};
      this.savedReportColumnTotals = {};
      this.reportColumnLayout = { groups: [], merges: [] };
      this.savedReportColumnLayout = { groups: [], merges: [] };
      this.reportGroupByField = "";
      this.savedReportGroupByField = "";
      this.pinnedColumnKeys = [];
      this.savedPinnedColumnKeys = [];
      this.savedPerPage = 20;
      this.savedSortField = "";
      this.savedSortOrder = "asc";
    },
    /**
     * Encabezado por defecto (sin título personalizado del reporte).
     */
    baseTableColumnHeaderText(field) {
      if (
        this.selectedModelData &&
        (field.key === "parent" ||
          field.key === "title" ||
          field.key === "name")
      ) {
        return this.selectedModelData.label
          ? this.$t(this.selectedModelData.label)
          : this.$t(this.selectedModelData.modelName);
      }
      if (field.abbreviation) return field.abbreviation;
      if (
        field.type === "reference_subfield" ||
        field.type === "group_subfield"
      ) {
        return field.label;
      }
      return this.$t(field.label);
    },
    /**
     * Encabezado mostrado en tabla (incluye el nombre personalizado del reporte o de
     * las preferencias del listado).
     * La columna del flag de listado no lleva rótulo propio: usa la etiqueta del campo
     * `category`, la misma que muestra «Customize display», para que el usuario que la
     * oculta la reconozca al ir a activarla de nuevo.
     */
    tableColumnHeaderText(field) {
      if (this.reportColumnLabels && this.reportColumnLabels[field.key]) {
        return this.reportColumnLabels[field.key];
      }
      return this.baseTableColumnHeaderText(field);
    },
    tableColumnHeaderTextForCol(col) {
      if (!col) return "";
      if (col.displayType === "merged") {
        if (col.label) return col.label;
        return col.fields
          .map((f) => this.tableColumnHeaderText(f))
          .join(" / ");
      }
      return `${this.tableColumnHeaderText(col.field)}${this.columnOverrideHeaderSuffix(
        col.field
      )}`;
    },
    /**
     * Un filtro de módulo cambió lo que muestra la columna (p. ej. "Saldo al"):
     * que se note en el título, en la tabla y en el Excel.
     */
    columnOverrideHeaderSuffix(field) {
      const override =
        field && this.columnOverrides && this.columnOverrides[field.key];
      if (!override || !override.asOf) return "";
      const [year, month, day] = String(override.asOf).split("-");
      return ` (${this.$t("listColumnAsOf", {
        date: `${day}/${month}/${year}`,
      })})`;
    },
    isDisplayColSortable(col) {
      if (!col || col.displayType === "merged") return false;
      const f = col.field;
      // Columna ajustada por un filtro de módulo: el backend ordenaría por el
      // valor guardado, no por el que se ve.
      if (this.columnOverrides && this.columnOverrides[f.key]) return false;
      // Las referencias sí se pueden ordenar: el backend ordena por el título
      // del registro apuntado (el texto del chip), no por su id.
      return f.type !== "group";
    },
    getSortKeyForDisplayCol(col) {
      if (!col || col.displayType !== "field") return null;
      return col.field.key;
    },

    openColumnClipViewMorePopup(item, col) {
      if (!item || !col) return;
      this.clipViewMorePopup = {
        show: true,
        item,
        col,
        title: this.tableColumnHeaderTextForCol(col) || this.$t("See more"),
      };
    },

    closeColumnClipViewMorePopup() {
      this.clipViewMorePopup = {
        show: false,
        item: null,
        col: null,
        title: "",
      };
    },

    clipViewMoreCellKey(item, col) {
      if (!item || !col) return "";
      const id = item._id != null ? String(item._id) : "";
      return id + "|" + String(col.key || "");
    },

    hasClipViewMoreOverflow(item, col) {
      const key = this.clipViewMoreCellKey(item, col);
      return !!(key && this.clipViewMoreOverflowMap[key]);
    },

    isClipCellExpanded(item, col) {
      const key = this.clipViewMoreCellKey(item, col);
      return !!key && this.expandedClipCellKey === key;
    },

    /**
     * Abre o cierra la celda en el lugar. Al cerrarla vuelve a recortarse, así
     * que hay que volver a medir el desborde en el mismo tick: si no, el botón
     * se iría hasta la próxima medición (el mapa la dejó como "no desborda"
     * mientras estuvo abierta).
     */
    toggleClipCellExpanded(item, col) {
      const key = this.clipViewMoreCellKey(item, col);
      if (!key) return;
      this.expandedClipCellKey = this.expandedClipCellKey === key ? "" : key;
      this.$nextTick(() => {
        this.measureClipViewMoreOverflow();
      });
    },

    /** Clave del título de la columna en el mapa de desborde; no choca con `id|colKey`. */
    clipViewMoreHeaderKey(col) {
      return col ? "header|" + String(col.key || "") : "";
    },

    hasClipViewMoreHeaderOverflow(col) {
      const key = this.clipViewMoreHeaderKey(col);
      return !!(key && this.clipViewMoreOverflowMap[key]);
    },

    isClipHeaderExpanded(col) {
      const key = this.clipViewMoreHeaderKey(col);
      return (
        !!key &&
        this.expandedClipHeaderKey === key &&
        this.isColumnClipActive(col.key)
      );
    },

    /** Como la celda: al cerrar el título hay que volver a medir para que el «+» siga. */
    toggleClipHeaderExpanded(col) {
      const key = this.clipViewMoreHeaderKey(col);
      if (!key) return;
      this.expandedClipHeaderKey =
        this.expandedClipHeaderKey === key ? "" : key;
      this.$nextTick(() => {
        this.measureClipViewMoreOverflow();
      });
    },

    // ------------------------------- formato de todas las columnas

    toggleAllColumnsWidthMenu() {
      if (this.allColumnsWidthMenu.show) {
        this.closeAllColumnsWidthMenu();
        return;
      }
      const btn = this.$refs.allColumnsWidthMenuBtn;
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      // Que no se salga por la derecha en pantallas angostas.
      const MENU_WIDTH_PX = 260;
      const left = Math.max(
        8,
        Math.min(rect.left, window.innerWidth - MENU_WIDTH_PX - 8)
      );
      this.allColumnsWidthMenu = { show: true, top: rect.bottom + 4, left };
      // Se cierra al hacer clic afuera, con Escape o si la página se mueve
      // (el menú es fijo y quedaría despegado del botón).
      this._allColumnsWidthMenuClose = (event) => {
        if (event.type === "keydown" && event.key !== "Escape") return;
        if (event.type === "mousedown") {
          const menu = this.$refs.allColumnsWidthMenu;
          if (menu && menu.contains(event.target)) return;
          if (btn.contains(event.target)) return;
        }
        this.closeAllColumnsWidthMenu();
      };
      document.addEventListener("mousedown", this._allColumnsWidthMenuClose);
      document.addEventListener("keydown", this._allColumnsWidthMenuClose);
      window.addEventListener("scroll", this._allColumnsWidthMenuClose, true);
      window.addEventListener("resize", this._allColumnsWidthMenuClose);
    },

    closeAllColumnsWidthMenu() {
      if (this._allColumnsWidthMenuClose) {
        document.removeEventListener("mousedown", this._allColumnsWidthMenuClose);
        document.removeEventListener("keydown", this._allColumnsWidthMenuClose);
        window.removeEventListener("scroll", this._allColumnsWidthMenuClose, true);
        window.removeEventListener("resize", this._allColumnsWidthMenuClose);
        this._allColumnsWidthMenuClose = null;
      }
      if (this.allColumnsWidthMenu.show) {
        this.allColumnsWidthMenu = { show: false, top: 0, left: 0 };
      }
    },

    applyAllColumnsWidthMode(mode) {
      this.closeAllColumnsWidthMenu();
      // Un título abierto con su «+» dejaría de tener sentido si la columna cambia.
      this.expandedClipHeaderKey = "";
      this.expandedClipCellKey = "";
      this.setAllColumnsWidthMode(mode);
    },

    measureClipViewMoreOverflow() {
      if (typeof document === "undefined" || !this.$el || !this.$el.querySelectorAll) {
        return;
      }
      const nodes = this.$el.querySelectorAll("[data-clip-view-more-body='1']");
      const map = {};
      nodes.forEach((el) => {
        const key = el.getAttribute("data-clip-view-more-key");
        if (!key) return;
        // +1 tolerance for subpixel rounding
        const overflow =
          el.scrollWidth > el.clientWidth + 1 ||
          el.scrollHeight > el.clientHeight + 1;
        map[key] = overflow;
      });
      const prev = this.clipViewMoreOverflowMap || {};
      const prevKeys = Object.keys(prev);
      const nextKeys = Object.keys(map);
      let same =
        prevKeys.length === nextKeys.length &&
        nextKeys.every((k) => prev[k] === map[k]);
      if (!same) {
        this.clipViewMoreOverflowMap = map;
      }
    },

    scheduleClipViewMoreOverflowMeasure() {
      if (this._clipViewMoreMeasureTimer) {
        clearTimeout(this._clipViewMoreMeasureTimer);
      }
      this._clipViewMoreMeasureTimer = setTimeout(() => {
        this._clipViewMoreMeasureTimer = null;
        this.$nextTick(() => {
          this.measureClipViewMoreOverflow();
          this.bindClipViewMoreResizeObserver();
        });
      }, 50);
    },

    bindClipViewMoreResizeObserver() {
      if (typeof ResizeObserver === "undefined") return;
      if (this._clipViewMoreResizeObserver) {
        this._clipViewMoreResizeObserver.disconnect();
        this._clipViewMoreResizeObserver = null;
      }
      if (!this.$el || !this.$el.querySelectorAll) return;
      const nodes = this.$el.querySelectorAll("[data-clip-view-more-body='1']");
      if (!nodes.length) return;
      const ro = new ResizeObserver(() => {
        this.measureClipViewMoreOverflow();
      });
      nodes.forEach((el) => ro.observe(el));
      this._clipViewMoreResizeObserver = ro;
    },

    onHoverlessMediaChange() {
      const mq = this._hoverlessMediaQuery;
      this.listActionsHoverless = !!(mq && mq.matches);
      this.scheduleListLeadColMeasure();
    },

    scheduleListLeadColMeasure() {
      if (!this.listActionsHoverless) return;
      if (this._listLeadColMeasureTimer) {
        clearTimeout(this._listLeadColMeasureTimer);
      }
      this._listLeadColMeasureTimer = setTimeout(() => {
        this._listLeadColMeasureTimer = null;
        this.$nextTick(() => this.measureListLeadColWidth());
      }, 50);
    },

    /**
     * Sin hover los botones van a la vista, y cambian por permisos, por vista
     * (papelera / archivo) y por fila (p. ej. el botón de operación FOB). El
     * contenido es inline-flex sin corte de línea, así que mide su ancho
     * natural aunque la celda sea menor.
     */
    measureListLeadColWidth() {
      const root = this.$el;
      if (!root || !root.querySelectorAll) return;
      let next = 0;
      root
        .querySelectorAll(".gt-list-row-actions .gt-list-lead-inner")
        .forEach((inner) => {
          const cell = inner.closest("td");
          const cs = cell ? getComputedStyle(cell) : null;
          const pad = cs
            ? (parseFloat(cs.paddingLeft) || 0) +
              (parseFloat(cs.paddingRight) || 0) +
              (parseFloat(cs.borderLeftWidth) || 0) +
              (parseFloat(cs.borderRightWidth) || 0)
            : 0;
          next = Math.max(next, inner.getBoundingClientRect().width + pad);
        });
      if (next <= 0) return;
      next = Math.ceil(next + 2);
      if (next !== this.listLeadColMeasuredPx) {
        this.listLeadColMeasuredPx = next;
      }
    },

    teardownClipViewMoreOverflowMeasure() {
      if (this._clipViewMoreMeasureTimer) {
        clearTimeout(this._clipViewMoreMeasureTimer);
        this._clipViewMoreMeasureTimer = null;
      }
      if (this._clipViewMoreResizeObserver) {
        this._clipViewMoreResizeObserver.disconnect();
        this._clipViewMoreResizeObserver = null;
      }
    },

    hideDisplayColumn(col) {
      if (!col) return;
      this.unpinColumnKey(col.key);
      if (col.displayType === "merged") {
        col.fields.forEach((f) => this.hideColumn(f.key));
        return;
      }
      this.hideColumn(col.field.key);
    },
    getMergedSumValue(item, col) {
      return (col.fields || []).reduce((total, f) => {
        const v = this.getFieldValue(item, f);
        if (v === null || v === undefined || v === "") return total;
        if (typeof v === "number" && Number.isFinite(v)) return total + v;
        const n = parseFloat(v);
        return total + (Number.isFinite(n) ? n : 0);
      }, 0);
    },
    getMergedTotalsSum(col) {
      let hasAny = false;
      const sum = (col.fields || []).reduce((total, f) => {
        if (this.totals[f.key] === undefined) return total;
        hasAny = true;
        return total + (parseFloat(this.totals[f.key]) || 0);
      }, 0);
      return hasAny ? sum : null;
    },
    /**
     * Texto de la celda usado como clave y etiqueta del grupo. Reutiliza el
     * mismo formateo que el export (resuelve referencias, listas y fechas).
     * @returns {string}
     */
    /**
     * Clave de agrupación: estable y sincrónica. Para una referencia sin
     * poblar es el ObjectId, que es justo lo que la hace estable.
     */
    groupCellKey(item, col) {
      if (!item || !col || !col.field) return "";
      try {
        const value = this.getFieldValue(item, col.field);
        const text = this.formatCellForExcelExport(value, col.field, item);
        return text == null ? "" : String(text).trim();
      } catch (error) {
        console.warn("[groupCellKey]", error?.message);
        return "";
      }
    },
    /**
     * Etiqueta a mostrar. Igual que la clave salvo en referencias sin poblar,
     * donde se usa el nombre ya resuelto; si todavía no llegó, cae a la clave.
     */
    groupCellLabel(item, col) {
      const key = this.groupCellKey(item, col);
      if (!item || !col || !col.field) return key;
      const cached = this.groupRefLabelCache[
        this.groupRefCacheKey(col.field, this.getFieldValue(item, col.field))
      ];
      return cached || key;
    },
    /**
     * Ordena para que cada grupo quede contiguo y los grupos salgan alfabéticos
     * por la etiqueta visible (no por el ObjectId). Lo usan la pantalla y el
     * export, para que el Excel salga igual que el listado.
     */
    sortRowsByGroupColumn(rows, col) {
      return (rows || [])
        .map((item, i) => ({
          item,
          i,
          key: this.groupCellKey(item, col),
          label: this.groupCellLabel(item, col),
        }))
        .sort((a, b) => {
          if (a.key === b.key) return a.i - b.i; // orden original dentro del grupo
          if (!a.key) return 1; // vacíos al final
          if (!b.key) return -1;
          const byLabel = a.label.localeCompare(b.label, undefined, {
            numeric: true,
            sensitivity: "base",
          });
          if (byLabel !== 0) return byLabel;
          return a.key.localeCompare(b.key);
        })
        .map((row) => row.item);
    },
    /**
     * Índice de fila → encabezado del grupo que arranca en esa fila.
     * Se segmenta por la clave (estable) y se rotula con la etiqueta.
     * @returns {Object<number, {label: string, count: number}>}
     */
    buildGroupHeaders(sortedRows, col) {
      const headers = {};
      const rows = sortedRows || [];
      if (!col || rows.length === 0) return headers;
      const keys = rows.map((item) => this.groupCellKey(item, col));
      const labels = rows.map((item) => this.groupCellLabel(item, col));
      let start = 0;
      for (let i = 1; i <= keys.length; i++) {
        if (i === keys.length || keys[i] !== keys[start]) {
          headers[start] = {
            label: labels[start] || this.$t("reportGroupByEmpty"),
            count: i - start,
          };
          start = i;
        }
      }
      return headers;
    },
    /** Modelo referenciado por el campo, o "" si no lo declara. */
    groupRefModel(field) {
      if (!field) return "";
      return String(
        field.subFieldRef || field.subFieldDef?.ref || field.ref || ""
      );
    },
    /** Id suelto (sin poblar) de un valor de referencia, o "" si no aplica. */
    groupRefBareId(field, value) {
      if (!field) return "";
      const type = field.subFieldType || field.type;
      if (type !== "reference" && type !== "users") return "";
      if (value == null || value === "") return "";
      if (typeof value === "object") {
        // Ya poblado: el formateador normal resuelve el nombre.
        if (value.name != null || value.label != null) return "";
        return value._id != null ? String(value._id) : "";
      }
      const text = String(value).trim();
      return MONGODB_OBJECT_ID_RE.test(text) ? text : "";
    },
    groupRefCacheKey(field, value) {
      const id = this.groupRefBareId(field, value);
      if (!id) return "";
      const refModel = this.groupRefModel(field);
      return refModel ? `${refModel}:${id}` : "";
    },
    /**
     * Resuelve los nombres de las referencias de la columna de agrupación.
     * Una petición por id distinto de la página, no por celda: el encabezado
     * es un computed sincrónico y no puede esperar como hace FieldReference.
     */
    async ensureGroupRefLabels(rows = null) {
      if (this.groupRefLabelsLoading) {
        // Que no se pierda un cambio de página llegado a mitad de carga.
        this._groupRefLabelsDirty = true;
        return;
      }
      this.groupRefLabelsLoading = true;
      try {
        await this.resolveGroupRefLabels(rows);
      } finally {
        this.groupRefLabelsLoading = false;
        if (this._groupRefLabelsDirty) {
          this._groupRefLabelsDirty = false;
          this.ensureGroupRefLabels();
        }
      }
    },
    /**
     * Resuelve los nombres sin guardia de concurrencia: el export tiene que
     * poder esperarlo aunque haya una carga de página en curso.
     */
    async resolveGroupRefLabels(rows = null) {
      const col = this.activeGroupColumn;
      if (!col || !col.field) return;
      const field = col.field;
      const refModel = this.groupRefModel(field);
      if (!refModel) return;

      const pending = new Map();
      (rows || this.items || []).forEach((item) => {
        const value = this.getFieldValue(item, field);
        const id = this.groupRefBareId(field, value);
        if (!id) return;
        const cacheKey = `${refModel}:${id}`;
        if (this.groupRefLabelCache[cacheKey] === undefined) {
          pending.set(cacheKey, id);
        }
      });
      if (!pending.size) return;

      if (refModel.toLowerCase() === "users") {
        await this.loadGroupUserLabels(refModel, pending);
      } else {
        await this.loadGroupReferenceLabels(refModel, pending);
      }
    },
    /**
     * Filas del Excel: cabecera y datos, y si hay agrupación activa una fila
     * de encabezado antes de cada grupo, igual que en pantalla. Comparte el
     * orden y la segmentación con el listado.
     * @returns {{ exportData: Array, rowFillByIndex: Object }} `rowFillByIndex`
     *   pinta las filas de grupo para que se vea qué filas caen bajo cada una.
     */
    async buildExcelExportData(allItems) {
      const columnPlan = this.buildExcelExportColumnPlan();
      const exportData = [columnPlan.map((c) => c.header)];

      const groupCol = this.activeGroupColumn;
      let rows = allItems || [];
      let groupHeaders = null;
      if (groupCol) {
        // El export trae todo el dataset, no solo la página: hay que resolver
        // los nombres de esos grupos antes de ordenar por etiqueta.
        await this.resolveGroupRefLabels(rows);
        rows = this.sortRowsByGroupColumn(rows, groupCol);
        groupHeaders = this.buildGroupHeaders(rows, groupCol);
      }

      const rowFillByIndex = {};
      rows.forEach((item, index) => {
        const header = groupHeaders && groupHeaders[index];
        if (header) {
          const groupRow = new Array(columnPlan.length).fill("");
          groupRow[0] = `${header.label} (${header.count})`;
          // Se pinta antes de push: el índice es la posición en `exportData`.
          rowFillByIndex[exportData.length] = EXCEL_GROUP_ROW_FILL_ARGB;
          exportData.push(groupRow);
        }
        exportData.push(
          columnPlan.map((col) => this.getExcelExportCellValue(item, col))
        );
      });

      return { exportData, rowFillByIndex };
    },
    async loadGroupReferenceLabels(refModel, pending) {
      const entries = [...pending.entries()];
      const capped = entries.slice(0, GROUP_REF_LABEL_MAX_IDS);
      if (capped.length < entries.length) {
        console.warn(
          `[ensureGroupRefLabels] ${entries.length - capped.length} grupos sin ` +
            `resolver: el tope es ${GROUP_REF_LABEL_MAX_IDS} ids distintos.`
        );
      }

      // El listado acepta `_id=a,b,c` como $in: un lote por petición en vez
      // de una petición por id como hace FieldReference celda a celda.
      for (let i = 0; i < capped.length; i += GROUP_REF_LABEL_BATCH_SIZE) {
        const batch = capped.slice(i, i + GROUP_REF_LABEL_BATCH_SIZE);
        const ids = batch.map(([, id]) => id);
        let byId = new Map();
        try {
          const { data } = await wencesApi.get(
            `/api/gotrading/dynamic/${refModel}`,
            { params: { _id: ids.join(","), all: "true" } }
          );
          const items = Array.isArray(data) ? data : data?.items || [];
          byId = new Map(items.map((it) => [String(it._id), it]));
        } catch (error) {
          console.warn(
            `[ensureGroupRefLabels] ${refModel} (${ids.length} ids):`,
            error?.message
          );
        }
        // Se cachea "" en los que no volvieron para no reintentar cada render.
        batch.forEach(([cacheKey, id]) => {
          const found = byId.get(id);
          this.$set(
            this.groupRefLabelCache,
            cacheKey,
            found ? found.name || found.label || "" : ""
          );
        });
      }
    },
    /** Los usuarios no viven en /dynamic: una sola petición para todos. */
    async loadGroupUserLabels(refModel, pending) {
      try {
        const { data } = await wencesApi.get("/api/users/all");
        const users = Array.isArray(data) ? data : data?.users || [];
        const byId = new Map(users.map((u) => [String(u._id), u]));
        pending.forEach((id, cacheKey) => {
          const user = byId.get(id);
          this.$set(
            this.groupRefLabelCache,
            cacheKey,
            user ? user.name || user.username || user.email || "" : ""
          );
        });
      } catch (error) {
        console.warn("[ensureGroupRefLabels] users:", error?.message);
        pending.forEach((id, cacheKey) => {
          this.$set(this.groupRefLabelCache, cacheKey, "");
        });
      }
    },
    /** Cambia la columna de agrupación; si hay un reporte cargado, lo persiste. */
    async handleGroupByFieldChange(fieldKey) {
      this.reportGroupByField = fieldKey || "";
      if (this.currentLoadedReport?._id) {
        await this.saveCurrentLoadedReport({ showSuccess: false });
      }
    },
    async handleReportColumnLayoutChanged(layout) {
      this.reportColumnLayout = layout || { groups: [], merges: [] };
      this.$nextTick(() => this.scheduleUpdateListHorizontalScroll());
      if (this.currentLoadedReport?._id) {
        await this.saveCurrentLoadedReport();
      }
    },
    async saveCurrentLoadedReport({ showSuccess = true } = {}) {
      if (!this.currentLoadedReport?._id) return;
      if (this._applyingReport) return;
      if (this.isSavingPreferences) return;

      this.isSavingPreferences = true;
      try {
        const reportData = this.currentReportData;
        const updatePayload = {
          columns: reportData.columns,
          columnOrder: reportData.columnOrder,
          columnWidths: reportData.columnWidths,
          columnLabels: reportData.columnLabels,
          columnDescriptions: reportData.columnDescriptions,
          columnEmphasis: reportData.columnEmphasis,
          columnTotals: reportData.columnTotals,
          columnLayout: reportData.columnLayout,
          pinnedColumnKeys: reportData.pinnedColumnKeys,
          groupByField: reportData.groupByField,
          filters: reportData.filters,
          selectedFilterFields: reportData.selectedFilterFields,
          sortField: reportData.sortField,
          sortOrder: reportData.sortOrder,
          pagination: reportData.pagination,
        };

        await wencesApi.put(
          `/api/gotrading/reports/${this.currentLoadedReport._id}`,
          updatePayload
        );

        this.currentLoadedReport = {
          ...this.currentLoadedReport,
          ...updatePayload,
        };
        this.updateSavedState();

        if (showSuccess) {
          Swal.fire({
            icon: "success",
            title: this.$tn("success"),
            text: this.$tn("ReportUpdatedSuccessfully"),
            timer: 2000,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("Error saving report:", error);
        Swal.fire({
          icon: "error",
          title: this.$tn("error"),
          text:
            error.response?.data?.error || this.$tn("ErrorUpdatingReport"),
        });
        throw error;
      } finally {
        this.isSavingPreferences = false;
      }
    },
    getReportColumnGroupForCol(col) {
      if (!col?.key) return null;
      const groups = this.reportColumnLayout?.groups || [];
      for (const g of groups) {
        if ((g.members || []).includes(col.key)) return g;
      }
      return null;
    },
    reportColumnGroupStyle(color) {
      if (!color) return {};
      return { "--report-group-color": color };
    },
    reportColumnHeaderThStyle(col) {
      const group = this.getReportColumnGroupForCol(col);
      if (group?.color) {
        return this.reportColumnGroupStyle(group.color);
      }
      return {};
    },
    reportColumnBodyTdStyle(col) {
      const group = this.getReportColumnGroupForCol(col);
      if (group?.color) {
        return this.reportColumnGroupStyle(group.color);
      }
      return {};
    },
    isReportColumnEmphasized(fieldKey) {
      return !!(
        fieldKey &&
        this.reportColumnEmphasis &&
        this.reportColumnEmphasis[fieldKey]
      );
    },
    isReportColumnTotalEnabled(fieldKey) {
      return !!(
        fieldKey &&
        this.reportColumnTotals &&
        this.reportColumnTotals[fieldKey]
      );
    },
    reportColumnBodyEmphasisClass(col) {
      if (!col) return "";
      if (col.displayType === "field") {
        return this.isReportColumnEmphasized(col.field?.key)
          ? "report-column-emphasis"
          : "";
      }
      if (col.displayType === "merged" && col.mode === "sum") {
        return this.isReportColumnEmphasized(col.fields?.[0]?.key)
          ? "report-column-emphasis"
          : "";
      }
      return "";
    },
    /** Tooltip del campo (ModelDefinition.fields[].tooltip) para ayuda en columnas. */
    columnFieldTooltip(field) {
      if (!field) return "";
      const candidates = [
        field.tooltip,
        field.subFieldDef?.tooltip,
        field.nestedSubFieldDef?.tooltip,
      ];
      for (const value of candidates) {
        if (value != null && String(value).trim() !== "") {
          return String(value).trim();
        }
      }
      return "";
    },
    /**
     * Ayuda del icono «?» de una columna del listado.
     *
     * Gana la que el usuario escribió en el reporte (columnDescriptions) sobre la que
     * define el ModelDefinition, porque es la que describe *esta* columna de *este*
     * reporte. Sirve para columnas de campo y para columnas unidas: las unidas no tienen
     * field, solo key. Devuelve "" cuando no hay nada, y con eso el icono no se
     * renderiza.
     */
    columnHelpTooltip(col) {
      if (!col) return "";
      const own = this.reportColumnDescriptionFor(col);
      if (own) return own;
      return col.displayType === "field" ? this.columnFieldTooltip(col.field) : "";
    },
    /** Ayuda guardada para esta columna, en el reporte o en las preferencias del listado. */
    reportColumnDescriptionFor(col) {
      if (!col) return "";
      const value = this.reportColumnDescriptions?.[col.key];
      return value != null && String(value).trim() !== "" ? String(value).trim() : "";
    },
    /**
     * Ayuda de la columna: el texto que ve el usuario en el icono «?» de la cabecera.
     *
     * Se guarda en el reporte, o en las preferencias del usuario si es el listado (no en
     * el ModelDefinition), así que la escribe quien lo usa, sin pasar por un
     * desarrollador. Vacío borra la ayuda y con eso desaparece el icono. Queda
     * pendiente hasta que se guarda, igual que el título personalizado.
     */
    async openEditReportColumnDescription(col) {
      if (!col) return;
      const key = col.key;
      // La ayuda que el usuario ve puede venir del ModelDefinition: se precarga esa, como
      // hace el modal de renombrar con el nombre por defecto, para editar lo que está a la
      // vista en vez de arrancar en blanco sobre una columna que ya se explica.
      const inheritedText =
        col.displayType === "field" ? this.columnFieldTooltip(col.field) : "";
      const inputValue = this.reportColumnDescriptions[key] || inheritedText;
      const escapeHtml = (value) =>
        String(value || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      const columnName = escapeHtml(this.tableColumnHeaderTextForCol(col));

      const { value, isConfirmed } = await Swal.fire({
        title: this.$tn("editColumnDescription"),
        html: `<p class="text-muted small mb-2">${this.$tn(
          "editColumnDescriptionHint"
        )}</p>
        <p class="small mb-0"><strong>${columnName}</strong></p>`,
        input: "textarea",
        inputValue,
        inputAttributes: {
          rows: 4,
          "aria-label": this.$tn("editColumnDescription"),
        },
        showCancelButton: true,
        confirmButtonText: this.$tn("Save"),
        cancelButtonText: this.$tn("Cancel"),
      });

      if (!isConfirmed) return;
      const trimmed = value != null ? String(value).trim() : "";
      // Vacío, o igual a la del ModelDefinition, no guarda nada: la columna vuelve a
      // heredar la de siempre en vez de quedar con una copia que no se actualiza sola.
      if (!trimmed || trimmed === inheritedText) {
        this.$delete(this.reportColumnDescriptions, key);
      } else {
        this.$set(this.reportColumnDescriptions, key, trimmed);
      }
    },
    async openEditReportColumnLabel(field) {
      if (!field) return;
      const key = field.key;
      const defaultText = this.baseTableColumnHeaderText(field);
      const currentCustom = this.reportColumnLabels[key];
      const inputValue =
        currentCustom !== undefined && currentCustom !== ""
          ? currentCustom
          : defaultText;
      const emphasisChecked = this.isReportColumnEmphasized(key);
      const showTotalChecked = this.isReportColumnTotalEnabled(key);
      const canShowTotal = isSummableListField(field);
      // Agrupar por columna: solo en reportes y sobre columnas no unidas.
      const canGroupBy =
        !!this.currentLoadedReport &&
        this.groupableColumns.some((c) => c.key === key);
      const groupByChecked = this.reportGroupByField === key;

      const { value, isConfirmed } = await Swal.fire({
        title: this.$tn("editColumnDisplayName"),
        html: `<p class="text-muted small mb-2">${this.$tn(
          "editColumnDisplayNameHint"
        )}</p>
        <div class="d-flex flex-wrap gap-2 justify-content-center mb-1">
          <button type="button" id="swal-col-move-start" class="btn btn-sm btn-outline-secondary">
            <i class="fas fa-angle-double-left me-1" aria-hidden="true"></i>${this.$tn(
              "editColumnMoveToStart"
            )}
          </button>
          <button type="button" id="swal-col-move-end" class="btn btn-sm btn-outline-secondary">
            ${this.$tn("editColumnMoveToEnd")}<i class="fas fa-angle-double-right ms-1" aria-hidden="true"></i>
          </button>
        </div>
        <label for="swal-col-emphasis" class="d-flex align-items-center justify-content-center gap-2 mt-2 mb-0 user-select-none">
          <input type="checkbox" id="swal-col-emphasis" class="form-check-input m-0"${emphasisChecked ? " checked" : ""}>
          <span>${this.$tn("editColumnDisplayBold")}</span>
        </label>${
          canShowTotal
            ? `<label for="swal-col-total" class="d-flex align-items-center justify-content-center gap-2 mt-2 mb-0 user-select-none">
          <input type="checkbox" id="swal-col-total" class="form-check-input m-0"${
            showTotalChecked ? " checked" : ""
          }>
          <span>${this.$tn("editColumnShowTotal")}</span>
        </label>`
            : ""
        }${
          canGroupBy
            ? `<label for="swal-col-groupby" class="d-flex align-items-center justify-content-center gap-2 mt-2 mb-0 user-select-none">
          <input type="checkbox" id="swal-col-groupby" class="form-check-input m-0"${
            groupByChecked ? " checked" : ""
          }>
          <span>${this.$tn("editColumnGroupBy")}</span>
        </label>`
            : ""
        }`,
        input: "text",
        inputValue,
        showCancelButton: true,
        confirmButtonText: this.$tn("Save"),
        cancelButtonText: this.$tn("Cancel"),
        didOpen: (popup) => {
          const startBtn = popup.querySelector("#swal-col-move-start");
          const endBtn = popup.querySelector("#swal-col-move-end");
          const syncMoveButtons = () => {
            const cols = this.displayTableColumns;
            const idx = cols.findIndex(
              (c) => c.displayType === "field" && c.field?.key === key
            );
            if (startBtn) startBtn.disabled = idx <= 0;
            if (endBtn) endBtn.disabled = idx < 0 || idx >= cols.length - 1;
          };
          syncMoveButtons();
          startBtn?.addEventListener("click", () => {
            this.moveDisplayColumnToStart(key);
            this.$nextTick(syncMoveButtons);
          });
          endBtn?.addEventListener("click", () => {
            this.moveDisplayColumnToEnd(key);
            this.$nextTick(syncMoveButtons);
          });
        },
        inputValidator: (v) => {
          if (v != null && String(v).length > 200) {
            return this.$tn("editColumnDisplayNameTooLong");
          }
          return null;
        },
      });

      if (!isConfirmed) return;
      const trimmed = value != null ? String(value).trim() : "";
      if (!trimmed || trimmed === defaultText) {
        this.$delete(this.reportColumnLabels, key);
      } else {
        this.$set(this.reportColumnLabels, key, trimmed);
      }
      const emphasisEl = document.getElementById("swal-col-emphasis");
      const emphasisOn = !!(emphasisEl && emphasisEl.checked);
      if (emphasisOn) {
        this.$set(this.reportColumnEmphasis, key, true);
      } else {
        this.$delete(this.reportColumnEmphasis, key);
      }
      const totalEl = document.getElementById("swal-col-total");
      if (totalEl) {
        const totalOn = !!totalEl.checked;
        if (totalOn) {
          this.$set(this.reportColumnTotals, key, true);
        } else {
          this.$delete(this.reportColumnTotals, key);
        }
      }
      const groupByEl = document.getElementById("swal-col-groupby");
      if (groupByEl) {
        // Marcado agrupa por esta columna; desmarcado solo desagrupa si era la activa.
        const nextGroupBy = groupByEl.checked
          ? key
          : this.reportGroupByField === key
          ? ""
          : this.reportGroupByField;
        if (nextGroupBy !== this.reportGroupByField) {
          await this.handleGroupByFieldChange(nextGroupBy);
        }
      }
      this.refreshList();
    },
    addSystemFieldsToModelFields() {
      // Add system fields for filtering if they don't already exist
      const systemFields = [
        {
          key: "createdAt",
          label: "CreationDate",
          type: "date",
          isSystemField: true,
        },
        {
          key: "createdBy",
          label: "CreatedBy",
          type: "reference",
          ref: "users",
          isSystemField: true,
        },
        {
          key: "updatedAt",
          label: "UpdateDate",
          type: "date",
          isSystemField: true,
        },
        {
          key: "updatedBy",
          label: "UpdatedBy",
          type: "reference",
          ref: "users",
          isSystemField: true,
        },
        {
          key: "_hasRelatedContent",
          label: "Has Related Content",
          type: "boolean",
          isSystemField: true,
          isSpecialFilter: true,
        },
      ];

      systemFields.forEach((sysField) => {
        if (!this.modelFields.find((f) => f.key === sysField.key)) {
          this.modelFields.push(sysField);
        }
      });

      this.syncHiddenFilterField();
    },
    /**
     * Filtros de módulo (p. ej. "Saldo al" del financiero en Contactos): el
     * backend dice cuáles ofrece este modelo en el tenant, y entran como un
     * campo filtrable más, no como columna (igual que "Has Related Content").
     * Tienen que estar antes de restaurar filtros de la URL o de un reporte:
     * una clave que no es campo se descarta.
     */
    async addListModuleFiltersToModelFields() {
      if (!this.selectedModel || this.selectedModelData?.isGroupModel) return;
      try {
        const { data } = await wencesApi.get(
          `/api/gotrading/dynamic/${this.selectedModel}/module-filters`
        );
        (data?.filters || []).forEach((moduleFilter) => {
          if (this.modelFields.some((f) => f.key === moduleFilter.key)) return;
          this.modelFields.push({
            key: moduleFilter.key,
            label: moduleFilter.label,
            type: moduleFilter.type,
            filterOperators: moduleFilter.operators,
            filterRangeOnly: moduleFilter.rangeOnly === true,
            overridesField: moduleFilter.overridesField,
            isSystemField: true,
            isSpecialFilter: true,
            isModuleFilter: true,
          });
        });
      } catch (error) {
        console.error("Error loading list module filters:", error);
      }
    },
    async loadTableFields() {
      const defaultFields = [
        { key: "createdAt", label: "CreationDate", type: "date" },
        {
          key: "createdBy",
          label: "CreatedBy",
          type: "reference",
          ref: "users",
        },
        { key: "updatedAt", label: "UpdateDate", type: "date" },
        {
          key: "updatedBy",
          label: "UpdatedBy",
          type: "reference",
          ref: "users",
        },
      ];
      if (!this.view) {
        defaultFields.push({ key: "modelId", label: "ID", type: "number" }); // ID is already a standard key
      }

      // Filtrar campos ocultos (hideDisplay = true) y excluir campos de sistema
      // (ya que los campos de sistema se agregan en defaultFields)
      const defaultFieldKeys = defaultFields.map((f) => f.key);
      const visibleModelFields = this.modelFields.filter(
        (field) =>
          !field.hideDisplay &&
          !field.isSpecialFilter &&
          !defaultFieldKeys.includes(field.key)
      );

      this.tableFields = [...defaultFields, ...visibleModelFields];
      this.nonGroupFields = this.tableFields.filter(
        (field) => field.type !== "group"
      );
      this.groupFields = this.tableFields.filter(
        (field) => field.type === "group"
      );
    },
    /**
     * Etiqueta de columna anidada: "Hoja (Raíz > … > padre)" en lugar de "Raíz → … → Hoja".
     */
    formatNestedColumnLabelFromParts(leafLabel, pathSegments) {
      const leaf = (leafLabel != null ? String(leafLabel) : "").trim();
      const path = (pathSegments || [])
        .map((s) => (s != null ? String(s).trim() : ""))
        .filter(Boolean);
      if (!leaf) return path.length ? `(${path.join(" > ")})` : "";
      if (!path.length) return leaf;
      return `${leaf} (${path.join(" > ")})`;
    },
    async loadVisibleTableFields() {
      this.visibleTableFields = [];
      const existingFields = [];

      // Agregar campos normales (excluyendo campos ocultos)
      for (const field of this.nonGroupFields) {
        // Solo mostrar si está explícitamente marcado como true
        if (this.selectedColumns[field.key] === true && !field.hideDisplay) {
          if (field.key == "parent") {
            if (this.modelFields.find((m) => m.key === field.key)?.ref) {
              field.order = 0;
              existingFields.push(field.key);
              this.visibleTableFields.push(field);
            }
          }

          if (existingFields.includes(field.key)) {
            continue;
          }
          existingFields.push(field.key);

          // Agregar la propiedad shouldSum si el campo es array y numérico
          const fieldWithSum = {
            ...field,
            shouldSum: this.selectedColumns._columnSums?.[field.key] === true,
          };

          this.visibleTableFields.push(fieldWithSum);
        }

        // Agregar subcampos de reference seleccionados
        if (field.type === "reference" && field.ref) {
          const subFieldKeys = Object.keys(this.selectedColumns).filter(
            (key) =>
              key.startsWith(`${field.key}.`) &&
              this.selectedColumns[key] === true
          );

          if (subFieldKeys.length > 0) {
            console.log(
              "[loadVisibleTableFields] 🔍 Procesando subcampos de referencia",
              {
                fieldKey: field.key,
                ref: field.ref,
                subFieldKeys: subFieldKeys,
              }
            );

            // Cargar la model definition del modelo referenciado si hay subcampos seleccionados
            const refModelDef = await this.getModelDefinition(field.ref);

            for (const key of subFieldKeys) {
              const subFieldPath = key.replace(`${field.key}.`, "");
              if (!existingFields.includes(key)) {
                existingFields.push(key);

                // Verificar si el subcampo tiene anidación (ej: products.product)
                const subFieldParts = subFieldPath.split(".");
                const firstSubFieldKey = subFieldParts[0];

                // Buscar la definición del primer subcampo
                let subFieldDef =
                  refModelDef?.fields?.find(
                    (f) => f.key === firstSubFieldKey
                  ) ||
                  findReferenceSystemSubField(firstSubFieldKey) ||
                  {};

                // Si hay más niveles de anidación (ej: products.product)
                let nestedFieldDef = null;
                let nestedFieldKey = null;
                if (subFieldParts.length > 1) {
                  nestedFieldKey = subFieldParts.slice(1).join(".");

                  console.log(
                    "[loadVisibleTableFields] 🔍 Detectado campo anidado de doble nivel",
                    {
                      fieldKey: key,
                      parentField: field.key,
                      subFieldPath: subFieldPath,
                      firstSubFieldKey: firstSubFieldKey,
                      nestedFieldKey: nestedFieldKey,
                      subFieldDef: {
                        type: subFieldDef.type,
                        ref: subFieldDef.ref,
                        isArray: subFieldDef.isArray,
                      },
                    }
                  );

                  // Si el primer subcampo es un array de reference, buscar el campo anidado
                  if (
                    subFieldDef.type === "reference" &&
                    subFieldDef.ref &&
                    subFieldDef.isArray
                  ) {
                    const nestedRefModelDef = await this.getModelDefinition(
                      subFieldDef.ref
                    );
                    if (nestedRefModelDef) {
                      // Buscar el campo anidado (ej: product dentro de products)
                      nestedFieldDef =
                        nestedRefModelDef.fields?.find(
                          (f) => f.key === nestedFieldKey
                        ) || {};
                      console.log(
                        "[loadVisibleTableFields] ✅ Campo anidado encontrado",
                        {
                          nestedFieldKey: nestedFieldKey,
                          nestedFieldDef: nestedFieldDef,
                        }
                      );
                    } else {
                      console.log(
                        "[loadVisibleTableFields] ⚠️ No se encontró definición del modelo anidado",
                        {
                          ref: subFieldDef.ref,
                        }
                      );
                    }
                  } else {
                    console.log(
                      "[loadVisibleTableFields] ⚠️ El subcampo no es un array de reference",
                      {
                        type: subFieldDef.type,
                        ref: subFieldDef.ref,
                        isArray: subFieldDef.isArray,
                      }
                    );
                  }
                }

                const effectiveSubDef = nestedFieldDef || subFieldDef;
                const effectiveSubType = nestedFieldDef
                  ? nestedFieldDef.type
                  : subFieldDef.type;
                // Campo derivado de grupo multivalor: enlaza varias filas del grupo con el
                // mismo valor de display (ver syncGroupDisplayFields en el back). Se detecta
                // por estructura — clave `<grupo>_<valor>` y ref al modelo del grupo — y no
                // solo por `isDerivedField`, que las definiciones viejas no traen. Así queda
                // afuera cualquier referencia array normal (collect, collects_only_shipping…).
                const derivedRefIsMultiValue =
                  field.isArray === true &&
                  (field.isDerivedField === true ||
                    this.modelFields.some(
                      (groupField) =>
                        groupField &&
                        groupField.type === "group" &&
                        groupField.isArray === true &&
                        groupField.groupDisplayField &&
                        field.key !== groupField.key &&
                        field.key.startsWith(`${groupField.key}_`) &&
                        String(field.ref || "").endsWith(`_${groupField.key}`)
                    ));
                // List edit via derived reference (ej. expenses_courrier.date/amount/invoice/type)
                const canListEditRefScalar =
                  !nestedFieldKey &&
                  !(subFieldDef.isArray === true) &&
                  !!effectiveSubDef.listedit &&
                  [
                    "date",
                    "datetime",
                    "text",
                    "string",
                    "email",
                    "textarea",
                    "number",
                    "list",
                    "file",
                  ].includes(effectiveSubType) &&
                  !!field.ref;

                this.visibleTableFields.push({
                  key: key,
                  label: nestedFieldDef
                    ? this.formatNestedColumnLabelFromParts(
                        nestedFieldDef.label
                          ? this.$t(nestedFieldDef.label)
                          : nestedFieldKey,
                        [
                          this.$t(field.label),
                          subFieldDef.label
                            ? this.$t(subFieldDef.label)
                            : firstSubFieldKey,
                        ]
                      )
                    : this.formatNestedColumnLabelFromParts(
                        subFieldDef.label
                          ? this.$t(subFieldDef.label)
                          : subFieldPath,
                        [this.$t(field.label)]
                      ),
                  type: "reference_subfield",
                  parentField: field,
                  subFieldKey: firstSubFieldKey, // Primer nivel (ej: products)
                  nestedFieldKey: nestedFieldKey, // Segundo nivel si existe (ej: product)
                  subFieldType: effectiveSubType,
                  subFieldRef: nestedFieldDef
                    ? nestedFieldDef.ref
                    : subFieldDef.ref,
                  subFieldListType: nestedFieldDef
                    ? nestedFieldDef.listType
                    : subFieldDef.listType,
                  subFieldListRef: nestedFieldDef
                    ? nestedFieldDef.listRef
                    : subFieldDef.listRef,
                  subFieldDef: effectiveSubDef, // Definición completa del subcampo para formato
                  nestedSubFieldDef: nestedFieldDef, // Definición del campo anidado
                  ref: field.ref,
                  // Multivalor: el primer subcampo es array, o el campo es una referencia
                  // derivada de grupo que enlaza varias filas (ej. dos Broker Commission en
                  // expenses_broker_commission). En ambos casos la celda muestra una línea
                  // por valor y admite suma con _columnSums. El gate mira isDerivedField
                  // para no cambiar el render de las referencias array normales
                  // (collect.date, collects_only_shipping.date…).
                  isArray: subFieldDef.isArray === true || derivedRefIsMultiValue,
                  refIsArray: derivedRefIsMultiValue,
                  listedit: canListEditRefScalar,
                  shouldSum: this.selectedColumns._columnSums?.[key] === true, // Agregar shouldSum si el campo es array y numérico
                });
              }
            }
          }
        }

        // Agregar subcampos de group seleccionados (ej: productandprice.products.product)
        if (field.type === "group" && field.fields) {
          const subFieldKeys = Object.keys(this.selectedColumns).filter(
            (key) =>
              key.startsWith(`${field.key}.`) &&
              this.selectedColumns[key] === true
          );

          if (subFieldKeys.length > 0) {
            console.log(
              "[loadVisibleTableFields] 🔍 Procesando subcampos de grupo",
              {
                fieldKey: field.key,
                type: field.type,
                subFieldKeys: subFieldKeys,
              }
            );

            for (const key of subFieldKeys) {
              const subFieldPath = key.replace(`${field.key}.`, "");
              if (!existingFields.includes(key)) {
                existingFields.push(key);

                // Verificar si el subcampo tiene anidación (ej: products.product)
                const subFieldParts = subFieldPath.split(".");
                const firstSubFieldKey = subFieldParts[0];

                // Buscar la definición del primer subcampo dentro del grupo
                let subFieldDef =
                  field.fields?.find((f) => f.key === firstSubFieldKey) || {};

                // Si hay más niveles de anidación (ej: products.product)
                let nestedFieldDef = null;
                let nestedFieldKey = null;
                if (subFieldParts.length > 1) {
                  nestedFieldKey = subFieldParts.slice(1).join(".");

                  console.log(
                    "[loadVisibleTableFields] 🔍 Detectado campo anidado de doble nivel en grupo",
                    {
                      fieldKey: key,
                      parentField: field.key,
                      subFieldPath: subFieldPath,
                      firstSubFieldKey: firstSubFieldKey,
                      nestedFieldKey: nestedFieldKey,
                      subFieldDef: {
                        type: subFieldDef.type,
                        ref: subFieldDef.ref,
                        isArray: subFieldDef.isArray,
                      },
                    }
                  );

                  // Si el primer subcampo es un array de reference, buscar el campo anidado
                  if (
                    subFieldDef.type === "reference" &&
                    subFieldDef.ref &&
                    subFieldDef.isArray
                  ) {
                    const nestedRefModelDef = await this.getModelDefinition(
                      subFieldDef.ref
                    );
                    if (nestedRefModelDef) {
                      // Buscar el campo anidado (ej: product dentro de products)
                      nestedFieldDef =
                        nestedRefModelDef.fields?.find(
                          (f) => f.key === nestedFieldKey
                        ) || {};
                      console.log(
                        "[loadVisibleTableFields] ✅ Campo anidado encontrado en grupo",
                        {
                          nestedFieldKey: nestedFieldKey,
                          nestedFieldDef: nestedFieldDef,
                        }
                      );
                    } else {
                      console.log(
                        "[loadVisibleTableFields] ⚠️ No se encontró definición del modelo anidado en grupo",
                        {
                          ref: subFieldDef.ref,
                        }
                      );
                    }
                  } else {
                    console.log(
                      "[loadVisibleTableFields] ⚠️ El subcampo del grupo no es un array de reference",
                      {
                        type: subFieldDef.type,
                        ref: subFieldDef.ref,
                        isArray: subFieldDef.isArray,
                      }
                    );
                  }
                }

                this.visibleTableFields.push({
                  key: key,
                  label: nestedFieldDef
                    ? this.formatNestedColumnLabelFromParts(
                        nestedFieldDef.label
                          ? this.$t(nestedFieldDef.label)
                          : nestedFieldKey,
                        [
                          this.$t(field.label),
                          subFieldDef.label
                            ? this.$t(subFieldDef.label)
                            : firstSubFieldKey,
                        ]
                      )
                    : this.formatNestedColumnLabelFromParts(
                        subFieldDef.label
                          ? this.$t(subFieldDef.label)
                          : subFieldPath,
                        [this.$t(field.label)]
                      ),
                  type: "reference_subfield",
                  parentField: field,
                  subFieldKey: firstSubFieldKey, // Primer nivel (ej: products)
                  nestedFieldKey: nestedFieldKey, // Segundo nivel si existe (ej: product)
                  subFieldType: nestedFieldDef
                    ? nestedFieldDef.type
                    : subFieldDef.type,
                  subFieldRef: nestedFieldDef
                    ? nestedFieldDef.ref
                    : subFieldDef.ref,
                  subFieldListType: nestedFieldDef
                    ? nestedFieldDef.listType
                    : subFieldDef.listType,
                  subFieldListRef: nestedFieldDef
                    ? nestedFieldDef.listRef
                    : subFieldDef.listRef,
                  subFieldDef: nestedFieldDef || subFieldDef, // Definición completa del subcampo para formato
                  nestedSubFieldDef: nestedFieldDef, // Definición del campo anidado
                  ref: nestedFieldDef ? nestedFieldDef.ref : subFieldDef.ref, // Referencia del campo anidado (product) o del primer subcampo (products)
                  isArray: subFieldDef.isArray || false, // Si el primer subcampo es array
                  shouldSum: this.selectedColumns._columnSums?.[key] === true, // Agregar shouldSum si el campo es array y numérico
                });
              }
            }
          }
        }
      }
      // Función recursiva para filtrar campos de grupo incluyendo grupos anidados
      const filterGroupFields = (fields, basePath) => {
        if (!fields) return [];

        return fields
          .filter((subField) => {
            if (subField.hideDisplay) return false;
            const subFieldKey = `${basePath}.${subField.key}`;
            const subFieldValue = this.selectedColumns[subFieldKey];

            // Si está explícitamente deseleccionado, NO mostrar
            if (subFieldValue === false) return false;
            // Si está explícitamente seleccionado, mostrar
            if (subFieldValue === true) return true;

            // Si es un grupo anidado, verificar si tiene subcampos seleccionados
            if (subField.type === "group" && subField.fields) {
              const nestedPath = subFieldKey;
              const hasSelectedNested = subField.fields.some((nestedField) => {
                const nestedKey = `${nestedPath}.${nestedField.key}`;
                return this.selectedColumns[nestedKey] === true;
              });
              if (hasSelectedNested) return true;
            }

            return false;
          })
          .map((subField) => {
            // Si es un grupo anidado, filtrar sus campos recursivamente
            if (subField.type === "group" && subField.fields) {
              const nestedPath = `${basePath}.${subField.key}`;
              return {
                ...subField,
                fields: filterGroupFields(subField.fields, nestedPath),
              };
            }
            return subField;
          });
      };

      // Procesar subcampos de group seleccionados ANTES de filtrar (ej: productandprice.products.product)
      for (const field of this.groupFields) {
        if (field.type === "group" && field.fields) {
          const subFieldKeys = Object.keys(this.selectedColumns).filter(
            (key) =>
              key.startsWith(`${field.key}.`) &&
              this.selectedColumns[key] === true
          );

          if (subFieldKeys.length > 0) {
            console.log(
              "[loadVisibleTableFields] 🔍 Procesando subcampos de grupo (groupFields)",
              {
                fieldKey: field.key,
                type: field.type,
                subFieldKeys: subFieldKeys,
              }
            );

            for (const key of subFieldKeys) {
              const subFieldPath = key.replace(`${field.key}.`, "");
              if (existingFields.includes(key)) {
                continue;
              }

              const subFieldParts = subFieldPath.split(".");
              const resolvedGarr = this.resolveGroupArrayReferencePath(
                field,
                subFieldParts
              );

              // Subcampo simple de group (ej. expenses.file / expenses.date): lo maneja
              // processGroupSubFields como group_subfield + listedit. Este bloque es solo
              // para rutas anidadas (productandprice.products.product) o garr.
              if (!resolvedGarr && subFieldParts.length === 1) {
                continue;
              }

              existingFields.push(key);

              let firstSubFieldKey;
              let nestedFieldKey = null;
              let subFieldDef = {};
              let nestedFieldDef = null;

              if (resolvedGarr) {
                  const refRel = resolvedGarr.refRelPath;
                  firstSubFieldKey = refRel[0];
                  nestedFieldKey =
                    refRel.length > 1 ? refRel.slice(1).join(".") : null;
                  const refModelDef = await this.getModelDefinition(
                    resolvedGarr.refField.ref
                  );
                  subFieldDef =
                    refModelDef?.fields?.find(
                      (f) => f.key === firstSubFieldKey
                    ) ||
                    findReferenceSystemSubField(firstSubFieldKey) ||
                    {};
                  if (nestedFieldKey) {
                    nestedFieldDef = await this.resolveFieldDefAlongNestedPath(
                      subFieldDef,
                      nestedFieldKey
                    );
                  }
                  const garrPathPrefix = [
                    this.$t(field.label),
                    ...resolvedGarr.nestedGroups.map((g) =>
                      g.label ? this.$t(g.label) : g.key
                    ),
                    resolvedGarr.refField.label
                      ? this.$t(resolvedGarr.refField.label)
                      : resolvedGarr.refField.key,
                  ].filter(Boolean);
                  this.visibleTableFields.push({
                    key: key,
                    label: nestedFieldDef
                      ? this.formatNestedColumnLabelFromParts(
                          nestedFieldDef.label
                            ? this.$t(nestedFieldDef.label)
                            : nestedFieldKey,
                          [
                            ...garrPathPrefix,
                            subFieldDef.label
                              ? this.$t(subFieldDef.label)
                              : firstSubFieldKey,
                          ]
                        )
                      : this.formatNestedColumnLabelFromParts(
                          subFieldDef.label
                            ? this.$t(subFieldDef.label)
                            : firstSubFieldKey,
                          garrPathPrefix
                        ),
                    type: "reference_subfield",
                    parentField: field,
                    garrNestedGroups: resolvedGarr.nestedGroups,
                    garrRefField: resolvedGarr.refField,
                    subFieldKey: firstSubFieldKey,
                    nestedFieldKey: nestedFieldKey,
                    subFieldType: nestedFieldDef
                      ? nestedFieldDef.type
                      : subFieldDef.type,
                    subFieldRef: nestedFieldDef
                      ? nestedFieldDef.ref
                      : subFieldDef.ref,
                    subFieldListType: nestedFieldDef
                      ? nestedFieldDef.listType
                      : subFieldDef.listType,
                    subFieldListRef: nestedFieldDef
                      ? nestedFieldDef.listRef
                      : subFieldDef.listRef,
                    subFieldDef: nestedFieldDef || subFieldDef,
                    nestedSubFieldDef: nestedFieldDef,
                    ref: resolvedGarr.refField.ref,
                    isArray: true,
                    shouldSum: this.selectedColumns._columnSums?.[key] === true,
                  });
                  continue;
                }

                firstSubFieldKey = subFieldParts[0];

                // Buscar la definición del primer subcampo dentro del grupo
                subFieldDef =
                  field.fields?.find((f) => f.key === firstSubFieldKey) || {};

                // Si hay más niveles de anidación (ej: products.product)
                nestedFieldDef = null;
                nestedFieldKey = null;
                if (subFieldParts.length > 1) {
                  nestedFieldKey = subFieldParts.slice(1).join(".");

                  console.log(
                    "[loadVisibleTableFields] 🔍 Detectado campo anidado de doble nivel en grupo (groupFields)",
                    {
                      fieldKey: key,
                      parentField: field.key,
                      subFieldPath: subFieldPath,
                      firstSubFieldKey: firstSubFieldKey,
                      nestedFieldKey: nestedFieldKey,
                      subFieldDef: {
                        type: subFieldDef.type,
                        ref: subFieldDef.ref,
                        isArray: subFieldDef.isArray,
                      },
                    }
                  );

                  // Si el primer subcampo es un array de reference, buscar el campo anidado
                  if (
                    subFieldDef.type === "reference" &&
                    subFieldDef.ref &&
                    subFieldDef.isArray
                  ) {
                    const nestedRefModelDef = await this.getModelDefinition(
                      subFieldDef.ref
                    );
                    if (nestedRefModelDef) {
                      // Buscar el campo anidado (ej: product dentro de products)
                      nestedFieldDef =
                        nestedRefModelDef.fields?.find(
                          (f) => f.key === nestedFieldKey
                        ) || {};
                      console.log(
                        "[loadVisibleTableFields] ✅ Campo anidado encontrado en grupo (groupFields)",
                        {
                          nestedFieldKey: nestedFieldKey,
                          nestedFieldDef: nestedFieldDef,
                        }
                      );
                    } else {
                      console.log(
                        "[loadVisibleTableFields] ⚠️ No se encontró definición del modelo anidado en grupo (groupFields)",
                        {
                          ref: subFieldDef.ref,
                        }
                      );
                    }
                  } else if (
                    subFieldDef.type === "group" &&
                    subFieldDef.fields &&
                    subFieldDef.isArray
                  ) {
                    // Si el primer subcampo es un array de group, buscar el campo anidado dentro del group
                    const nestedFieldInGroup = subFieldDef.fields.find(
                      (f) => f.key === nestedFieldKey
                    );
                    if (nestedFieldInGroup) {
                      nestedFieldDef = nestedFieldInGroup;
                      console.log(
                        "[loadVisibleTableFields] ✅ Campo anidado encontrado en grupo (groupFields - group)",
                        {
                          nestedFieldKey: nestedFieldKey,
                          nestedFieldDef: nestedFieldDef,
                        }
                      );
                    } else {
                      console.log(
                        "[loadVisibleTableFields] ⚠️ Campo anidado no encontrado en grupo (groupFields - group)",
                        {
                          nestedFieldKey: nestedFieldKey,
                          availableFields: subFieldDef.fields.map((f) => f.key),
                        }
                      );
                    }
                  } else {
                    console.log(
                      "[loadVisibleTableFields] ⚠️ El subcampo del grupo no es un array de reference ni group (groupFields)",
                      {
                        type: subFieldDef.type,
                        ref: subFieldDef.ref,
                        isArray: subFieldDef.isArray,
                        hasFields: !!subFieldDef.fields,
                      }
                    );
                  }
                }

                this.visibleTableFields.push({
                  key: key,
                  label: nestedFieldDef
                    ? this.formatNestedColumnLabelFromParts(
                        nestedFieldDef.label
                          ? this.$t(nestedFieldDef.label)
                          : nestedFieldKey,
                        [
                          this.$t(field.label),
                          subFieldDef.label
                            ? this.$t(subFieldDef.label)
                            : firstSubFieldKey,
                        ]
                      )
                    : this.formatNestedColumnLabelFromParts(
                        subFieldDef.label
                          ? this.$t(subFieldDef.label)
                          : subFieldPath,
                        [this.$t(field.label)]
                      ),
                  type: "reference_subfield",
                  parentField: field,
                  subFieldKey: firstSubFieldKey, // Primer nivel (ej: products)
                  nestedFieldKey: nestedFieldKey, // Segundo nivel si existe (ej: product)
                  subFieldType: nestedFieldDef
                    ? nestedFieldDef.type
                    : subFieldDef.type,
                  subFieldRef: nestedFieldDef
                    ? nestedFieldDef.ref
                    : subFieldDef.ref,
                  subFieldListType: nestedFieldDef
                    ? nestedFieldDef.listType
                    : subFieldDef.listType,
                  subFieldListRef: nestedFieldDef
                    ? nestedFieldDef.listRef
                    : subFieldDef.listRef,
                  subFieldDef: nestedFieldDef || subFieldDef, // Definición completa del subcampo para formato
                  nestedSubFieldDef: nestedFieldDef, // Definición del campo anidado
                  ref: nestedFieldDef ? nestedFieldDef.ref : subFieldDef.ref, // Referencia del campo anidado (product) o del primer subcampo (products)
                  isArray: subFieldDef.isArray || false, // Si el primer subcampo es array
                  shouldSum: this.selectedColumns._columnSums?.[key] === true, // Agregar shouldSum si el campo es array y numérico
                });
            }
          }
        }
      }

      const filteredGroupFields = this.groupFields
        .map((field) => {
          const isGroupSelected = this.selectedColumns[field.key] === true;
          return {
            ...field,
            fields: filterGroupFields(field.fields, field.key).filter((f) => {
              // También verificar si el campo padre estaba seleccionado
              const subFieldKey = `${field.key}.${f.key}`;
              const subFieldValue = this.selectedColumns[subFieldKey];
              if (subFieldValue === false) return false;
              if (subFieldValue === true) return true;
              return isGroupSelected;
            }),
          };
        })
        .filter((field) => field.fields.length > 0);

      // Función recursiva para procesar subcampos de grupos (incluyendo grupos anidados)
      const processGroupSubFields = (
        groupField,
        basePath,
        parentGroupField = null,
        pathPrefixSegments = [],
        parentSubFieldGroup = null
      ) => {
        const selectedSubFields = groupField.fields.filter((subField) => {
          const subFieldKey = `${basePath}.${subField.key}`;
          return this.selectedColumns[subFieldKey] === true;
        });

        selectedSubFields.forEach((subField) => {
          const subFieldKey = `${basePath}.${subField.key}`;
          if (!existingFields.includes(subFieldKey)) {
            existingFields.push(subFieldKey);

            if (subField.type === "group" && subField.fields) {
              processGroupSubFields(
                subField,
                subFieldKey,
                parentGroupField || groupField,
                [
                  ...pathPrefixSegments,
                  groupField.label ? this.$t(groupField.label) : groupField.key,
                ],
                subField
              );
            } else {
              const pathSegs = [
                ...pathPrefixSegments,
                groupField.label ? this.$t(groupField.label) : groupField.key,
              ];
              const fullLabel = this.formatNestedColumnLabelFromParts(
                subField.label ? this.$t(subField.label) : subField.key,
                pathSegs
              );
              const rootGroup = parentGroupField || groupField;
              // List edit inline: date/text/number/list en group isArray de un nivel (sin group anidado)
              const canListEditGroupScalar =
                !!subField.listedit &&
                !parentSubFieldGroup &&
                rootGroup.isArray === true &&
                [
                  "date",
                  "datetime",
                  "text",
                  "string",
                  "email",
                  "textarea",
                  "number",
                  "list",
                  "file",
                ].includes(subField.type);
              this.visibleTableFields.push({
                key: subFieldKey,
                label: fullLabel,
                type: "group_subfield",
                parentField: rootGroup,
                parentSubField: parentSubFieldGroup,
                subFieldKey: subField.key,
                subFieldType: subField.type,
                subFieldRef: subField.ref,
                subFieldListType: subField.listType,
                subFieldListRef: subField.listRef,
                subFieldDef: subField,
                isArray: rootGroup.isArray,
                listedit: canListEditGroupScalar,
                shouldSum:
                  this.selectedColumns._columnSums?.[subFieldKey] === true,
              });
            }
          }
        });
      };

      // Procesar campos de grupo: crear columnas individuales para subcampos seleccionados
      filteredGroupFields.forEach((groupField) => {
        // Verificar si hay subcampos individuales seleccionados
        const selectedSubFields = groupField.fields.filter((subField) => {
          const subFieldKey = `${groupField.key}.${subField.key}`;
          return this.selectedColumns[subFieldKey] === true;
        });

        if (selectedSubFields.length > 0) {
          // Procesar recursivamente todos los subcampos (incluyendo grupos anidados)
          processGroupSubFields(groupField, groupField.key);
        } else if (
          this.selectedColumns[groupField.key] === true &&
          !groupField.hideDisplay
        ) {
          // Si no hay subcampos individuales seleccionados pero el grupo está seleccionado,
          // mostrar el grupo completo (comportamiento original)
          this.visibleTableFields.push(groupField);
        }
      });

      // Aplicar orden de columnas si existe
      if (this.savedColumnOrder && this.savedColumnOrder.length > 0) {
        this.applyColumnOrder();
      }

      // La columna de banderas arranca pegada a Actions. Si el usuario ya la
      // movió, el orden guardado manda y no se toca.
      if (
        this.modelHasCategoryField &&
        !(this.savedColumnOrder || []).includes("category")
      ) {
        const flagIndex = this.visibleTableFields.findIndex(
          (f) => f && f.key === "category"
        );
        if (flagIndex > 0) {
          const [flagField] = this.visibleTableFields.splice(flagIndex, 1);
          this.visibleTableFields.unshift(flagField);
        }
      }

      // Sin columnas visibles (p. ej. todas desmarcadas): mostrar al menos name o title
      if (this.visibleTableFields.length === 0) {
        const fallbackKeys = ["name", "title"];
        for (const key of fallbackKeys) {
          const field = this.nonGroupFields.find(
            (f) => f.key === key && !f.hideDisplay
          );
          if (field) {
            this.$set(this.selectedColumns, key, true);
            this.visibleTableFields.push({
              ...field,
              shouldSum: this.selectedColumns._columnSums?.[key] === true,
            });
            break;
          }
        }
      }
    },
    async getView() {
      const { data } = await wencesApi.get(
        `/api/gotrading/views/${this.effectiveViewId}`
      );
      this.view = data;
      this.selectedModelData = {};
      this.selectedModelData.visualGroup = {};
      this.selectedModelData.label = this.view.name;
    },
    async fetchModels(modelName = null) {
      try {
        // Si se especifica un modelo, cargar solo ese modelo para optimizar
        if (modelName) {
          const { data } = await wencesApi.get(
            `/api/gotrading/model-definitions/${modelName}`
          );
          // Convertir a array para mantener compatibilidad con el código existente
          this.models = [data];
          this.isModelsLoaded = true;
        } else {
          // Si no se especifica, cargar todos los modelos (para casos donde se necesite el selector)
          const { data } = await wencesApi.get(
            "/api/gotrading/model-definitions"
          );
          this.models = data;
          this.isModelsLoaded = true;
        }
      } catch (error) {
        console.error("Error loading models:", error);
        this.isModelsLoaded = false;
      }
    },
    isGroupModel() {
      // Si tiene fieldName en la ruta o es una view, es un modelo de grupo
      if (this.$route.params.fieldName || this.view) {
        return true;
      }

      // Si selectedModelData no existe o no tiene _id, es un modelo derivado (ej: shipping_expenses)
      // Los modelos principales de ModelDefinitions siempre tienen _id
      // Los modelos derivados vienen de campos tipo group de otros modelos
      if (!this.selectedModelData || !this.selectedModelData._id) {
        return true;
      }

      return false;
    },
    goEditItem(item) {
      this.$router.push({
        name: "DynamicModelEdit",
        params: { modelName: this.selectedModel, itemId: item._id },
      });
    },
    viewItem(item) {
      if (this.view) {
        return;
      }
      const title = item && (item.name || item.title) ? item.name || item.title : "";
      this.$router.push(
        buildDynamicModelItemViewPath(this.selectedModel, item._id, title)
      );
    },
    /** Id de proforma para ruta FOB operación (solo listado Proform; Negotiation puede tener muchas proformas). */
    resolveProformIdForFobRoute(item) {
      if (!item) return "";
      const m = String(this.selectedModel || "").toLowerCase();
      if (m === "proform" && item._id) return String(item._id);
      return "";
    },
    showFobOperacionRowAction(item) {
      if (!this.selectedModel || this.isGroupModel() || !item) return false;
      const m = String(this.selectedModel).toLowerCase();
      if (m !== "proform") return false;
      return !!this.resolveProformIdForFobRoute(item);
    },
    openFobOperacionView(item) {
      const pid = this.resolveProformIdForFobRoute(item);
      if (!pid) return;
      this.$router.push({
        name: "FobtradingOperacion",
        params: { proformId: pid },
      });
    },
    async loadModelFields() {
      // Si es una View de tipo query_report, obtener tipos de campos del Query Report
      if (this.view && this.view.type === "query_report") {
        console.log(
          "🔍 View de tipo query_report detectada, obteniendo tipos de campos del Query Report"
        );

        try {
          // Obtener el Query Report asociado para obtener los tipos de campos
          const queryReportResponse = await wencesApi.get(
            `/api/gotrading/query-reports/${this.view.queryReportId}`
          );
          const queryReport = queryReportResponse.data;

          console.log("✅ Query Report obtenido:", queryReport);
          console.log("📊 Campos del Query Report:", queryReport.fields);

          // Convertir los campos de la View usando la información del Query Report
          this.modelFields = this.view.fields.map((field) => {
            // Buscar el campo correspondiente en queryReport.fields
            const queryReportField = queryReport.fields[field.key];

            return {
              key: field.key,
              label: field.label || field.key,
              type: queryReportField?.type || "string", // Usar tipo del Query Report
              ref: queryReportField?.ref || "", // Referencia si es reference
              time: queryReportField?.time || false, // Si es date con tiempo
              order: field.order || 20,
              visible: field.visible !== false,
              showTotal: field.showTotal || false,
              showNegative: field.showNegative || false,
              renderAs: field.renderAs || "default",
              hideDisplay: false,
            };
          });

          console.log(
            "✅ Campos de View convertidos con tipos del Query Report:",
            this.modelFields
          );
          return;
        } catch (error) {
          console.error(
            "❌ Error obteniendo Query Report para tipos de campos:",
            error
          );

          // Fallback: usar tipos por defecto
          this.modelFields = this.view.fields.map((field) => ({
            key: field.key,
            label: field.label || field.key,
            type: "string", // Por defecto string
            order: field.order || 20,
            visible: field.visible !== false,
            showTotal: field.showTotal || false,
            showNegative: field.showNegative || false,
            renderAs: field.renderAs || "default",
            hideDisplay: false,
          }));

          console.log(
            "⚠️ Usando tipos por defecto debido a error:",
            this.modelFields
          );
          return;
        }
      }

      // Obtener todos los modelos únicos que necesitamos
      const uniqueModels = new Set();

      // Agregar el modelo principal
      if (this.view.modelName) {
        this.view.combinedViews.forEach((model) => {
          uniqueModels.add(model);
        });
      }

      // Agregar modelos de referencias si existen
      if (this.view.fields) {
        this.view.fields.forEach((field) => {
          if (field.type === "reference" && field.ref) {
            uniqueModels.add(field.ref);
          }
        });
      }

      const modelFields = [];
      const uniqueKeys = new Set();

      for (const modelName of uniqueModels) {
        let model = this.models.find(
          (m) => m.modelName.toLowerCase() === modelName.toLowerCase()
        );

        // Si el modelo no está cargado, cargarlo bajo demanda
        if (!model) {
          try {
            const { data } = await wencesApi.get(
              `/api/gotrading/model-definitions/${modelName}`
            );
            this.models.push(data);
            model = data;
          } catch (error) {
            console.error(`Error loading model ${modelName}:`, error);
            continue; // Saltar este modelo si no se puede cargar
          }
        }

        if (model && !this.view) {
          // Agregar los campos del modelo con un prefijo para identificar su origen
          const prefixedFields = model.fields
            .map((field) => ({
              ...field,
              key:
                modelName === this.view.modelName
                  ? field.key
                  : `${modelName}_${field.key}`,
              label: `${field.label || field.key}`,
            }))
            .filter((field) => {
              if (!uniqueKeys.has(field.key)) {
                uniqueKeys.add(field.key);
                return true;
              }
              return false;
            });

          prefixedFields.forEach((field) => {
            const fieldKey =
              modelName === this.view.modelName
                ? field.key
                : `${modelName}_${field.key}`;
            field.showNegative =
              this.view.fields.find((f) => f.key === fieldKey)?.showNegative ||
              false;
          });

          modelFields.push(...prefixedFields);
        } else {
          if (model && model.fields) {
            const prefixedFields = model.fields
              .map((field) => ({
                ...field,
                key: field.key,
                label: field.label,
              }))
              .filter((field) => {
                // Si es parent, lo incluimos
                if (field.key == "parent") {
                  if (!this.labelFields[field.key]) {
                    this.labelFields[field.key] = [];
                  }
                  this.labelFields[field.key].push(field.label);

                  if (
                    this.labelFields[field.key] &&
                    this.labelFields[field.key].length > 1
                  ) {
                    // Usar Set para eliminar duplicados y luego convertir a array
                    const uniqueLabels = [
                      ...new Set(this.labelFields[field.key]),
                    ];
                    const label = uniqueLabels.join(" / ");
                    field.label = label;
                  }
                }
                // Buscamos en view.fields si existe el campo
                let fieldExists = false;
                model.fields.forEach((viewField) => {
                  // Verificamos ambos formatos posibles
                  const correctKey =
                    modelName === this.view.modelName
                      ? field.key
                      : `${modelName}_${field.key}`;

                  if (
                    (viewField.key === `${modelName}_${field.key}` ||
                      viewField.key === field.key) &&
                    (this.view.fields.find(
                      (f) => f.key === `${modelName}_${field.key}`
                    ) !== undefined ||
                      this.view.fields.find((f) => f.key === viewField.key) !==
                        undefined)
                  ) {
                    fieldExists = true;
                    if (!field.order) {
                      field.order =
                        this.view.fields.find((f) => f.key === viewField.key)
                          ?.order || false;
                      if (field.order == false) {
                        field.order =
                          this.view.fields.find(
                            (f) => f.key === `${modelName}_${field.key}`
                          )?.order || false;
                      }
                    }
                  } else {
                    //PEPE
                  }
                });
                return fieldExists;
              });

            modelFields.push(...prefixedFields);
          }
        }
      }
      modelFields.sort((a, b) => {
        return a.order - b.order;
      });
      this.modelFields = modelFields;
    },
    async fetchViewFields() {
      this.modelFields = [];
      this.items = [];
      this.editingId = null;

      await this.getView();

      if (!this.view) return;

      // Cargar todos los modelos necesarios
      await this.loadModelFields();
      // Add system fields for filtering
      this.addSystemFieldsToModelFields();
      await this.loadTableFields();

      this.selectedModel = this.view._id;

      // Con reportId en la URL el reporte define columnas/orden/pins (evitar prefs de usuario)
      if (!this.$route.query?.reportId && !this.currentLoadedReport) {
        this.isLoadingColumnPreferences = true;
        const savedColumns = await this.loadColumnPreferences();
        this.selectedColumns = this.mergeNewColumns(savedColumns);

        await this.loadVisibleTableFields();
        this.loadPinnedColumnsForList();
        this.updateSavedState();
      }

      // Solo cargar items si no hay filtros en la URL (los filtros se manejan en initializeFromRoute)
      if (
        Object.keys(this.getFilterQueryParams(this.$route.query)).length === 0 &&
        !this.$route.query?.reportId
      ) {
        await this.fetchViewItems();
      }
    },
    async fetchFields() {
      this.modelFields = [];
      this.items = [];
      this.editingId = null;
      if (!this.selectedModel) return;

      const model = this.models.find(
        (m) => m.modelName.toLowerCase() === this.selectedModel.toLowerCase()
      );

      if (model) {
        this.selectedModelData = model;
        this.modelFields = Array.isArray(model.fields) ? [...model.fields] : [];
        // Para modelos de grupo, "name" existe en el esquema pero no en la model definition; añadirlo para listados
        if (
          model.isGroupModel &&
          !this.modelFields.some((f) => f.key === "name")
        ) {
          const parentIndex = this.modelFields.findIndex(
            (f) => f.key === "parent"
          );
          const insertAt = parentIndex >= 0 ? parentIndex + 1 : 0;
          this.modelFields.splice(insertAt, 0, {
            key: "name",
            type: "string",
            label: "Name",
            hideDisplay: false,
          });
        }
        // Add system fields for filtering
        this.addSystemFieldsToModelFields();
        await this.addListModuleFiltersToModelFields();
        await this.loadTableFields();

        const reportId = this.$route.query?.reportId;

        // Con reportId en la URL el reporte define columnas/orden/pins (evitar prefs de usuario)
        if (!reportId && !this.currentLoadedReport) {
          this.isLoadingColumnPreferences = true;
          const [savedColumns] = await Promise.all([
            this.loadColumnPreferences(),
            this.loadFilterPreferences(),
          ]);
          this.selectedColumns = this.mergeNewColumns(savedColumns);

          await this.loadVisibleTableFields();
          this.loadPinnedColumnsForList();
          this.initializeDefaultWidths();
          this.updateSavedState();
        }

        // Solo cargar items si no hay filtros en la URL (los filtros se manejan en initializeFromRoute)
        if (
          Object.keys(this.getFilterQueryParams(this.$route.query)).length === 0 &&
          !this.$route.query?.reportId
        ) {
          if (this.isArchiveView) {
            await this.refreshArchiveHasRecords();
          }
          await this.fetchItems();
        }

        this.ensureArchiveRouteAllowed();
        await this.loadCategoryCatalogIfNeeded();

        // OPTIMIZACIÓN: fetchReportViews() se carga de forma lazy cuando se abre el modal
        // No es necesario cargarlo aquí para mostrar el listado inicial
        // this.fetchReportViews();
      }
    },
    /**
     * Filtros fijos del listado embebido: se aplican siempre y pisan lo que el usuario
     * haya filtrado por esa misma clave (acotan el listado, no son un filtro más).
     */
    appendFixedFilterParams(params) {
      if (!this.paramFilters) return;
      Object.entries(this.paramFilters).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "") return;
        params.delete(key);
        params.append(
          key,
          Array.isArray(value) ? value.join(",") : String(value)
        );
      });
    },
    /**
     * Pide el listado. Si la query no entra en la URL (una selección de cientos de ids
     * pasa los 20 KB) el server corta con 431: en ese caso va por POST, mismo contrato.
     */
    async requestDynamicListItems(modelName, params, config = undefined) {
      const queryString = params.toString();
      const base = `/api/gotrading/dynamic/${modelName}`;
      if (queryString.length <= 6000) {
        const { data } = await wencesApi.get(`${base}?${queryString}`, config);
        return data;
      }
      const body = {};
      params.forEach((value, key) => {
        body[key] = value;
      });
      const { data } = await wencesApi.post(`${base}/list`, body, config);
      return data;
    },
    async fetchViewItems(queryString = "") {
      // Prevenir múltiples llamadas simultáneas
      if (this.isFetchingItems) {
        console.log(
          "[fetchViewItems] Ya hay una llamada en curso, ignorando..."
        );
        return;
      }

      this.isFetchingItems = true;
      this.isLoading = true;
      try {
        // Construir la URL con los parámetros de paginación y ordenamiento
        const params = new URLSearchParams(queryString);
        params.append("page", this.pagination.page);
        params.append("perPage", this.pagination.perPage);

        // Agregar parámetros de ordenamiento si existen
        if (this.sortField) {
          params.append("order", this.sortField);
          params.append("orderDirection", this.sortOrder);
        }
        if (this.isArchiveView) {
          params.append("archived", "true");
        }
        this.appendReportHideListParams(params);
        this.appendOwnerScopeParam(params);
        this.appendFixedFilterParams(params);

        const url = `/api/gotrading/views/${
          this.effectiveViewId
        }/combined-items?${params.toString()}`;

        const { data } = await wencesApi.get(url);

        // Asegurarnos de que modelId esté presente en cada item
        this.items = data.items.map((item) => ({
          ...item,
        }));
        this.pagination = data.pagination;

        this.totals = data.totals;
        this.columnOverrides = data.columnOverrides || {};

        // Las listas ya vienen mapeadas en los items desde el backend, no es necesario cargarlas aquí
      } catch (error) {
        console.error("Error al cargar items:", error);
      } finally {
        this.isLoading = false;
        this.isFetchingItems = false;
      }
    },
    async fetchItems(queryString = "") {
      // Prevenir múltiples llamadas simultáneas
      if (this.isFetchingItems) {
        console.log("[fetchItems] Ya hay una llamada en curso, ignorando...");
        return;
      }

      if (this.view) {
        this.fetchViewItems(queryString);
        return;
      }

      this.isFetchingItems = true;
      this.isLoading = true;
      try {
        // Construir la URL con los parámetros de paginación y ordenamiento
        const params = new URLSearchParams(queryString);
        params.append("page", this.pagination.page);
        params.append("perPage", this.pagination.perPage);

        // Agregar parámetros de ordenamiento si existen
        if (this.sortField) {
          params.append("order", this.sortField);
          params.append("orderDirection", this.sortOrder);
        }

        // Enviar columnas seleccionadas para optimizar la consulta
        // Excluir textPlainVersion (solo se usa para búsquedas, nunca se muestra)
        const selectedFields = Object.keys(this.selectedColumns || {}).filter(
          (key) =>
            this.selectedColumns[key] === true &&
            key !== "textPlainVersion" &&
            // Las claves `_` son metadatos de las preferencias, no campos.
            !key.startsWith("_")
        );

        // Si hay campos reference_subfield (formato "A.B"), asegurarse de incluir el campo padre "A"
        // para que el backend pueda poblar el campo reference
        const fieldsToSend = [...selectedFields];
        selectedFields.forEach((fieldKey) => {
          // Si el campo es un subcampo de reference (contiene un punto)
          if (fieldKey.includes(".")) {
            const parts = fieldKey.split(".");
            const parentFieldKey = parts[0];
            // Verificar si el campo padre es de tipo reference
            const parentField = this.modelFields.find(
              (f) => f.key === parentFieldKey && f.type === "reference"
            );
            if (parentField && !fieldsToSend.includes(parentFieldKey)) {
              // Agregar el campo padre para que el backend lo pueble
              fieldsToSend.push(parentFieldKey);
            }

            // Si hay doble anidación (ej: proform.products.product), también agregar el campo intermedio
            if (parts.length > 2) {
              const intermediateField = `${parentFieldKey}.${parts[1]}`; // ej: proform.products
              if (!fieldsToSend.includes(intermediateField)) {
                fieldsToSend.push(intermediateField);
              }
            }
            this.ensurePopulatePrefixesForGroupArrayRefColumn(
              fieldKey,
              fieldsToSend
            );
            this.ensureGroupPrefixFieldsInExportRequest(fieldKey, fieldsToSend);
          }
        });

        this.ensureFobOperacionListFieldsInRequest(fieldsToSend);
        this.ensureMissingPrepaymentListFieldsInRequest(fieldsToSend);
        this.ensureListCategoryFieldInRequest(fieldsToSend);
        this.ensureExpenseNoteFieldsInRequest(fieldsToSend);

        const totalKeys = activeColumnTotalKeys(this.reportColumnTotals);
        if (totalKeys.length > 0) {
          params.append("totalFields", totalKeys.join(","));
        }

        if (fieldsToSend.length > 0) {
          params.append("fields", fieldsToSend.join(","));
        }

        // Agregar parámetro de papelera si estamos en vista de papelera
        if (this.isTrashView) {
          params.append("deleted", "true");
        }
        if (this.isArchiveView) {
          params.append("archived", "true");
        }
        this.appendReportHideListParams(params);
        this.appendOwnerScopeParam(params);
        this.appendFixedFilterParams(params);

        const data = await this.requestDynamicListItems(
          this.selectedModel,
          params
        );

        // Asegurarnos de que modelId esté presente en cada item
        this.items = data.items.map((item) => ({
          ...item,
          modelId: item.idModel, // Asegurarnos de que modelId tenga el valor de _id
        }));
        this.pagination = data.pagination;
        this.totals = data.totals || {};
        this.columnOverrides = data.columnOverrides || {};

        // Las listas ya vienen mapeadas en los items desde el backend, no es necesario cargarlas aquí
      } catch (error) {
        console.error("Error al cargar items:", error);
      } finally {
        this.isLoading = false;
        this.isFetchingItems = false;
      }
    },
    refreshList() {
      // Recargar el listado manteniendo los filtros, paginación y ordenamiento actuales
      const queryString = this.getCurrentFiltersQueryString();
      if (this.view) {
        this.fetchViewItems(queryString);
      } else {
        this.fetchItems(queryString);
      }
    },
    resetForm() {
      const defaultForm = {};
      this.modelFields.forEach((field) => {
        if (field.isArray) {
          defaultForm[field.key] = [];
        } else if (field.type === "group") {
          defaultForm[field.key] = {};
          if (field.fields) {
            field.fields.forEach((subField) => {
              defaultForm[field.key][subField.key] =
                subField.type === "number" ? 0 : "";
            });
          }
        } else {
          defaultForm[field.key] = field.type === "number" ? 0 : "";
        }
      });
      this.form = defaultForm;
      this.editingId = null;
    },
    editItem(item) {
      const formData = { ...item };

      if (
        this.selectedModelData.visualGroups &&
        this.selectedModelData.visualGroups.length > 0
      ) {
        this.selectedModelData.visualGroups.forEach((group) => {
          const groupKey = `group_${group.name}`;
          formData[groupKey] = {};

          this.modelFields.forEach((field) => {
            if (
              field.visualGroup === group.name &&
              formData[field.key] !== undefined
            ) {
              formData[groupKey][field.key] = formData[field.key];
              copyTranslatableSiblingsInto(formData[groupKey], formData, field);
            }
          });
        });
      }

      this.form = formData;
      this.editingId = item._id;
    },
    async onSubmit(form) {
      const dataToSave = { ...form };
      // Función para limpiar un valor según su tipo
      const cleanValue = (value, fieldType) => {
        if (value === null || value === undefined) return null;
        if (value === "") return null;
        if (Array.isArray(value) && value.length === 0) return [];
        if (typeof value === "object" && Object.keys(value).length === 0)
          return null;

        // Limpieza específica por tipo de campo
        switch (fieldType) {
          case "reference":
            if (typeof value === "string" && value.trim() === "") return null;
            if (typeof value === "object" && value._id) return value._id;
            return value;
          case "number":
            if (value === "" || !value) return 0;
            return Number(value);
          case "date":
            if (value === "") return null;
            return value;
          default:
            return value;
        }
      };

      // Función para limpiar un objeto según sus campos
      const cleanObject = (obj, fields) => {
        const cleaned = {};
        fields.forEach((field) => {
          const value = obj[field.key];
          if (value !== undefined) {
            cleaned[field.key] = cleanValue(value, field.type);
          }
        });
        return cleaned;
      };

      // Procesar los campos según su tipo
      const processFields = (data, fields) => {
        Object.keys(data).forEach((key) => {
          const fieldDef = fields.find((f) => f.key === key);
          if (fieldDef) {
            if (fieldDef.type === "group" && data[key]) {
              if (fieldDef.isArray && Array.isArray(data[key])) {
                data[key] = data[key]
                  .map((item) => {
                    if (item && typeof item === "object") {
                      const cleanedItem = cleanObject(item, fieldDef.fields);
                      return Object.keys(cleanedItem).length > 0
                        ? cleanedItem
                        : null;
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
              } else {
                data[key] = cleanObject(data[key], fieldDef.fields);
              }
            } else if (Array.isArray(data[key])) {
              data[key] = data[key]
                .map((item) => cleanValue(item, fieldDef.type))
                .filter((item) => item !== null);
            } else {
              data[key] = cleanValue(data[key], fieldDef.type);
            }
          }
        });
        return data;
      };

      // Procesar los grupos visuales
      if (
        this.selectedModelData.visualGroups &&
        this.selectedModelData.visualGroups.length > 0
      ) {
        this.selectedModelData.visualGroups.forEach((group) => {
          const groupKey = `group_${group.name}`;
          if (dataToSave[groupKey]) {
            dataToSave[groupKey] = processFields(
              dataToSave[groupKey],
              this.modelFields
            );
            Object.keys(dataToSave[groupKey]).forEach((fieldKey) => {
              dataToSave[fieldKey] = dataToSave[groupKey][fieldKey];
            });
            delete dataToSave[groupKey];
          }
        });
      }

      // Procesar los campos en el nivel raíz
      processFields(dataToSave, this.modelFields);

      if (this.editingId) {
        await wencesApi.put(
          `/api/gotrading/dynamic/${this.selectedModel}/${this.editingId}`,
          dataToSave
        );
      } else {
        await wencesApi.post(
          `/api/gotrading/dynamic/${this.selectedModel}`,
          dataToSave
        );
      }

      this.fetchItems();
    },
    onCancel() {
      this.resetForm();
    },
    async fetchLists(forceRefresh = false) {
      // Cargar listas solo bajo demanda (lazy loading)
      // La mayoría de los casos, los labels ya vienen del backend en los items

      // Obtener el stack trace para saber desde dónde se llama
      const stack = new Error().stack;
      const caller = stack?.split("\n")[2]?.trim() || "unknown";

      console.log("[fetchLists] 🔍 Llamada detectada:", {
        reason: forceRefresh ? "forceRefresh=true" : "lazy loading",
        caller: caller,
        hasCache: !!(this.listsCache && this.listsCacheTimestamp),
        cacheAge: this.listsCacheTimestamp
          ? Date.now() - this.listsCacheTimestamp
          : null,
        timestamp: new Date().toISOString(),
      });

      // Verificar si tenemos datos en cache y si aún son válidos
      const now = Date.now();
      if (
        !forceRefresh &&
        this.listsCache &&
        this.listsCacheTimestamp &&
        now - this.listsCacheTimestamp < this.listsCacheMaxAge
      ) {
        console.log(
          "[fetchLists] ✅ Usando cache (edad:",
          Math.round((now - this.listsCacheTimestamp) / 1000),
          "segundos)"
        );
        this.lists = this.listsCache;
        this.referenceItems = this.listsCache;
        return;
      }

      console.log("[fetchLists] 📡 Cargando listas desde API...");
      // Si no hay cache o está expirado, cargar desde la API
      const { data } = await wencesApi.get("/api/gotrading/lists");
      this.lists = data;
      this.referenceItems = data;

      // Actualizar cache
      this.listsCache = data;
      this.listsCacheTimestamp = now;
      console.log("[fetchLists] ✅ Listas cargadas:", data.length, "listas");
    },
    handleFilter(filters, options = {}) {
      // El listado embebido no es dueño de la URL: filtra sin tocarla
      const skipUrlUpdate = options.skipUrlUpdate === true || this.isEmbeddedList;
      this.selectedItems = [];
      // Resetear paginación a página 1 cuando se aplican filtros
      this.pagination.page = 1;
      const params = new URLSearchParams();

      // Procesar los filtros y agregarlos a los parámetros de la URL
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          if (Array.isArray(value)) {
            // Si es un array (ej. referencias múltiples), unir IDs con comas
            params.append(
              key,
              value.map((v) => v && (v._id != null ? v._id : v)).join(",")
            );
          } else if (typeof value === "object" && value !== null) {
            // Si es un objeto de referencia, usar su _id
            params.append(key, value._id != null ? value._id : value);
          } else {
            // Para valores simples (string, number, etc.)
            params.append(key, value);
          }
        }
      });

      this.appendOwnerScopeParam(params);
      const queryString = params.toString();

      // Actualizar la URL del navegador con los filtros (sin recargar la página)
      if (!skipUrlUpdate) {
        const query = {};
        params.forEach((value, key) => {
          query[key] = value;
        });

        // Preservar el reportId si estamos viendo un reporte
        if (this.currentLoadedReport && this.currentLoadedReport._id) {
          query.reportId = this.currentLoadedReport._id;
        }

        // Usar replace para no crear nueva entrada en el historial por cada cambio de filtro
        const newRoute = {
          path: this.$route.path,
          query: Object.keys(query).length > 0 ? query : undefined,
        };

        // Solo actualizar si la query es diferente
        const currentQuery = JSON.stringify(this.$route.query || {});
        const newQuery = JSON.stringify(query);
        if (currentQuery !== newQuery) {
          // Marcar que estamos actualizando la ruta programáticamente
          this.isUpdatingRoute = true;
          this.$router
            .replace(newRoute)
            .catch(() => {})
            .finally(() => {
              // Usar nextTick para asegurar que el watcher de $route se ejecute antes de resetear el flag
              this.$nextTick(() => {
                this.isUpdatingRoute = false;
              });
            });
        }
      }

      this.isLoading = true; // Mostrar loading
      this.fetchItems(queryString);
    },
    openColumnFilterFromHeader(field) {
      if (!field || field.type === "group" || field.type === "image") return;
      const fc = this.$refs.filtersComponent;
      if (!fc || typeof fc.openColumnFilterPopup !== "function") return;
      fc.openColumnFilterPopup(field.key);
    },
    columnHeaderFilterActive(fieldKey) {
      const fc = this.$refs.filtersComponent;
      if (!fc || typeof fc.isColumnFilterActive !== "function") return false;
      return fc.isColumnFilterActive(fieldKey);
    },
    async exportToExcel() {
      if (this.isExporting) return;

      try {
        this.isExporting = true;

        // Mostrar loading
        const exportMessage =
          this.selectedItems && this.selectedItems.length > 0
            ? this.$t("Preparing export of selected items...") ||
              `Preparing export of ${this.selectedItems.length} selected items...`
            : this.$t("Loading all data... This may take a moment.");

        Swal.fire({
          title: this.$tn("Preparing Export"),
          text: exportMessage,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        await this.fetchLists();

        // Construir los parámetros de consulta usando getCurrentFiltersQueryString para mantener consistencia
        // Esto asegura que todos los filtros (incluyendo is_null, is_not_null, operadores >, <, etc.) se incluyan correctamente
        const filtersQueryString = this.getCurrentFiltersQueryString();
        const params = new URLSearchParams(filtersQueryString);

        // Agregar parámetros de ordenamiento si existen
        if (this.sortField) {
          params.append("order", this.sortField);
          params.append("orderDirection", this.sortOrder);
        }

        // Enviar columnas seleccionadas para optimizar la consulta y poblar referencias
        // Excluir textPlainVersion (solo se usa para búsquedas, nunca se muestra)
        const selectedFields = Object.keys(this.selectedColumns || {}).filter(
          (key) =>
            this.selectedColumns[key] === true &&
            key !== "textPlainVersion" &&
            // Las claves `_` son metadatos de las preferencias, no campos.
            !key.startsWith("_")
        );

        const nestedFields = selectedFields.filter(
          (f) => f.split(".").length > 2
        );
        console.log(
          "[exportToExcel] 🔍 Campos seleccionados antes de procesar",
          {
            selectedFields: selectedFields,
            hasNestedFields: nestedFields.length > 0,
            nestedFields: nestedFields,
            nestedFieldsDetails: nestedFields.map((f) => {
              const parts = f.split(".");
              return {
                fullKey: f,
                parentField: parts[0],
                intermediateField: parts[1],
                finalField: parts[2],
                partsCount: parts.length,
              };
            }),
            visibleTableFieldsWithNested: this.visibleTableFields
              .filter((f) => f.nestedFieldKey)
              .map((f) => ({
                key: f.key,
                nestedFieldKey: f.nestedFieldKey,
                subFieldKey: f.subFieldKey,
                parentField: f.parentField?.key,
              })),
            referenceFieldsInModel: this.modelFields
              .filter((f) => f.type === "reference")
              .map((f) => ({
                key: f.key,
                ref: f.ref,
              })),
          }
        );

        // Si hay campos reference_subfield (formato "A.B"), asegurarse de incluir el campo padre "A"
        // para que el backend pueda poblar el campo reference
        const fieldsToSend = [...selectedFields];
        selectedFields.forEach((fieldKey) => {
          // Si el campo es un subcampo de reference (contiene un punto)
          if (fieldKey.includes(".")) {
            const parts = fieldKey.split(".");
            const parentFieldKey = parts[0];
            // Verificar si el campo padre es de tipo reference
            const parentField = this.modelFields.find(
              (f) => f.key === parentFieldKey && f.type === "reference"
            );
            if (parentField && !fieldsToSend.includes(parentFieldKey)) {
              // Agregar el campo padre para que el backend lo pueble
              fieldsToSend.push(parentFieldKey);
            }

            // Si hay doble anidación (ej: proform.products.product), también agregar el campo intermedio
            if (parts.length > 2) {
              const intermediateField = `${parentFieldKey}.${parts[1]}`; // ej: proform.products
              if (!fieldsToSend.includes(intermediateField)) {
                fieldsToSend.push(intermediateField);
              }
            }
            this.ensurePopulatePrefixesForGroupArrayRefColumn(
              fieldKey,
              fieldsToSend
            );
            this.ensureGroupPrefixFieldsInExportRequest(fieldKey, fieldsToSend);
          }
        });

        this.ensureMissingPrepaymentListFieldsInRequest(fieldsToSend);
        this.ensureListCategoryFieldInRequest(fieldsToSend);
        this.ensureExpenseNoteFieldsInRequest(fieldsToSend);

        if (fieldsToSend.length > 0) {
          console.log("[exportToExcel] 📤 Campos enviados al backend", {
            fieldsToSend: fieldsToSend,
            hasNestedFields: fieldsToSend.some((f) => f.split(".").length > 2),
            nestedFields: fieldsToSend.filter((f) => f.split(".").length > 2),
          });
          params.append("fields", fieldsToSend.join(","));
        }

        // Agregar parámetros para obtener todos los datos sin paginación y procesados para exportación
        params.append("all", "true");
        params.append("export", "true");
        this.appendReportHideListParams(params);
        // Embebido: el Excel sale de lo que muestra el popup, no del modelo entero
        this.appendFixedFilterParams(params);

        // Obtener todos los datos
        let allItems = [];

        // Si hay items seleccionados, solo exportar esos items
        if (this.selectedItems && this.selectedItems.length > 0) {
          // Obtener todos los datos primero para poder filtrar los seleccionados
          if (this.view) {
            // Para vistas combinadas
            const url = `/api/gotrading/views/${
              this.effectiveViewId
            }/combined-items?${params.toString()}`;
            const { data } = await wencesApi.get(
              url,
              this.excelExportRequestConfig()
            );
            const allData = (data.items || data || []).map((item) => ({
              ...item,
              modelId: item.idModel, // Mapear idModel a modelId para el campo ID
            }));
            // Filtrar solo los items seleccionados
            allItems = allData.filter(
              (item) =>
                this.selectedItems.includes(item._id) ||
                this.selectedItems.includes(item._id?.toString())
            );
          } else {
            // Para modelos normales
            const data = await this.requestDynamicListItems(
              this.selectedModel,
              params,
              this.excelExportRequestConfig()
            );
            const allData = (data.items || data || []).map((item) => ({
              ...item,
              modelId: item.idModel, // Mapear idModel a modelId para el campo ID
            }));
            // Filtrar solo los items seleccionados
            allItems = allData.filter(
              (item) =>
                this.selectedItems.includes(item._id) ||
                this.selectedItems.includes(item._id?.toString())
            );
          }
        } else {
          // Si no hay items seleccionados, exportar todos los datos
          if (this.view) {
            // Para vistas combinadas
            const url = `/api/gotrading/views/${
              this.effectiveViewId
            }/combined-items?${params.toString()}`;
            const { data } = await wencesApi.get(
              url,
              this.excelExportRequestConfig()
            );
            allItems = (data.items || data || []).map((item) => ({
              ...item,
              modelId: item.idModel, // Mapear idModel a modelId para el campo ID
            }));
          } else {
            // Para modelos normales
            const data = await this.requestDynamicListItems(
              this.selectedModel,
              params,
              this.excelExportRequestConfig()
            );
            allItems = (data.items || data || []).map((item) => ({
              ...item,
              modelId: item.idModel, // Mapear idModel a modelId para el campo ID
            }));
          }
        }

        if (!allItems || allItems.length === 0) {
          Swal.close();
          Swal.fire({
            icon: "warning",
            title: this.$tn("No Data"),
            text:
              this.selectedItems && this.selectedItems.length > 0
                ? this.$tn("No selected items to export") ||
                  "No selected items to export"
                : this.$tn("No data to export"),
          });
          return;
        }

        // Preparar datos para exportación - listas jerárquicas (categorías) → una columna por nivel
        const { exportData, rowFillByIndex } =
          await this.buildExcelExportData(allItems);

        Swal.close();

        // Generar nombre de archivo
        const modelLabel = this.selectedModelData?.label || this.selectedModel;
        const itemCount =
          this.selectedItems && this.selectedItems.length > 0
            ? `_${this.selectedItems.length}_selected`
            : "";
        const hiddenSuffix =
          this.isHiddenRowsView && this.canUseReportRowHide ? "_hidden" : "";
        const fileName = `${this.$t(modelLabel) || modelLabel}${itemCount}${hiddenSuffix}_${
          new Date().toISOString().split("T")[0]
        }`;

        // Exportar a Excel
        await ExportService.exportDataToExcel(
          exportData,
          fileName,
          this.$t(modelLabel) || "Datos",
          { rowFillByIndex }
        );

        const successMessage =
          this.selectedItems && this.selectedItems.length > 0
            ? this.$t("Selected items exported successfully") ||
              `${this.selectedItems.length} selected items exported successfully`
            : this.$t("Data exported successfully");

        Swal.fire({
          icon: "success",
          title: this.$tn("Export Successful"),
          text: successMessage,
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error exporting data:", error);
        Swal.close();
        Swal.fire({
          icon: "error",
          title: this.$tn("Export Error"),
          text: error.response?.data?.error || this.$tn("Failed to export data"),
        });
      } finally {
        this.isExporting = false;
      }
    },
    /** Same flow as exportToExcel but opens email modal with Excel blob instead of downloading. */
    async sendExportByEmail() {
      if (this.isExporting) return;
      try {
        this.isExporting = true;
        const exportMessage =
          this.selectedItems && this.selectedItems.length > 0
            ? this.$t("Preparing export of selected items...") ||
              `Preparing export of ${this.selectedItems.length} selected items...`
            : this.$t("Loading all data... This may take a moment.");
        Swal.fire({
          title: this.$tn("Preparing Export"),
          text: exportMessage,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        await this.fetchLists();
        const filtersQueryString = this.getCurrentFiltersQueryString();
        const params = new URLSearchParams(filtersQueryString);
        if (this.sortField) {
          params.append("order", this.sortField);
          params.append("orderDirection", this.sortOrder);
        }
        const selectedFields = Object.keys(this.selectedColumns || {}).filter(
          (key) =>
            this.selectedColumns[key] === true &&
            key !== "textPlainVersion" &&
            // Las claves `_` son metadatos de las preferencias, no campos.
            !key.startsWith("_")
        );
        const fieldsToSend = [...selectedFields];
        selectedFields.forEach((fieldKey) => {
          if (fieldKey.includes(".")) {
            const parts = fieldKey.split(".");
            const parentField = this.modelFields.find(
              (f) => f.key === parts[0] && f.type === "reference"
            );
            if (parentField && !fieldsToSend.includes(parts[0]))
              fieldsToSend.push(parts[0]);
            if (parts.length > 2) {
              const intermediate = `${parts[0]}.${parts[1]}`;
              if (!fieldsToSend.includes(intermediate))
                fieldsToSend.push(intermediate);
            }
            this.ensurePopulatePrefixesForGroupArrayRefColumn(
              fieldKey,
              fieldsToSend
            );
            this.ensureGroupPrefixFieldsInExportRequest(fieldKey, fieldsToSend);
          }
        });
        this.ensureMissingPrepaymentListFieldsInRequest(fieldsToSend);
        this.ensureListCategoryFieldInRequest(fieldsToSend);
        this.ensureExpenseNoteFieldsInRequest(fieldsToSend);
        if (fieldsToSend.length > 0)
          params.append("fields", fieldsToSend.join(","));
        params.append("all", "true");
        params.append("export", "true");
        this.appendReportHideListParams(params);
        let allItems = [];
        if (this.selectedItems && this.selectedItems.length > 0) {
          const url = this.view
            ? `/api/gotrading/views/${
                this.effectiveViewId
              }/combined-items?${params.toString()}`
            : `/api/gotrading/dynamic/${
                this.selectedModel
              }?${params.toString()}`;
          const { data } = await wencesApi.get(
            url,
            this.excelExportRequestConfig()
          );
          const allData = (data.items || data || []).map((item) => ({
            ...item,
            modelId: item.idModel,
          }));
          allItems = allData.filter(
            (item) =>
              this.selectedItems.includes(item._id) ||
              this.selectedItems.includes(item._id?.toString())
          );
        } else {
          const url = this.view
            ? `/api/gotrading/views/${
                this.effectiveViewId
              }/combined-items?${params.toString()}`
            : `/api/gotrading/dynamic/${
                this.selectedModel
              }?${params.toString()}`;
          const { data } = await wencesApi.get(
            url,
            this.excelExportRequestConfig()
          );
          allItems = (data.items || data || []).map((item) => ({
            ...item,
            modelId: item.idModel,
          }));
        }
        if (!allItems || allItems.length === 0) {
          Swal.close();
          Swal.fire({
            icon: "warning",
            title: this.$tn("No Data"),
            text: this.selectedItems?.length
              ? this.$tn("No selected items to export") ||
                "No selected items to export"
              : this.$tn("No data to export") || "No data to export",
          });
          return;
        }
        const { exportData, rowFillByIndex } =
          await this.buildExcelExportData(allItems);
        const modelLabel = this.selectedModelData?.label || this.selectedModel;
        const itemCount = this.selectedItems?.length
          ? `_${this.selectedItems.length}_selected`
          : "";
        const hiddenSuffix =
          this.isHiddenRowsView && this.canUseReportRowHide ? "_hidden" : "";
        const fileName = `${this.$t(modelLabel) || modelLabel}${itemCount}${hiddenSuffix}_${
          new Date().toISOString().split("T")[0]
        }`;
        const sheetName = this.$t(modelLabel) || "Datos";
        Swal.close();
        const { blob, fileName: fullFileName } =
          await ExportService.exportDataToExcelAsBlob(
            exportData,
            fileName,
            sheetName,
            { rowFillByIndex }
          );
        this.emailExportBlob = blob;
        this.emailExportFileName = fullFileName;
        this.showEmailExportModal = true;
      } catch (error) {
        console.error("Error preparing export for email:", error);
        Swal.close();
        this.$root.$emit(
          "show-error",
          error.response?.data?.error ||
            this.$t("Failed to prepare export") ||
            "Failed to prepare export"
        );
      } finally {
        this.isExporting = false;
      }
    },
    onCloseEmailExportModal() {
      this.showEmailExportModal = false;
      this.emailExportBlob = null;
      this.emailExportFileName = null;
    },
    async checkSmartEmailEnabled() {
      try {
        const res = await wencesApi.get(
          "/api/emails/config/smart-email-enabled"
        );
        this.smartEmailEnabled =
          res.data?.success && res.data?.data?.templatePdfEnabled === true;
      } catch (e) {
        this.smartEmailEnabled = false;
      }
    },
    /**
     * Formatea un valor para exportación a Excel usando el mismo criterio visual de la tabla.
     */
    formatDateForExcelExport(value, field, subField = null) {
      const dash = "-";
      if (value === null || value === undefined || value === "") return dash;
      const type = subField
        ? subField.type
        : field.type === "reference_subfield"
        ? field.subFieldType
        : field.type;
      const hasTime = subField
        ? subField.time === true
        : field.type === "reference_subfield"
        ? field.subFieldDef?.time === true
        : field.time === true;
      if (type !== "date" && type !== "datetime") {
        return String(value);
      }
      return hasTime
        ? formatDateTimeSync(value, String(value), dash)
        : formatDateSync(value, String(value), dash);
    },
    /** Tipo del dato a exportar según model definition (subcampo o campo raíz). */
    effectiveExportFieldType(field) {
      if (
        field.type === "reference_subfield" ||
        field.type === "group_subfield"
      ) {
        return field.subFieldDef?.type || field.subFieldType || "string";
      }
      return field.type;
    },
    /** Columna derivada (subcampo de grupo / de referencia): huecos → guión como en tabla */
    isDerivedSubfieldColumn(field) {
      return (
        field.type === "group_subfield" || field.type === "reference_subfield"
      );
    },
    buildExcelListHierarchyChain(itemId, listValues, visited = new Set()) {
      if (itemId == null || itemId === "" || visited.has(String(itemId))) {
        return [];
      }
      visited.add(String(itemId));
      const row = listValues.find((opt) => {
        const oid = opt._id || opt.id;
        return oid && String(oid) === String(itemId);
      });
      if (!row) return [];
      if (row.parent) {
        const pid =
          typeof row.parent === "object" && row.parent.toString
            ? row.parent.toString()
            : String(row.parent);
        const parentChain = this.buildExcelListHierarchyChain(
          pid,
          listValues,
          visited
        );
        return [...parentChain, row];
      }
      return [row];
    },
    formatListValueForExcel(value, field) {
      const loc = (this.$i18n && this.$i18n.locale) || "es";
      const listValues = this.getExcelListValuesForExport(field);
      const formatOne = (v) => {
        if (v == null || v === "") {
          return this.isDerivedSubfieldColumn(field) ? "-" : "";
        }
        if (
          typeof v === "object" &&
          v !== null &&
          typeof v.hierarchy === "string"
        ) {
          return v.hierarchy;
        }
        const id = typeof v === "object" && v !== null ? v._id || v.id : v;
        if (id != null && id !== "" && listValues.length > 0) {
          const chain = this.buildExcelListHierarchyChain(id, listValues);
          if (chain.length > 1) {
            return chain
              .map((it) => getTranslatedListLabel(it, loc))
              .join(" > ");
          }
          if (chain.length === 1) {
            return getTranslatedListLabel(chain[0], loc);
          }
        }
        if (typeof v === "object" && v !== null) {
          return (
            getTranslatedListLabel(v, loc) ||
            (v.label != null ? String(v.label) : "") ||
            (v.name != null ? String(v.name) : "") ||
            (v._id != null ? String(v._id) : "")
          );
        }
        return String(v);
      };
      if (Array.isArray(value)) {
        const rows = value.map(formatOne);
        if (this.isDerivedSubfieldColumn(field)) {
          return rows.join("\n");
        }
        return rows.filter(Boolean).join("\n");
      }
      return formatOne(value);
    },
    excelExportRequestConfig() {
      const loc = (this.$i18n && this.$i18n.locale) || "es";
      return { headers: { "Accept-Language": String(loc) } };
    },
    isShippingStatusExportField(field) {
      if (!field) return false;
      const model = String(this.selectedModel || "").toLowerCase();
      if (model !== "shipping") return false;
      const key = field.subFieldKey || field.key;
      return key === "status";
    },
    appendExcelPrepaymentWarning(text, entity, field) {
      if (!entity || typeof entity !== "object") return text;
      const fieldKey = field?.subFieldKey || field?.key;
      const ref =
        field?.subFieldRef ||
        field?.subFieldDef?.ref ||
        field?.nestedSubFieldDef?.ref ||
        field?.ref;
      const t = this.effectiveExportFieldType(field);
      const isRef = t === "reference" || t === "users";
      const isIdentity = fieldKey === "name" || fieldKey === "label";
      if (isRef) {
        if (!isProformOrShippingModelName(ref)) return text;
      } else if (
        !isIdentity ||
        !isProformOrShippingModelName(this.selectedModel)
      ) {
        return text;
      }
      if (!hasMissingAssociatedPrepayment(entity)) return text;
      return appendExcelMarker(text, this.$t("Sin prepayment asociado"));
    },
    applyExcelRowVisualStatus(cellValue, item, col) {
      if (!item || !col || !col.field) return cellValue;
      const fieldKey = col.field.subFieldKey || col.field.key;
      const isIdentity = fieldKey === "name" || fieldKey === "label";
      const identityExported = (this.visibleTableFields || []).some(
        (f) => f && (f.key === "name" || f.key === "label")
      );
      const firstVisible = (this.visibleTableFields || [])[0];
      const isFirstColumnFallback =
        !identityExported &&
        col.kind === "simple" &&
        firstVisible &&
        firstVisible.key === col.field.key;
      if (!isIdentity && !isFirstColumnFallback) return cellValue;
      const tFn = (k) => this.$t(k);
      const includePaid =
        String(this.selectedModel || "").toLowerCase() === "payment";
      let out = appendExcelMarkers(
        cellValue,
        collectExcelVisualMarkers(item, tFn, { includePaid })
      );
      // La bandera se pega entre paréntesis sólo cuando su columna no viaja en
      // el Excel. El campo es `flag_category` salvo en definiciones viejas, que
      // seguían usando `category`: comparar contra el literal dejaba el label
      // duplicado (columna Flag + paréntesis en Shipping).
      const flagFieldKey = this.listFlagFieldKey;
      const categoryExported = (this.visibleTableFields || []).some(
        (f) =>
          f &&
          f.key === flagFieldKey &&
          this.selectedColumns &&
          this.selectedColumns[f.key] === true
      );
      const categoryLabel = this.getListCategoryLabel(this.listFlagValueOf(item));
      if (this.modelHasCategoryField && !categoryExported && categoryLabel) {
        out = appendExcelMarker(out, categoryLabel);
      }
      return this.appendExcelPrepaymentWarning(out, item, col.field);
    },
    stringifyExcelScalar(value, field, item) {
      const t = this.effectiveExportFieldType(field);
      if (t === "date" || t === "datetime") {
        return this.formatDateForExcelExport(value, field);
      }
      if (
        this.isDerivedSubfieldColumn(field) &&
        (value === null || value === undefined || value === "")
      ) {
        return "-";
      }
      if (value === null || value === undefined || value === "") return "";
      if (t === "icon") {
        return wrapExcelIconName(value);
      }
      if (this.isShippingStatusExportField(field)) {
        const n = Number(value);
        if (Number.isInteger(n)) {
          const label = getStatusLabel(n, this.$t);
          return this.$t(label);
        }
        // El backend ya resuelve el estado a su etiqueta ("On board"). El campo
        // sigue declarado `number`, así que sin este corte caía en el formateo
        // numérico de abajo, que no la puede parsear y devolvía "".
        return String(value);
      }
      if (t === "number" || t === "currency") {
        const num = typeof value === "string" ? parseFloat(value) : value;
        if (value === "" || Number.isNaN(num)) return "";
        const hasCurrency =
          field.subFieldDef?.currency === true || field.currency === true;
        const decimals = getDisplayDecimalsOverrideForFieldKey(field?.key);
        return formatNumberSync(num, null, !!hasCurrency, decimals);
      }
      if (t === "boolean") {
        return value === true || value === "true"
          ? this.$t("Yes") || "Yes"
          : this.$t("No") || "No";
      }
      if (t === "reference" || t === "users") {
        const paidOpts = { includePaid: isPaymentRefField(field) };
        const tFn = (k) => this.$t(k);
        if (typeof value === "object" && value !== null) {
          const label =
            (value.name != null ? String(value.name) : "") ||
            (value.label != null ? String(value.label) : "") ||
            (value._id != null ? String(value._id) : "");
          const withStatus = formatExcelLabelWithVisualStatus(
            label,
            value,
            tFn,
            paidOpts
          );
          return this.appendExcelPrepaymentWarning(withStatus, value, field);
        }
        // Varias refs en un string (p. ej. shippings[].client uno por línea)
        if (typeof value === "string" && /[\r\n]/.test(value)) {
          return value
            .split(/\r?\n/)
            .map((line) => line.trim())
            .filter(Boolean)
            .map((line) => this.stringifyExcelScalar(line, field, item))
            .join("\n");
        }
        const refModel =
          field.subFieldRef || field.subFieldDef?.ref || field.ref;
        if (refModel && this.referenceItems) {
          const bucket =
            this.referenceItems[refModel] ||
            this.referenceItems[refModel.toLowerCase()] ||
            this.referenceItems[
              refModel.charAt(0).toUpperCase() + refModel.slice(1)
            ];
          const arr = Array.isArray(bucket) ? bucket : [];
          const found = arr.find(
            (x) =>
              String(x._id) === String(value) ||
              (x._id && value && x._id.toString() === value.toString())
          );
          if (found) {
            const label =
              found.name || found.label || String(found._id || "");
            const withStatus = formatExcelLabelWithVisualStatus(
              label,
              found,
              tFn,
              paidOpts
            );
            return this.appendExcelPrepaymentWarning(withStatus, found, field);
          }
        }
        return String(value);
      }
      if (t === "list") {
        return this.formatListValueForExcel(value, field);
      }
      if (isFieldTranslatable(field.subFieldDef || field) && item) {
        const loc =
          this.$i18n && this.$i18n.locale
            ? String(this.$i18n.locale).split("-")[0]
            : "es";
        const def = field.subFieldDef || field;
        const key = field.subFieldKey || def.key || field.key;
        return getTranslatedFieldValueFromItem(
          item,
          key,
          loc,
          getFieldTranslatableLocales(def)
        );
      }
      if (typeof value === "object" && value !== null) {
        return (
          (value.name != null ? String(value.name) : "") ||
          (value.label != null ? String(value.label) : "") ||
          (typeof value.hierarchy === "string" ? value.hierarchy : "") ||
          (value._id != null ? String(value._id) : "")
        );
      }
      return String(value);
    },
    formatCellForExcelExport(value, field, item) {
      const t = this.effectiveExportFieldType(field);
      if (value === null || value === undefined) {
        if (t === "date" || t === "datetime") return "-";
        if (this.isDerivedSubfieldColumn(field)) return "-";
        return "";
      }
      if (Array.isArray(value)) {
        // Sin filtrar vacíos: cada posición del array = una línea (huecos con null en grupo isArray)
        const joined = value
          .map((v) => this.stringifyExcelScalar(v, field, item))
          .join("\n");
        if (
          joined === "" &&
          (t === "date" ||
            t === "datetime" ||
            this.isDerivedSubfieldColumn(field))
        ) {
          return "-";
        }
        return joined;
      }
      return this.stringifyExcelScalar(value, field, item);
    },
    /** Definición de lista para export (listType, listRef o key del subcampo). */
    excelExportListFieldDef(field) {
      const def = field.subFieldDef || field;
      return {
        listRef: field.subFieldListRef || def.listRef,
        listType: field.subFieldListType || def.listType,
        key: field.subFieldKey || def.key || field.key,
      };
    },
    getExcelListDefinitionForExport(field) {
      return this.findListDefinitionForField(
        this.excelExportListFieldDef(field),
        this.lists
      );
    },
    getExcelListValuesForExport(field) {
      const listDef = this.getExcelListDefinitionForExport(field);
      return listDef?.values || [];
    },
    /** listType efectivo para resolver etiquetas de lista en export. */
    excelExportListType(field) {
      const listDef = this.getExcelListDefinitionForExport(field);
      if (listDef?.type) return listDef.type;
      return (
        field.subFieldDef?.listType ||
        field.subFieldListType ||
        field.listType ||
        ""
      );
    },
    /**
     * Asegura prefijos de grupo en fields= para export (raíz + grupos anidados).
     */
    ensureGroupPrefixFieldsInExportRequest(fieldKey, fieldsToSend) {
      if (!fieldKey || !fieldKey.includes(".") || !Array.isArray(fieldsToSend)) {
        return;
      }
      const parts = fieldKey.split(".").filter(Boolean);
      if (parts.length < 2) return;
      const root = this.modelFields.find(
        (f) => f.key === parts[0] && f.type === "group"
      );
      if (!root) return;
      if (!fieldsToSend.includes(parts[0])) {
        fieldsToSend.push(parts[0]);
      }
      let fields = root.fields || [];
      let acc = parts[0];
      for (let i = 1; i < parts.length - 1; i++) {
        const seg = parts[i];
        const sub = fields.find((f) => f.key === seg && f.type === "group");
        if (!sub) break;
        acc = `${acc}.${seg}`;
        if (!fieldsToSend.includes(acc)) {
          fieldsToSend.push(acc);
        }
        fields = sub.fields || [];
      }
    },
    /** Cabecera legible de una columna de export (misma lógica que la tabla: name/parent/title → etiqueta del modelo). */
    excelExportFieldHeader(field) {
      const text =
        this.reportColumnLabels && this.reportColumnLabels[field.key]
          ? this.reportColumnLabels[field.key]
          : this.baseTableColumnHeaderText(field);
      return `${text}${this.columnOverrideHeaderSuffix(field)}`;
    },
    /**
     * Plan de columnas: { kind: 'simple', field, header }.
     *
     * Una columna por campo visible, igual que el listado. Las listas
     * jerárquicas bajan en una sola celda con la cadena completa
     * ("CAMERUN > DOUALA"); abrirlas en una columna por nivel
     * ("Port of Delivery — 1/— 2") dejaba el Excel sin parecido con la
     * pantalla y el que lo recibe no lo reconoce.
     */
    buildExcelExportColumnPlan() {
      const cols = [];
      for (const field of this.visibleTableFields) {
        if (field.type === "group" && field.fields) {
          field.fields.forEach((subField) => {
            if (this.selectedColumns[`${field.key}.${subField.key}`] !== true) {
              return;
            }
            const synthetic = {
              type: "group_subfield",
              parentField: field,
              subFieldKey: subField.key,
              subFieldType: subField.type,
              subFieldRef: subField.ref,
              subFieldDef: subField,
              subFieldListType: subField.listType,
              subFieldListRef: subField.listRef,
              isArray: field.isArray === true,
              parentSubField: null,
              key: `${field.key}.${subField.key}`,
            };
            cols.push({
              kind: "simple",
              field: synthetic,
              header:
                subField.abbreviation ||
                this.$t(subField.label) ||
                subField.label ||
                `${field.label || field.key}.${subField.key}`,
            });
          });
        } else {
          cols.push({
            kind: "simple",
            field,
            header: this.excelExportFieldHeader(field),
          });
        }
      }
      return cols;
    },
    getExcelExportCellValue(item, col) {
      // La columna de banderas se resuelve igual que en el listado: el campo
      // propio y, si está vacío, el `category` legado. Leyendo sólo
      // `flag_category` las filas anteriores a esa migración bajaban en blanco
      // aunque la pantalla les mostrara la bandera.
      if (this.isListFlagFieldKey(col.field?.key)) {
        return this.getListCategoryLabel(this.listFlagValueOf(item));
      }
      const value = this.getFieldValue(item, col.field);
      const formatted = this.formatCellForExcelExport(value, col.field, item);
      return this.applyExcelRowVisualStatus(formatted, item, col);
    },
    // NOTA: El método formatValueForExport ya no se usa porque el backend devuelve
    // todos los valores ya formateados cuando export=true. Se mantiene comentado
    // por si se necesita en el futuro para formateo adicional en el frontend.
    /*
    formatValueForExport(value, field, item) {
      // Si el valor es null o undefined, retornar cadena vacía
      if (value === null || value === undefined) {
        return "";
      }

      // Para campos reference_subfield, usar el subFieldType para determinar el formato
      // Si hay un campo anidado (ej: products.product), usar el tipo del campo anidado
      const fieldType = field.type === "reference_subfield" 
        ? (field.nestedSubFieldDef?.type || field.subFieldType) 
        : field.type;
      const isReferenceSubfield = field.type === "reference_subfield";

      // Campo de tipo fecha
      // SIEMPRE mostrar solo la fecha, sin hora ni minutos
      if (fieldType === "date" || fieldType === "datetime") {
        return formatDateSync(value, "");
      }

      // Campo de tipo número
      if (fieldType === "number" || fieldType === "currency") {
        if (value === null || value === undefined || value === "") {
          return "";
        }
        // Para arrays (reference_subfield con isArray), manejar como array
        if (Array.isArray(value)) {
          const formattedValues = value
            .map((v) => {
              const numVal = typeof v === "string" ? parseFloat(v) : v;
              if (isNaN(numVal)) return "";
              return formatNumberSync(numVal);
            })
            .filter((v) => v !== "");
          return formattedValues.join(", ");
        }
        const numValue = typeof value === "string" ? parseFloat(value) : value;
        if (isNaN(numValue)) {
          return "";
        }
        // Para reference_subfield, verificar si el subcampo tiene currency
        const hasCurrency = isReferenceSubfield 
          ? field.subFieldDef?.currency 
          : field.currency;
        if (hasCurrency) {
          // Formato usando la función utilitaria - siempre mostrar decimales para currency
          let formatted = formatNumberSync(numValue, null, true);
          // Agregar símbolo de moneda si existe
          const currencyField = isReferenceSubfield 
            ? field.subFieldDef?.currencyField 
            : field.currencyField;
          if (currencyField && item) {
            // Para reference_subfield, el currencyField puede estar en el item de referencia
            const currency = item[currencyField];
            const symbol = currency?.label || currency;
            if (symbol) {
              formatted = `${formatted} ${symbol}`;
            }
          }
          return formatted;
        }
        // Formato de número usando la función utilitaria
        return formatNumberSync(numValue);
      }

      // Campo de tipo referencia
      if (fieldType === "reference") {
        // Para arrays (reference_subfield con isArray), manejar como array
        if (Array.isArray(value)) {
          // Si hay un campo anidado, usar la referencia del campo anidado
          const refModel = isReferenceSubfield 
            ? (field.nestedSubFieldDef?.ref || field.subFieldRef) 
            : field.ref;
          
          return value
            .map((v) => {
              if (typeof v === "object" && v !== null) {
                // Si tiene name o label, usarlo directamente
                if (v.name || v.label) {
                  return v.name || v.label;
                }
                // Si solo tiene _id, intentar buscar en referenceItems
                if (v._id && refModel && this.referenceItems) {
                  const refItems = this.referenceItems[refModel] ||
                                  this.referenceItems[refModel.toLowerCase()] ||
                                  this.referenceItems[refModel.charAt(0).toUpperCase() + refModel.slice(1)] ||
                                  [];
                  const itemsArray = Array.isArray(refItems) ? refItems : [];
                  const refItem = itemsArray.find(
                    (item) => {
                      const itemId = item._id;
                      const valueId = v._id;
                      return itemId === valueId || 
                             itemId?.toString() === valueId?.toString() ||
                             (itemId && valueId && itemId.toString() === valueId.toString());
                    }
                  );
                  if (refItem) {
                    return refItem.name || refItem.label || String(v._id);
                  }
                }
                // Si tiene _id pero no name, convertirlo a string para evitar [object Object]
                if (v._id) {
                  return String(v._id);
                }
                // Si es un objeto sin _id, intentar convertirlo a string
                return String(v);
              }
              return String(v || "");
            })
            .filter((v) => v !== "")
            .join(", ");
        }
        if (typeof value === "object" && value !== null) {
          // Si es un objeto de referencia, extraer name, label o _id
          // Si el objeto tiene _id pero no name, podría ser un ObjectId, convertirlo a string
          if (value._id && !value.name && !value.label) {
            return String(value._id);
          }
          return value.name || value.label || (value._id ? String(value._id) : "") || "";
        }
        // Si es solo un ID, intentar buscar en referenceItems
        // Si hay un campo anidado, usar la referencia del campo anidado
        const refModel = isReferenceSubfield 
          ? (field.nestedSubFieldDef?.ref || field.subFieldRef) 
          : field.ref;
        if (refModel && this.referenceItems) {
          // Intentar buscar con diferentes variaciones del nombre del modelo
          const refItems = this.referenceItems[refModel] ||
                          this.referenceItems[refModel.toLowerCase()] ||
                          this.referenceItems[refModel.charAt(0).toUpperCase() + refModel.slice(1)] ||
                          [];
          
          const itemsArray = Array.isArray(refItems) ? refItems : [];
          const refItem = itemsArray.find(
            (item) => {
              const itemId = item._id;
              const valueId = value;
              return itemId === valueId || 
                     itemId?.toString() === valueId?.toString() ||
                     (itemId && valueId && itemId.toString() === valueId.toString());
            }
          );
          if (refItem) {
            return refItem.name || refItem.label || refItem._id || value;
          }
        }
        return value || "";
      }

      // Campo de tipo lista
      if (fieldType === "list") {
        // Si hay un campo anidado, usar los valores del campo anidado
        // Si hay un campo anidado, usar los valores del campo anidado
        const listType = isReferenceSubfield
          ? (field.nestedSubFieldDef?.listType || field.subFieldListType)
          : field.listType;
        const listRef = isReferenceSubfield
          ? (field.nestedSubFieldDef?.listRef || field.subFieldListRef)
          : field.listRef;
        const isArrayField = isReferenceSubfield ? field.isArray : field.isArray;
        
        if (isArrayField && Array.isArray(value)) {
          return value
            .map((v) => {
              // El backend ya devuelve los valores como objetos con _id y label
              // Confiar primero en los datos del backend
              if (typeof v === "object" && v !== null && v.label) {
                // Si tiene hierarchy, usar la jerarquía completa
                if (v.hierarchy && typeof v.hierarchy === 'string') {
                  return v.hierarchy;
                }
                
                // Si el label es un string, retornarlo directamente
                if (typeof v.label === 'string') {
                  return v.label;
                }
                // Si el label es un objeto, intentar extraer el string del label
                if (typeof v.label === 'object' && v.label !== null) {
                  // CASO ESPECIAL: El backend a veces devuelve una estructura anidada incorrecta:
                  // {_id: {label: "valor"}, label: {label: "valor"}}
                  // En este caso, necesitamos extraer label.label o _id.label
                  let labelValue = null;
                  
                  // Intentar extraer de label.label primero
                  if (v.label.label && typeof v.label.label === 'string') {
                    labelValue = v.label.label;
                  } else if (v.label.name && typeof v.label.name === 'string') {
                    labelValue = v.label.name;
                  } else if (v.label.value && typeof v.label.value === 'string') {
                    labelValue = v.label.value;
                  } else if (v._id && typeof v._id === 'object' && v._id.label && typeof v._id.label === 'string') {
                    // Si _id también es un objeto con label, usar ese
                    labelValue = v._id.label;
                  } else if (v.label._id) {
                    labelValue = String(v.label._id);
                  }
                  
                  if (labelValue && typeof labelValue === 'string') {
                    return labelValue;
                  }
                  // Si no se puede extraer, buscar en las listas usando el _id del valor
                  // Primero intentar obtener el _id real (puede estar anidado)
                  let actualId = v._id;
                  if (actualId && typeof actualId === 'object' && actualId._id) {
                    actualId = actualId._id;
                  }
                  
                  if (actualId && listType && this.lists && this.lists.length > 0) {
                    const list = this.lists.find((l) => l.type === listType);
                    if (list && list.values) {
                      const option = list.values.find(
                        (opt) => {
                          if (!opt._id) return false;
                          const optId = opt._id.toString();
                          const valId = actualId.toString();
                          return optId === valId;
                        }
                      );
                      if (option && option.label) {
                        // Si option.label es un string, retornarlo
                        if (typeof option.label === 'string') {
                          return option.label;
                        }
                        // Si option.label es un objeto, intentar extraer el string
                        if (typeof option.label === 'object' && option.label !== null) {
                          const extractedLabel = option.label.label || option.label.name || option.label.value || 
                                               (option.label._id ? String(option.label._id) : null);
                          if (extractedLabel && typeof extractedLabel === 'string') {
                            return extractedLabel;
                          }
                        }
                      }
                    }
                  }
                  // Si todo falla, retornar el _id como fallback
                  if (actualId) {
                    return String(actualId);
                  }
                  return "";
                }
                // Si el label es otro tipo, convertirlo a string
                return String(v.label);
              }
              // Fallback: Si es un objeto con _id pero sin label, cargar listas bajo demanda
              if (typeof v === "object" && v !== null && v._id) {
                // Solo cargar listas si realmente es necesario (fallback)
                if (listType && (!this.lists || this.lists.length === 0)) {
                  console.warn('[formatFieldValue] ⚠️ FALLBACK: Campo list sin label detectado', {
                    field: field.key,
                    listType: listType,
                    value: v,
                    reason: 'El backend debería haber mapeado este valor con label, pero no lo tiene. Cargando listas como fallback.',
                    model: this.selectedModel
                  });
                  // Cargar listas bajo demanda solo si no están cargadas
                  this.fetchLists().catch(() => {
                    // Si falla, continuar con el fallback
                  });
                }
                // Buscar en las listas usando listType (si ya están cargadas)
                if (listType && this.lists && this.lists.length > 0) {
                  const list = this.lists.find((l) => l.type === listType);
                  if (list && list.values) {
                    const option = list.values.find(
                      (opt) => opt._id && opt._id.toString() === v._id.toString()
                    );
                    if (option && option.label) {
                      return option.label;
                    }
                  }
                }
                // Si no se encuentra, usar el _id como fallback
                return String(v._id);
              }
              // Si es solo un ID (string o número), es un caso raro (el backend debería mapearlo)
              if (typeof v === 'string' || typeof v === 'number') {
                console.warn('[formatFieldValue] ⚠️ CASO RARO: Valor de lista es solo ID sin mapear', {
                  field: field.key,
                  listType: listType,
                  value: v,
                  reason: 'El backend debería haber devuelto un objeto con _id y label, pero solo vino el ID',
                  model: this.selectedModel
                });
              }
              // Usar el valor directamente
              return String(v);
            })
            .join(", ");
        } else {
          // Valor único (no array)
          // El backend ya devuelve los valores como objetos con _id y label
          // Confiar primero en los datos del backend
          if (typeof value === "object" && value !== null && value.label) {
            // Si tiene hierarchy, usar la jerarquía completa
            if (value.hierarchy && typeof value.hierarchy === 'string') {
              return value.hierarchy;
            }
            
            // Si el label es un string, retornarlo directamente
            if (typeof value.label === 'string') {
              return value.label;
            }
            // Si el label es un objeto, intentar extraer el string del label
            if (typeof value.label === 'object' && value.label !== null) {
              // CASO ESPECIAL: El backend a veces devuelve una estructura anidada incorrecta:
              // {_id: {label: "valor"}, label: {label: "valor"}}
              // En este caso, necesitamos extraer label.label o _id.label
              let labelValue = null;
              
              // Intentar extraer de label.label primero
              if (value.label.label && typeof value.label.label === 'string') {
                labelValue = value.label.label;
              } else if (value.label.name && typeof value.label.name === 'string') {
                labelValue = value.label.name;
              } else if (value.label.value && typeof value.label.value === 'string') {
                labelValue = value.label.value;
              } else if (value._id && typeof value._id === 'object' && value._id.label && typeof value._id.label === 'string') {
                // Si _id también es un objeto con label, usar ese
                labelValue = value._id.label;
              } else if (value.label._id) {
                labelValue = String(value.label._id);
              }
              
              if (labelValue && typeof labelValue === 'string') {
                return labelValue;
              }
              // Si no se puede extraer, buscar en las listas usando el _id del valor
              // Primero intentar obtener el _id real (puede estar anidado)
              let actualId = value._id;
              if (actualId && typeof actualId === 'object' && actualId._id) {
                actualId = actualId._id;
              }
              
              if (actualId && listType && this.lists && this.lists.length > 0) {
                const list = this.lists.find((l) => l.type === listType);
                if (list && list.values) {
                  const option = list.values.find(
                    (opt) => {
                      if (!opt._id) return false;
                      const optId = opt._id.toString();
                      const valId = actualId.toString();
                      return optId === valId;
                    }
                  );
                  if (option && option.label) {
                    // Si option.label es un string, retornarlo
                    if (typeof option.label === 'string') {
                      return option.label;
                    }
                    // Si option.label es un objeto, intentar extraer el string
                    if (typeof option.label === 'object' && option.label !== null) {
                      const extractedLabel = option.label.label || option.label.name || option.label.value || 
                                           (option.label._id ? String(option.label._id) : null);
                      if (extractedLabel && typeof extractedLabel === 'string') {
                        return extractedLabel;
                      }
                    }
                  }
                }
              }
              // Si todo falla, retornar el _id como fallback
              if (actualId) {
                return String(actualId);
              }
              return "";
            }
            // Si el label es otro tipo, convertirlo a string
            return String(value.label);
          }
          // Fallback: Si es un objeto con _id pero sin label, cargar listas bajo demanda
          if (typeof value === "object" && value !== null && value._id) {
            // Solo cargar listas si realmente es necesario (fallback)
            if (listType && (!this.lists || this.lists.length === 0)) {
              console.warn('[formatFieldValue] ⚠️ FALLBACK: Campo list sin label detectado', {
                field: field.key,
                listType: listType,
                value: value,
                reason: 'El backend debería haber mapeado este valor con label, pero no lo tiene. Cargando listas como fallback.',
                model: this.selectedModel
              });
              // Cargar listas bajo demanda solo si no están cargadas
              this.fetchLists().catch(() => {
                // Si falla, continuar con el fallback
              });
            }
            // Buscar en las listas usando listType (si ya están cargadas)
            if (listType && this.lists && this.lists.length > 0) {
              const list = this.lists.find((l) => l.type === listType);
              if (list && list.values) {
                const option = list.values.find(
                  (opt) => opt._id && opt._id.toString() === value._id.toString()
                );
                if (option && option.label) {
                  return option.label;
                }
              }
            }
            // Si no se encuentra, usar el _id como fallback
            return String(value._id);
          }
          // Si es solo un ID (string o número), es un caso raro (el backend debería mapearlo)
          if (typeof value === 'string' || typeof value === 'number') {
            console.warn('[formatFieldValue] ⚠️ CASO RARO: Valor de lista es solo ID sin mapear', {
              field: field.key,
              listType: listType,
              value: value,
              reason: 'El backend debería haber devuelto un objeto con _id y label, pero solo vino el ID',
              model: this.selectedModel
            });
          }
          // Usar el valor directamente
          return String(value || "");
        }
      }

      // Campo de tipo booleano
      if (fieldType === "boolean") {
        // Para arrays (reference_subfield con isArray), manejar como array
        if (Array.isArray(value)) {
          return value
            .map((v) => (v ? this.$t("Yes") || "Sí" : this.$t("No") || "No"))
            .join(", ");
        }
        return value ? this.$t("Yes") || "Sí" : this.$t("No") || "No";
      }

      // Campo de tipo array
      if (Array.isArray(value)) {
        return value.join(", ");
      }

      // Campo de tipo grupo (ya se maneja arriba con subcampos)
      if (field.type === "group") {
        return JSON.stringify(value);
      }

      // Por defecto, convertir a string
      return String(value || "");
    },
    */
    /**
     * Analiza una lista para determinar si es jerárquica y cuántos niveles tiene
     * @param {Object} field - Campo de tipo list
     * @returns {Object} - { isHierarchical, maxDepth, list }
     */
    getHierarchicalListInfo(field) {
      if (!field.listType || !this.lists) {
        if (!this.lists && field.listType) {
          console.log(
            "[getHierarchicalListInfo] ℹ️ Listas no cargadas para análisis jerárquico",
            {
              field: field.key,
              listType: field.listType,
              reason: "Las listas se cargarán bajo demanda si es necesario",
            }
          );
        }
        return { isHierarchical: false, maxDepth: 1, list: null };
      }

      const list = this.lists.find((l) => l.type === field.listType);
      if (!list || !list.values || !Array.isArray(list.values)) {
        return { isHierarchical: false, maxDepth: 1, list: null };
      }

      // Verificar si algún item tiene parent (lo hace jerárquico)
      const hasParents = list.values.some((item) => item && item.parent);
      if (!hasParents) {
        return { isHierarchical: false, maxDepth: 1, list };
      }

      // Calcular la profundidad máxima de la jerarquía
      const getDepth = (itemId, visited = new Set()) => {
        if (!itemId || visited.has(itemId.toString())) return 0;
        visited.add(itemId.toString());

        const item = list.values.find(
          (v) => v && v._id && v._id.toString() === itemId.toString()
        );
        if (!item) return 0;
        if (!item.parent) return 1;

        return 1 + getDepth(item.parent, visited);
      };

      let maxDepth = 1;
      for (const item of list.values) {
        if (item && item._id) {
          const depth = getDepth(item._id);
          if (depth > maxDepth) {
            maxDepth = depth;
          }
        }
      }

      return { isHierarchical: true, maxDepth, list };
    },
    /**
     * Obtiene los labels de toda la jerarquía de un valor de lista (de raíz a hoja)
     * @param {Object|String} value - Valor del campo (puede ser objeto con _id o ID directo)
     * @param {Object} list - Lista con los valores
     * @returns {Array<String>} - Array de labels desde la raíz hasta el elemento actual
     */
    getHierarchyLabels(value, list) {
      if (!value || !list || !list.values) {
        return [];
      }

      // Obtener el ID del valor
      let valueId = value;
      if (typeof value === "object" && value !== null) {
        valueId = value._id || value;
      }
      if (!valueId) return [];

      // Buscar el item en la lista
      const item = list.values.find(
        (v) => v && v._id && v._id.toString() === valueId.toString()
      );
      if (!item) return [];

      // Construir la jerarquía desde el item hacia arriba (hacia la raíz)
      const hierarchy = [];
      let currentItem = item;
      const visited = new Set();

      while (currentItem && !visited.has(currentItem._id?.toString())) {
        visited.add(currentItem._id?.toString());
        hierarchy.unshift(
          currentItem.label || currentItem.name || String(currentItem._id)
        );

        if (!currentItem.parent) break;

        // Buscar el padre
        currentItem = list.values.find(
          (v) =>
            v && v._id && v._id.toString() === currentItem.parent.toString()
        );
      }

      return hierarchy;
    },
    handlePageChange(page) {
      this.pagination.page = page;
      this.isLoading = true; // Mostrar loading
      // Mantener los filtros actuales al cambiar de página
      const queryString = this.getCurrentFiltersQueryString();
      this.fetchItems(queryString);
    },
    handlePerPageChange(perPage) {
      this.pagination.perPage = perPage;
      this.pagination.page = 1; // Reset to first page when changing items per page
      this.isLoading = true; // Mostrar loading
      // Mantener los filtros actuales al cambiar la cantidad por página
      const queryString = this.getCurrentFiltersQueryString();
      this.fetchItems(queryString);
    },
    /**
     * textPlainVersion no vive en filters{} del Filters.vue; está en textSearchQuery (y puede estar solo en la URL).
     */
    appendTextPlainVersionFromSearchOrRoute(params) {
      if (!params || params.has("textPlainVersion")) return;
      const tc = this.$refs.filtersComponent;
      let q = "";
      if (
        tc &&
        typeof tc.textSearchQuery === "string" &&
        tc.textSearchQuery.trim()
      ) {
        q = tc.textSearchQuery.trim();
      } else {
        const rq =
          this.$route &&
          this.$route.query &&
          this.$route.query.textPlainVersion;
        if (rq != null && rq !== "") {
          q = Array.isArray(rq)
            ? String(rq[0] || "").trim()
            : String(rq).trim();
        }
      }
      if (q) {
        params.append("textPlainVersion", q);
      }
    },
    // Obtener los filtros actuales como query string
    getCurrentFiltersQueryString() {
      const params = new URLSearchParams();
      if (
        !this.$refs.filtersComponent ||
        !this.$refs.filtersComponent.filters
      ) {
        const routeFilters = this.getFilterQueryParams(
          this.$route?.query || {}
        );
        Object.entries(routeFilters).forEach(([key, value]) => {
          if (value != null && value !== "") {
            params.append(
              key,
              Array.isArray(value)
                ? value.map(String).join(",")
                : String(value)
            );
          }
        });
        this.appendTextPlainVersionFromSearchOrRoute(params);
        this.appendOwnerScopeParam(params);
        return params.toString();
      }

      const filters = this.$refs.filtersComponent.filters;
      const filterOperators = this.$refs.filtersComponent.filterOperators || {};

      Object.entries(filters).forEach(([key, value]) => {
        const operator = filterOperators[key] || "=";

        // Incluir operadores especiales (is_null, is_not_null) ANTES de verificar si el valor está vacío
        // porque estos operadores pueden tener valores null o vacíos
        if (operator === "is_null" || operator === "is_not_null") {
          params.append(key, operator);
          return;
        }

        // Manejar texto plano (búsqueda de texto)
        if (key === "textPlainVersion") {
          if (value && value.trim()) {
            params.append(key, value.trim());
          }
          return;
        }

        // Permitir false como valor válido para booleanos, pero excluir null, undefined y ""
        if (value === null || value === undefined || value === "") return;

        const field =
          this.modelFields.find((f) => f.key === key) ||
          (this.$refs.filtersComponent.visibleFilterFields || []).find(
            (f) => f.key === key
          );
        let emitValue = value;
        if (field && field.type === "boolean") {
          emitValue = coerceBooleanFilterValue(value);
          if (typeof emitValue !== "boolean") return;
        }

        // Manejar objetos de referencia
        if (typeof emitValue === "object" && emitValue !== null && emitValue._id) {
          params.append(key, emitValue._id);
        }
        // Manejar arrays
        else if (Array.isArray(emitValue)) {
          params.append(key, emitValue.map((v) => v._id || v).join(","));
        }
        // Manejar valores simples con operadores
        else {
          const valueStr = String(emitValue);

          // Detectar si es un rango de fechas (formato "start - end")
          const isDateRange = valueStr.includes(" - ");

          // Aplicar formato de operador si es necesario
          if (operator === "contains") {
            params.append(key, `contains:${emitValue}`);
          } else if (operator === "startswith") {
            params.append(key, `startswith:${emitValue}`);
          } else if (operator === "endswith") {
            params.append(key, `endswith:${emitValue}`);
          } else if (operator === "regex") {
            params.append(key, `regex:${emitValue}`);
          } else if (operator !== "=" && operator !== "between" && !isDateRange) {
            // Para operadores de comparación (!=, >, <, >=, <=)
            // Si el valor ya contiene el operador, usar el valor directamente
            // De lo contrario, concatenar operador + valor
            // NOTA: No aplicar operadores a rangos de fechas (ya tienen formato "start - end")
            if (
              valueStr.startsWith(operator) ||
              valueStr.startsWith(">=") ||
              valueStr.startsWith("<=") ||
              valueStr.startsWith(">") ||
              valueStr.startsWith("<") ||
              valueStr.startsWith("!=")
            ) {
              // El valor ya tiene el operador, usar directamente
              params.append(key, valueStr.trim());
            } else {
              // Concatenar operador + valor
              params.append(key, `${operator}${emitValue}`);
            }
          } else {
            // Para operador = o rangos de fechas, usar el valor directamente
            params.append(key, emitValue);
          }
        }
      });

      this.appendTextPlainVersionFromSearchOrRoute(params);
      this.appendOwnerScopeParam(params);
      return params.toString();
    },

    // Método para detectar y agregar nuevas columnas automáticamente
    mergeNewColumns(preferences) {
      const mergedPreferences = { ...preferences };

      // Agregar campos normales que no estén en las preferencias
      this.nonGroupFields.forEach((field) => {
        if (mergedPreferences[field.key] === undefined && !field.hideDisplay) {
          // Para modelos de grupo, mostrar "name" por defecto (existe en esquema pero no en model definition)
          const defaultVisible =
            (this.isGroupModel() && field.key === "name") ||
            this.isListFlagFieldKey(field.key);
          mergedPreferences[field.key] = defaultVisible;
        }
      });

      // Agregar campos de grupo que no estén en las preferencias
      this.groupFields.forEach((field) => {
        if (mergedPreferences[field.key] === undefined && !field.hideDisplay) {
          mergedPreferences[field.key] = false; // Ocultar por defecto

          // Agregar subcampos del grupo
          field.fields.forEach((subField) => {
            const subFieldKey = `${field.key}.${subField.key}`;
            if (
              mergedPreferences[subFieldKey] === undefined &&
              !subField.hideDisplay
            ) {
              mergedPreferences[subFieldKey] = false; // Ocultar por defecto
            }
          });
        }
      });

      return mergedPreferences;
    },
    async fetchItem(itemId) {
      try {
        const { data } = await wencesApi.get(
          `/api/gotrading/dynamic/${this.selectedModel}/${itemId}`
        );
        this.editItem(data);
      } catch (error) {
        console.error("Error loading item:", error);
      }
    },
/** Reportes guardados (propios + publicos) del modelo actual, para la barra de tabs. */
    async fetchAccessibleReports() {
      const modelName = this.selectedModel;
      if (!modelName) {
        this.accessibleReports = [];
        return;
      }
      try {
        const { data } = await wencesApi.get(
          `/api/gotrading/reports?modelName=${encodeURIComponent(modelName)}`
        );
        // Evitar pisar la lista si el usuario cambio de modelo mientras cargaba
        if (this.selectedModel !== modelName) return;
        this.accessibleReports = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error("Error loading accessible reports:", error);
        if (this.selectedModel === modelName) {
          this.accessibleReports = [];
        }
      }
    },
    /**
     * Lee el color de fondo de la cabecera de la tabla (varia por modelo:
     * shipping verde, proform rojo, resto gris neutro) y lo reutiliza como
     * color del tab activo. Cabeceras neutras o muy claras conservan el azul
     * por defecto, que en ese caso es el legible.
     */
    syncReportTabsAccentColor() {
      if (!this.showReportTabsBar) return;
      if (this.reportTabsAccentModel === this.selectedModel) return;
      const th =
        this.$el && this.$el.querySelector
          ? this.$el.querySelector(
              ".gt-list-bottom-hscroll table thead tr.headerlist th"
            )
          : null;
      // Todavia no se renderizo la tabla: reintentar en el proximo update
      if (!th) return;

      this.reportTabsAccentModel = this.selectedModel;

      const background = window.getComputedStyle(th).backgroundColor || "";
      const match = background.match(/rgba?\(([^)]+)\)/);
      if (!match) {
        this.reportTabsAccentColor = null;
        return;
      }
      const parts = match[1].split(",").map((value) => parseFloat(value));
      const [r, g, b] = parts;
      const alpha = parts.length > 3 ? parts[3] : 1;
      if ([r, g, b].some((value) => Number.isNaN(value))) {
        this.reportTabsAccentColor = null;
        return;
      }
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      this.reportTabsAccentColor =
        alpha < 0.1 || luminance > 0.75 ? null : `rgb(${r}, ${g}, ${b})`;
    },
    canEditReportTab(report) {
      return canEditReport(report, this.currentUserId, this.isCurrentUserAdmin);
    },
    /** Lapiz del tab: edita nombre/descripcion/icono/visibilidad del reporte. */
    async editReportTab(report) {
      const updated = await openEditReportDialog({
        report,
        t: this.$t.bind(this),
        isAdmin: this.isCurrentUserAdmin,
      });
      if (!updated) return;

      await this.fetchAccessibleReports();

      // Si es el reporte abierto, reflejar los cambios en la cabecera del listado
      if (
        this.currentLoadedReport &&
        String(this.currentLoadedReport._id) === String(report._id)
      ) {
        this.currentLoadedReport = {
          ...this.currentLoadedReport,
          name: updated.name,
          description: updated.description,
          icon: updated.icon,
          isPublic: updated.isPublic,
        };
      }
    },
    isActiveReportTab(report) {
      if (!report || !report._id) return false;
      return String(this.activeReportTabId || "") === String(report._id);
    },
    /** Carga un reporte desde la barra de tabs (el watcher de $route hace el resto). */
    selectReportTab(report) {
      if (!report || !report._id || this.isActiveReportTab(report)) return;
      this.$router
        .push({
          path: this.$route.path,
          query: { reportId: String(report._id) },
        })
        .catch(() => {});
    },
    /** Vuelve al listado sin reporte (restaura las preferencias del usuario). */
    clearReportTab() {
      if (!this.activeReportTabId) return;
      this.$router
        .push({ path: this.$route.path, query: {} })
        .catch(() => {});
    },
    async fetchReportViews() {
      try {
        const { data } = await wencesApi.get(
          `/api/gotrading/views?modelName=${this.selectedModel}&type=report`
        );
        // Filtrar solo los reportes que pertenecen al modelo actual
        this.reportViews = data.filter(
          (view) =>
            (view.type === "report" || view.type === "combined_view") &&
            view.modelName.toLowerCase() === this.selectedModel.toLowerCase()
        );
      } catch (error) {
        console.error("Error loading report views:", error);
      }
    },
    goToReport(viewId, type) {
      let route;
      if (type === "combined_view") {
        route = this.$router.resolve({
          name: "DynamicModelCombined",
          params: {
            modelName: this.selectedModel,
            viewId: viewId,
          },
        });
      } else {
        route = this.$router.resolve({
          name: "DynamicModelReport",
          params: {
            modelName: this.selectedModel,
            viewId: viewId,
          },
        });
      }
      window.open(route.href, "_blank");
    },
    handleGoToReference({ modelName, itemId, itemName }) {
      console.log("[dynamic-model.handleGoToReference] 🔍 Navegando a:", {
        modelName,
        itemId,
      });
      if (!modelName || !itemId) {
        console.log("[dynamic-model.handleGoToReference] ⚠️ Faltan parámetros");
        return;
      }
      const path = buildDynamicModelItemViewPath(modelName, itemId, itemName);
      window.open(path, "_blank");
    },
    getFilteredVisibleFields(item) {
      return this.visibleTableFields.filter((field) => item && item[field.key]);
    },
    handleSort(field) {
      if (this.sortField === field) {
        // Toggle sort order if clicking the same field
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        // Set new sort field and default to ascending
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.isLoading = true; // Mostrar loading
      // Mantener los filtros actuales al ordenar
      const queryString = this.getCurrentFiltersQueryString();
      // En una vista hay que recargar por el endpoint de la vista (igual que
      // handleColumnsChanged): con fetchItems el orden traía los items del
      // modelo plano en lugar de los de la vista (ticket #395).
      if (this.reportSortPersistEnabled && this.view) {
        this.fetchViewItems(queryString);
      } else {
        this.fetchItems(queryString);
      }
    },
    async handleColumnsChanged() {
      // NO guardar automáticamente - solo actualizar la vista
      await this.loadVisibleTableFields();
      if (this.currentLoadedReport) {
        this.reportColumnLayout = normalizeColumnLayout(
          this.reportColumnLayout,
          this.visibleTableFields.map((f) => f.key)
        );
      }
      // Mantener los filtros actuales al cambiar columnas
      const queryString = this.getCurrentFiltersQueryString();
      // Usar el método correcto según si estamos en una vista o modelo normal
      if (this.view) {
        this.isLoading = true; // Mostrar loading
        this.fetchViewItems(queryString);
      } else {
        this.isLoading = true; // Mostrar loading
        this.fetchItems(queryString);
      }
    },
    handleFilterColumnsChanged(updatedColumns) {
      // Este método se llama cuando se cambian las columnas de filtro
      // Actualizar selectedFilterFields con los nuevos valores
      if (updatedColumns) {
        // Limpiar campos que ya no están seleccionados
        Object.keys(this.selectedFilterFields).forEach((key) => {
          if (!(key in updatedColumns)) {
            this.$delete(this.selectedFilterFields, key);
          }
        });
        // Actualizar con los nuevos valores
        Object.keys(updatedColumns).forEach((key) => {
          this.$set(this.selectedFilterFields, key, updatedColumns[key]);
        });
      }

      // Forzar la actualización de los campos visibles en el componente Filters
      // También inicializar filtros para los nuevos campos agregados
      this.$nextTick(() => {
        if (this.$refs.filtersComponent) {
          // Inicializar filtros para los nuevos campos que se agregaron
          Object.keys(this.selectedFilterFields).forEach((key) => {
            if (
              this.selectedFilterFields[key] &&
              this.$refs.filtersComponent.filters &&
              !(key in this.$refs.filtersComponent.filters)
            ) {
              this.$set(this.$refs.filtersComponent.filters, key, null);
              if (this.$refs.filtersComponent.filterOperators) {
                this.$set(
                  this.$refs.filtersComponent.filterOperators,
                  key,
                  "="
                );
              }
              // Inicializar rangos de fecha si es un campo de fecha
              const field = this.modelFields.find((f) => f.key === key);
              if (
                field &&
                field.type === "date" &&
                this.$refs.filtersComponent.tempDateRanges
              ) {
                this.$set(this.$refs.filtersComponent.tempDateRanges, key, {
                  start: "",
                  end: "",
                });
              }
            }
          });

          // Actualizar los campos visibles
          if (this.$refs.filtersComponent.updateVisibleFilterFields) {
            this.$refs.filtersComponent.updateVisibleFilterFields();
          }
        }
      });

      // Detectar campos de filtro que se quitaron y limpiar sus filtros aplicados
      if (this.$refs.filtersComponent) {
        // Comparar el estado guardado con el estado actual para encontrar campos quitados
        const savedFields = Object.keys(this.savedSelectedFilterFields || {});
        const currentFields = Object.keys(this.selectedFilterFields || {});

        // Encontrar campos que estaban guardados pero ya no están seleccionados
        const removedFields = savedFields.filter((fieldKey) => {
          // El campo estaba guardado (true) pero ahora no está o está en false
          return (
            this.savedSelectedFilterFields[fieldKey] === true &&
            this.selectedFilterFields[fieldKey] !== true
          );
        });

        // Limpiar los filtros aplicados para los campos quitados
        let hasClearedFilters = false;
        removedFields.forEach((fieldKey) => {
          if (
            this.$refs.filtersComponent.filters &&
            this.$refs.filtersComponent.filters[fieldKey] !== null &&
            this.$refs.filtersComponent.filters[fieldKey] !== ""
          ) {
            // Limpiar el filtro directamente en el componente Filters
            this.$set(this.$refs.filtersComponent.filters, fieldKey, null);
            if (this.$refs.filtersComponent.filterOperators) {
              this.$set(
                this.$refs.filtersComponent.filterOperators,
                fieldKey,
                "="
              );
            }
            // Limpiar también los rangos de fecha si es un campo de fecha
            if (
              this.$refs.filtersComponent.tempDateRanges &&
              this.$refs.filtersComponent.tempDateRanges[fieldKey]
            ) {
              this.$set(this.$refs.filtersComponent.tempDateRanges, fieldKey, {
                start: "",
                end: "",
              });
            }
            hasClearedFilters = true;
          }
        });

        // Emitir los filtros actualizados una sola vez después de limpiar todos
        if (hasClearedFilters && this.$refs.filtersComponent.emitFilters) {
          this.$refs.filtersComponent.emitFilters();
        }
      }
    },
    handleFilterPopupOpened() {
      // Las preferencias ya se cargaron antes de abrir el popup
      // No es necesario hacer otra llamada al endpoint
    },
    async handleFilterSavePreferences(applyToAll = false) {
      try {
        // Si hay un reporte cargado, NO guardar preferencias generales
        // Los cambios se guardarán cuando se guarde el reporte
        if (this.currentLoadedReport) {
          console.log(
            "📊 Report loaded - filter field selection will be saved with the report"
          );
          return;
        }

        // Solo guardar preferencias generales si NO hay reporte cargado
        const preferences = {
          modelName: this.selectedModel,
          preferences: this.selectedFilterFields,
          applyToAll: applyToAll, // Opción para aplicar a todos los usuarios (admin o preferences.apply_to_all)
        };

        console.log(
          "💾 Saving filter field selection (general preferences):",
          preferences
        );
        await wencesApi.post("/api/users/filter-preferences", preferences);
        console.log("✅ Filter field selection saved successfully");
      } catch (error) {
        console.error("❌ Error saving filter field selection:", error);
      }
    },
    async handleFilterButtonClick() {
      // Mostrar indicador de carga
      this.isLoadingFilterPreferences = true;
      try {
        // Si hay un reporte cargado, usar sus selectedFilterFields en lugar de cargar preferencias generales
        if (
          this.currentLoadedReport &&
          this.currentLoadedReport.selectedFilterFields
        ) {
          // Ya tenemos selectedFilterFields del reporte cargado, no necesitamos cargar preferencias generales
          // Solo asegurarnos de que savedSelectedFilterFields esté sincronizado
          this.savedSelectedFilterFields = JSON.parse(
            JSON.stringify(this.selectedFilterFields)
          );
        } else {
          // Si no hay reporte cargado, cargar las preferencias generales del usuario
          await this.loadFilterPreferences();
        }
        // Luego abrir el popup
        this.showFilterColumnSelector = true;
      } catch (error) {
        console.error("Error loading filter preferences:", error);
      } finally {
        // Ocultar indicador de carga
        this.isLoadingFilterPreferences = false;
      }
    },
    async loadFilterPreferences(forceRefresh = false) {
      try {
        // Usar selectedModel como identificador
        if (!this.selectedModel) {
          return;
        }

        // NO cargar preferencias si hay un reporte cargado o un reportId en la URL
        // Los filtros del reporte tienen prioridad sobre las preferencias generales
        const reportId = this.$route.query?.reportId;
        if (this.currentLoadedReport || reportId) {
          return;
        }

        // Verificar cache
        const now = Date.now();
        const cacheKey = this.selectedModel;
        if (
          !forceRefresh &&
          this.filterPreferencesCache[cacheKey] &&
          this.filterPreferencesCacheTimestamp[cacheKey] &&
          now - this.filterPreferencesCacheTimestamp[cacheKey] <
            this.filterPreferencesCacheMaxAge
        ) {
          const cached = this.filterPreferencesCache[cacheKey];
          this.selectedFilterFields = cached;
          this.savedSelectedFilterFields = JSON.parse(JSON.stringify(cached));
          return;
        }

        const { data } = await wencesApi.get(
          `/api/users/filter-preferences/${this.selectedModel}`
        );

        let preferences;
        if (data.data && data.data.preferences) {
          preferences = data.data.preferences;
          this.selectedFilterFields = preferences;
          // Guardar el estado "guardado" para comparación
          this.savedSelectedFilterFields = JSON.parse(
            JSON.stringify(preferences)
          );
        } else {
          // Si no hay preferencias guardadas, inicializar todos los campos como visibles
          preferences = {};
          this.modelFields.forEach((field) => {
            if (field.type === "group" && field.fields) {
              this.$set(this.selectedFilterFields, field.key, true);
              preferences[field.key] = true;
              field.fields.forEach((subField) => {
                const subKey = `${field.key}.${subField.key}`;
                this.$set(this.selectedFilterFields, subKey, true);
                preferences[subKey] = true;
              });
            } else {
              this.$set(this.selectedFilterFields, field.key, true);
              preferences[field.key] = true;
            }
          });
          // Guardar el estado "guardado" para comparación (inicializado)
          this.savedSelectedFilterFields = JSON.parse(
            JSON.stringify(this.selectedFilterFields)
          );
        }

        // Actualizar cache
        this.filterPreferencesCache[cacheKey] = preferences;
        this.filterPreferencesCacheTimestamp[cacheKey] = now;
      } catch (error) {
        console.error("Error loading filter preferences:", error);
        // En caso de error, inicializar con valores por defecto
        this.modelFields.forEach((field) => {
          if (field.type === "group" && field.fields) {
            this.$set(this.selectedFilterFields, field.key, true);
            field.fields.forEach((subField) => {
              this.$set(
                this.selectedFilterFields,
                `${field.key}.${subField.key}`,
                true
              );
            });
          } else {
            this.$set(this.selectedFilterFields, field.key, true);
          }
        });
      }
    },
    openDeleteBlockedFinancialModal(entities, summaryText = "") {
      this.deleteBlockedFinancialEntities = Array.isArray(entities)
        ? entities.filter(Boolean)
        : [];
      this.deleteBlockedFinancialSummary = summaryText || "";
      this.showDeleteBlockedFinancialModal = true;
    },
    closeDeleteBlockedFinancialModal() {
      this.showDeleteBlockedFinancialModal = false;
      this.deleteBlockedFinancialEntities = [];
      this.deleteBlockedFinancialSummary = "";
    },
    resolveFailedDeleteLabel(failedItem) {
      if (!failedItem) return "";
      const fromDetails = failedItem.blockDetails && failedItem.blockDetails.name;
      if (fromDetails) return String(fromDetails);
      const id = failedItem.id != null ? String(failedItem.id) : "";
      const fromList = (this.items || []).find(
        (it) => it && String(it._id) === id
      );
      if (fromList && (fromList.name || fromList.idModel)) {
        return String(fromList.name || fromList.idModel);
      }
      const msg = String(failedItem.error || "");
      const m = msg.match(
        /No se puede eliminar (?:la proforma|el embarque) (.+?) porque/
      );
      if (m && m[1]) return m[1].trim();
      return id ? `…${id.slice(-6)}` : this.$t("record");
    },
    async confirmDelete(item) {
      const trashCommentField = getTrashCommentField(this.modelFields);
      const showComment = shouldShowTrashDeleteComment(this.selectedModel, trashCommentField);
      const messageText = `${this.$tn("Do you want to move this")} ${
        this.selectedModelData.label || this.$tn("record")
      } ${this.$tn("to the trash? You can recover it later.")}`;
      const checkboxHtml = deletePermanentlyCheckboxHtml(this.$tn.bind(this));
      let deletePermanently = false;

      const result = await Swal.fire({
        title: this.$tn("Are you sure?"),
        ...(showComment
          ? {
              html: buildTrashDeleteConfirmHtml({
                messageHtml: `<p>${messageText}</p>`,
                commentHtml:
                  buildTrashCommentFieldHtml(
                    this.$tn.bind(this),
                    this.selectedModel,
                    trashCommentField
                  ) + checkboxHtml,
              }),
              ...getTrashDeleteCommentSwalOptions(),
              preConfirm: resolveTrashDeletePreConfirm(this.selectedModel, trashCommentField),
            }
          : { html: `<div style="text-align: left;"><p>${messageText}</p>${checkboxHtml}</div>` }),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: this.$tn("Yes, move to trash"),
        cancelButtonText: this.$tn("Cancel"),
        didOpen: () => {
          bindDeletePermanentlyCheckbox({
            trashText: this.$tn("Yes, move to trash"),
            permanentText: this.$tn("Yes, permanently delete"),
            onChange: (checked) => {
              deletePermanently = checked;
            },
          });
        },
      });

      if (result.isConfirmed) {
        try {
          const trashDeleteComment = showComment
            ? trashDeleteCommentFromSwalResult(result)
            : "";
          const deleteConfig = trashDeleteComment
            ? buildSoftDeleteRequestConfig(trashDeleteComment)
            : {};
          showTrashDeleteLoadingSwal();
          try {
            await wencesApi.delete(
              deletePermanently
                ? `/api/gotrading/dynamic/${this.selectedModel}/${item._id}/permanent`
                : `/api/gotrading/dynamic/${this.selectedModel}/${item._id}`,
              deleteConfig
            );
          } finally {
            closeTrashDeleteLoadingSwal();
          }
          await Swal.fire({
            title: deletePermanently ? this.$tn("Deleted") : this.$tn("Moved to trash"),
            text: deletePermanently
              ? this.$tn("The record has been permanently deleted.")
              : this.$tn("The record has been moved to trash successfully."),
            icon: "success",
          });
          // Usar el método correcto según si estamos en una vista o modelo normal
          if (this.view) {
            this.isLoading = true; // Mostrar loading
            this.fetchViewItems();
          } else {
            this.isLoading = true; // Mostrar loading
            this.fetchItems();
          }
        } catch (error) {
          console.error("Error deleting:", error);
          const errorData = getApiErrorData(error);
          if (
            errorData &&
            errorData.code === "DELETE_BLOCKED_BY_FINANCIAL_LINKS" &&
            errorData.blockDetails
          ) {
            this.openDeleteBlockedFinancialModal([errorData.blockDetails]);
            return;
          }
          await Swal.fire({
            title: this.$tn("Error"),
            text: getApiErrorMessage(
              error,
              deletePermanently
                ? this.$tn("An error occurred while deleting the record.")
                : this.$tn("An error occurred while moving the record to trash.")
            ),
            icon: "error",
          });
        }
      }
    },
    async confirmRestoreAll() {
      if (!this.selectedItems.length) return;

      const result = await Swal.fire({
        title: this.$tn("Restore?"),
        text: `${this.$tn("Do you want to restore")} ${
          this.selectedItems.length
        } ${this.$tn("records")}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        confirmButtonText: this.$tn("Yes, restore"),
        cancelButtonText: this.$tn("Cancel"),
      });

      if (result.isConfirmed) {
        try {
          const response = await wencesApi.post(
            `/api/gotrading/dynamic/${this.selectedModel}/bulk-restore`,
            { ids: this.selectedItems }
          );

          console.log("Bulk restore response:", response);

          // Mostrar mensaje de éxito con resultados detallados
          const successCount = response.data.results?.success?.length || 0;
          const failedCount = response.data.results?.failed?.length || 0;

          if (failedCount === 0) {
            await Swal.fire({
              title: this.$tn("Restored"),
              text: `${successCount} ${this.$tn(
                "records have been restored successfully."
              )}`,
              icon: "success",
            });
          } else {
            await Swal.fire({
              title: this.$tn("Partial Success"),
              text: `${successCount} ${this.$tn(
                "records restored"
              )}, ${failedCount} ${this.$tn("failed")}.`,
              icon: "warning",
            });
          }

          // Limpiar selección y recargar items
          this.selectedItems = [];
          // Usar el método correcto según si estamos en una vista o modelo normal
          if (this.view) {
            this.fetchViewItems();
          } else {
            this.fetchItems();
          }
        } catch (error) {
          console.error("Error in bulk restore:", error);
          await Swal.fire({
            title: this.$tn("Error"),
            text: this.$tn("An error occurred while restoring the records."),
            icon: "error",
          });
        }
      }
    },
    async archiveSelected() {
      if (!this.selectedItems.length || !this.canUseArchive) return;

      try {
        const response = await wencesApi.post(
          `/api/gotrading/dynamic/${this.selectedModel}/bulk-archive`,
          { ids: this.selectedItems }
        );

        const successCount = response.data.results?.success?.length || 0;
        const failedCount = response.data.results?.failed?.length || 0;

        if (failedCount === 0) {
          this.$toast?.success?.(
            `${successCount} ${this.$t("records archived successfully.")}`
          );
        } else if (successCount > 0) {
          this.$toast?.warning?.(
            `${successCount} ${this.$t("records archived")}, ${failedCount} ${this.$t("failed")}.`
          );
        } else {
          this.$toast?.error?.(this.$t("An error occurred while archiving the records."));
        }

        this.selectedItems = [];
        if (this.view) {
          this.fetchViewItems();
        } else {
          this.fetchItems();
        }
      } catch (error) {
        console.error("Error in bulk archive:", error);
        this.$toast?.error?.(this.$t("An error occurred while archiving the records."));
      }
    },
    async unarchiveSelected() {
      if (!this.selectedItems.length) return;

      try {
        const response = await wencesApi.post(
          `/api/gotrading/dynamic/${this.selectedModel}/bulk-unarchive`,
          { ids: this.selectedItems }
        );

        const successCount = response.data.results?.success?.length || 0;
        const failedCount = response.data.results?.failed?.length || 0;

        if (failedCount === 0) {
          this.$toast?.success?.(
            `${successCount} ${this.$t("records unarchived successfully.")}`
          );
        } else if (successCount > 0) {
          this.$toast?.warning?.(
            `${successCount} ${this.$t("records unarchived")}, ${failedCount} ${this.$t("failed")}.`
          );
        } else {
          this.$toast?.error?.(this.$t("An error occurred while unarchiving the records."));
        }

        this.selectedItems = [];
        if (this.view) {
          this.fetchViewItems();
        } else {
          this.fetchItems();
        }
      } catch (error) {
        console.error("Error in bulk unarchive:", error);
        this.$toast?.error?.(this.$t("An error occurred while unarchiving the records."));
      }
    },
    async unarchiveItem(item) {
      try {
        await wencesApi.post(
          `/api/gotrading/dynamic/${this.selectedModel}/bulk-unarchive`,
          { ids: [item._id] }
        );
        this.$toast?.success?.(this.$t("The record has been unarchived successfully."));
        this.fetchItems();
      } catch (error) {
        console.error("Error unarchiving:", error);
        this.$toast?.error?.(this.$t("An error occurred while unarchiving the record."));
      }
    },
    async restoreItem(item) {
      const result = await Swal.fire({
        title: this.$tn("Restore?"),
        text: `${this.$tn("Do you want to restore this")} ${
          this.selectedModelData.label || this.$tn("record")
        }?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        confirmButtonText: this.$tn("Yes, restore"),
        cancelButtonText: this.$tn("Cancel"),
      });

      if (result.isConfirmed) {
        try {
          await wencesApi.post(
            `/api/gotrading/dynamic/${this.selectedModel}/${item._id}/restore`
          );
          await Swal.fire({
            title: this.$tn("Restored"),
            text: this.$tn("The record has been restored successfully."),
            icon: "success",
          });
          // Recargar items
          this.fetchItems();
        } catch (error) {
          console.error("Error restoring:", error);
          await Swal.fire({
            title: this.$tn("Error"),
            text: this.$tn("An error occurred while restoring the record."),
            icon: "error",
          });
        }
      }
    },
    async permanentDelete(item) {
      const trashCommentField = getTrashCommentField(this.modelFields);
      const commentHtml = trashCommentField
        ? deleteCommentFieldHtml(this.$t.bind(this), trashCommentField)
        : "";

      const result = await Swal.fire({
        title: this.$tn("Permanently delete?"),
        html: trashCommentField
          ? buildTrashDeleteConfirmHtml({
              messageHtml: `<p>${this.$tn("Are you sure you want to permanently delete this")} ${
                this.selectedModelData.label || this.$tn("record")
              }?</p><p class="text-danger mb-0">${this.$tn("This action cannot be undone.")}</p>`,
              commentHtml,
            })
          : `${this.$tn("Are you sure you want to permanently delete this")} ${
          this.selectedModelData.label || this.$tn("record")
        }?<br><br><span class="text-danger">${this.$tn(
          "This action cannot be undone."
        )}</span>`,
        ...(trashCommentField ? getTrashDeleteCommentSwalOptions() : {}),
        ...(trashCommentField ? { preConfirm: trashDeleteCommentPreConfirm } : {}),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: this.$tn("Yes, permanently delete"),
        cancelButtonText: this.$tn("Cancel"),
      });

      if (result.isConfirmed) {
        const trashDeleteComment = trashCommentField
          ? trashDeleteCommentFromSwalResult(result)
          : "";
        const deleteConfig = trashDeleteComment
          ? buildSoftDeleteRequestConfig(trashDeleteComment)
          : {};
        try {
          showTrashDeleteLoadingSwal();
          try {
            await wencesApi.delete(
              `/api/gotrading/dynamic/${this.selectedModel}/${item._id}/permanent`,
              deleteConfig
            );
          } finally {
            closeTrashDeleteLoadingSwal();
          }
          await Swal.fire({
            title: this.$tn("Deleted"),
            text: this.$tn("The record has been permanently deleted."),
            icon: "success",
          });
          // Recargar items
          this.fetchItems();
        } catch (error) {
          console.error("Error permanently deleting:", error);
          const errorData = getApiErrorData(error);
          if (
            errorData &&
            errorData.code === "DELETE_BLOCKED_BY_FINANCIAL_LINKS" &&
            errorData.blockDetails
          ) {
            this.openDeleteBlockedFinancialModal([errorData.blockDetails]);
            return;
          }
          await Swal.fire({
            title: this.$tn("Error"),
            text: getApiErrorMessage(
              error,
              this.$tn("An error occurred while deleting the record.")
            ),
            icon: "error",
          });
        }
      }
    },
    handleImportSuccess(result) {
      // Usar el método correcto según si estamos en una vista o modelo normal
      if (this.view) {
        this.isLoading = true; // Mostrar loading
        this.fetchViewItems();
      } else {
        this.isLoading = true; // Mostrar loading
        this.fetchItems();
      }
    },

    handleBulkEditSuccess() {
      this.showBulkEdit = false;
      this.selectedItems = []; // Limpiar selección después de editar
      // Usar el método correcto según si estamos en una vista o modelo normal
      if (this.view) {
        this.isLoading = true; // Mostrar loading
        this.fetchViewItems();
      } else {
        this.isLoading = true; // Mostrar loading
        this.fetchItems();
      }
    },
    async selectAllItems() {
      const total = this.pagination?.total || 0;
      if (total === 0) {
        this.selectedItems = [];
        return;
      }

      if (this.isAllFilteredSelected) {
        this.selectedItems = [];
        return;
      }

      this.selectingAllItems = true;
      try {
        const params = new URLSearchParams(this.getCurrentFiltersQueryString());
        params.set("all", "true");
        params.set("fields", "_id");

        if (this.sortField) {
          params.set("order", this.sortField);
          params.set("orderDirection", this.sortOrder);
        }

        if (this.isTrashView) {
          params.set("deleted", "true");
        }
        if (this.isArchiveView) {
          params.set("archived", "true");
        }
        this.appendReportHideListParams(params);

        let url;
        if (this.view) {
          url = `/api/gotrading/views/${
            this.effectiveViewId
          }/combined-items?${params.toString()}`;
        } else {
          url = `/api/gotrading/dynamic/${
            this.selectedModel
          }?${params.toString()}`;
        }

        const { data } = await wencesApi.get(url);
        this.selectedItems = extractItemIds(normalizeListResponseItems(data));
      } catch (error) {
        console.error("Error selecting all filtered items:", error);
        await Swal.fire({
          title: this.$tn("Error"),
          text: this.$tn("An error occurred while selecting records."),
          icon: "error",
        });
      } finally {
        this.selectingAllItems = false;
      }
    },
    async confirmDeleteAllRecords() {
      if (!this.canDeleteAllRecords || !this.selectedModel || this.view) return;

      try {
        const totalItems = this.pagination?.total || this.items.length || 0;
        const result = await Swal.fire({
          title: this.$tn("Permanently delete all?"),
          html: `
            <div>
              ${this.$tn(
                "This will permanently delete the full collection"
              )} <strong>${
            this.selectedModel
          }</strong> (${totalItems} ${this.$tn("records")}).<br/>
              <span class="text-danger">${this.$tn(
                "This action cannot be undone."
              )}</span>
            </div>
          `,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#6c757d",
          confirmButtonText: this.$tn("Yes, permanently delete all"),
          cancelButtonText: this.$tn("Cancel"),
        });

        if (!result.isConfirmed) return;

        const response = await wencesApi.post(
          `/api/gotrading/dynamic/${this.selectedModel}/purge-all`
        );
        const deletedCount = response?.data?.deletedCount || 0;

        await Swal.fire({
          title: this.$tn("Deleted"),
          text: `${deletedCount} ${this.$tn(
            "records have been permanently deleted."
          )}`,
          icon: "success",
        });

        this.selectedItems = [];
        if (this.view) {
          this.fetchViewItems();
        } else {
          this.fetchItems();
        }
      } catch (error) {
        console.error("Error purging full collection:", error);
        await Swal.fire({
          title: this.$tn("Error"),
          text: this.$tn(
            "An error occurred while deleting the full collection."
          ),
          icon: "error",
        });
      }
    },
    async confirmDeleteAll(options = {}) {
      if (!this.selectedItems.length) return;
      const deleteAllMode = options.deleteAllMode === true;

      // Determinar el mensaje según si estamos en papelera o no
      const isPermanentDelete = this.isTrashView;
      const title = isPermanentDelete
        ? this.$t("Permanently delete?")
        : this.$t("Are you sure?");
      const text = deleteAllMode
        ? isPermanentDelete
          ? `${this.$t(
              "Are you sure you want to permanently delete all filtered records"
            )} (${this.selectedItems.length})? ${this.$t(
              "This action cannot be undone."
            )}`
          : `${this.$t("Do you want to move all filtered records")} (${
              this.selectedItems.length
            }) ${this.$t("to the trash? You can recover them later.")}`
        : isPermanentDelete
        ? `${this.$t("Are you sure you want to permanently delete")} ${
            this.selectedItems.length
          } ${this.$t("records")}? ${this.$t("This action cannot be undone.")}`
        : `${this.$t("Do you want to move")} ${
            this.selectedItems.length
          } ${this.$t("records")} ${this.$t(
            "to the trash? You can recover them later."
          )}`;
      const confirmText = isPermanentDelete
        ? deleteAllMode
          ? this.$t("Yes, permanently delete all")
          : this.$t("Yes, permanently delete")
        : deleteAllMode
        ? this.$t("Yes, move all to trash")
        : this.$t("Yes, move to trash");

      const modelTrashCommentField = getTrashCommentField(this.modelFields);
      const showComment = shouldShowTrashDeleteComment(this.selectedModel, modelTrashCommentField, {
        isPermanentDelete,
      });

      // En papelera ya es permanente; fuera de ella se ofrece el checkbox.
      const checkboxHtml = isPermanentDelete
        ? ""
        : deletePermanentlyCheckboxHtml(this.$t.bind(this));
      let deletePermanently = isPermanentDelete;

      const result = await Swal.fire({
        title: title,
        ...(showComment
          ? {
              html: buildTrashDeleteConfirmHtml({
                messageHtml: `<p>${text}</p>`,
                commentHtml:
                  buildTrashCommentFieldHtml(
                    this.$t.bind(this),
                    this.selectedModel,
                    modelTrashCommentField || { key: "commentdelete" }
                  ) + checkboxHtml,
              }),
              ...getTrashDeleteCommentSwalOptions(),
              preConfirm: resolveTrashDeletePreConfirm(
                this.selectedModel,
                modelTrashCommentField || { key: "commentdelete" }
              ),
            }
          : checkboxHtml
          ? { html: `<div style="text-align: left;"><p>${text}</p>${checkboxHtml}</div>` }
          : { text }),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: confirmText,
        cancelButtonText: this.$tn("Cancel"),
        didOpen: () => {
          if (isPermanentDelete) return;
          bindDeletePermanentlyCheckbox({
            trashText: confirmText,
            permanentText: deleteAllMode
              ? this.$tn("Yes, permanently delete all")
              : this.$tn("Yes, permanently delete"),
            onChange: (checked) => {
              deletePermanently = checked;
            },
          });
        },
      });

      // Variables para WebSocket (declaradas fuera del try para que estén disponibles en catch)
      let progressWs = null;
      let progressInterval = null;

      if (result.isConfirmed) {
        const trashDeleteComment = showComment
          ? trashDeleteCommentFromSwalResult(result)
          : "";
        try {
          // Conectar WebSocket para recibir actualizaciones de progreso
          const userId =
            localStorage.getItem("userId") || localStorage.getItem("_id");

          // Configurar WebSocket para recibir actualizaciones de progreso
          const setupProgressListener = () => {
            try {
              // Usar la misma estructura que otros componentes
              const wsUrl = process.env.VUE_APP_WEBHOOK_API_URL
                ? process.env.VUE_APP_WEBHOOK_API_URL.replace(
                    /^https?/,
                    window.location.protocol === "https:" ? "wss" : "ws"
                  )
                : (window.location.protocol === "https:" ? "wss:" : "ws:") +
                  "//" +
                  window.location.hostname +
                  ":4000";

              console.log("🔌 [BULK_DELETE] Conectando WebSocket a:", wsUrl);
              progressWs = new WebSocket(wsUrl);

              progressWs.onopen = () => {
                console.log("✅ [BULK_DELETE] WebSocket conectado");
                if (userId) {
                  const identifyMessage = {
                    type: "identify",
                    userId: userId + "-" + Date.now(),
                  };
                  console.log(
                    "📤 [BULK_DELETE] Enviando identificación:",
                    identifyMessage
                  );
                  progressWs.send(JSON.stringify(identifyMessage));
                } else {
                  console.warn("⚠️ [BULK_DELETE] No hay userId disponible");
                }
              };

              progressWs.onmessage = (event) => {
                try {
                  const message = JSON.parse(event.data);
                  console.log("📥 [BULK_DELETE] Mensaje recibido:", message);

                  if (
                    message.type === "bulk_delete_progress" &&
                    message.modelName === this.selectedModel
                  ) {
                    // Actualizar el SweetAlert con el progreso
                    const progress = message.progress || 0;
                    const current = message.current || 0;
                    const total = message.total || this.selectedItems.length;
                    const success = message.success || 0;
                    const failed = message.failed || 0;

                    console.log(
                      `📊 [BULK_DELETE] Actualizando progreso: ${current}/${total} (${progress}%)`
                    );

                    const updateTitle = deletePermanently
                      ? this.$t("Permanently deleting records...")
                      : this.$t("Moving records to trash...");
                    Swal.update({
                      title: updateTitle,
                      html: `
                        <div style="text-align: center;">
                          <div style="margin-bottom: 20px;">
                            <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">
                              ${current} / ${total} records
                            </div>
                            <div style="width: 100%; background-color: #e0e0e0; border-radius: 10px; overflow: hidden;">
                              <div style="width: ${progress}%; background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%); height: 30px; transition: width 0.3s ease; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold;">
                                ${progress}%
                              </div>
                            </div>
                          </div>
                          <div style="font-size: 14px; color: #666;">
                            <div style="margin: 5px 0;">✅ Success: <strong>${success}</strong></div>
                            ${
                              failed > 0
                                ? `<div style="margin: 5px 0; color: #dc3545;">❌ Failed: <strong>${failed}</strong></div>`
                                : ""
                            }
                          </div>
                        </div>
                      `,
                    });
                  } else {
                    console.log(
                      "ℹ️ [BULK_DELETE] Mensaje ignorado (tipo o modelo no coincide):",
                      message.type,
                      message.modelName,
                      "vs",
                      this.selectedModel
                    );
                  }
                } catch (e) {
                  console.error(
                    "❌ [BULK_DELETE] Error parsing WebSocket message:",
                    e,
                    event.data
                  );
                }
              };

              progressWs.onerror = (error) => {
                console.error("❌ [BULK_DELETE] WebSocket error:", error);
              };

              progressWs.onclose = (event) => {
                console.log(
                  "🔌 [BULK_DELETE] WebSocket cerrado:",
                  event.code,
                  event.reason
                );
              };
            } catch (e) {
              console.error(
                "❌ [BULK_DELETE] Could not setup WebSocket for progress updates:",
                e
              );
            }
          };

          // Configurar WebSocket ANTES de iniciar el bulk delete
          await new Promise((resolve) => {
            setupProgressListener();
            // Esperar un poco para que el WebSocket se conecte
            setTimeout(() => {
              resolve();
            }, 500);
          });

          // Mostrar loading inicial
          const loadingTitle = deletePermanently
            ? this.$t("Permanently deleting records...")
            : this.$t("Moving records to trash...");
          Swal.fire({
            title: loadingTitle,
            html: `
              <div style="text-align: center;">
                <div style="margin-bottom: 20px;">
                  <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">
                    0 / ${this.selectedItems.length} records
                  </div>
                  <div style="width: 100%; background-color: #e0e0e0; border-radius: 10px; overflow: hidden;">
                    <div style="width: 0%; background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%); height: 30px; transition: width 0.3s ease; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold;">
                      0%
                    </div>
                  </div>
                </div>
                <div style="font-size: 14px; color: #666;">
                  <div style="margin: 5px 0;">✅ Success: <strong>0</strong></div>
                  <div style="margin: 5px 0;">❌ Failed: <strong>0</strong></div>
                </div>
              </div>
            `,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          // ✅ USAR NUEVO ENDPOINT DE BULK DELETE (secuencial)
          const bulkDeletePayload = { ids: this.selectedItems };
          if (trashDeleteComment) {
            bulkDeletePayload.commentdelete = trashDeleteComment;
          }
          if (deletePermanently) {
            bulkDeletePayload.permanent = true;
          }
          const response = await wencesApi.post(
            `/api/gotrading/dynamic/${this.selectedModel}/bulk-delete`,
            bulkDeletePayload
          );

          // Cerrar WebSocket cuando termine
          if (progressWs) {
            progressWs.close();
          }
          if (progressInterval) {
            clearInterval(progressInterval);
          }

          // Cerrar el Swal de progreso antes de mostrar éxito / popup de bloqueo
          Swal.close();

          console.log("Bulk delete response:", response);

          // Mostrar mensaje de éxito con resultados detallados
          const successCount = response.data.results?.success?.length || 0;
          const failedCount = response.data.results?.failed?.length || 0;

          const successTitle = deletePermanently
            ? this.$t("Deleted")
            : this.$t("Moved to trash");
          const successText = deletePermanently
            ? `${successCount} ${this.$t(
                "records have been permanently deleted."
              )}`
            : `${successCount} ${this.$t(
                "records have been moved to trash successfully."
              )}`;

          if (failedCount === 0) {
            await Swal.fire({
              title: successTitle,
              text: successText,
              icon: "success",
            });
          } else {
            const failed = response.data.results?.failed || [];
            const blockedEntities = failed
              .map((f) => f && f.blockDetails)
              .filter(Boolean);
            const looksFinancial =
              blockedEntities.length > 0 ||
              failed.some(
                (f) =>
                  typeof (f && f.error) === "string" &&
                  /No se puede eliminar .+ porque tiene/.test(f.error)
              );
            const summary = `${successCount} ${
              deletePermanently
                ? this.$t("records deleted")
                : this.$t("records moved to trash")
            }, ${failedCount} ${this.$t("failed")}.`;

            if (looksFinancial) {
              // Si faltan blockDetails (API vieja), armar entidades mínimas clickeables por id.
              const entities =
                blockedEntities.length > 0
                  ? blockedEntities
                  : failed
                      .filter((f) => f && f.id)
                      .map((f) => ({
                        model: String(this.selectedModel || "proform").toLowerCase(),
                        id: String(f.id),
                        name: this.resolveFailedDeleteLabel(f),
                        payments: [],
                        collects: [],
                        notasComerciales: [],
                        creditNotes: [],
                        debitNotes: [],
                        shippings: [],
                        errorText: f.error || "",
                      }));
              this.openDeleteBlockedFinancialModal(entities, summary);
            } else {
              const failedErrors = failed
                .map((f) => f && f.error)
                .filter((msg) => typeof msg === "string" && msg.trim());
              const uniqueFailed = [...new Set(failedErrors)].slice(0, 8);
              const escapeHtml = (value) =>
                String(value || "")
                  .replace(/&/g, "&amp;")
                  .replace(/</g, "&lt;")
                  .replace(/>/g, "&gt;")
                  .replace(/"/g, "&quot;");
              await Swal.fire({
                title: this.$tn("Partial Success"),
                html: `<div style="text-align:left">${escapeHtml(summary)}${
                  uniqueFailed.length
                    ? `<ul style="margin:12px 0 0;padding-left:18px">${uniqueFailed
                        .map((m) => `<li style="margin-bottom:8px">${escapeHtml(m)}</li>`)
                        .join("")}</ul>`
                    : ""
                }</div>`,
                icon: "warning",
                width: 640,
              });
            }
          }

          // Limpiar selección y recargar items
          this.selectedItems = [];
          // Usar el método correcto según si estamos en una vista o modelo normal
          if (this.view) {
            this.fetchViewItems();
          } else {
            this.fetchItems();
          }
        } catch (error) {
          console.error("Error deleting:", error);

          // Cerrar WebSocket si existe
          if (progressWs) {
            progressWs.close();
          }
          if (progressInterval) {
            clearInterval(progressInterval);
          }

          Swal.close();

          await Swal.fire({
            title: "Error",
            text: getApiErrorMessage(
              error,
              "An error occurred while deleting the records."
            ),
            icon: "error",
          });
        }
      }
    },
    async toggleSelectAll(event) {
      if (event.target.checked) {
        await this.selectAllItems();
      } else {
        this.selectedItems = [];
      }
    },
    isItemSelected(itemId) {
      return isItemIdSelected(this.selectedItems, itemId);
    },
    toggleItemSelection(itemId) {
      const id = normalizeItemId(itemId);
      if (!id) return;
      if (this.multiple) {
        const index = this.selectedItems.findIndex(
          (selectedId) => normalizeItemId(selectedId) === id
        );
        if (index === -1) {
          this.selectedItems.push(id);
        } else {
          this.selectedItems.splice(index, 1);
        }
      } else {
        this.selectedItems = [id];
      }
    },
    goToNonModelList(fieldName) {
      const route = this.$router.resolve({
        name: "DynamicModel",
        params: {
          modelName: this.selectedModel + "_" + fieldName,
          fieldName: fieldName,
        },
      });
      window.open(route.href, "_blank");
    },
    formatListIdCell(value) {
      if (value === null || value === undefined) return "";
      return String(value);
    },
    formatTotal(value, type, field = null) {
      if (value === undefined || value === null) return "";

      const fieldDecimals = getDisplayDecimalsOverrideForFieldKey(field?.key);

      // Si es un campo de moneda o número, usar el formato configurado
      if (
        field &&
        (field.currency || type === "number" || type === "currency")
      ) {
        // Si tiene currency activado, siempre mostrar decimales
        const isCurrency = field.currency || type === "currency";
        return formatNumberSync(value, null, isCurrency, fieldDecimals);
      }

      // Para otros tipos, usar el formato configurado si es numérico
      if (type === "number" || type === "currency") {
        // Si es currency, siempre mostrar decimales
        return formatNumberSync(value, null, type === "currency", fieldDecimals);
      }

      return value;
    },

    // Método para formatear campos de moneda (similar al de ViewNumber)
    formatCurrencyForDisplay(value) {
      // Siempre mostrar decimales para valores monetarios
      return formatNumberSync(value, null, true);
    },
    goToAdd() {
      const route = this.$router.resolve({
        name: "DynamicModelAdd",
        params: { modelName: this.selectedModel },
      });
      window.open(route.href, "_blank");
    },
    // Método para manejar cambios de ruta de forma controlada
    async handleRouteChange() {
      if (this.paramViewId) {
        return; // Si se pasa por prop, ignorar cambios de ruta
      }

      this.loading = true;
      this.view = null;

      this.resetState();

      // Obtener el modelName de la ruta para optimizar la carga
      const modelName = this.effectiveModelName;
      // Cargar solo el modelo necesario si está disponible, sino cargar todos
      await this.fetchModels(modelName || null);

      // Procesar la ruta actual de forma controlada
      await this.initializeFromRoute();

      // Si ya hay un modelo seleccionado Y NO hay un reporte cargado, cargar las preferencias de filtros
      // Si hay un reporte cargado, los selectedFilterFields ya vienen del reporte
      if (
        this.selectedModel &&
        this.modelFields.length > 0 &&
        !this.currentLoadedReport
      ) {
        await this.loadFilterPreferences();
      }
      this.loading = false;
    },

    // Método centralizado para inicializar desde la ruta
    async initializeFromRoute() {
      const modelName = this.effectiveModelName;
      const viewId = this.effectiveViewId;
      const itemId = this.$route.params.itemId;
      const reportId = this.paramReportId || this.$route.query.reportId;

      if (viewId) {
        await this.fetchViewFields();
      } else if (modelName) {
        // Si los modelos no están cargados o el modelo específico no está en la lista, cargarlo
        if (!this.isModelsLoaded || this.models.length === 0) {
          await this.fetchModels(modelName);
        }

        const found = this.models.find(
          (m) => m.modelName.toLowerCase() === modelName.toLowerCase()
        );
        if (found) {
          this.selectedModel = found.modelName;
          await this.fetchFields();
        } else {
          // Si no se encontró, intentar cargar solo ese modelo
          await this.fetchModels(modelName);
          const reloaded = this.models.find(
            (m) => m.modelName.toLowerCase() === modelName.toLowerCase()
          );
          if (reloaded) {
            this.selectedModel = reloaded.modelName;
            await this.fetchFields();
          }
        }
      }

      // Popup con reporte fijo: su armado vive en ese reporte, no en la URL
      if (this.pinnedPopupReportKey && this.selectedModel) {
        await this.loadPinnedPopupReport();
        return;
      }

      // Si hay un reportId en la URL, cargar ese reporte
      if (reportId && this.selectedModel) {
        await this.loadReportById(reportId);
        return; // El reporte maneja sus propios filtros, no procesar query params adicionales
      }

      // Procesar query params de filtros (ignorando params del sistema/tutorial).
      // Embebido no: la URL es de la pantalla que lo contiene, sus filtros son otros.
      if (
        this.selectedModel &&
        !this.isEmbeddedList &&
        Object.keys(this.$route.query).length > 0
      ) {
        const filters = this.getFilterQueryParams(this.$route.query);

        if (Object.keys(filters).length > 0) {
          if (this.isArchiveView) {
            await this.refreshArchiveHasRecords();
          }
          // skipUrlUpdate: true porque ya estamos leyendo de la URL
          this.handleFilter(filters, { skipUrlUpdate: true });

          // Guardar filtros pendientes para aplicar cuando el componente esté disponible
          this.pendingUrlFilters = filters;
        }
      }

      // Procesar itemId si existe
      if (itemId && this.selectedModel && this.isModelsLoaded) {
        await this.fetchItem(itemId);
      }
    },
    pinnedColumnsStorageKey() {
      const userId =
        localStorage.getItem("userId") ||
        localStorage.getItem("_id") ||
        "anon";
      const model = (this.selectedModel || "unknown").toLowerCase();
      return `gt-dynamic-list-pinned-cols:${userId}:${model}`;
    },
    loadPinnedColumnsFromStorage() {
      if (this.currentLoadedReport) {
        return;
      }
      if (!this.selectedModel) {
        this.pinnedColumnKeys = [];
        return;
      }
      try {
        const raw = localStorage.getItem(this.pinnedColumnsStorageKey());
        const parsed = raw ? JSON.parse(raw) : [];
        this.pinnedColumnKeys = Array.isArray(parsed) ? parsed : [];
      } catch {
        this.pinnedColumnKeys = [];
      }
    },
    loadPinnedColumnsForList() {
      if (this.currentLoadedReport) {
        return;
      }
      if (!this.selectedModel) {
        this.pinnedColumnKeys = [];
        return;
      }
      if (!this.pinnedColumnKeys.length) {
        this.loadPinnedColumnsFromStorage();
      }
      this.prunePinnedColumnKeys();
    },
    savePinnedColumnsToStorage() {
      if (this.currentLoadedReport) {
        return;
      }
      if (!this.selectedModel) return;
      try {
        localStorage.setItem(
          this.pinnedColumnsStorageKey(),
          JSON.stringify(this.pinnedColumnKeys)
        );
      } catch (error) {
        console.error("Error saving pinned columns:", error);
      }
    },
    async persistPinnedColumns() {
      if (this._applyingReport) return;
      if (this.currentLoadedReport?._id) {
        await this.saveCurrentLoadedReport({ showSuccess: false });
        return;
      }
      this.savePinnedColumnsToStorage();
      try {
        await this.saveColumnPreferences(true, false);
        this.savedPinnedColumnKeys = [...(this.pinnedColumnKeys || [])];
      } catch (error) {
        console.error("Error persisting pinned columns:", error);
      }
    },
    getListStickyHeaderMainTopPx() {
      if (this.reportGroupHeaderCells) return REPORT_LIST_STICKY_HEADER_GROUP_PX;
      return 0;
    },
    async getModelDefinition(modelName) {
      // Usar cache si ya está cargado
      if (this.modelDefinitionsCache[modelName]) {
        return this.modelDefinitionsCache[modelName];
      }

      try {
        const response = await wencesApi.get(
          `/api/gotrading/model-definitions/${modelName}`
        );
        if (response.data) {
          this.modelDefinitionsCache[modelName] = response.data;
          return response.data;
        }
      } catch (error) {
        console.error(
          `Error loading model definition for ${modelName}:`,
          error
        );
      }
      return null;
    },
    isTruthyArrayGroup(f) {
      if (!f || f.type !== "group") return false;
      return f.isArray === true || f.isArray === "true";
    },
    /**
     * Resuelve rutas bajo un grupo raíz isArray: ...grupos anidados... + reference + subcampos en el modelo referenciado.
     * pathParts es el path relativo (sin la clave del grupo raíz), p.ej. ['lines','detail','product','name'].
     */
    /**
     * Resuelve la definición del campo final siguiendo un path anidado sobre referencias
     * (ej. custom_proform.operationaluser → campo users de proform).
     */
    async resolveFieldDefAlongNestedPath(startFieldDef, nestedPath) {
      if (!startFieldDef || !nestedPath) return null;
      const parts = String(nestedPath)
        .split(".")
        .map((p) => p.trim())
        .filter(Boolean);
      if (!parts.length) return null;

      let currentDef = startFieldDef;
      let leafDef = null;
      for (const part of parts) {
        if (
          currentDef.type === "reference" &&
          currentDef.ref &&
          String(currentDef.ref).toLowerCase() !== "users"
        ) {
          const refModelDef = await this.getModelDefinition(currentDef.ref);
          leafDef =
            refModelDef?.fields?.find((f) => f.key === part) || null;
        } else if (currentDef.type === "group" && currentDef.fields) {
          leafDef = currentDef.fields.find((f) => f.key === part) || null;
        } else if (currentDef.fields) {
          leafDef = currentDef.fields.find((f) => f.key === part) || null;
        } else {
          return null;
        }
        if (!leafDef) return null;
        currentDef = leafDef;
      }
      return leafDef;
    },
    resolveGroupArrayReferencePath(rootGroupField, pathParts) {
      if (!rootGroupField?.fields || pathParts.length < 2) return null;
      if (!this.isTruthyArrayGroup(rootGroupField)) return null;
      let fields = rootGroupField.fields;
      const nestedGroups = [];
      let i = 0;
      while (i < pathParts.length) {
        const key = pathParts[i];
        const g = fields.find((f) => f.key === key && f.type === "group");
        if (g?.fields) {
          nestedGroups.push(g);
          fields = g.fields;
          i++;
          continue;
        }
        const refFld = fields.find(
          (f) =>
            f.key === key &&
            f.type === "reference" &&
            f.ref &&
            f.ref !== "users"
        );
        if (!refFld || i >= pathParts.length - 1) return null;
        const refRelPath = pathParts.slice(i + 1);
        if (!refRelPath.length) return null;
        return { nestedGroups, refField: refFld, refRelPath };
      }
      return null;
    },
    collectGarrRefObjectsFromParent(
      parentValue,
      isParentArray,
      nestedGroups,
      refKey
    ) {
      const normalizeRefVals = (v) => {
        if (v == null || v === "") return [];
        return Array.isArray(v) ? v.filter(Boolean) : [v];
      };
      const walk = (obj, idx) => {
        if (!obj || typeof obj !== "object") return [];
        if (idx >= nestedGroups.length) {
          return normalizeRefVals(obj[refKey]);
        }
        const g = nestedGroups[idx];
        const seg = obj[g.key];
        if (seg == null) return [];
        const isArr = g.isArray === true || g.isArray === "true";
        if (isArr) {
          if (!Array.isArray(seg)) return [];
          return seg.flatMap((el) => walk(el, idx + 1));
        }
        return walk(seg, idx + 1);
      };
      if (isParentArray && Array.isArray(parentValue)) {
        return parentValue.flatMap((row) => walk(row, 0));
      }
      if (
        parentValue &&
        typeof parentValue === "object" &&
        !Array.isArray(parentValue)
      ) {
        return walk(parentValue, 0);
      }
      return [];
    },
    /**
     * Listado con `fields=`: incluir datos mínimos para el botón vista FOB operación.
     * Negotiation ↔ primer id en `proforms` (no suele estar entre columnas visibles).
     * Solo si ya hay campos parciales (si no hay `fields`, el backend devuelve el documento completo).
     */
    ensureFobOperacionListFieldsInRequest(fieldsToSend) {
      if (!Array.isArray(fieldsToSend) || fieldsToSend.length === 0) return;
      const m = String(this.selectedModel || "").toLowerCase();
      if (m === "negotiation" && !fieldsToSend.includes("proforms")) {
        fieldsToSend.push("proforms");
      }
    },
    /**
     * Ticket #328: con `fields=` parcial el listado no traía remaining_advance /
     * total_remaining_advance y el warning «Sin prepayment asociado» no podía evaluarse.
     */
    ensureMissingPrepaymentListFieldsInRequest(fieldsToSend) {
      if (!Array.isArray(fieldsToSend) || fieldsToSend.length === 0) return;
      const m = String(this.selectedModel || "").toLowerCase();
      if (m !== "proform" && m !== "proforma" && m !== "shipping") return;
      if (!fieldsToSend.includes("remaining_advance")) {
        fieldsToSend.push("remaining_advance");
      }
      if (!fieldsToSend.includes("total_remaining_advance")) {
        fieldsToSend.push("total_remaining_advance");
      }
      // Pendiente propio: anticipo esperado − cobrado (mismo criterio que Finanzas)
      for (const key of ["expected_advance", "total_collected", "total_collected_advance"]) {
        if (!fieldsToSend.includes(key)) {
          fieldsToSend.push(key);
        }
      }
      // Tooltip PI: líneas "shipping — monto" con el pendiente de cada embarque.
      // Pedir subcampos hace que el backend pueble la referencia con el documento completo.
      if (m === "proform" || m === "proforma") {
        for (const key of [
          "shippings",
          "shippings.expected_advance",
          "shippings.total_collected",
          "shippings.total_collected_advance",
          "shippings.total_remaining_advance",
        ]) {
          if (!fieldsToSend.includes(key)) {
            fieldsToSend.push(key);
          }
        }
      }
      // Embarque sin montos propios: el pendiente sale de la proforma padre.
      // `total_remaining` lo usa el badge de status para marcar en verde los
      // embarques ya cobrados (ticket #424), aunque su columna no esté visible.
      if (m === "shipping") {
        for (const key of [
          "custom_proform.remaining_advance",
          "custom_proform.shippings",
          "total_remaining",
        ]) {
          if (!fieldsToSend.includes(key)) {
            fieldsToSend.push(key);
          }
        }
      }
    },
    /** Hidden list-flag field: keep in fields= so row color survives reload. */
    ensureListCategoryFieldInRequest(fieldsToSend) {
      if (!Array.isArray(fieldsToSend) || fieldsToSend.length === 0) return;
      if (!this.modelHasCategoryField) return;
      // El flag vive en su propio campo; hay que pedirlo aunque su columna esté
      // oculta, porque entonces la etiqueta se pega a la celda identidad.
      const flagKey = this.listFlagFieldKey;
      if (flagKey && !fieldsToSend.includes(flagKey)) {
        fieldsToSend.push(flagKey);
      }
      // `category` se sigue pidiendo por las filas anteriores a esa migración,
      // que guardan la bandera como texto plano.
      if (!fieldsToSend.includes("category")) {
        fieldsToSend.push("category");
      }
    },
    /**
     * Notas comerciales de las líneas de gasto que el listado muestra con su importe.
     *
     * El efecto de una nota (la de crédito del proveedor baja el costo, la de débito lo
     * sube) se dibuja al lado del importe, así que hacen falta los ids de las notas de esa
     * línea. Solo se piden para las columnas de importe que están a la vista: el detalle de
     * cada nota lo resuelve el componente, por página y en una sola llamada.
     */
    ensureExpenseNoteFieldsInRequest(fieldsToSend) {
      if (!Array.isArray(fieldsToSend)) return;
      if (!isNotaComercialModuleActive()) return;
      for (const field of this.visibleTableFields || []) {
        const parentKey = this.expenseNotesParentKeyForField(field);
        if (!parentKey) continue;
        const noteKey = `${parentKey}.commercialnotes`;
        if (!fieldsToSend.includes(noteKey)) {
          fieldsToSend.push(noteKey);
        }
      }
    },
    /**
     * Campo derivado del que cuelgan las notas de una columna de importe, o "".
     *
     * Vale para la columna `<grupo>_<tipo>.amount` de las líneas de gasto; cualquier otra
     * columna, o un modelo sin notas comerciales, devuelve "".
     */
    expenseNotesParentKeyForField(field) {
      if (!field || field.type !== "reference_subfield") return "";
      if (field.subFieldKey !== "amount" || field.nestedFieldKey) return "";
      const parent = field.parentField;
      if (!parent || !parent.key) return "";
      // El subcampo `commercialnotes` solo existe en el grupo de gastos del embarque.
      if (!String(parent.ref || "").endsWith("_expenses")) return "";
      return parent.key;
    },
    /**
     * Ids de las notas comerciales colgadas de la línea (o líneas) de gasto de esta celda.
     *
     * El campo derivado puede ser multivalor (varias facturas del mismo tipo de gasto): se
     * juntan las notas de todas, igual que hace el detalle del embarque con el total.
     */
    expenseNoteIdsForCell(item, col) {
      const parentKey = this.expenseNotesParentKeyForField(col && col.field);
      if (!parentKey || !item) return null;
      const raw = item[parentKey];
      const rows = Array.isArray(raw) ? raw : raw ? [raw] : [];
      const ids = [];
      for (const row of rows) {
        if (!row || typeof row !== "object") continue;
        const notes = Array.isArray(row.commercialnotes) ? row.commercialnotes : [];
        for (const note of notes) {
          const id =
            note && typeof note === "object" ? String(note._id || "") : String(note || "");
          if (id && !ids.includes(id)) ids.push(id);
        }
      }
      return ids.length ? ids : null;
    },
    ensurePopulatePrefixesForGroupArrayRefColumn(fieldKey, fieldsToSend) {
      if (!fieldKey || !fieldKey.includes(".")) return;
      const parts = fieldKey.split(".");
      const root = this.modelFields.find(
        (f) => f.key === parts[0] && f.type === "group"
      );
      if (!root || !this.isTruthyArrayGroup(root)) return;
      const rel = parts.slice(1);
      const res = this.resolveGroupArrayReferencePath(root, rel);
      if (!res) return;
      if (!fieldsToSend.includes(parts[0])) {
        fieldsToSend.push(parts[0]);
      }
      let acc = parts[0];
      for (const seg of [
        ...res.nestedGroups.map((g) => g.key),
        res.refField.key,
      ]) {
        acc = `${acc}.${seg}`;
        if (!fieldsToSend.includes(acc)) {
          fieldsToSend.push(acc);
        }
      }
    },
    /**
     * Lee un subcampo anidado que puede tener varios niveles ("custom_proform.operationaluser").
     * Con un solo nivel equivale a source[key]; con varios sigue las referencias ya pobladas.
     */
    readNestedPathValue(source, nestedKey) {
      if (!nestedKey) return undefined;
      const parts = String(nestedKey).split(".").filter(Boolean);
      let current = source;
      for (const part of parts) {
        if (current === null || current === undefined) return undefined;
        if (Array.isArray(current)) {
          const collected = current
            .map((entry) =>
              entry && typeof entry === "object" ? entry[part] : undefined
            )
            .filter((v) => v !== undefined && v !== null);
          if (collected.length === 0) return undefined;
          current = collected.length === 1 ? collected[0] : collected;
          continue;
        }
        if (typeof current !== "object") return undefined;
        current = current[part];
      }
      return current;
    },
    /**
     * ¿La columna termina en un campo de tipo reference (incl. rutas anidadas y de grupo)?
     */
    isReferenceValueColumn(field) {
      const type = field?.nestedSubFieldDef?.type || field?.subFieldType;
      return type === "reference" || type === "users";
    },
    /** Identidad de un valor de referencia para comparar repetidos (_id, si no name/valor). */
    referenceValueIdentity(value) {
      if (value && typeof value === "object") {
        if (value._id !== undefined && value._id !== null) {
          return `id:${String(value._id)}`;
        }
        if (value.name !== undefined && value.name !== null) {
          return `name:${String(value.name)}`;
        }
        try {
          return `json:${JSON.stringify(value)}`;
        } catch (e) {
          return `obj:${String(value)}`;
        }
      }
      return `raw:${String(value)}`;
    },
    /**
     * Columnas de referencia con un valor por fila del grupo: si varias filas apuntan al mismo
     * documento (p. ej. varias expenses de la misma proforma) se repetiría el mismo nombre.
     * Se muestra una sola vez; los huecos se descartan porque al deduplicar ya no hay
     * correspondencia posicional con las otras columnas del grupo.
     */
    dedupeReferenceColumnValues(values) {
      const seen = new Set();
      const unique = [];
      (values || []).forEach((value) => {
        if (value === null || value === undefined || value === "") return;
        const identity = this.referenceValueIdentity(value);
        if (seen.has(identity)) return;
        seen.add(identity);
        unique.push(value);
      });
      return unique;
    },
    getFieldValue(item, field) {
      // Export (export=true): el backend deja el valor ya resuelto en la clave plana "a.b.c"
      if (
        item &&
        field &&
        typeof field.key === "string" &&
        field.key.includes(".") &&
        Object.prototype.hasOwnProperty.call(item, field.key) &&
        item[field.key] !== undefined &&
        item[field.key] !== null
      ) {
        const flatExport = item[field.key];
        const exportType = this.effectiveExportFieldType(field);
        const flatIsRefId =
          (exportType === "reference" || exportType === "users") &&
          typeof flatExport === "string" &&
          /^[a-fA-F0-9]{24}$/.test(flatExport.trim());
        if (!flatIsRefId) {
          return flatExport;
        }
      }
      // Una referencia múltiple cuyo subcampo es una lista múltiple da un doble arreglo:
      // los correos del contrato, y las etiquetas de cada correo. Lo que sirve en una celda
      // no es esa matriz sino el conjunto —cada etiqueta una vez, en orden de aparición—,
      // que es como se lee un reporte: qué hitos tiene este envío. Sin esto la celda
      // repetiría «ETD, ETD, ETD» y crecería con cada correo enganchado.
      if (
        field.type === "reference_subfield" &&
        field.parentField &&
        field.parentField.isArray === true &&
        field.subFieldType === "list" &&
        field.subFieldDef &&
        // El campo de banderas admite varias sin declararse `isArray` —el esquema lo
        // guarda Mixed para que convivan el arreglo y el valor suelto—, así que la marca
        // que lo identifica es `listFlagField`, igual que hace el backend.
        (field.subFieldDef.isArray === true || field.subFieldDef.listFlagField === true) &&
        !field.nestedFieldKey
      ) {
        const rows = item ? item[field.parentField.key] : null;
        if (!Array.isArray(rows)) return null;
        // El back suele dejar los valores de lista como {_id, label}, pero no en todos los
        // caminos (un modelo de grupo arma su definición aparte). Cuando llega un id suelto
        // se resuelve acá contra la lista ya cargada, para no mostrar un ObjectId en la celda.
        const listValues =
          (field.subFieldDef.listType &&
            (this.lists || []).find((l) => l && l.type === field.subFieldDef.listType)
              ?.values) ||
          [];
        const labelForId = (id) => {
          const found = listValues.find(
            (v) => v && v._id && String(v._id) === String(id)
          );
          return (found && (found.label || found.name)) || String(id);
        };
        const seen = new Set();
        const labels = [];
        for (const row of rows) {
          if (!row || typeof row !== "object") continue;
          const raw = row[field.subFieldKey];
          for (const value of Array.isArray(raw) ? raw : [raw]) {
            if (!value) continue;
            const isObject = typeof value === "object";
            const label = isObject
              ? value.label || value.hierarchy || labelForId(value._id)
              : labelForId(value);
            if (!label) continue;
            const dedupeKey = isObject ? String(value._id || label) : String(value);
            if (seen.has(dedupeKey)) continue;
            seen.add(dedupeKey);
            labels.push(label);
          }
        }
        return labels.length ? labels.join(", ") : null;
      }

      // Para campos de tipo reference_subfield, obtener el valor del subcampo
      if (field.type === "reference_subfield" && field.parentField) {
        const parentValue = item[field.parentField.key];
        const isParentArray = field.parentField.isArray === true;

        // Debug para campos anidados de doble nivel
        if (field.nestedFieldKey) {
          console.log("[getFieldValue] 🔍 Campo anidado detectado", {
            fieldKey: field.key,
            parentField: field.parentField.key,
            subFieldKey: field.subFieldKey,
            nestedFieldKey: field.nestedFieldKey,
            parentValue: parentValue,
            isParentArray: isParentArray,
          });
        }

        let sourceRows = null;
        if (field.garrRefField) {
          sourceRows = this.collectGarrRefObjectsFromParent(
            parentValue,
            isParentArray,
            field.garrNestedGroups || [],
            field.garrRefField.key
          );
          if (!sourceRows.length) {
            return null;
          }
        }

        // Si el campo padre es un array, manejar como array
        if (sourceRows || (isParentArray && Array.isArray(parentValue))) {
          const rowSource = sourceRows || parentValue;
          // Extraer el subcampo de cada elemento del array
          const values = rowSource
            .map((refItem) => {
              if (!refItem) return null;

              // Si el item es un objeto (reference poblado), obtener el subcampo directamente
              if (typeof refItem === "object" && !Array.isArray(refItem)) {
                let subFieldValue = refItem[field.subFieldKey];

                // Si hay un campo anidado (ej: products.product), extraer el valor anidado
                if (field.nestedFieldKey && subFieldValue) {
                  // Si subFieldValue es un array (ej: products es un array), extraer el campo anidado de cada item
                  if (Array.isArray(subFieldValue)) {
                    // Para arrays anidados, retornar array de valores del campo anidado
                    subFieldValue = subFieldValue
                      .map((nestedItem) => {
                        if (!nestedItem) return null;
                        if (
                          typeof nestedItem === "object" &&
                          this.readNestedPathValue(
                            nestedItem,
                            field.nestedFieldKey
                          ) !== undefined
                        ) {
                          const nestedValue = this.readNestedPathValue(
                            nestedItem,
                            field.nestedFieldKey
                          );
                          // Si el campo anidado es de tipo reference y el valor es un objeto, retornarlo
                          // El backend ya procesa estos valores cuando export=true
                          return nestedValue;
                        }
                        return null;
                      })
                      .filter((v) => v !== null);
                    // Si solo hay un valor, retornarlo directamente; si hay varios, retornar el array
                    // Pero primero verificar si son objetos de referencia y necesitan ser procesados
                    const finalSubFieldType =
                      field.nestedSubFieldDef?.type || field.subFieldType;
                    const finalSubFieldRef =
                      field.nestedSubFieldDef?.ref || field.subFieldRef;
                    if (
                      finalSubFieldType === "reference" &&
                      finalSubFieldRef &&
                      subFieldValue.length > 0
                    ) {
                      // Si son objetos de referencia, asegurar que tengan name o buscarlos en referenceItems
                      const processedValues = subFieldValue.map((v) => {
                        if (typeof v === "object" && v !== null) {
                          if (v._id && v.name) {
                            return v; // Ya tiene name
                          }
                          // Buscar en referenceItems
                          if (
                            v._id &&
                            this.referenceItems &&
                            this.referenceItems[finalSubFieldRef]
                          ) {
                            const refItems = Array.isArray(
                              this.referenceItems[finalSubFieldRef]
                            )
                              ? this.referenceItems[finalSubFieldRef]
                              : [];
                            const found = refItems.find(
                              (item) =>
                                item._id === v._id ||
                                item._id?.toString() === v._id?.toString()
                            );
                            if (found) return found;
                          }
                          return v; // Retornar como está si no se encuentra
                        }
                        return v;
                      });
                      return processedValues.length === 1
                        ? processedValues[0]
                        : processedValues.length > 0
                        ? processedValues
                        : null;
                    }
                    // Para list: retornar objetos crudos (no extraer label) para que FieldList muestre badge y jerarquía
                    if (finalSubFieldType === "list") {
                      return subFieldValue.length === 1
                        ? subFieldValue[0]
                        : subFieldValue.length > 0
                        ? subFieldValue
                        : null;
                    }
                    return subFieldValue.length === 1
                      ? subFieldValue[0]
                      : subFieldValue.length > 0
                      ? subFieldValue
                      : null;
                  } else if (
                    typeof subFieldValue === "object" &&
                    this.readNestedPathValue(
                      subFieldValue,
                      field.nestedFieldKey
                    ) !== undefined
                  ) {
                    // Si subFieldValue es un objeto único, extraer el campo anidado
                    subFieldValue = this.readNestedPathValue(
                      subFieldValue,
                      field.nestedFieldKey
                    );
                  }
                }

                // Si el subcampo (o campo anidado) es de tipo reference y el valor es solo un _id, buscar el objeto completo
                const finalSubFieldType =
                  field.nestedSubFieldDef?.type || field.subFieldType;
                const finalSubFieldRef =
                  field.nestedSubFieldDef?.ref || field.subFieldRef;

                if (finalSubFieldType === "reference" && finalSubFieldRef) {
                  // Si el valor es un objeto con _id y name, ya está poblado - retornar solo el name para consistencia
                  if (
                    typeof subFieldValue === "object" &&
                    subFieldValue !== null &&
                    subFieldValue._id &&
                    subFieldValue.name
                  ) {
                    // Para campos anidados de referencia, retornar el objeto completo
                    // El backend ya procesa estos valores cuando export=true
                    return subFieldValue;
                  }
                  // Si el valor es solo un _id (string o objeto con solo _id), buscar en referenceItems
                  if (
                    subFieldValue &&
                    (typeof subFieldValue === "string" ||
                      (typeof subFieldValue === "object" &&
                        subFieldValue._id &&
                        !subFieldValue.name))
                  ) {
                    const refId =
                      typeof subFieldValue === "string"
                        ? subFieldValue
                        : subFieldValue._id;
                    if (
                      this.referenceItems &&
                      this.referenceItems[finalSubFieldRef]
                    ) {
                      const refItems = Array.isArray(
                        this.referenceItems[finalSubFieldRef]
                      )
                        ? this.referenceItems[finalSubFieldRef]
                        : [];
                      const foundRefItem = refItems.find(
                        (item) =>
                          item._id === refId ||
                          item._id?.toString() === refId?.toString()
                      );
                      if (foundRefItem) {
                        return foundRefItem;
                      }
                    }
                  }
                }

                // Para list: retornar objeto crudo (no extraer label) para que FieldList muestre badge y jerarquía
                return subFieldValue;
              }

              // Si el item es un string/ID (no poblado), intentar buscar en referenceItems
              if (
                typeof refItem === "string" ||
                (typeof refItem === "object" && refItem._id)
              ) {
                const refId =
                  typeof refItem === "string" ? refItem : refItem._id;

                // Buscar el item de referencia en referenceItems
                if (
                  field.ref &&
                  this.referenceItems &&
                  this.referenceItems[field.ref]
                ) {
                  const refItems = Array.isArray(this.referenceItems[field.ref])
                    ? this.referenceItems[field.ref]
                    : [];
                  const foundRefItem = refItems.find(
                    (item) =>
                      item._id === refId ||
                      item._id?.toString() === refId?.toString()
                  );

                  if (
                    foundRefItem &&
                    foundRefItem[field.subFieldKey] !== undefined
                  ) {
                    let subFieldValue = foundRefItem[field.subFieldKey];

                    // Si hay un campo anidado (ej: products.product), extraer el valor anidado
                    if (field.nestedFieldKey && subFieldValue) {
                      // Si subFieldValue es un array (ej: products es un array), extraer el campo anidado de cada item
                      if (Array.isArray(subFieldValue)) {
                        // Para arrays anidados, retornar array de valores del campo anidado
                        subFieldValue = subFieldValue
                          .map((nestedItem) => {
                            if (!nestedItem) return null;
                            if (
                              typeof nestedItem === "object" &&
                              this.readNestedPathValue(
                            nestedItem,
                            field.nestedFieldKey
                          ) !== undefined
                            ) {
                              return this.readNestedPathValue(
                                nestedItem,
                                field.nestedFieldKey
                              );
                            }
                            return null;
                          })
                          .filter((v) => v !== null);
                        // Si solo hay un valor, retornarlo directamente; si hay varios, retornar el array
                        subFieldValue =
                          subFieldValue.length === 1
                            ? subFieldValue[0]
                            : subFieldValue.length > 0
                            ? subFieldValue
                            : null;
                      } else if (
                        typeof subFieldValue === "object" &&
                        this.readNestedPathValue(
                          subFieldValue,
                          field.nestedFieldKey
                        ) !== undefined
                      ) {
                        // Si subFieldValue es un objeto único, extraer el campo anidado
                        subFieldValue = this.readNestedPathValue(
                          subFieldValue,
                          field.nestedFieldKey
                        );
                      }
                    }

                    // Si el subcampo (o campo anidado) es de tipo reference y el valor es solo un _id, buscar el objeto completo
                    const finalSubFieldType =
                      field.nestedSubFieldDef?.type || field.subFieldType;
                    const finalSubFieldRef =
                      field.nestedSubFieldDef?.ref || field.subFieldRef;

                    if (finalSubFieldType === "reference" && finalSubFieldRef) {
                      // Si el valor es un objeto con _id y name, ya está poblado
                      if (
                        typeof subFieldValue === "object" &&
                        subFieldValue !== null &&
                        subFieldValue._id &&
                        subFieldValue.name
                      ) {
                        return subFieldValue;
                      }
                      // Si el valor es solo un _id (string o objeto con solo _id), buscar en referenceItems
                      if (
                        subFieldValue &&
                        (typeof subFieldValue === "string" ||
                          (typeof subFieldValue === "object" &&
                            subFieldValue._id &&
                            !subFieldValue.name))
                      ) {
                        const refId =
                          typeof subFieldValue === "string"
                            ? subFieldValue
                            : subFieldValue._id;
                        if (
                          this.referenceItems &&
                          this.referenceItems[finalSubFieldRef]
                        ) {
                          const refItems = Array.isArray(
                            this.referenceItems[finalSubFieldRef]
                          )
                            ? this.referenceItems[finalSubFieldRef]
                            : [];
                          const foundNestedRefItem = refItems.find(
                            (item) =>
                              item._id === refId ||
                              item._id?.toString() === refId?.toString()
                          );
                          if (foundNestedRefItem) {
                            return foundNestedRefItem;
                          }
                        }
                      }
                    }

                    return subFieldValue;
                  }
                }
              }

              return null;
            })
            .map((val) => (val === undefined ? null : val));

          // Aplanar arrays anidados (cuando hay múltiples items y cada uno retorna un array)
          const flattenedValues = [];
          values.forEach((val) => {
            if (Array.isArray(val)) {
              flattenedValues.push(...val);
            } else {
              flattenedValues.push(val);
            }
          });

          // Si shouldSum es true y el campo es numérico, sumar los valores (ignorar huecos)
          if (
            field.shouldSum === true &&
            (field.subFieldType === "number" ||
              field.subFieldType === "currency")
          ) {
            if (flattenedValues.length === 0) {
              return null;
            }
            const sum = flattenedValues.reduce((acc, val) => {
              if (val === null || val === undefined || val === "") {
                return acc;
              }
              const numVal = typeof val === "number" ? val : parseFloat(val);
              return acc + (isNaN(numVal) ? 0 : numVal);
            }, 0);
            return sum;
          }

          // Referencias: sin repetidos (varias filas pueden apuntar al mismo documento)
          if (this.isReferenceValueColumn(field)) {
            const uniqueValues = this.dedupeReferenceColumnValues(flattenedValues);
            return uniqueValues.length > 0 ? uniqueValues : null;
          }

          // Una posición por ítem del padre (p. ej. shipping[]); null = hueco → guion en tabla/Excel
          return flattenedValues.length > 0 ? flattenedValues : null;
        }

        // Si NO es array, manejar como objeto único
        if (!parentValue) {
          return null;
        }

        // Si parentValue es un objeto (reference poblado), obtener el subcampo directamente
        if (typeof parentValue === "object" && !Array.isArray(parentValue)) {
          // Verificar si tiene _id (es un objeto de referencia poblado)
          let subFieldValue = parentValue[field.subFieldKey];

          // Si hay un campo anidado (ej: products.product), extraer el valor anidado
          if (field.nestedFieldKey && subFieldValue) {
            // Si subFieldValue es un array (ej: products es un array), extraer el campo anidado de cada item
            if (Array.isArray(subFieldValue)) {
              // Para arrays anidados, retornar array de valores del campo anidado
              subFieldValue = subFieldValue
                .map((nestedItem) => {
                  if (!nestedItem) return null;
                  if (
                    typeof nestedItem === "object" &&
                    this.readNestedPathValue(
                      nestedItem,
                      field.nestedFieldKey
                    ) !== undefined
                  ) {
                    return this.readNestedPathValue(
                      nestedItem,
                      field.nestedFieldKey
                    );
                  }
                  return null;
                })
                .filter((v) => v !== null);
              // Si solo hay un valor, retornarlo directamente; si hay varios, retornar el array
              subFieldValue =
                subFieldValue.length === 1
                  ? subFieldValue[0]
                  : subFieldValue.length > 0
                  ? subFieldValue
                  : null;
            } else if (
              typeof subFieldValue === "object" &&
              this.readNestedPathValue(subFieldValue, field.nestedFieldKey) !==
                undefined
            ) {
              // Si subFieldValue es un objeto único, extraer el campo anidado
              subFieldValue = this.readNestedPathValue(
                subFieldValue,
                field.nestedFieldKey
              );
            }
          }

          // Si el subcampo (o campo anidado) es de tipo reference y el valor es solo un _id, buscar el objeto completo
          const finalSubFieldType =
            field.nestedSubFieldDef?.type || field.subFieldType;
          const finalSubFieldRef =
            field.nestedSubFieldDef?.ref || field.subFieldRef;

          if (finalSubFieldType === "reference" && finalSubFieldRef) {
            // Si el valor es un objeto con _id, ya está poblado
            if (
              typeof subFieldValue === "object" &&
              subFieldValue !== null &&
              subFieldValue._id
            ) {
              return subFieldValue;
            }
            // Si el valor es solo un _id (string o objeto con solo _id), buscar en referenceItems
            if (
              subFieldValue &&
              (typeof subFieldValue === "string" ||
                (typeof subFieldValue === "object" &&
                  subFieldValue._id &&
                  !subFieldValue.name))
            ) {
              const refId =
                typeof subFieldValue === "string"
                  ? subFieldValue
                  : subFieldValue._id;
              if (
                this.referenceItems &&
                this.referenceItems[finalSubFieldRef]
              ) {
                const refItems = Array.isArray(
                  this.referenceItems[finalSubFieldRef]
                )
                  ? this.referenceItems[finalSubFieldRef]
                  : [];
                const foundRefItem = refItems.find(
                  (item) =>
                    item._id === refId ||
                    item._id?.toString() === refId?.toString()
                );
                if (foundRefItem) {
                  return foundRefItem;
                }
              }
            }
          }

          // Para list: retornar objeto crudo (no extraer label) para que FieldList muestre badge y jerarquía
          return subFieldValue;
        }

        // Si parentValue es un string/ID (no poblado), intentar buscar en referenceItems
        if (
          typeof parentValue === "string" ||
          (typeof parentValue === "object" && parentValue._id)
        ) {
          const refId =
            typeof parentValue === "string" ? parentValue : parentValue._id;

          // Buscar el item de referencia en referenceItems
          if (
            field.ref &&
            this.referenceItems &&
            this.referenceItems[field.ref]
          ) {
            const refItems = Array.isArray(this.referenceItems[field.ref])
              ? this.referenceItems[field.ref]
              : [];
            const refItem = refItems.find(
              (item) =>
                item._id === refId || item._id?.toString() === refId?.toString()
            );

            if (refItem && refItem[field.subFieldKey] !== undefined) {
              let subFieldValue = refItem[field.subFieldKey];

              // Si hay un campo anidado (ej: products.product), extraer el valor anidado
              if (field.nestedFieldKey && subFieldValue) {
                // Si subFieldValue es un array (ej: products es un array), extraer el campo anidado de cada item
                if (Array.isArray(subFieldValue)) {
                  // Para arrays anidados, retornar array de valores del campo anidado
                  subFieldValue = subFieldValue
                    .map((nestedItem) => {
                      if (!nestedItem) return null;
                      if (
                        typeof nestedItem === "object" &&
                        this.readNestedPathValue(
                          nestedItem,
                          field.nestedFieldKey
                        ) !== undefined
                      ) {
                        return this.readNestedPathValue(
                          nestedItem,
                          field.nestedFieldKey
                        );
                      }
                      return null;
                    })
                    .filter((v) => v !== null);
                  // Si solo hay un valor, retornarlo directamente; si hay varios, retornar el array
                  subFieldValue =
                    subFieldValue.length === 1
                      ? subFieldValue[0]
                      : subFieldValue.length > 0
                      ? subFieldValue
                      : null;
                } else if (
                  typeof subFieldValue === "object" &&
                  this.readNestedPathValue(
                    subFieldValue,
                    field.nestedFieldKey
                  ) !== undefined
                ) {
                  // Si subFieldValue es un objeto único, extraer el campo anidado
                  subFieldValue = this.readNestedPathValue(
                    subFieldValue,
                    field.nestedFieldKey
                  );
                }
              }

              // Si el subcampo (o campo anidado) es de tipo reference y el valor es solo un _id, buscar el objeto completo
              const finalSubFieldType =
                field.nestedSubFieldDef?.type || field.subFieldType;
              const finalSubFieldRef =
                field.nestedSubFieldDef?.ref || field.subFieldRef;

              if (finalSubFieldType === "reference" && finalSubFieldRef) {
                // Si el valor es un objeto con _id y name, ya está poblado
                if (
                  typeof subFieldValue === "object" &&
                  subFieldValue !== null &&
                  subFieldValue._id &&
                  subFieldValue.name
                ) {
                  return subFieldValue;
                }
                // Si el valor es solo un _id (string o objeto con solo _id), buscar en referenceItems
                if (
                  subFieldValue &&
                  (typeof subFieldValue === "string" ||
                    (typeof subFieldValue === "object" &&
                      subFieldValue._id &&
                      !subFieldValue.name))
                ) {
                  const refId =
                    typeof subFieldValue === "string"
                      ? subFieldValue
                      : subFieldValue._id;
                  if (
                    this.referenceItems &&
                    this.referenceItems[finalSubFieldRef]
                  ) {
                    const refItems = Array.isArray(
                      this.referenceItems[finalSubFieldRef]
                    )
                      ? this.referenceItems[finalSubFieldRef]
                      : [];
                    const foundNestedRefItem = refItems.find(
                      (item) =>
                        item._id === refId ||
                        item._id?.toString() === refId?.toString()
                    );
                    if (foundNestedRefItem) {
                      return foundNestedRefItem;
                    }
                  }
                }
              }

              // Para list: retornar objeto crudo (no extraer label) para que FieldList muestre badge y jerarquía
              return subFieldValue;
            }
          }
        }

        // Si no se pudo obtener el valor, retornar null
        return null;
      }

      // Para campos de tipo group_subfield, obtener el valor del subcampo del grupo
      if (field.type === "group_subfield" && field.parentField) {
        const groupValue = item[field.parentField.key];

        // Función auxiliar para extraer el valor de un item del grupo
        const extractValue = (groupItem) => {
          // Una entrada por fila del grupo; null = hueco (ej. fecha sin cargar) para alinear con Excel.
          if (!groupItem || typeof groupItem !== "object") {
            return [null];
          }

          // Si hay un grupo anidado (parentSubField), navegar primero a ese grupo
          if (field.parentSubField) {
            const nestedGroupKey = field.parentSubField.key;
            const nestedGroup = groupItem[nestedGroupKey];

            if (nestedGroup && typeof nestedGroup === "object") {
              // Si el grupo anidado es un array, extraer el valor de TODOS los items (una posición por ítem)
              if (Array.isArray(nestedGroup)) {
                const nestedValues = [];
                nestedGroup.forEach((nestedItem) => {
                  if (nestedItem && typeof nestedItem === "object") {
                    const val = nestedItem[field.subFieldKey];
                    nestedValues.push(
                      val !== undefined && val !== null ? val : null
                    );
                  } else {
                    nestedValues.push(null);
                  }
                });
                return nestedValues;
              }
              // Grupo anidado simple (no array)
              const value = nestedGroup[field.subFieldKey];
              return [value !== undefined && value !== null ? value : null];
            }
            return [null];
          }

          // Si no hay grupo anidado, un valor por ítem del grupo padre
          const value = groupItem[field.subFieldKey];
          return [value !== undefined && value !== null ? value : null];
        };

        // Si el grupo es un array (múltiples items)
        if (
          field.isArray &&
          Array.isArray(groupValue) &&
          groupValue.length > 0
        ) {
          // Extraer valores de todos los items y aplanar todos los arrays anidados
          const allValues = [];
          groupValue.forEach((groupItem) => {
            const extracted = extractValue(groupItem);
            if (Array.isArray(extracted)) {
              allValues.push(...extracted);
            }
          });

          // Si shouldSum está habilitado Y el campo es numérico, sumar (ignorar huecos)
          if (
            field.shouldSum === true &&
            (field.subFieldType === "number" ||
              field.subFieldType === "currency")
          ) {
            return allValues.reduce((total, val) => {
              if (val === null || val === undefined || val === "") {
                return total;
              }
              return total + (parseFloat(val) || 0);
            }, 0);
          }

          // Referencias: sin repetidos (varias filas pueden apuntar al mismo documento)
          if (this.isReferenceValueColumn(field)) {
            const uniqueValues = this.dedupeReferenceColumnValues(allValues);
            return uniqueValues.length > 0 ? uniqueValues : null;
          }

          // Conservar null por fila para que fecha vacía → "-" en Excel / multilínea en tabla
          return allValues;
        }

        // Si no es array, devolver el valor del subcampo directamente
        if (
          groupValue &&
          typeof groupValue === "object" &&
          !Array.isArray(groupValue)
        ) {
          const extracted = extractValue(groupValue);
          // extractValue siempre devuelve un array, tomar el primer elemento si hay solo uno
          if (Array.isArray(extracted)) {
            return extracted.length === 1 ? extracted[0] : extracted;
          }
          return extracted;
        }

        return null;
      }

      // Para campos normales, verificar si es array y si debe sumarse
      const value = item[field.key];

      // Si el campo es un array y shouldSum está habilitado y es numérico
      if (field.isArray && Array.isArray(value) && value.length > 0) {
        const shouldSum =
          this.selectedColumns._columnSums?.[field.key] === true;

        if (
          shouldSum &&
          (field.type === "number" || field.type === "currency")
        ) {
          // Sumar los valores del array
          const sum = value.reduce((total, val) => {
            return total + (parseFloat(val) || 0);
          }, 0);
          return sum;
        }

        // Si no se debe sumar, devolver el array para mostrar uno debajo del otro
        return value;
      }

      // Para campos normales no-array, devolver el valor directo
      return value;
    },
    initializeDefaultWidths() {
      // Inicializar anchos por defecto para campos que no tienen ancho guardado
      const cols = this.displayTableColumns.length
        ? this.displayTableColumns
        : this.visibleTableFields.map((f) => ({
            key: f.key,
            displayType: "field",
            field: f,
          }));
      cols.forEach((col) => {
        const key = col.key;
        const field = col.displayType === "field" ? col.field : col.fields?.[0];
        // La columna de banderas se mide sola (lo más angosta posible) hasta
        // que el usuario la redimensione a mano.
        if (this.isListFlagFieldKey(key)) return;
        if (!this.columnWidths[key]) {
          // Anchos por defecto basados en el tipo de campo
          let defaultWidth = 150;
          if (col.displayType === "merged") {
            defaultWidth = Math.max(
              150,
              (col.fields?.length || 1) * 100
            );
          } else if (field?.type === "date" || field?.type === "datetime") {
            defaultWidth = 120;
          } else if (field?.type === "number" || field?.type === "currency") {
            defaultWidth = 100;
          } else if (field?.type === "boolean") {
            defaultWidth = 80;
          } else if (
            field?.type === "text" &&
            field.maxLength &&
            field.maxLength > 100
          ) {
            defaultWidth = 200;
          }
          this.$set(this.columnWidths, key, defaultWidth);
        }
      });
    },
    applyColumnOrder() {
      if (!this.savedColumnOrder || this.savedColumnOrder.length === 0) {
        return;
      }

      // Crear un mapa de los campos YA FILTRADOS en visibleTableFields
      const allFieldsMap = new Map();
      this.visibleTableFields.forEach((field) => {
        allFieldsMap.set(field.key, field);
      });

      // Aplicar el orden guardado
      const newVisibleFields = [];
      const processedFields = new Set();

      // Primero, agregar los campos en el orden guardado
      this.savedColumnOrder.forEach((fieldKey) => {
        const field = allFieldsMap.get(fieldKey);
        if (field && !processedFields.has(fieldKey)) {
          newVisibleFields.push(field);
          processedFields.add(fieldKey);
        }
      });

      // Luego, agregar cualquier campo que esté seleccionado pero no esté en el orden guardado
      allFieldsMap.forEach((field, fieldKey) => {
        if (!processedFields.has(fieldKey)) {
          newVisibleFields.push(field);
        }
      });

      this.visibleTableFields = newVisibleFields;
    },
    hideColumn(fieldKey) {
      // Encontrar el campo para obtener su información
      const field = this.visibleTableFields.find((f) => f.key === fieldKey);
      const fieldLabel = field ? this.tableColumnHeaderText(field) : fieldKey;

      // Ocultar la columna en las preferencias usando $set para reactividad
      this.$set(this.selectedColumns, fieldKey, false);

      // Remover la columna de la lista de columnas visibles
      const index = this.visibleTableFields.findIndex(
        (field) => field.key === fieldKey
      );
      if (index > -1) {
        this.visibleTableFields.splice(index, 1);
      }

      // Forzar la actualización del ColumnSelector
      this.columnSelectorKey++;

      // NO guardar automáticamente - el usuario debe usar el botón "Guardar preferencias"

      // Guardar información para undo
      this.lastRemovedColumn = {
        fieldKey,
        fieldLabel,
        field,
      };

      // Mostrar notificación flotante
      this.showUndoNotification = true;

      // Auto-dismiss después de 5 segundos
      this.undoTimeout = setTimeout(() => {
        this.dismissUndoNotification();
      }, 5000);
    },

    undoColumn() {
      if (!this.lastRemovedColumn) {
        return;
      }

      const { fieldKey, field } = this.lastRemovedColumn;

      // Restaurar la columna en las preferencias
      this.$set(this.selectedColumns, fieldKey, true);

      // Agregar la columna de vuelta a la lista de columnas visibles
      if (field) {
        // Encontrar la posición correcta para insertar la columna
        const insertIndex = this.findInsertionIndex(field);
        this.visibleTableFields.splice(insertIndex, 0, field);
      }

      // Forzar la actualización del ColumnSelector
      this.columnSelectorKey++;

      // NO guardar automáticamente - el usuario debe usar el botón "Guardar preferencias"

      const restoredLabel = this.lastRemovedColumn?.fieldLabel;
      this.dismissUndoNotification();

      // Mostrar notificación de confirmación
      this.$notify({
        message: `${this.$tn("Column")} "${restoredLabel}" ${this.$tn(
          "restored"
        )}`,
        type: "success",
        timeout: 3000,
        icon: "fas fa-undo",
        verticalAlign: "top",
        horizontalAlign: "center",
      });
    },

    dismissUndoNotification() {
      this.showUndoNotification = false;
      this.lastRemovedColumn = null;
      if (this.undoTimeout) {
        clearTimeout(this.undoTimeout);
        this.undoTimeout = null;
      }
    },

    findInsertionIndex(field) {
      // Encontrar la posición correcta para insertar la columna basada en el orden guardado
      if (!this.savedColumnOrder || this.savedColumnOrder.length === 0) {
        return this.visibleTableFields.length;
      }

      const fieldIndex = this.savedColumnOrder.indexOf(field.key);
      if (fieldIndex === -1) {
        return this.visibleTableFields.length;
      }

      // Encontrar la posición correcta basada en el orden guardado
      for (let i = 0; i < this.visibleTableFields.length; i++) {
        const currentFieldIndex = this.savedColumnOrder.indexOf(
          this.visibleTableFields[i].key
        );
        if (currentFieldIndex > fieldIndex) {
          return i;
        }
      }

      return this.visibleTableFields.length;
    },

    async handleFieldUpdated(event) {
      console.log("📨 DynamicModel: handleFieldUpdated received:", event);
      const {
        fieldKey,
        itemId,
        value,
        groupItemId,
        groupModelName,
        parentGroupKey,
        previousValue,
      } = event;

      try {
        const itemIndex = this.items.findIndex((item) => item._id === itemId);

        // Date listedit en fila de group isArray o reference derivado (expenses_courrier.date)
        if (groupItemId && groupModelName) {
          if (itemIndex !== -1 && parentGroupKey) {
            const parentVal = this.items[itemIndex][parentGroupKey];
            if (Array.isArray(parentVal)) {
              const giIdx = parentVal.findIndex(
                (g) => g && String(g._id) === String(groupItemId)
              );
              if (giIdx !== -1) {
                this.$set(
                  this.items[itemIndex][parentGroupKey][giIdx],
                  fieldKey,
                  value
                );
              }
            } else if (
              parentVal &&
              typeof parentVal === "object" &&
              !Array.isArray(parentVal)
            ) {
              this.$set(parentVal, fieldKey, value);
            }
          }

          await wencesApi.put(
            `/api/gotrading/dynamic/${encodeURIComponent(
              groupModelName
            )}/${encodeURIComponent(groupItemId)}`,
            {
              [fieldKey]: value,
              partialUpdate: true,
            }
          );
          console.log("✅ DynamicModel: Group/ref date field updated:", {
            groupModelName,
            groupItemId,
            fieldKey,
            value,
          });
          return;
        }

        if (itemIndex !== -1) {
          console.log(
            "🔄 DynamicModel: Updating local item at index:",
            itemIndex
          );
          this.$set(this.items[itemIndex], fieldKey, value);
        }

        const updateData = {
          [fieldKey]: value,
          partialUpdate: true,
        };

        console.log("📤 DynamicModel: Sending to server:", updateData);

        if (this.view) {
          await wencesApi.put(
            `/api/gotrading/views/${this.effectiveViewId}/items/${itemId}`,
            updateData
          );
        } else {
          await wencesApi.put(
            `/api/gotrading/dynamic/${this.selectedModel}/${itemId}`,
            updateData
          );
        }

        console.log("✅ DynamicModel: Field updated successfully:", {
          fieldKey,
          itemId,
          value,
        });
      } catch (error) {
        console.error("❌ DynamicModel: Error updating field:", error);

        const itemIndex = this.items.findIndex((item) => item._id === itemId);
        if (itemIndex !== -1) {
          if (groupItemId && parentGroupKey) {
            const parentVal = this.items[itemIndex][parentGroupKey];
            if (Array.isArray(parentVal)) {
              const giIdx = parentVal.findIndex(
                (g) => g && String(g._id) === String(groupItemId)
              );
              if (giIdx !== -1) {
                this.$set(
                  this.items[itemIndex][parentGroupKey][giIdx],
                  fieldKey,
                  previousValue
                );
              }
            } else if (
              parentVal &&
              typeof parentVal === "object" &&
              !Array.isArray(parentVal)
            ) {
              this.$set(parentVal, fieldKey, previousValue);
            }
          } else {
            this.$set(
              this.items[itemIndex],
              fieldKey,
              this.items[itemIndex][fieldKey]
            );
          }
        }

        console.error("Error updating field:", error);
      }
    },
    handleReportSaved(report) {
      this.$root.$emit("gotrading-report-created", report);
      this.fetchAccessibleReports();
      // Cuando se guarda un reporte, redirigir al reporte recién creado
      if (report && report._id && this.selectedModel) {
        this.$router.push({
          name: "DynamicModel",
          params: { modelName: this.selectedModel },
          query: { reportId: report._id },
        });
      }

      // Recargar la lista de reportes si está abierta
      if (this.showReportsListModal) {
        // El modal se encargará de recargar
      }
    },
    /**
     * Reporte fijo del popup: es la configuración de ese listado, compartida por
     * todos. Si todavía no existe, el listado arranca con los valores por defecto
     * y el reporte se crea en el primer autoguardado.
     */
    async loadPinnedPopupReport() {
      try {
        const { data } = await wencesApi.get(
          `/api/gotrading/reports/pinned/${encodeURIComponent(
            this.pinnedPopupReportKey
          )}?modelName=${encodeURIComponent(this.selectedModel)}`
        );
        if (data && data._id) {
          await this.handleLoadReport(data);
        }
      } catch (error) {
        console.error("Error loading pinned popup report:", error);
      } finally {
        this.isLoading = false;
        this.pinnedPopupReportReady = true;
      }
    },
    schedulePinnedPopupReportSave() {
      if (this.pinnedPopupReportSaveTimer) {
        clearTimeout(this.pinnedPopupReportSaveTimer);
      }
      // Margen para no escribir una vez por cada clic mientras acomoda columnas
      this.pinnedPopupReportSaveTimer = setTimeout(() => {
        this.pinnedPopupReportSaveTimer = null;
        this.savePinnedPopupReport();
      }, 1200);
    },
    async savePinnedPopupReport() {
      if (!this.pinnedPopupReportKey || !this.selectedModel) return;
      if (this._applyingReport || this.isSavingPreferences) return;

      this.isSavingPreferences = true;
      try {
        const reportData = this.currentReportData;
        const { data } = await wencesApi.put(
          `/api/gotrading/reports/pinned/${encodeURIComponent(
            this.pinnedPopupReportKey
          )}`,
          {
            modelName: this.selectedModel,
            columns: reportData.columns,
            columnOrder: reportData.columnOrder,
            columnWidths: reportData.columnWidths,
            columnLabels: reportData.columnLabels,
            columnEmphasis: reportData.columnEmphasis,
            columnTotals: reportData.columnTotals,
            columnLayout: reportData.columnLayout,
            pinnedColumnKeys: reportData.pinnedColumnKeys,
            groupByField: reportData.groupByField,
            selectedFilterFields: reportData.selectedFilterFields,
            sortField: reportData.sortField,
            sortOrder: reportData.sortOrder,
            pagination: reportData.pagination,
          }
        );
        if (data && data._id) {
          this.currentLoadedReport = {
            ...(this.currentLoadedReport || {}),
            ...data,
          };
        }
        this.updateSavedState();
      } catch (error) {
        console.error("Error saving pinned popup report:", error);
      } finally {
        this.isSavingPreferences = false;
      }
    },
    async loadReportById(reportId) {
      try {
        // Asegurar que el estado de carga esté activo
        this.isLoading = true;
        const { data: report } = await wencesApi.get(
          `/api/gotrading/reports/${reportId}`
        );
        if (report) {
          await this.handleLoadReport(report);
        }
      } catch (error) {
        console.error("Error loading report by ID:", error);
        this.isLoading = false;
      }
    },
    async handleLoadReport(report) {
      this._applyingReport = true;
      try {
        if (this.isArchiveView) {
          await this.refreshArchiveHasRecords();
          await this.$nextTick();
        }
        // Filtrar selectedFilterFields ANTES de guardar el reporte
        // para que currentLoadedReport tenga solo los campos seleccionados
        if (report.selectedFilterFields) {
          // Filtrar solo los campos que tienen valor true (seleccionados)
          const selectedFields = {};
          Object.entries(report.selectedFilterFields).forEach(
            ([key, value]) => {
              if (value === true) {
                selectedFields[key] = true;
              }
            }
          );

          // Actualizar el reporte para que tenga solo los campos seleccionados
          report.selectedFilterFields = selectedFields;
        }

        // Incorporar filtros presentes en la URL (ej. expenses.type=...) al cargar el reporte
        const queryFilters = this.getFilterQueryParams(this.$route.query || {});
        if (Object.keys(queryFilters).length > 0) {
          report.filters = { ...(report.filters || {}) };
          report.selectedFilterFields = {
            ...(report.selectedFilterFields || {}),
          };
          for (const [qk, qv] of Object.entries(queryFilters)) {
            if (qv === undefined || qv === null || String(qv).trim() === "") {
              continue;
            }
            if (
              !(qk in report.filters) ||
              report.filters[qk] === null ||
              report.filters[qk] === ""
            ) {
              report.filters[qk] = qv;
            }
            this.$set(report.selectedFilterFields, qk, true);
          }
        }

        // Guardar el reporte cargado (ahora con selectedFilterFields filtrado)
        this.currentLoadedReport = report;
        this.syncHiddenFilterField();
        this.reportColumnLabels = {
          ...(report.columnLabels && typeof report.columnLabels === "object"
            ? report.columnLabels
            : {}),
        };
        this.reportColumnDescriptions = {
          ...(report.columnDescriptions &&
          typeof report.columnDescriptions === "object"
            ? report.columnDescriptions
            : {}),
        };
        this.reportColumnEmphasis = {
          ...(report.columnEmphasis &&
          typeof report.columnEmphasis === "object"
            ? report.columnEmphasis
            : {}),
        };
        this.reportColumnTotals = {
          ...(report.columnTotals && typeof report.columnTotals === "object"
            ? report.columnTotals
            : {}),
        };

        // Actualizar la URL con el reportId (sin disparar una recarga).
        // Embebido no: la URL es de la pantalla que lo contiene, y cambiarla la
        // hace navegar (y al popup, cerrarse).
        if (
          !this.isEmbeddedList &&
          report._id &&
          this.$route.query.reportId !== report._id
        ) {
          const newQuery = {
            reportId: report._id,
            ...this.getFilterQueryParams(this.$route.query || {}),
          };
          // Marcar que estamos actualizando la ruta programáticamente
          this.isUpdatingRoute = true;
          this.$router
            .replace({
              path: this.$route.path,
              query: newQuery,
            })
            .catch(() => {})
            .finally(() => {
              // Usar nextTick para asegurar que el watcher de $route se ejecute antes de resetear el flag
              this.$nextTick(() => {
                this.isUpdatingRoute = false;
              });
            });
        }

        // Aplicar la configuración del reporte
        if (report.columns) {
          this.selectedColumns = { ...report.columns };
        }
        if (report.columnOrder && report.columnOrder.length > 0) {
          this.savedColumnOrder = [...report.columnOrder];
        }
        if (report.columnWidths) {
          this.columnWidths = { ...report.columnWidths };
        }
        const layoutRaw =
          report.columnLayout && typeof report.columnLayout === "object"
            ? report.columnLayout
            : { groups: [], merges: [] };
        if (report.selectedFilterFields) {
          // Esperar un tick para asegurar que isReportMode esté actualizado en el componente Filters
          await this.$nextTick();

          // Asignar directamente (Vue detectará el cambio)
          this.selectedFilterFields = { ...report.selectedFilterFields };

          // Actualizar savedSelectedFilterFields para que esté sincronizado con el reporte
          this.savedSelectedFilterFields = JSON.parse(
            JSON.stringify(report.selectedFilterFields)
          );
        } else {
          // Si el reporte no tiene selectedFilterFields, inicializar con valores vacíos
          // para que el componente Filters use los campos por defecto
          await this.$nextTick();
          this.selectedFilterFields = {};
          this.savedSelectedFilterFields = {};
        }
        if (this.reportSortPersistEnabled) {
          // Asignación incondicional: un reporte sin orden guardado tiene que
          // limpiar el orden del reporte anterior, no heredarlo (ticket #395).
          this.sortField =
            typeof report.sortField === "string" ? report.sortField : "";
          this.sortOrder = report.sortOrder === "desc" ? "desc" : "asc";
        } else {
          if (report.sortField) {
            this.sortField = report.sortField;
          }
          if (report.sortOrder) {
            this.sortOrder = report.sortOrder;
          }
        }
        if (report.pagination) {
          this.pagination.page = report.pagination.page || 1;
          this.pagination.perPage = report.pagination.perPage || 20;
        }

        // Columnas visibles antes de layout/pins (evita displayTableColumns con estado mezclado)
        await this.loadVisibleTableFields();
        this.reportColumnLayout = normalizeColumnLayout(
          layoutRaw,
          this.visibleTableFields.map((f) => f.key)
        );
        this.pinnedColumnKeys = Array.isArray(report.pinnedColumnKeys)
          ? [...report.pinnedColumnKeys]
          : [];
        this.prunePinnedColumnKeys();
        this.reportGroupByField =
          typeof report.groupByField === "string" ? report.groupByField : "";

        // Limpiar filtros anteriores antes de aplicar los nuevos
        if (this.$refs.filtersComponent) {
          // Guardar las claves de los filtros del reporte para no sobrescribir sus operadores
          const reportFilterKeys = report.filters
            ? Object.keys(report.filters)
            : [];

          Object.keys(this.$refs.filtersComponent.filters || {}).forEach(
            (key) => {
              this.$set(this.$refs.filtersComponent.filters, key, null);
            }
          );
          if (this.$refs.filtersComponent.filterOperators) {
            Object.keys(
              this.$refs.filtersComponent.filterOperators || {}
            ).forEach((key) => {
              this.$set(
                this.$refs.filtersComponent.filterOperators,
                key,
                "="
              );
            });
          }
          if (this.$refs.filtersComponent.textSearchQuery !== undefined) {
            this.$refs.filtersComponent.textSearchQuery = "";
          }

          // Forzar actualización de campos visibles basándose en selectedFilterFields del reporte
          // Esperar a que Vue procese los cambios en selectedFilterFields y isReportMode
          await this.$nextTick();
          await this.$nextTick(); // Doble nextTick para asegurar que las props se hayan actualizado
          if (
            this.$refs.filtersComponent &&
            this.$refs.filtersComponent.updateVisibleFilterFields
          ) {
            await this.$refs.filtersComponent.updateVisibleFilterFields();
          }
        }

        // Aplicar filtros si existen
        if (report.filters && Object.keys(report.filters).length > 0) {
          // Esperar a que el componente Filters esté completamente inicializado
          await this.$nextTick();
          await new Promise((resolve) => setTimeout(resolve, 200));

          // Cargar opciones de referencia si es necesario antes de aplicar filtros
          if (
            this.$refs.filtersComponent &&
            this.$refs.filtersComponent.loadReferenceOptions
          ) {
            await this.$refs.filtersComponent.loadReferenceOptions();
          }

          // Aplicar filtros al componente Filters para que se muestren visualmente
          await this.applyFiltersToComponent(report.filters);

          // Usar filtros normalizados del componente (corrige formatos legacy como "=false")
          await this.$nextTick();
          this.pagination.page = 1;
          this.isLoading = true;
          // Preferir los strings guardados del reporte (ej. remaining=>0): un race del
          // watcher de Filters puede dejar operator "=" y value "0" → remaining=0 (lista vacía).
          const reportFilterQs = Object.entries(report.filters || {})
            .filter(
              ([key, value]) =>
                key !== "textPlainVersion" &&
                value !== null &&
                value !== undefined &&
                String(value).trim() !== ""
            )
            .map(
              ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
            )
            .join("&");
          // La búsqueda de texto no viaja en reportFilterQs (se excluye arriba): se agrega
          // aparte para que ?reportId=...&textPlainVersion=X filtre el reporte en lugar de
          // quedar solo pintada en la caja de búsqueda.
          const reportSearchParams = new URLSearchParams();
          this.appendTextPlainVersionFromSearchOrRoute(reportSearchParams);
          const reportQs = [reportFilterQs, reportSearchParams.toString()]
            .filter(Boolean)
            .join("&");
          await this.fetchItems(
            reportQs || this.getCurrentFiltersQueryString()
          );
        } else {
          // Si no hay filtros, recargar items normalmente
          if (this.view) {
            this.isLoading = true;
            await this.fetchViewItems();
          } else {
            this.isLoading = true;
            await this.fetchItems();
          }
        }

        // Actualizar el estado "guardado" después de cargar el reporte
        this.updateSavedState();

        // Mostrar mensaje de éxito
        // Nota: isLoading se establece en false por fetchItems/fetchViewItems o handleFilter
      } catch (error) {
        console.error("Error loading report:", error);
        this.isLoading = false; // Asegurar que el estado de carga se desactive en caso de error
        Swal.fire({
          icon: "error",
          title: this.$tn("error"),
          text: this.$tn("ErrorLoadingReport"),
        });
      } finally {
        this._applyingReport = false;
      }
    },
    async saveAllPreferences() {
      if (this.isSavingPreferences) return;

      // Reporte cargado: saveCurrentLoadedReport gestiona isSavingPreferences (no pre-bloquear aquí)
      if (this.currentLoadedReport) {
        await this.saveCurrentLoadedReport();
        return;
      }

      this.isSavingPreferences = true;
      try {
        await this.resolveCurrentUserAdminStatus();
          const canApplyToAll =
            this.isCurrentUserAdmin ||
            this.hasPermission("preferences.apply_to_all");

          let applyToAll = false;

          if (canApplyToAll) {
            // Admins o permiso preferences.apply_to_all: mostrar popup con opción de aplicar a todos
            const result = await Swal.fire({
              title: this.$tn("savePreferences"),
              html: `
                <div class="form-check text-start mt-3">
                  <input class="form-check-input" type="checkbox" id="applyToAllUsers">
                  <label class="form-check-label" for="applyToAllUsers">
                    ${this.$tn("applyPreferencesToAllUsers")}
                  </label>
                  <div class="text-muted small mt-1">${this.$tn(
                    "applyPreferencesToAllUsersHint"
                  )}</div>
                </div>
              `,
              icon: "question",
              showCancelButton: true,
              confirmButtonText: this.$tn("Save"),
              cancelButtonText: this.$tn("Cancel"),
              preConfirm: () => {
                return {
                  applyToAll:
                    document.getElementById("applyToAllUsers").checked,
                };
              },
            });

            if (!result.isConfirmed) {
              return; // Usuario canceló
            }

            applyToAll = result.value.applyToAll;

            // Guardar preferencias
            await this.saveColumnPreferences(true, applyToAll);
            await this.handleFilterSavePreferences(applyToAll);
            this.updateSavedState();

            // Mostrar mensaje de éxito
            const successMessage = applyToAll
              ? this.$t("preferencesAppliedToAllUsers")
              : this.$t("preferencesSaved");

            Swal.fire({
              icon: "success",
              title: this.$tn("success"),
              text: successMessage,
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            // Para usuarios normales: guardar silenciosamente sin popup
            await this.saveColumnPreferences(true, false);
            await this.handleFilterSavePreferences(false);
            this.updateSavedState();
          }
      } catch (error) {
        console.error("Error saving preferences:", error);
        Swal.fire({
          icon: "error",
          title: this.$tn("error"),
          text: error.response?.data?.error || this.$tn("preferencesSaveError"),
        });
      } finally {
        this.isSavingPreferences = false;
      }
    },
    /** Listas para resolver labels de filtros tipo list (padre o hijo Filters). */
    getListsDatasetForFilters() {
      if (this.lists && this.lists.length > 0) {
        return this.lists;
      }
      const fc = this.$refs.filtersComponent;
      if (fc && fc.lists && fc.lists.length > 0) {
        return fc.lists;
      }
      return [];
    },
    findListDefinitionForField(field, listsData) {
      if (!listsData || !listsData.length || !field) {
        return null;
      }
      if (field.listRef) {
        return (
          listsData.find(
            (l) =>
              l._id === field.listRef || String(l._id) === String(field.listRef)
          ) || null
        );
      }
      if (field.listType) {
        return listsData.find((l) => l.type === field.listType) || null;
      }
      return listsData.find((l) => l.type === field.key) || null;
    },
    async ensureListsLoadedForFilters() {
      if (this.getListsDatasetForFilters().length > 0) {
        if (
          this.lists &&
          this.lists.length > 0 &&
          this.$refs.filtersComponent &&
          (!this.$refs.filtersComponent.lists ||
            this.$refs.filtersComponent.lists.length === 0)
        ) {
          this.$set(this.$refs.filtersComponent, "lists", [...this.lists]);
        }
        return;
      }
      try {
        await this.fetchLists();
      } catch (e) {
        console.warn("ensureListsLoadedForFilters: fetchLists failed", e);
      }
      if (this.lists && this.lists.length > 0 && this.$refs.filtersComponent) {
        this.$set(this.$refs.filtersComponent, "lists", [...this.lists]);
      }
    },
    async applyFiltersToComponent(savedFilters) {
      // Aplicar los filtros guardados al componente Filters para que se muestren visualmente
      if (!this.$refs.filtersComponent || !savedFilters) {
        return;
      }

      await this.$nextTick();

      // Primero, cargar las opciones de referencia para campos que las necesiten
      const referenceFieldsNeeded = [];
      let hasReferenceSubfieldFilters = false;

      Object.keys(savedFilters).forEach((key) => {
        if (key === "textPlainVersion") return;

        // Detectar filtros de subcampos de reference (formato: referenceField.subField)
        if (key.includes(".")) {
          hasReferenceSubfieldFilters = true;
          return;
        }

        const field = this.modelFields.find((f) => f.key === key);
        if (field && (field.type === "reference" || field.type === "list")) {
          referenceFieldsNeeded.push(field);
        }
      });

      // Cargar opciones de referencia si es necesario
      if (
        referenceFieldsNeeded.length > 0 &&
        this.$refs.filtersComponent.loadReferenceOptions
      ) {
        await this.$refs.filtersComponent.loadReferenceOptions();
        // Esperar un poco más para que las opciones se carguen
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      // Precargar usuarios si hay filtros de subcampos o referencias → users
      if (hasReferenceSubfieldFilters && this.$refs.filtersComponent) {
        if (this.$refs.filtersComponent.ensureUsersFilterDataLoaded) {
          await this.$refs.filtersComponent.ensureUsersFilterDataLoaded();
        }
      }

      const needsListResolution = Object.keys(savedFilters).some((k) => {
        if (k === "textPlainVersion" || k.includes(".")) {
          return false;
        }
        const f = this.modelFields.find((x) => x.key === k);
        return f && f.type === "list";
      });
      if (needsListResolution) {
        await this.ensureListsLoadedForFilters();
      }

      // Parsear los filtros guardados y aplicarlos al componente
      for (const [key, value] of Object.entries(savedFilters)) {
        if (key === "textPlainVersion") {
          // Manejar búsqueda de texto por separado
          if (value) {
            this.$set(this.$refs.filtersComponent, "textSearchQuery", value);
          }
          continue;
        }

        // Detectar si es un filtro de subcampo de reference (formato: referenceField.subField)
        const isReferenceSubfield = key.includes(".");

        let field = this.modelFields.find((f) => f.key === key);

        // Si es un filtro de subcampo de reference, crear un campo virtual (incl. A.B.C cuando B es ref isArray)
        if (!field && isReferenceSubfield) {
          const resolved = await resolveReferenceSubfieldFilterField(
            this.modelFields,
            key,
            (name) => this.getModelDefinition(name)
          );
          if (resolved) {
            const parentField = resolved.parentField;
            const leafDef = resolved.subFieldDef;
            const intermediate = resolved.intermediateRefField;
            let label;
            if (intermediate && resolved.nestedFieldKey) {
              label = `${this.$t(
                parentField.label || parentField.key
              )} → ${this.$t(
                intermediate.label || resolved.subFieldKey
              )} → ${this.$t(leafDef.label || resolved.nestedFieldKey)}`;
            } else {
              label = `${this.$t(
                parentField.label || parentField.key
              )} → ${this.$t(leafDef.label || resolved.subFieldKey)}`;
            }
            field = {
              key: resolved.key,
              type: "reference_subfield",
              parentField,
              subFieldKey: resolved.subFieldKey,
              nestedFieldKey: resolved.nestedFieldKey || undefined,
              subFieldType: resolved.subFieldType,
              subFieldRef: resolved.subFieldRef,
              subFieldListType: resolved.subFieldListType,
              subFieldListRef: resolved.subFieldListRef,
              subFieldDef: leafDef,
              nestedSubFieldDef: resolved.nestedSubFieldDef || undefined,
              ref: resolved.ref,
              isArray: resolved.isArray,
              label,
            };
          }
        }

        // Subcampos de grupo raíz (ej. shipping.expenses.type — expenses es group, no reference)
        if (!field && isReferenceSubfield) {
          const g = resolveGroupSubfieldFilterField(this.modelFields, key);
          if (g) {
            const label = `${this.$t(
              g.groupRootField.label || g.groupRootField.key
            )} → ${g.labelParts.map((p) => this.$t(p)).join(" → ")}`;
            field = {
              ...g.fieldDef,
              key: g.key,
              label,
            };
          }
        }

        if (!field) continue;

        // Agregar el campo a selectedFilterFields si no está para que sea visible
        if (!this.selectedFilterFields[key]) {
          this.$set(this.selectedFilterFields, key, true);
        }

        // Agregar el campo a visibleFilterFields del componente si no está
        if (
          this.$refs.filtersComponent &&
          this.$refs.filtersComponent.visibleFilterFields
        ) {
          const existsInVisible =
            this.$refs.filtersComponent.visibleFilterFields.some(
              (f) => f.key === key
            );
          if (!existsInVisible) {
            this.$refs.filtersComponent.visibleFilterFields.push(field);
          }
        }

        let filterValue = value;
        let operator = "=";

        // Parsear el formato de filtro guardado
        if (typeof value === "string") {
          // Detectar operadores en el formato guardado
          if (value.startsWith("contains:")) {
            operator = "contains";
            filterValue = value.replace("contains:", "");
          } else if (value.startsWith("startswith:")) {
            operator = "startswith";
            filterValue = value.replace("startswith:", "");
          } else if (value.startsWith("endswith:")) {
            operator = "endswith";
            filterValue = value.replace("endswith:", "");
          } else if (value.startsWith("regex:")) {
            operator = "regex";
            filterValue = value.replace("regex:", "");
          } else if (value === "is_null") {
            operator = "is_null";
            filterValue = null;
          } else if (value === "is_not_null") {
            operator = "is_not_null";
            filterValue = null;
          } else if (value.startsWith(">=")) {
            operator = ">=";
            filterValue = value.replace(">=", "").trim();
          } else if (value.startsWith("<=")) {
            operator = "<=";
            filterValue = value.replace("<=", "").trim();
          } else if (value.startsWith(">")) {
            operator = ">";
            filterValue = value.replace(">", "").trim();
          } else if (value.startsWith("<")) {
            operator = "<";
            filterValue = value.replace("<", "").trim();
          } else if (value.startsWith("!=")) {
            operator = "!=";
            filterValue = value.replace("!=", "").trim();
            // Si el valor está vacío después del operador, convertir a is_not_null (not empty)
            if (filterValue === "") {
              operator = "is_not_null";
              filterValue = null;
            }
          } else if (value.startsWith("=")) {
            operator = "=";
            filterValue = value.replace("=", "").trim();
          } else if (value.includes(LEGACY_DATE_RANGE_SEPARATOR)) {
            // Rango de fechas: se edita con el operador "between" (dos inputs).
            // Los guardados viejos traen el operador pegado al valor, así que
            // se limpia para que la fecha de inicio siga siendo una fecha.
            const range = legacyDateRangeFromValue(value);
            operator = "between";
            this.$set(this.$refs.filtersComponent.tempDateRanges, key, {
              start: range.start,
              end: range.end,
            });
            filterValue = stripLegacyBetweenPrefix(value);
          } else {
            // Valor simple
            filterValue = value;
          }
        } else {
          filterValue = value;
        }

        // Para operadores especiales (is_null, is_not_null), siempre aplicar aunque el valor esté vacío
        const isSpecialOperator =
          operator === "is_null" || operator === "is_not_null";

        // Si el valor está vacío pero no es un operador especial, saltar este filtro
        if (
          !isSpecialOperator &&
          (filterValue === null || filterValue === "")
        ) {
          continue;
        }

        // is_null / is_not_null no tienen valor que resolver (evita id.toString() sobre null)
        if (isSpecialOperator) {
          this.$set(this.$refs.filtersComponent.filters, key, null);
          this.$set(this.$refs.filtersComponent.filterOperators, key, operator);
          continue;
        }

        // Para campos de referencia o lista, necesitamos cargar el objeto completo
        if (field.type === "reference" || field.type === "list") {
          // Verificar si el valor es una cadena separada por comas (múltiples valores)
          const isMultipleValues =
            typeof filterValue === "string" && filterValue.includes(",");
          const valueIds = (
            isMultipleValues
              ? filterValue.split(",").map((id) => id.trim())
              : [filterValue]
          ).filter((id) => id != null && id !== "");

          if (field.type === "reference" && field.ref) {
            // Cargar opciones de referencia si no están cargadas
            if (
              !this.$refs.filtersComponent.internalReferenceOptions?.[key] ||
              this.$refs.filtersComponent.internalReferenceOptions[key]
                .length === 0
            ) {
              await this.$refs.filtersComponent.loadReferenceOptions(key);
            }

            const refOptions =
              this.$refs.filtersComponent.internalReferenceOptions?.[key] ||
              this.referenceItems?.[field.ref] ||
              [];

            // Buscar todos los valores en las opciones
            const foundRefs = valueIds
              .map((id) => {
                const found = refOptions.find((item) => {
                  if (item == null || id == null) return false;
                  const itemId = item._id?.toString();
                  return itemId === String(id);
                });
                if (found) return found;

                // Si no se encuentra, intentar cargar desde la API
                return null;
              })
              .filter((item) => item !== null);

            // Cargar valores faltantes desde la API
            const missingIds = valueIds.filter(
              (id) =>
                id != null &&
                !foundRefs.some(
                  (ref) => ref._id?.toString() === String(id)
                )
            );

            for (const missingId of missingIds) {
              try {
                const userEndpoint =
                  field.ref === "users"
                    ? `/api/users/${missingId}`
                    : `/api/gotrading/dynamic/${field.ref}/${missingId}`;
                const { data } = await wencesApi.get(userEndpoint);
                if (data) {
                  foundRefs.push(data);
                }
              } catch (error) {
                console.warn(
                  `Could not load reference item for ${key}:`,
                  error
                );
              }
            }

            // Establecer el valor: array si hay múltiples, objeto único si hay uno, o el ID si no se encontró
            if (foundRefs.length > 0) {
              this.$set(
                this.$refs.filtersComponent.filters,
                key,
                isMultipleValues ? foundRefs : foundRefs[0]
              );
            } else {
              this.$set(
                this.$refs.filtersComponent.filters,
                key,
                isMultipleValues ? valueIds : filterValue
              );
            }
          } else if (field.type === "list") {
            const listsData = this.getListsDatasetForFilters();
            const list = this.findListDefinitionForField(field, listsData);
            const setListFilterValue = (objects) => {
              this.$set(
                this.$refs.filtersComponent.filters,
                key,
                isMultipleValues ? objects : objects[0]
              );
            };
            if (list && Array.isArray(list.values)) {
              const foundValues = valueIds
                .map((id) =>
                  list.values.find((v) => String(v._id) === String(id))
                )
                .filter((v) => v !== undefined);
              if (foundValues.length > 0) {
                setListFilterValue(foundValues);
              } else {
                const placeholders = valueIds.map((id) => ({
                  _id: id,
                  label: String(id),
                }));
                setListFilterValue(placeholders);
              }
            } else {
              const placeholders = valueIds.map((id) => ({
                _id: id,
                label: String(id),
              }));
              setListFilterValue(placeholders);
            }
          } else if (field.type === "reference") {
            this.$set(
              this.$refs.filtersComponent.filters,
              key,
              isMultipleValues ? valueIds : filterValue
            );
          }
        } else if (field.type === "reference_subfield") {
          // Para subcampos de reference, determinar el tipo real del subcampo
          const subFieldType = field.subFieldType;
          const subFieldRef = field.subFieldRef;

          // Si es un campo de tipo 'users' (el tipo puede ser 'users' o ref puede ser 'users')
          const isUsersField =
            subFieldType === "users" || subFieldRef === "users";

          if (isUsersField) {
            if (this.$refs.filtersComponent.ensureUsersFilterDataLoaded) {
              await this.$refs.filtersComponent.ensureUsersFilterDataLoaded();
            } else if (this.$refs.filtersComponent.loadUsersOptions) {
              await this.$refs.filtersComponent.loadUsersOptions();
            }
            const usersOptions = this.$refs.filtersComponent.usersOptions || [];

            // Verificar si el valor es una cadena separada por comas (múltiples valores)
            const isMultipleValues =
              typeof filterValue === "string" && filterValue.includes(",");
            const valueIds = (
              isMultipleValues
                ? filterValue.split(",").map((id) => id.trim())
                : [filterValue]
            ).filter((id) => id != null && id !== "");

            const foundUsers = valueIds
              .map((id) => {
                const found = usersOptions.find((user) => {
                  if (user == null || id == null) return false;
                  const userId = user._id?.toString();
                  return userId === String(id);
                });
                if (found) return found;

                // Intentar cargar el usuario desde la API
                return null;
              })
              .filter((user) => user !== null);

            // Cargar usuarios faltantes desde la API
            const missingIds = valueIds.filter(
              (id) =>
                id != null &&
                !foundUsers.some(
                  (user) => user._id?.toString() === String(id)
                )
            );

            for (const missingId of missingIds) {
              try {
                const { data } = await wencesApi.get(`/api/users/${missingId}`);
                if (data) {
                  foundUsers.push(data);
                }
              } catch (error) {
                console.warn(`Could not load user for ${key}:`, error);
              }
            }

            // Establecer el valor: array si hay múltiples, objeto único si hay uno
            if (foundUsers.length > 0) {
              this.$set(
                this.$refs.filtersComponent.filters,
                key,
                isMultipleValues ? foundUsers : foundUsers[0]
              );
            } else {
              this.$set(
                this.$refs.filtersComponent.filters,
                key,
                isMultipleValues ? valueIds : filterValue
              );
            }
          } else if (subFieldType === "reference" && subFieldRef) {
            // Es un reference a otro modelo, cargar desde la API
            // Verificar si el valor es una cadena separada por comas (múltiples valores)
            const isMultipleValues =
              typeof filterValue === "string" && filterValue.includes(",");
            const valueIds = (
              isMultipleValues
                ? filterValue.split(",").map((id) => id.trim())
                : [filterValue]
            ).filter((id) => id != null && id !== "");

            const foundRefs = [];
            for (const id of valueIds) {
              try {
                const { data } = await wencesApi.get(
                  `/api/gotrading/dynamic/${subFieldRef}/${id}`
                );
                if (data) {
                  foundRefs.push(data);
                }
              } catch (error) {
                console.warn(
                  `Could not load reference item for ${key}:`,
                  error
                );
              }
            }

            // Establecer el valor: array si hay múltiples, objeto único si hay uno
            if (foundRefs.length > 0) {
              this.$set(
                this.$refs.filtersComponent.filters,
                key,
                isMultipleValues ? foundRefs : foundRefs[0]
              );
            } else {
              this.$set(
                this.$refs.filtersComponent.filters,
                key,
                isMultipleValues ? valueIds : filterValue
              );
            }
          } else {
            // Es otro tipo de campo (string, number, etc.), aplicar directamente
            this.$set(this.$refs.filtersComponent.filters, key, filterValue);
          }
        } else if (
          field.type === "date" ||
          field.type === "datetime" ||
          (field.type === "reference_subfield" &&
            (field.subFieldType === "date" ||
              field.subFieldType === "datetime"))
        ) {
          // Para fechas (incluyendo reference_subfield con tipo date), restaurar en tempDateRanges si hay un operador y un valor de fecha
          if (
            filterValue &&
            typeof filterValue === "string" &&
            !filterValue.includes(" - ")
          ) {
            // Si es una fecha simple con operador, restaurar en tempDateRanges según el operador
            if (operator === ">=" || operator === ">") {
              // Operadores >= o > van en start
              if (!this.$refs.filtersComponent.tempDateRanges) {
                this.$set(this.$refs.filtersComponent, "tempDateRanges", {});
              }
              this.$set(this.$refs.filtersComponent.tempDateRanges, key, {
                start: filterValue,
                end: "",
              });
            } else if (operator === "<=" || operator === "<") {
              // Operadores <= o < van en end
              if (!this.$refs.filtersComponent.tempDateRanges) {
                this.$set(this.$refs.filtersComponent, "tempDateRanges", {});
              }
              this.$set(this.$refs.filtersComponent.tempDateRanges, key, {
                start: "",
                end: filterValue,
              });
            } else if (operator === "=") {
              // Operador = puede ir en ambos o solo en start
              if (!this.$refs.filtersComponent.tempDateRanges) {
                this.$set(this.$refs.filtersComponent, "tempDateRanges", {});
              }
              this.$set(this.$refs.filtersComponent.tempDateRanges, key, {
                start: filterValue,
                end: filterValue,
              });
            }
          }
          // Ya manejamos el rango arriba en tempDateRanges para rangos (formato "start - end")
          this.$set(this.$refs.filtersComponent.filters, key, filterValue);
        } else if (field.type === "boolean") {
          const boolValue = coerceBooleanFilterValue(filterValue);
          if (typeof boolValue === "boolean") {
            this.$set(this.$refs.filtersComponent.filters, key, boolValue);
          }
        } else {
          // Para otros tipos, aplicar el valor directamente
          this.$set(this.$refs.filtersComponent.filters, key, filterValue);
        }

        // Validar y corregir operador según el tipo de campo antes de aplicarlo
        const validNumberOperators = [
          "=",
          ">",
          "<",
          ">=",
          "<=",
          "!=",
          "is_null",
          "is_not_null",
        ];
        const textOperators = ["contains", "startswith", "endswith", "regex"];

        // Determinar si es un campo numérico (incluyendo reference_subfield con subFieldType number)
        const isNumberField =
          field.type === "number" ||
          (field.type === "reference_subfield" &&
            field.subFieldType === "number");

        // Determinar si es un campo de texto
        const isTextField =
          ["string", "text", "varchar", "char", "autoincrement"].includes(
            field.type
          ) ||
          (field.type === "reference_subfield" &&
            ["string", "text", "varchar", "char"].includes(field.subFieldType));

        // Si es un campo numérico y tiene un operador de texto, corregirlo
        if (isNumberField && textOperators.includes(operator)) {
          operator = "=";
        }

        // Si es un campo de texto y tiene un operador numérico inválido, corregirlo
        if (
          isTextField &&
          !validNumberOperators.includes(operator) &&
          !textOperators.includes(operator) &&
          operator !== "="
        ) {
          operator = "=";
        }

        // Aplicar el operador
        this.$set(this.$refs.filtersComponent.filterOperators, key, operator);
      }

      // Asegurar que textSearchQuery se aplique si existe
      if (savedFilters.textPlainVersion) {
        this.$set(
          this.$refs.filtersComponent,
          "textSearchQuery",
          savedFilters.textPlainVersion
        );
      }

      // Forzar actualización del componente Filters para que muestre los filtros activos
      await this.$nextTick();
      this.$refs.filtersComponent.$forceUpdate();
    },
    // Método para aplicar filtros desde cambios de URL (cuando ya estamos en el mismo modelo)
    async applyFiltersFromUrl(queryParams) {
      // Resetear paginación a página 1 cuando se aplican filtros desde la URL
      this.pagination.page = 1;

      if (!queryParams || Object.keys(queryParams).length === 0) {
        // Si no hay query params, limpiar filtros y recargar
        if (this.$refs.filtersComponent) {
          this.$refs.filtersComponent.clearAll();
        }
        await this.fetchItems();
        return;
      }

      // Aplicar los filtros visualmente al componente
      await this.applyFiltersToComponent(queryParams);

      // Llamar a handleFilter para refrescar los datos con skipUrlUpdate=true
      // porque la URL ya cambió
      this.handleFilter(queryParams, { skipUrlUpdate: true });
    },
    // Método para limpiar filtros, restaurar preferencias del usuario y recargar el listado (cuando se hace click en "All")
    async clearFiltersAndReload() {
      // Limpiar el reporte cargado
      this.currentLoadedReport = null;
      this.reportColumnLabels = {};
      this.savedReportColumnLabels = {};
      this.reportColumnDescriptions = {};
      this.savedReportColumnDescriptions = {};
      this.reportColumnEmphasis = {};
      this.savedReportColumnEmphasis = {};
      this.reportColumnTotals = {};
      this.savedReportColumnTotals = {};
      this.totals = {};
      this.reportColumnLayout = { groups: [], merges: [] };
      this.savedReportColumnLayout = { groups: [], merges: [] };
      this.reportGroupByField = "";
      this.savedReportGroupByField = "";
      this.pinnedColumnKeys = [];
      this.savedPinnedColumnKeys = [];

      // Restaurar las preferencias de columnas del usuario
      this.isLoadingColumnPreferences = true;
      const savedColumns = await this.loadColumnPreferences();
      this.selectedColumns = this.mergeNewColumns(savedColumns);

      // Cargar preferencias de filtros del usuario
      await this.loadFilterPreferences();

      // Recargar las columnas visibles con las preferencias del usuario
      await this.loadVisibleTableFields();

      // Inicializar anchos por defecto
      this.initializeDefaultWidths();

      this.loadPinnedColumnsForList();

      // Actualizar el estado "guardado" con las preferencias del usuario
      this.updateSavedState();

      // Limpiar filtros del componente Filters
      if (this.$refs.filtersComponent) {
        Object.keys(this.$refs.filtersComponent.filters || {}).forEach(
          (key) => {
            this.$set(this.$refs.filtersComponent.filters, key, null);
          }
        );
        if (this.$refs.filtersComponent.filterOperators) {
          Object.keys(
            this.$refs.filtersComponent.filterOperators || {}
          ).forEach((key) => {
            this.$set(this.$refs.filtersComponent.filterOperators, key, "=");
          });
        }
        if (this.$refs.filtersComponent.textSearchQuery !== undefined) {
          this.$refs.filtersComponent.textSearchQuery = "";
        }
      }

      // Resetear paginación a página 1 al limpiar filtros
      this.pagination.page = 1;

      if (this.$route.query && this.$route.query.ownerScope) {
        const query = { ...(this.$route.query || {}) };
        delete query.ownerScope;
        this.isUpdatingRoute = true;
        try {
          await this.$router
            .replace({ path: this.$route.path, query })
            .catch(() => {});
        } finally {
          await this.$nextTick();
          this.isUpdatingRoute = false;
        }
      }

      // Recargar el listado sin filtros
      await this.fetchItems();
    },
    async exitReport() {
      try {
        // Limpiar el reporte cargado
        this.currentLoadedReport = null;
        this.reportColumnLabels = {};
        this.savedReportColumnLabels = {};
        this.reportColumnDescriptions = {};
        this.savedReportColumnDescriptions = {};
        this.reportColumnEmphasis = {};
        this.savedReportColumnEmphasis = {};
        this.reportColumnTotals = {};
        this.savedReportColumnTotals = {};
        this.totals = {};
        this.reportColumnLayout = { groups: [], merges: [] };
        this.savedReportColumnLayout = { groups: [], merges: [] };
        this.reportGroupByField = "";
        this.savedReportGroupByField = "";
        this.pinnedColumnKeys = [];
        this.savedPinnedColumnKeys = [];

        // Limpiar la URL del reportId (el embebido nunca la ensució)
        if (!this.isEmbeddedList && this.$route.query.reportId) {
          this.$router
            .replace({
              path: this.$route.path,
              query: {},
            })
            .catch(() => {});
        }

        // Recargar las preferencias del usuario
        this.isLoadingColumnPreferences = true;
        const savedColumns = await this.loadColumnPreferences();
        this.selectedColumns = this.mergeNewColumns(savedColumns);

        // Cargar preferencias de filtros
        await this.loadFilterPreferences();

        // Recargar las columnas visibles
        await this.loadVisibleTableFields();

        // Inicializar anchos por defecto
        this.initializeDefaultWidths();

        this.loadPinnedColumnsForList();

        // Actualizar el estado "guardado" con las preferencias del usuario
        this.updateSavedState();

        // Limpiar filtros aplicados
        if (this.$refs.filtersComponent) {
          // Limpiar todos los filtros
          Object.keys(this.$refs.filtersComponent.filters || {}).forEach(
            (key) => {
              this.$set(this.$refs.filtersComponent.filters, key, null);
              if (this.$refs.filtersComponent.filterOperators) {
                this.$set(
                  this.$refs.filtersComponent.filterOperators,
                  key,
                  "="
                );
              }
            }
          );
          if (this.$refs.filtersComponent.textSearchQuery) {
            this.$refs.filtersComponent.textSearchQuery = "";
          }
          // Emitir filtros vacíos para recargar los items
          this.$refs.filtersComponent.emitFilters();
        } else {
          // Si no hay componente de filtros, recargar items normalmente
          if (this.view) {
            this.isLoading = true;
            await this.fetchViewItems();
          } else {
            this.isLoading = true;
            await this.fetchItems();
          }
        }

        Swal.fire({
          icon: "success",
          title: this.$tn("success"),
          text: this.$tn("ReportExited"),
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error exiting report:", error);
        Swal.fire({
          icon: "error",
          title: this.$tn("error"),
          text: this.$tn("ErrorExitingReport"),
        });
      }
    },
    updateSavedState() {
      // Actualizar el estado "guardado" con el estado actual
      this.savedSelectedColumns = JSON.parse(
        JSON.stringify(this.selectedColumns)
      );
      this.savedColumnOrder = [
        ...this.visibleTableFields.map((field) => field.key),
      ];
      this.savedColumnWidths = JSON.parse(JSON.stringify(this.columnWidths));
      this.savedSelectedFilterFields = JSON.parse(
        JSON.stringify(this.selectedFilterFields)
      );

      // Guardar los filtros actuales
      let filters = {};
      if (this.$refs.filtersComponent && this.$refs.filtersComponent.filters) {
        const filtersToSave = {};
        Object.entries(this.$refs.filtersComponent.filters).forEach(
          ([key, value]) => {
            const operator =
              this.$refs.filtersComponent.filterOperators[key] || "=";

            // Incluir operadores especiales aunque no tengan valor
            if (operator === "is_null" || operator === "is_not_null") {
              filtersToSave[key] = operator;
            } else if (value !== null && value !== "") {
              // Buscar el campo en modelFields o en visibleFilterFields (para reference_subfield)
              let field = this.modelFields.find((f) => f.key === key);
              if (
                !field &&
                this.$refs.filtersComponent &&
                this.$refs.filtersComponent.visibleFilterFields
              ) {
                field = this.$refs.filtersComponent.visibleFilterFields.find(
                  (f) => f.key === key
                );
              }

              // Para list y reference, manejar arrays de valores
              // Para reference_subfield, verificar el tipo del subcampo
              const isReferenceSubfieldNonNumeric =
                field &&
                field.type === "reference_subfield" &&
                field.subFieldType !== "number" &&
                field.subFieldType !== "date";

              if (
                field &&
                (field.type === "list" ||
                  field.type === "reference" ||
                  isReferenceSubfieldNonNumeric)
              ) {
                // Manejar arrays de valores
                if (Array.isArray(value)) {
                  // Extraer los IDs de cada elemento del array
                  const ids = value
                    .filter((item) => item !== null && item !== undefined)
                    .map((item) => {
                      if (typeof item === "object" && item._id) {
                        return item._id;
                      }
                      return item;
                    });

                  // Guardar como string separado por comas para compatibilidad
                  if (ids.length > 0) {
                    filtersToSave[key] = ids.join(",");
                  }
                } else {
                  // Si es un solo valor, extraer el ID
                  let filterValue = value;
                  if (typeof value === "object" && value._id) {
                    filterValue = value._id;
                  }
                  filtersToSave[key] = filterValue;
                }
              } else {
                let filterValue = value;
                if (typeof value === "object" && value._id) {
                  filterValue = value._id;
                }

                if (operator === "contains") {
                  filtersToSave[key] = `contains:${filterValue}`;
                } else if (operator === "startswith") {
                  filtersToSave[key] = `startswith:${filterValue}`;
                } else if (operator === "endswith") {
                  filtersToSave[key] = `endswith:${filterValue}`;
                } else if (operator === "regex") {
                  filtersToSave[key] = `regex:${filterValue}`;
                } else if (operator === "=") {
                  // Para el operador =, guardar solo el valor (sin el operador)
                  filtersToSave[key] = filterValue;
                } else if (
                  operator === "between" ||
                  String(filterValue).includes(LEGACY_DATE_RANGE_SEPARATOR)
                ) {
                  // El rango ya viaja como «inicio - fin»: prefijarlo con el
                  // operador rompía la fecha de inicio y se re-prefijaba en
                  // cada guardado (betweenbetween2026-09-01 - 2026-09-30).
                  filtersToSave[key] = stripLegacyBetweenPrefix(filterValue);
                } else {
                  // Para otros operadores (!=, >, <, >=, <=), concatenar operador + valor
                  filtersToSave[key] = `${operator}${filterValue}`;
                }
              }
            }
          }
        );

        if (this.$refs.filtersComponent.textSearchQuery) {
          filtersToSave.textPlainVersion =
            this.$refs.filtersComponent.textSearchQuery.trim();
        }

        filters = filtersToSave;
      }
      this.savedFilters = filters;
      this.savedReportColumnLabels = JSON.parse(
        JSON.stringify(this.reportColumnLabels || {})
      );
      this.savedReportColumnDescriptions = JSON.parse(
        JSON.stringify(this.reportColumnDescriptions || {})
      );
      this.savedReportColumnEmphasis = JSON.parse(
        JSON.stringify(this.reportColumnEmphasis || {})
      );
      this.savedReportColumnTotals = JSON.parse(
        JSON.stringify(this.reportColumnTotals || {})
      );
      this.savedReportColumnLayout = JSON.parse(
        JSON.stringify(this.reportColumnLayout || { groups: [], merges: [] })
      );
      this.savedReportGroupByField = this.reportGroupByField || "";
      this.savedPinnedColumnKeys = [...(this.pinnedColumnKeys || [])];
      this.savedPerPage = Number(this.pagination?.perPage) || 20;
      this.savedSortField = this.sortField || "";
      this.savedSortOrder = this.sortOrder === "desc" ? "desc" : "asc";
    },
  },
  computed: {
    /**
     * Selección con la que abre "Select filter fields". Sin selección guardada
     * (y fuera de un reporte) "Más filtros" muestra un conjunto por defecto:
     * el selector lo muestra tildado, así tildar un filtro más lo suma a los
     * que ya se veían en vez de dejar solo ese.
     */
    filterSelectorSelection() {
      const selected = this.selectedFilterFields || {};
      const isReportMode =
        !!this.currentLoadedReport || !!this.$route.query.reportId;
      if (Object.keys(selected).length > 0 || isReportMode) return selected;
      return defaultFilterFieldSelection(this.modelFields);
    },
    /**
     * Versión de teléfono del listado (components/mobile): solo como página completa.
     * Embebido (chooseItem/minimal: buscadores de referencias, widgets) sigue la tabla.
     */
    useMobileList() {
      return this.isMobileLayout && !this.minimal && !this.chooseItem;
    },
    mobileListSubtitle() {
      const parts = [];
      if (this.currentLoadedReport && !this.isAlternateListView) {
        parts.push(this.currentLoadedReport.name);
      }
      if (this.isMyItemsFilterActive) parts.push(this.$t("listTitleMyItems"));
      return parts.join(" · ");
    },
    mobileCanAdd() {
      return !!(
        this.selectedModelData &&
        this.selectedModelData.name !== "shipping" &&
        this.canEditModel &&
        !this.isAlternateListView &&
        !this.minimal
      );
    },
    mobileReportChips() {
      const chips = [
        {
          key: "__all",
          label: this.$t("All"),
          icon: "list-ul",
          active: !this.activeReportTabId,
        },
      ];
      (this.orderedReportTabs || []).forEach((report) => {
        chips.push({
          key: String(report._id),
          label: report.name,
          icon: report.icon || "file-alt",
          active: this.isActiveReportTab(report),
          locked: !report.isPublic,
          report,
        });
      });
      return chips;
    },
    /** Columnas que la tarjeta puede mostrar (las combinadas de reporte no entran). */
    mobileCardColumns() {
      return (this.displayTableColumns || []).filter(
        (col) => col && col.field && col.displayType !== "merged"
      );
    },
    /** Título de la tarjeta: el nombre/número del registro; si no está en la vista, la
     *  primera columna que no sea fecha, bandera ni lista. */
    mobileTitleCol() {
      const cols = this.mobileCardColumns;
      return (
        cols.find((c) => c.field.key === "name") ||
        cols.find(
          (c) =>
            !this.isListFlagCol(c) &&
            !["date", "datetime", "list"].includes(c.field.type)
        ) ||
        cols[0] ||
        null
      );
    },
    mobileRowTitle() {
      const item = this.mobileRowItem;
      if (!item) return "";
      return String(item.name || item.title || this.$t("mobile.recordActions"));
    },
    /**
     * Ticket #395: el orden de columnas del listado forma parte del reporte y se
     * persiste al actualizarlo. Pedido solo para Duntower: en el resto de los
     * tenants el orden sigue siendo volátil (no habilita «Actualizar reporte»
     * ni se limpia al cambiar de reporte), tal como venía funcionando.
     */
    reportSortPersistEnabled() {
      return isDuntowerTenant();
    },
    isTrashView() {
      return this.getListModeFromRoute() === "trash";
    },
    isArchiveView() {
      return this.getListModeFromRoute() === "archive";
    },
    isAlternateListView() {
      return this.isTrashView || this.isArchiveView;
    },
    /** Id del reporte activo (cargado o pendiente de cargar desde la URL). */
    activeReportTabId() {
      const id =
        (this.currentLoadedReport && this.currentLoadedReport._id) ||
        this.$route?.query?.reportId ||
        null;
      return id ? String(id) : null;
    },
    /**
     * Tabs de reportes con el reporte activo adelante, para que no quede
     * escondido detras del scroll horizontal. El tab "All" queda fijo a la
     * izquierda (se renderiza aparte, fuera de esta lista).
     */
    orderedReportTabs() {
      const activeId = this.activeReportTabId;
      if (!activeId) return this.accessibleReports;
      const index = this.accessibleReports.findIndex(
        (report) => report && String(report._id) === activeId
      );
      if (index <= 0) return this.accessibleReports;
      const ordered = [...this.accessibleReports];
      const [active] = ordered.splice(index, 1);
      ordered.unshift(active);
      return ordered;
    },
    /** Pinta el tab activo con el color de la cabecera de la tabla del modelo. */
    reportTabsAccentStyle() {
      return this.reportTabsAccentColor
        ? { "--gt-report-tab-active-color": this.reportTabsAccentColor }
        : null;
    },
    /** Barra de tabs de reportes: solo en el listado normal y si hay reportes accesibles. */
    showReportTabsBar() {
      return !!(
        this.selectedModelData &&
        !this.isAlternateListView &&
        this.accessibleReports.length > 0
      );
    },
    /**
     * Campo del flag en este modelo: `flag_category` (campo propio del flag) y, para
     * definiciones anteriores, el `category` inyectado cuando era texto plano.
     */
    listFlagFieldKey() {
      const fields = this.modelFields || [];
      if (fields.some((f) => f && f.key === "flag_category")) return "flag_category";
      return this.modelCategoryIsFlagField ? "category" : "";
    },
    modelHasCategoryField() {
      return !!this.listFlagFieldKey;
    },
    /** ¿El `category` de este modelo se usaba como flag? (texto plano, no lista/ref) */
    modelCategoryIsFlagField() {
      const field = (this.modelFields || []).find(
        (f) => f && f.key === "category"
      );
      if (!field) return false;
      // El flag sólo puede usar el campo `category` inyectado por el módulo
      // financial (string oculto). Si el modelo define su propio `category`
      // (p.ej. Proform, que lo usa como lista jerárquica) el flag se esconde:
      // compartir el campo sobrescribiría el dato real del modelo.
      if (field.listFlagField === true) return true;
      // Fallback para definiciones sin la marca: aceptar sólo texto plano libre.
      const type = String(field.type || "string");
      if (!["string", "text", "textarea"].includes(type)) return false;
      if (field.ref || field.listName || field.list) return false;
      // `options` puede llegar como array o como string separada por comas.
      const opts = field.options;
      if (Array.isArray(opts)) return opts.length === 0;
      return !(typeof opts === "string" && opts.trim());
    },
    listLeadColWidthPx() {
      if (this.listActionsHoverless && this.listLeadColMeasuredPx) {
        return this.listLeadColMeasuredPx;
      }
      return LIST_LEAD_COL_WIDTH_PX;
    },
    listLeadColStyle() {
      const px = `${this.listLeadColWidthPx}px`;
      return { width: px, minWidth: px, maxWidth: px };
    },
    /**
     * Ancho automático de la columna de banderas: lo mínimo que haga falta.
     * Sin ninguna bandera cargada queda del ancho del icono; con banderas
     * crece hasta lo que ocupe la etiqueta más larga (después envuelve).
     */
    listFlagsAutoWidthPx() {
      if (!this.modelHasCategoryField) return LIST_FLAGS_MIN_WIDTH_PX;
      let maxChars = 0;
      (this.items || []).forEach((item) => {
        const label = this.getListCategoryLabel(this.listFlagValueOf(item));
        if (label && label.length > maxChars) maxChars = label.length;
      });
      if (!maxChars) return LIST_FLAGS_MIN_WIDTH_PX;
      // icono + padding del badge + ancho estimado del texto
      const estimated = 46 + maxChars * 6.5;
      return Math.round(
        Math.max(
          LIST_FLAGS_MIN_WIDTH_PX,
          Math.min(LIST_FLAGS_AUTO_MAX_WIDTH_PX, estimated)
        )
      );
    },
    isHiddenRowsView() {
      const hidden = this.$route?.query?.hidden;
      return hidden === "1" || hidden === "true";
    },
    canUseReportRowHide() {
      return !!(
        this.rowHideModuleActive &&
        this.currentLoadedReport &&
        this.currentLoadedReport._id &&
        this.rowHideReportIds.includes(String(this.currentLoadedReport._id)) &&
        !this.isTrashView &&
        !this.isArchiveView
      );
    },
    isAllFilteredSelected() {
      return areAllFilteredSelected(
        this.selectedItems,
        this.pagination?.total || 0
      );
    },
    isHeaderCheckboxIndeterminate() {
      return isListHeaderCheckboxIndeterminate(
        this.selectedItems,
        this.pagination?.total || 0
      );
    },
    /** Búsqueda y filtros: listado normal siempre; archivados solo si hay registros. */
    showListSearchAndFilters() {
      if (this.isTrashView) return false;
      if (!this.isArchiveView) return true;
      return this.archiveHasRecords;
    },
    canUseMyItemsFilter() {
      if (!this.selectedModelData) return false;
      const fields = this.modelFields.length
        ? this.modelFields
        : this.selectedModelData.fields;
      return resolveValidUserOwnerFieldKeys(this.selectedModelData, fields)
        .length > 0;
    },
    isMyItemsFilterActive() {
      return (
        this.canUseMyItemsFilter &&
        String(this.$route.query?.ownerScope || "").toLowerCase() === "mine"
      );
    },
    canUseArchive() {
      return !!(this.selectedModelData && this.selectedModelData.archiveEnabled === true);
    },
    listPageTitle() {
      if (!this.selectedModelData) return "";
      const base = this.selectedModelData.label
        ? this.$t(this.selectedModelData.label)
        : this.$t(this.selectedModelData.modelName);
      if (this.isTrashView) return `${base} - ${this.$t("listTitleTrash")}`;
      if (this.isArchiveView) return `${base} - ${this.$t("listTitleArchive")}`;
      if (this.isHiddenRowsView && this.canUseReportRowHide) {
        return `${base} - ${this.$t("listTitleHidden")}`;
      }
      return base;
    },
    /** Nombre de modelo para extensiones de toolbar (p. ej. FindTeu bulk tracking). */
    listToolbarModelName() {
      if (this.selectedModelData?.modelName) {
        return this.selectedModelData.modelName;
      }
      if (this.view?.modelName) {
        return this.view.modelName;
      }
      return this.selectedModel || "";
    },
    dynamicListTableStyle() {
      const minPx = this.computeListTableMinWidthPx();
      const style = {
        tableLayout: "fixed",
        width: "100%",
      };
      if (minPx > 0) {
        style.minWidth = `${minPx}px`;
      }
      return style;
    },
    /** Seam del mixin: los reportes traen merges y grupos de columnas. */
    columnPreferencesLayout() {
      return this.reportColumnLayout || {};
    },
    reportGroupHeaderCells() {
      const cells = buildGroupHeaderRow(
        this.displayTableColumns,
        this.reportColumnLayout || {}
      );
      if (!cells) return null;
      return cells.some((c) => c.title) ? cells : null;
    },
    /** Columnas por las que se puede agrupar (las unidas del layout no aplican). */
    groupableColumns() {
      return (this.displayTableColumns || []).filter(
        (col) =>
          col && col.displayType !== "merged" && col.field && col.field.key
      );
    },
    /** Columna de agrupación activa, o null si no hay o ya no está visible. */
    activeGroupColumn() {
      // La agrupación es exclusiva de los reportes.
      if (!this.currentLoadedReport) return null;
      if (!this.reportGroupByField) return null;
      return (
        this.groupableColumns.find(
          (col) => col.key === this.reportGroupByField
        ) || null
      );
    },
    /**
     * Filas de la página ordenadas por el valor de agrupación para que cada
     * grupo quede contiguo. Sin agrupación devuelve `items` sin tocar.
     */
    groupedItems() {
      const col = this.activeGroupColumn;
      const rows = this.items || [];
      if (!col || rows.length === 0) return rows;
      return this.sortRowsByGroupColumn(rows, col);
    },
    /**
     * Índice de fila → encabezado del grupo que arranca en esa fila.
     * @returns {Object<number, {label: string, count: number}>}
     */
    listGroupHeaders() {
      const col = this.activeGroupColumn;
      const rows = this.groupedItems || [];
      if (!col || rows.length === 0) return {};
      return this.buildGroupHeaders(rows, col);
    },
    listLeadingColspan() {
      return 1 + (this.chooseItem ? 1 : 0);
    },
    /** Columnas del esqueleto de carga: las reales si ya se conocen. */
    listSkeletonCols() {
      if (this.isLoadingColumnPreferences) return 6;
      return this.displayTableColumns.length || 6;
    },
    /** Filas del esqueleto: las que se van a mostrar, con tope para no alargar la página. */
    listSkeletonRows() {
      return Math.min(
        Number(this.pagination && this.pagination.perPage) || 10,
        12
      );
    },
    listHeaderFullColspan() {
      return this.listLeadingColspan + this.displayTableColumns.length + 1;
    },
    // Verificar si el usuario puede editar el modelo actual
    canEditModel() {
      if (!this.selectedModel) return false;
      const modelNameLower = this.selectedModel.toLowerCase();
      return this.hasPermission(`${modelNameLower}.manage`);
    },
    canDeleteAllRecords() {
      if (!this.selectedModel || this.view || this.isGroupModel()) return false;
      if (this.isAlternateListView) return false;
      const totalItems = this.pagination?.total || this.items.length || 0;
      return this.isCurrentUserAdmin && this.canEditModel && totalItems > 0;
    },
    /** Cabecera fija al desplazar en todos los listados dinámicos (salvo papelera/archivados). */
    listStickyHeaderActive() {
      return !this.isAlternateListView;
    },
    /** Parche al scrollear solo sin fila de grupos; con grupos se mantiene top acumulado. */
    listStickyHeaderGutterScrollFix() {
      return (
        this.listStickyHeaderActive &&
        this.listStickyHeaderScrolled &&
        !this.reportGroupHeaderCells
      );
    },
    /** Reporte con grupos: tapar filas que asoman sin mover top acumulado (grupos + cabecera). */
    listStickyHeaderGroupScrollFix() {
      return (
        this.listStickyHeaderActive &&
        this.listStickyHeaderScrolled &&
        !!this.reportGroupHeaderCells
      );
    },
    arrayFields() {
      const fields = this.modelFields.filter((field) => {
        return (
          // Campo de tipo array con itemFields
          field.type === "group" &&
          field.fields &&
          field.fields.length > 0 &&
          field.isArray === true
        );
      });
      return fields;
    },
    areAllColumnsSelected() {
      return this.nonGroupFields.every(
        (field) => this.selectedColumns[field.key] === true
      );
    },
    effectiveViewId() {
      // Prioriza la prop paramViewId sobre la ruta
      return this.paramViewId || this.$route.params.viewId;
    },
    /** El listado vive dentro de otra pantalla: la URL es de esa pantalla, no suya. */
    isEmbeddedList() {
      return !!this.paramModelName;
    },
    pinnedPopupReportKey() {
      return String(this.paramPinnedReportKey || "").trim();
    },
    /**
     * Lo que se guarda en el reporte fijo del popup: el armado del listado.
     * Los filtros del momento quedan afuera a propósito — son de quien está mirando
     * esa celda, no de la vista, y guardarlos se los dejaría puestos a todos.
     */
    pinnedPopupLayoutSignature() {
      if (!this.pinnedPopupReportKey) return "";
      return JSON.stringify({
        columns: this.selectedColumns,
        columnOrder: this.visibleTableFields.map((field) => field.key),
        columnWidths: this.columnWidths,
        columnLabels: this.reportColumnLabels,
        columnEmphasis: this.reportColumnEmphasis,
        columnTotals: this.reportColumnTotals,
        columnLayout: this.reportColumnLayout,
        pinnedColumnKeys: this.pinnedColumnKeys,
        groupByField: this.reportGroupByField,
        selectedFilterFields: this.selectedFilterFields,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        perPage: this.pagination && this.pagination.perPage,
      });
    },
    effectiveModelName() {
      // Prioriza la prop paramModelName sobre la ruta
      return this.paramModelName || this.$route.params.modelName;
    },
    itemsToExportCount() {
      // Si hay items seleccionados, mostrar el número de items seleccionados
      if (this.selectedItems && this.selectedItems.length > 0) {
        return this.selectedItems.length;
      }
      // Si no hay items seleccionados, mostrar el total de items filtrados
      return this.pagination.total || this.items.length || 0;
    },
    currentReportData() {
      // Retorna los datos actuales del listado para guardar como reporte
      // Obtener filtros del componente Filters si está disponible
      let filters = {};
      if (this.$refs.filtersComponent && this.$refs.filtersComponent.filters) {
        // Construir el objeto de filtros similar a como lo hace emitFilters
        const filtersToSave = {};
        const visibleFilterFields =
          this.$refs.filtersComponent.visibleFilterFields || [];

        Object.entries(this.$refs.filtersComponent.filters).forEach(
          ([key, value]) => {
            const operator =
              this.$refs.filtersComponent.filterOperators[key] || "=";

            // Incluir operadores especiales aunque no tengan valor
            if (operator === "is_null" || operator === "is_not_null") {
              filtersToSave[key] = operator;
            } else if (value !== null && value !== "") {
              // Buscar el campo en modelFields o en visibleFilterFields (para reference_subfield)
              let field = this.modelFields.find((f) => f.key === key);
              if (!field) {
                field = visibleFilterFields.find((f) => f.key === key);
              }

              // Para list y reference, manejar arrays de valores
              // Para reference_subfield, verificar el tipo del subcampo
              const isReferenceSubfieldNonNumeric =
                field &&
                field.type === "reference_subfield" &&
                field.subFieldType !== "number" &&
                field.subFieldType !== "date";

              if (
                field &&
                (field.type === "list" ||
                  field.type === "reference" ||
                  isReferenceSubfieldNonNumeric)
              ) {
                // Manejar arrays de valores
                if (Array.isArray(value)) {
                  // Extraer los IDs de cada elemento del array
                  const ids = value
                    .filter((item) => item !== null && item !== undefined)
                    .map((item) => {
                      if (typeof item === "object" && item._id) {
                        return item._id;
                      }
                      return item;
                    });

                  // Guardar como string separado por comas para compatibilidad
                  if (ids.length > 0) {
                    filtersToSave[key] = ids.join(",");
                  }
                } else {
                  // Si es un solo valor, extraer el ID
                  let filterValue = value;
                  if (typeof value === "object" && value._id) {
                    filterValue = value._id;
                  }
                  filtersToSave[key] = filterValue;
                }
              } else if (field && field.type === "boolean") {
                const boolValue = coerceBooleanFilterValue(value);
                if (typeof boolValue === "boolean") {
                  filtersToSave[key] = boolValue;
                }
              } else {
                let filterValue = value;
                if (typeof value === "object" && value._id) {
                  filterValue = value._id;
                }

                if (operator === "contains") {
                  filtersToSave[key] = `contains:${filterValue}`;
                } else if (operator === "startswith") {
                  filtersToSave[key] = `startswith:${filterValue}`;
                } else if (operator === "endswith") {
                  filtersToSave[key] = `endswith:${filterValue}`;
                } else if (operator === "regex") {
                  filtersToSave[key] = `regex:${filterValue}`;
                } else if (operator === "=") {
                  // Para el operador =, guardar solo el valor (sin el operador)
                  filtersToSave[key] = filterValue;
                } else if (
                  operator === "between" ||
                  String(filterValue).includes(LEGACY_DATE_RANGE_SEPARATOR)
                ) {
                  // El rango ya viaja como «inicio - fin»: prefijarlo con el
                  // operador rompía la fecha de inicio y se re-prefijaba en
                  // cada guardado (betweenbetween2026-09-01 - 2026-09-30).
                  filtersToSave[key] = stripLegacyBetweenPrefix(filterValue);
                } else {
                  // Para otros operadores (!=, >, <, >=, <=), concatenar operador + valor
                  filtersToSave[key] = `${operator}${filterValue}`;
                }
              }
            }
          }
        );

        // Agregar búsqueda de texto si existe
        if (this.$refs.filtersComponent.textSearchQuery) {
          filtersToSave.textPlainVersion =
            this.$refs.filtersComponent.textSearchQuery.trim();
        }

        filters = filtersToSave;
      }

      return {
        columns: this.selectedColumns,
        columnOrder: this.visibleTableFields.map((field) => field.key),
        columnWidths: this.columnWidths,
        filters: filters,
        selectedFilterFields: this.selectedFilterFields,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: {
          page: this.pagination.page,
          perPage: this.pagination.perPage,
        },
        columnLabels: JSON.parse(JSON.stringify(this.reportColumnLabels || {})),
        columnDescriptions: JSON.parse(
          JSON.stringify(this.reportColumnDescriptions || {})
        ),
        columnEmphasis: JSON.parse(
          JSON.stringify(this.reportColumnEmphasis || {})
        ),
        columnTotals: JSON.parse(JSON.stringify(this.reportColumnTotals || {})),
        columnLayout: JSON.parse(
          JSON.stringify(this.reportColumnLayout || { groups: [], merges: [] })
        ),
        pinnedColumnKeys: [...(this.pinnedColumnKeys || [])],
        groupByField: this.reportGroupByField || "",
      };
    },
    currentUserId() {
      // Obtener el ID del usuario actual desde localStorage
      return (
        localStorage.getItem("userId") || localStorage.getItem("_id") || null
      );
    },
    hasUnsavedPreferences() {
      // Personalización de cabeceras: va al reporte o, en el listado, a las
      // preferencias del usuario (ticket #434).
      const cur = JSON.stringify(this.reportColumnLabels || {});
      const sav = JSON.stringify(this.savedReportColumnLabels || {});
      if (cur !== sav) {
        return true;
      }
      const curDesc = JSON.stringify(this.reportColumnDescriptions || {});
      const savDesc = JSON.stringify(this.savedReportColumnDescriptions || {});
      if (curDesc !== savDesc) {
        return true;
      }
      const curEmphasis = JSON.stringify(this.reportColumnEmphasis || {});
      const savEmphasis = JSON.stringify(this.savedReportColumnEmphasis || {});
      if (curEmphasis !== savEmphasis) {
        return true;
      }
      const curTotals = JSON.stringify(this.reportColumnTotals || {});
      const savTotals = JSON.stringify(this.savedReportColumnTotals || {});
      if (curTotals !== savTotals) {
        return true;
      }

      if (this.currentLoadedReport) {
        const curLayout = JSON.stringify(this.reportColumnLayout || {});
        const savLayout = JSON.stringify(this.savedReportColumnLayout || {});
        if (curLayout !== savLayout) {
          return true;
        }
        const curPinned = JSON.stringify(this.pinnedColumnKeys || []);
        const savPinned = JSON.stringify(this.savedPinnedColumnKeys || []);
        if (curPinned !== savPinned) {
          return true;
        }
        if (
          (this.reportGroupByField || "") !==
          (this.savedReportGroupByField || "")
        ) {
          return true;
        }
        // Items por página: es parte del reporte (page no, es solo visual)
        if (
          (Number(this.pagination?.perPage) || 0) !==
          (Number(this.savedPerPage) || 0)
        ) {
          return true;
        }
        // Orden del listado: es parte del reporte, igual que perPage. Sin esto el
        // botón «Actualizar reporte» no aparecía al ordenar por una columna y el
        // orden nunca llegaba a guardarse (ticket #395).
        if (this.reportSortPersistEnabled) {
          if ((this.sortField || "") !== (this.savedSortField || "")) {
            return true;
          }
          if (
            (this.sortOrder || "asc") !== (this.savedSortOrder || "asc") &&
            this.sortField
          ) {
            return true;
          }
        }
      }

      // Comparar columnas seleccionadas
      const currentColumnsStr = JSON.stringify(this.selectedColumns);
      const savedColumnsStr = JSON.stringify(this.savedSelectedColumns);
      if (currentColumnsStr !== savedColumnsStr) {
        return true;
      }

      // Comparar orden de columnas
      const currentOrder = this.visibleTableFields.map((field) => field.key);
      const savedOrder = this.savedColumnOrder || [];
      if (JSON.stringify(currentOrder) !== JSON.stringify(savedOrder)) {
        return true;
      }

      // Comparar anchos de columnas
      const currentWidthsStr = JSON.stringify(this.columnWidths);
      const savedWidthsStr = JSON.stringify(this.savedColumnWidths);
      if (currentWidthsStr !== savedWidthsStr) {
        return true;
      }

      const curPinned = JSON.stringify(this.pinnedColumnKeys || []);
      const savPinned = JSON.stringify(this.savedPinnedColumnKeys || []);
      if (curPinned !== savPinned) {
        return true;
      }

      // Comparar campos de filtro seleccionados
      const currentFilterFieldsStr = JSON.stringify(this.selectedFilterFields);
      const savedFilterFieldsStr = JSON.stringify(
        this.savedSelectedFilterFields
      );
      if (currentFilterFieldsStr !== savedFilterFieldsStr) {
        return true;
      }

      // Comparar filtros aplicados
      let currentFilters = {};
      if (this.$refs.filtersComponent && this.$refs.filtersComponent.filters) {
        const filtersToSave = {};
        Object.entries(this.$refs.filtersComponent.filters).forEach(
          ([key, value]) => {
            const operator =
              this.$refs.filtersComponent.filterOperators[key] || "=";

            // Incluir operadores especiales aunque no tengan valor
            if (operator === "is_null" || operator === "is_not_null") {
              filtersToSave[key] = operator;
            } else if (value !== null && value !== "") {
              // Buscar el campo en modelFields o en visibleFilterFields (para reference_subfield)
              let field = this.modelFields.find((f) => f.key === key);
              if (
                !field &&
                this.$refs.filtersComponent &&
                this.$refs.filtersComponent.visibleFilterFields
              ) {
                field = this.$refs.filtersComponent.visibleFilterFields.find(
                  (f) => f.key === key
                );
              }

              let filterValue = value;
              if (typeof value === "object" && value._id) {
                filterValue = value._id;
              }

              // Para list y reference, guardar solo el ID
              // Para reference_subfield, verificar el tipo del subcampo
              const isReferenceSubfieldNonNumeric =
                field &&
                field.type === "reference_subfield" &&
                field.subFieldType !== "number" &&
                field.subFieldType !== "date";

              if (
                field &&
                (field.type === "list" ||
                  field.type === "reference" ||
                  isReferenceSubfieldNonNumeric)
              ) {
                filtersToSave[key] = filterValue;
              } else {
                if (operator === "contains") {
                  filtersToSave[key] = `contains:${filterValue}`;
                } else if (operator === "startswith") {
                  filtersToSave[key] = `startswith:${filterValue}`;
                } else if (operator === "endswith") {
                  filtersToSave[key] = `endswith:${filterValue}`;
                } else if (operator === "regex") {
                  filtersToSave[key] = `regex:${filterValue}`;
                } else if (operator === "=") {
                  // Para el operador =, guardar solo el valor (sin el operador)
                  filtersToSave[key] = filterValue;
                } else if (
                  operator === "between" ||
                  String(filterValue).includes(LEGACY_DATE_RANGE_SEPARATOR)
                ) {
                  // El rango ya viaja como «inicio - fin»: prefijarlo con el
                  // operador rompía la fecha de inicio y se re-prefijaba en
                  // cada guardado (betweenbetween2026-09-01 - 2026-09-30).
                  filtersToSave[key] = stripLegacyBetweenPrefix(filterValue);
                } else {
                  // Para otros operadores (!=, >, <, >=, <=), concatenar operador + valor
                  filtersToSave[key] = `${operator}${filterValue}`;
                }
              }
            }
          }
        );

        if (this.$refs.filtersComponent.textSearchQuery) {
          filtersToSave.textPlainVersion =
            this.$refs.filtersComponent.textSearchQuery.trim();
        }

        currentFilters = filtersToSave;
      }

      const currentFiltersStr = JSON.stringify(currentFilters);
      const savedFiltersStr = JSON.stringify(this.savedFilters || {});
      if (currentFiltersStr !== savedFiltersStr) {
        return true;
      }

      return false;
    },
    // Detectar si hay filtros aplicados (para mostrar botón de guardar reporte)
    hasAppliedFilters() {
      if (this.isMyItemsFilterActive) {
        return true;
      }
      // Verificar filtros en la URL (ignorando params del sistema/tutorial)
      if (
        Object.keys(this.getFilterQueryParams(this.$route.query || {})).length >
        0
      ) {
        return true;
      }

      // Verificar filtros en el componente Filters
      if (this.$refs.filtersComponent && this.$refs.filtersComponent.filters) {
        const hasFilter = Object.entries(
          this.$refs.filtersComponent.filters
        ).some(([key, value]) => {
          const operator =
            this.$refs.filtersComponent.filterOperators?.[key] || "=";
          // Operadores especiales cuentan como filtro
          if (operator === "is_null" || operator === "is_not_null") {
            return true;
          }
          // Valores no vacíos cuentan como filtro
          return value !== null && value !== "" && value !== undefined;
        });

        if (hasFilter) {
          return true;
        }

        // Verificar búsqueda de texto
        if (
          this.$refs.filtersComponent.textSearchQuery &&
          this.$refs.filtersComponent.textSearchQuery.trim()
        ) {
          return true;
        }
      }

      return false;
    },
  },
  async mounted() {
    if (typeof window !== "undefined" && window.matchMedia) {
      this._hoverlessMediaQuery = window.matchMedia("(hover: none)");
      this._hoverlessMediaQuery.addEventListener(
        "change",
        this.onHoverlessMediaChange
      );
      this.onHoverlessMediaChange();
    }
    if (typeof window !== "undefined") {
      window.addEventListener(
        "resize",
        this.scheduleClipViewMoreOverflowMeasure
      );
    }

    try {
      this.loading = true;
      this.view = null;

      // Obtener el modelName de la ruta para optimizar la carga
      const modelName = this.effectiveModelName;
      // Solo cargar modelos si no están ya cargados (evitar duplicados)
      if (!this.isModelsLoaded) {
        await this.fetchModels(modelName || null);
      }

      const rowHideStatus = await fetchPerViewRowHideStatus();
      this.rowHideModuleActive = rowHideStatus.active;
      this.rowHideReportIds = rowHideStatus.reportIds;

      // Procesar la ruta actual de forma controlada
      await this.initializeFromRoute();
      await this.resolveCurrentUserAdminStatus();

      this.checkSmartEmailEnabled();

      // NOTA: loadFilterPreferences() ya se llama en fetchFields() dentro de initializeFromRoute()
      // No es necesario llamarlo aquí de nuevo para evitar duplicados

      this.$nextTick(() => {
        this.setupListHorizontalScrollObservers();
      });

      this.loading = false;
    } catch (error) {
      console.error("Error in mounted:", error);
      this.loading = false;
    }
  },
  beforeDestroy() {
    if (this.pinnedPopupReportSaveTimer) {
      clearTimeout(this.pinnedPopupReportSaveTimer);
      this.pinnedPopupReportSaveTimer = null;
    }
    this.teardownClipViewMoreOverflowMeasure();
    this.closeAllColumnsWidthMenu();
    if (this._listLeadColMeasureTimer) {
      clearTimeout(this._listLeadColMeasureTimer);
      this._listLeadColMeasureTimer = null;
    }
    if (this._hoverlessMediaQuery) {
      this._hoverlessMediaQuery.removeEventListener(
        "change",
        this.onHoverlessMediaChange
      );
      this._hoverlessMediaQuery = null;
    }
    if (typeof window !== "undefined") {
      window.removeEventListener(
        "resize",
        this.scheduleClipViewMoreOverflowMeasure
      );
    }

    // Limpiar timeout de undo si existe
    if (this.undoTimeout) {
      clearTimeout(this.undoTimeout);
      this.undoTimeout = null;
    }
    this.teardownListHorizontalScrollObservers();
  },
};
</script>

<style scoped>
.gt-model-title-group {
  gap: 0.25rem;
}

/* El botón "My items" es `components/gotrading/common/MyItemsButton.vue`, que se
   comparte con el dashboard (ticket #424). */

/* Aviso de "solo mis registros": más chico que el título, mismo naranja. */
.gt-my-items-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background-color: #e8590c;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
}

/* Columnas/filtro/refrescar: siempre pegados a la derecha; "More actions" crece hacia la izquierda */
.gt-model-fixed-actions {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  vertical-align: middle;
}

/* «Más acciones / Ocultar acciones» va pegado a columnas/filtro: lo que despliega
   aparece a su izquierda, así el botón no se corre al abrir. */
@media (min-width: 768px) {
  .gt-model-actions-toolbar > .gt-more-actions-toggle {
    order: 1;
  }
  .gt-model-actions-toolbar > .gt-model-fixed-actions {
    order: 2;
  }
}

@media (max-width: 767.98px) {
  .gt-model-fixed-actions {
    display: flex;
    width: 100%;
    gap: 0.25rem;
  }

  .gt-model-fixed-actions > .btn {
    flex: 1 1 0;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

/* Barra de reportes accesibles (tabs) pegada al comienzo de la tabla */
.gt-report-tabs-bar {
  margin: 0;
  min-width: 0;
}

.gt-report-tabs-title {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6c757d;
  margin-bottom: 0.15rem;
}

.gt-report-tabs {
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  /* Espacio para la barra de scroll: no debe tapar los tabs */
  padding-bottom: 0.45rem;
}

.gt-report-tabs-inner {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 0.25rem;
  width: max-content;
  min-width: 100%;
  border-bottom: 1px solid #dee2e6;
}

.gt-report-tabs::-webkit-scrollbar {
  height: 6px;
}

.gt-report-tabs::-webkit-scrollbar-thumb {
  background: #c7ced8;
  border-radius: 3px;
}

.gt-report-tab {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  border: 1px solid transparent;
  border-bottom: none;
  border-radius: 0.35rem 0.35rem 0 0;
  background: #f1f4f8;
  color: #495057;
  font-size: 0.8rem;
  line-height: 1.2;
  margin-bottom: -1px;
  max-width: 18rem;
  overflow: hidden;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.gt-report-tab-btn {
  min-width: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  padding: 0.3rem 0.6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.gt-report-tab:hover {
  background: #e6ecf4;
  color: #0d6efd;
}

/* El tab activo toma el color de la cabecera de la tabla (var seteada en JS) */
.gt-report-tab--active {
  background: #fff;
  color: var(--gt-report-tab-active-color, #0d6efd);
  font-weight: 600;
  border-color: #dee2e6;
  border-bottom: 1px solid #fff;
}

.gt-report-tab--active:hover {
  color: var(--gt-report-tab-active-color, #0d6efd);
}

.gt-report-tab-private {
  font-size: 0.65rem;
  margin-left: 0.3rem;
  opacity: 0.55;
}

/* Lapiz para editar el reporte: visible al pasar por encima del tab */
.gt-report-tab-edit {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 0.65rem;
  line-height: 1;
  padding: 0.25rem 0.45rem 0.25rem 0.1rem;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.gt-report-tab:hover .gt-report-tab-edit,
.gt-report-tab--active .gt-report-tab-edit {
  opacity: 0.6;
}

.gt-report-tab-edit:hover {
  opacity: 1;
}

@media (max-width: 767.98px) {
  .gt-report-tab {
    max-width: 12rem;
  }
}

.gt-model-keyword-search {
  width: 100%;
  max-width: 14rem;
}

.gt-model-keyword-search .form-control {
  font-size: 0.875rem;
  min-height: 2rem;
}

.gt-model-keyword-search .input-group-text {
  font-size: 0.8125rem;
}

.group-fields {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.group-field {
  display: flex;
  flex-direction: column;
}

.group-field small {
  font-size: 0.8em;
  color: #6c757d;
}

.group-field span {
  font-size: 0.9em;
}

.table-image {
  max-width: 50px;
  max-height: 50px;
  object-fit: contain;
  border-radius: 4px;
}

.list-values {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.list-values .badge {
  font-size: 0.8em;
  padding: 4px 8px;
}

.clickable-row td:last-child {
  cursor: default;
}

.clickable-row td:last-child:hover {
  background-color: transparent !important;
}

.gt-list-category-flag {
  color: #adb5bd;
  line-height: 1.2;
  text-decoration: none !important;
  display: inline-flex;
  align-items: flex-start;
  align-self: center;
  gap: 0.3rem;
  min-width: 0;
  max-width: 100%;
  flex: 0 1 auto;
  text-align: left;
  white-space: normal;
}
.gt-list-category-flag:hover {
  color: #0d6efd;
  opacity: 0.92;
}

/* Primera columna del listado: checkbox + acciones (ver / editar / borrar).
   Las acciones quedan contraídas en tres puntos (azul / gris / rojo, los
   colores de los botones). Al pasar el mouse por los puntos los botones se
   abren encima de las columnas vecinas, como el menú lateral, sin cambiar el
   ancho de la tabla. El hover es de los puntos y no de la celda para que el
   checkbox siga a mano. */
.gt-list-actions-col {
  box-sizing: border-box;
  white-space: nowrap;
  vertical-align: middle;
}

/* Botón de formato de todas las columnas, al lado del checkbox de filas.
   Mismo gris que los botones de la barra de la cabecera. */
.gt-all-columns-width-btn {
  color: #6c757d !important;
  font-size: 0.75rem;
  line-height: 1;
  opacity: 0.75;
  text-decoration: none !important;
  vertical-align: middle;
}
.gt-all-columns-width-btn:hover,
.gt-all-columns-width-btn:focus-visible,
.gt-all-columns-width-btn--active {
  color: #343a40 !important;
  opacity: 1;
}
.gt-all-columns-width-btn__caret {
  font-size: 0.6rem;
  margin-left: 1px;
}

.gt-all-columns-width-menu {
  position: fixed;
  z-index: 1060;
  min-width: 220px;
  max-width: 260px;
  font-size: 0.85rem;
}

.gt-list-row-actions {
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  overflow: visible !important;
}
.gt-list-row-actions:hover,
.gt-list-row-actions:focus-within {
  z-index: 30;
}

.gt-list-lead-inner {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.gt-list-lead-inner > .form-check-input {
  margin: 0;
  flex-shrink: 0;
}

.gt-list-actions-hover {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 6px 2px;
  cursor: pointer;
}

.gt-list-actions-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  transition: opacity 0.12s ease;
}
.gt-list-actions-dot {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
}
.gt-list-actions-dot.is-primary {
  background: var(--bs-primary, #0d6efd);
}
.gt-list-actions-dot.is-secondary {
  background: var(--bs-secondary, #6c757d);
}
.gt-list-actions-dot.is-danger {
  background: var(--bs-danger, #dc3545);
}

/* Las acciones siguen en el DOM (con opacidad 0) para que el tabulador llegue
   a ellas: `:focus-within` abre la pastilla igual que el hover. */
.gt-list-actions-pop {
  position: absolute;
  top: 50%;
  left: -4px;
  z-index: 30;
  display: inline-flex;
  padding: 3px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%) scaleX(0.6);
  transform-origin: left center;
  transition: opacity 0.12s ease, transform 0.12s ease;
}
.gt-list-actions-hover:hover .gt-list-actions-pop,
.gt-list-actions-hover:focus-within .gt-list-actions-pop {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(-50%) scaleX(1);
}
.gt-list-actions-hover:hover .gt-list-actions-dots,
.gt-list-actions-hover:focus-within .gt-list-actions-dots {
  opacity: 0;
}

/* Teléfono y tablet: no hay hover, así que los botones van a la vista y la
   columna toma el ancho medido (`listLeadColWidthPx`). */
@media (hover: none) {
  .gt-list-actions-hover {
    padding: 0;
    cursor: default;
  }
  .gt-list-actions-dots {
    display: none;
  }
  .gt-list-actions-pop {
    position: static;
    padding: 0;
    background: transparent;
    box-shadow: none;
    opacity: 1;
    pointer-events: auto;
    transform: none;
    transition: none;
  }
}

.gt-list-actions-wrap {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-wrap: nowrap;
}

.gt-list-actions-group .btn {
  padding: 0.25rem 0.5rem;
  line-height: 1.2;
  background: #fff;
}
.gt-list-actions-group .btn:hover {
  background: var(--bs-btn-hover-bg);
}

.gt-list-actions-group .btn i {
  font-size: 0.85rem;
}

.modal {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal.show {
  display: block;
}

/* Estilos para vista móvil */
@media (max-width: 767.98px) {
  .mobile-fields {
    margin-top: 0.5rem;
  }

  .mobile-fields .field-value {
    padding: 0.25rem 0;
    cursor: pointer;
  }

  .mobile-fields .field-value:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .mobile-fields .list-values {
    margin-top: 0.25rem;
  }

  .mobile-fields .group-fields {
    margin-top: 0.25rem;
  }

  .mobile-fields .group-item {
    background-color: rgba(0, 0, 0, 0.02);
    padding: 0.5rem;
    border-radius: 0.25rem;
    margin-bottom: 0.5rem;
  }

  .mobile-fields .group-field {
    margin-bottom: 0.25rem;
  }

  .mobile-fields .table-image {
    max-width: 100%;
    max-height: 150px;
  }
}

/* Cabecera de columna: label + sort; acciones en barra flotante al hover */
.column-header-inner {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-width: 0;
}

.column-header-content {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

/* Icono de ordenar: se veía diminuto y, sobre las cabeceras de color
   (proform / shipping tienen el texto en blanco), casi no se notaba que la
   columna fuera ordenable. Hereda el color del th y juega con la opacidad,
   así queda legible tanto en la cabecera gris como en las de color. */
.sortable-header .column-header-sort-icon,
.column-header-sort-icon {
  flex-shrink: 0;
  margin-left: 0;
  margin-right: 4px;
  font-size: 1em;
  line-height: 1;
  padding: 2px 3px;
  border-radius: 3px;
  color: inherit;
  opacity: 0.6;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}

.sortable-header:hover .column-header-sort-icon {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.08);
}

.column-header-sort-icon:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.18);
}

/* Columna ya ordenada: el icono muestra el estado actual, a full contraste. */
.sorted-asc .column-header-sort-icon,
.sorted-desc .column-header-sort-icon {
  opacity: 1;
}

.column-header-merge-icon {
  flex-shrink: 0;
  font-size: 0.75rem;
  opacity: 0.85;
}

.column-header-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Columna en renglones (o título abierto con su «+»): el título se parte
   según el ancho y la cabecera crece hacia abajo, igual que las celdas. */
.column-header-label.is-wrapped {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  overflow-wrap: anywhere;
}

.column-header-clip-btn {
  margin-left: 0.3rem;
}

.column-header-hover-toolbar {
  position: absolute;
  left: 50%;
  top: calc(100% - 2px);
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px 6px;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 120;
  white-space: nowrap;
  transition: opacity 0.15s ease, visibility 0.15s ease;
}

.sortable-header:hover .column-header-hover-toolbar,
.column-header-hover-toolbar:focus-within {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.column-header-toolbar-btn,
.column-header-hover-toolbar .hide-column-btn {
  padding: 0 2px;
  font-size: 1em;
  line-height: 1;
}

.column-header-toolbar-filter-btn {
  color: #0d6efd !important;
  text-decoration: none !important;
  opacity: 0.75;
}
.column-header-toolbar-filter-btn:hover,
.column-header-toolbar-filter-btn:focus {
  color: #0d6efd !important;
  opacity: 1;
  text-decoration: none !important;
}
.column-header-toolbar-filter-btn--active {
  opacity: 1 !important;
  color: #ffc107 !important;
}

.column-header-toolbar-pin-btn {
  color: #6c757d !important;
  text-decoration: none !important;
  opacity: 0.75;
}
/* El azul es solo para «encendido»: al pasar el mouse el botón se oscurece, y
   el foco del clic no lo pinta (si no, apagarlo lo dejaba azul como si siguiera
   activo). Con teclado, :focus-visible sí lo marca. */
.column-header-toolbar-pin-btn:hover,
.column-header-toolbar-pin-btn:focus-visible {
  color: #343a40 !important;
  opacity: 1;
  text-decoration: none !important;
}
.column-header-toolbar-pin-btn--active,
.column-header-toolbar-pin-btn--active:hover {
  color: #0d6efd !important;
  opacity: 1 !important;
  background-color: rgba(13, 110, 253, 0.12);
  border-radius: 3px;
}

/* Columna que ya tiene ayuda escrita: el botón queda marcado para no tener que
   abrir el modal solo para saber si hay texto. */
.column-header-toolbar-btn--active {
  color: #0d6efd !important;
  opacity: 1 !important;
}

.column-header-toolbar-clip-btn {
  color: #6c757d !important;
  text-decoration: none !important;
  opacity: 0.75;
}
.column-header-toolbar-clip-btn:hover,
.column-header-toolbar-clip-btn:focus-visible {
  color: #343a40 !important;
  opacity: 1;
  text-decoration: none !important;
}
.column-header-toolbar-clip-btn--active,
.column-header-toolbar-clip-btn--active:hover {
  color: #0d6efd !important;
  opacity: 1 !important;
  background-color: rgba(13, 110, 253, 0.12);
  border-radius: 3px;
}

.list-td-clip-view-more__row {
  display: block;
  min-width: 0;
  max-width: 100%;
}
.list-td-clip-view-more__row.is-clipped {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.3rem;
  max-width: 100%;
}
.list-td-clip-view-more__row.is-clipped .list-td-clip-view-more__body {
  flex: 1 1 0;
  min-width: 0;
  max-height: 1.5rem;
  overflow: hidden;
}
/* Sin max-width:100% en hijos: así scrollWidth/scrollHeight detectan si hay más contenido */
.list-td-clip-view-more__row.is-clipped .list-td-clip-view-more__body > * {
  white-space: nowrap;
}
.list-td-clip-view-more__btn {
  flex: 0 0 auto;
  align-self: center;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  padding: 0.15rem 0.4rem;
  min-width: 1.35rem;
}

/* Celda abierta en el lugar: mismo layout que la recortada (contenido + botón
   a la derecha), pero sin recorte y con el texto envuelto. El botón se alinea
   arriba para que quede a la altura de la primera línea. */
.list-td-clip-view-more__row.is-expanded {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 0.3rem;
  max-width: 100%;
}
.list-td-clip-view-more__row.is-expanded .list-td-clip-view-more__btn {
  align-self: flex-start;
}
/* El `:deep` es para los campos editables en listado (ListEditField), que
   recortan con su propio `nowrap` + ellipsis desde otro scope. */
.list-td-clip-view-more__row.is-expanded .list-td-clip-view-more__body,
.list-td-clip-view-more__row.is-expanded
  .list-td-clip-view-more__body
  :deep(*) {
  max-height: none !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: clip !important;
  word-break: break-word;
}
.list-td-clip-view-more__row.is-expanded .list-td-clip-view-more__body {
  flex: 1 1 0;
  min-width: 0;
}

/* Ajustar texto (módulo column_text_wrap): el contenido se parte en renglones
   según el ancho de la columna y la fila crece hacia abajo, como el «Ajustar
   texto» de Excel. Sin botón: la celda está siempre así. El `:deep` es por los
   campos editables en listado, que recortan desde su propio scope. */
.list-td-clip-view-more__row.is-wrapped,
.list-td-clip-view-more__row.is-wrapped .list-td-clip-view-more__body,
.list-td-clip-view-more__row.is-wrapped
  .list-td-clip-view-more__body
  :deep(*) {
  max-height: none !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: clip !important;
  word-break: break-word;
}

.dynamic-model-clip-view-more-modal {
  background: rgba(0, 0, 0, 0.45);
}
.dynamic-model-clip-view-more-body {
  white-space: normal;
  overflow: visible;
  word-break: break-word;
}
.dynamic-model-clip-view-more-body .list-td-clip-view-more__row.is-clipped,
.dynamic-model-clip-view-more-body .list-td-clip-view-more__body {
  max-height: none !important;
  overflow: visible !important;
  white-space: normal !important;
}

.list-col-pinned {
  position: sticky;
  background-clip: padding-box;
}

/* Fondo opaco del sticky: categoría / hover / hidden via --list-row-bg en el <tr> */
.table tbody tr {
  --list-row-bg: #fff;
}
.table-hover > tbody > tr:hover {
  --list-row-bg: #ececec;
}
html.dark-mode .table tbody tr {
  --list-row-bg: var(--dark-bg-primary, #0f1419);
}
html.dark-mode .table-hover > tbody > tr:hover {
  --list-row-bg: var(--dark-bg-hover, #2d343f);
}
.table tbody tr.per-view-row-hidden,
.table-hover > tbody > tr.per-view-row-hidden:hover {
  --list-row-bg: #9b1b30;
}

/* .sortable-header usa position:relative y anulaba el sticky del header */
.table th.sortable-header.list-col-pinned {
  position: sticky !important;
}

/* demo.css deja --bs-table-bg transparente en tbody; sticky necesita fondo opaco */
.table tbody .list-col-pinned:not(.report-column-cell-in-group) {
  background-color: var(--list-row-bg, #fff) !important;
  --bs-table-bg: var(--list-row-bg, #fff) !important;
  --bs-table-accent-bg: var(--list-row-bg, #fff) !important;
}

.table tbody td.report-column-cell-in-group.list-col-pinned {
  background-color: color-mix(
    in srgb,
    var(--report-group-color) 22%,
    var(--list-row-bg, white)
  ) !important;
  --bs-table-bg: color-mix(
    in srgb,
    var(--report-group-color) 22%,
    var(--list-row-bg, white)
  ) !important;
  --bs-table-accent-bg: color-mix(
    in srgb,
    var(--report-group-color) 22%,
    var(--list-row-bg, white)
  ) !important;
}

.totals-row .list-col-pinned {
  background-color: #f8f9fa !important;
  --bs-table-bg: #f8f9fa !important;
  --bs-table-accent-bg: #f8f9fa !important;
}

.list-col-pinned-boundary {
  box-shadow: 3px 0 6px -2px rgba(0, 0, 0, 0.12);
}

/* El icono de ayuda vive al lado del título de la columna: el componente nace con
   opacity 0 para revelarse al pasar el mouse, pero acá tiene que verse siempre, porque
   es la señal de que la columna está documentada. */
.column-header-content ::v-deep .column-field-help-btn {
  opacity: 1;
}

.sortable-header {
  cursor: pointer;
  user-select: none;
  overflow: visible;
  padding-right: 14px !important;
}

.sortable-header:not(.list-col-pinned) {
  position: relative;
}

.sortable-header:hover {
  background-color: rgba(0, 0, 0, 0.05);
  z-index: 15;
}

.sorted-asc,
.sorted-desc {
  background-color: rgba(0, 0, 0, 0.05);
}

.sortable-header i {
  margin-left: 5px;
  font-size: 0.8em;
}

.sortable-header.not-sortable {
  cursor: default;
}
.sortable-header.not-sortable:hover {
  background-color: transparent;
}

.report-column-group-row th {
  padding: 6px 8px;
  font-size: 0.8rem;
  font-weight: 600;
  vertical-align: middle;
}
.report-column-group-title {
  display: block;
  line-height: 1.2;
}
.report-merged-stack-line + .report-merged-stack-line {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed #dee2e6;
}
.report-merged-cell {
  vertical-align: top;
}

/* Encabezado de grupo del listado (estilo planilla) */
.list-group-header-row td {
  background-color: #eef2f7;
  border-top: 2px solid #c7d2e0;
  border-bottom: 1px solid #c7d2e0;
  padding: 0.4rem 0.75rem;
}

/* La etiqueta acompaña el scroll horizontal: en tablas anchas el grupo
   sigue visible aunque el usuario se corra a la derecha. */
.list-group-header-row__inner {
  position: sticky;
  left: 0.75rem;
  display: inline-flex;
  align-items: baseline;
  gap: 0.5rem;
}

.list-group-header-row__label {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #23303f;
}

.list-group-header-row__count {
  font-weight: 400;
  color: #6c7a89;
}

.totals-row {
  font-weight: bold;
  background-color: #f8f9fa;
}

.totals-row td {
  border-top: 2px solid #dee2e6;
}

/* Estilos para drag and drop */
.sortable-header[draggable="true"] {
  cursor: grab;
}

.sortable-header[draggable="true"]:active {
  cursor: grabbing;
}

.sortable-header.dragging {
  opacity: 0.5;
}

/* Estilos para redimensionar columnas */
.resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 14px;
  min-width: 14px;
  background-color: rgba(255, 255, 255, 0.15);
  cursor: col-resize;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  border-right: 2px solid rgba(255, 255, 255, 0.5);
  z-index: 20;
  box-sizing: border-box;
  pointer-events: auto;
  touch-action: none;
}
.report-column-group-row + tr.headerlist .resize-handle {
  z-index: 25;
}

.hide-column-btn:hover {
  background-color: #dc3545 !important;
  color: white !important;
}

.sortable-header:hover .resize-handle,
.resize-handle:hover {
  background-color: rgba(0, 123, 255, 0.45);
  border-right-color: #007bff;
}

/* Mejorar la experiencia de redimensionado */
.table th,
.table td {
  min-width: 50px;
  max-width: 500px;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Foco desde URL (?focusON=id&message=...) - clase añadida por applyFocusFromQuery */

/* Barra de scroll horizontal duplicada (arriba del listado), todos los anchos */
.gt-list-hscroll-wrap {
  min-width: 0;
}

.gt-list-top-hscroll {
  overflow-x: scroll;
  overflow-y: hidden;
  min-height: 14px;
  margin-bottom: 4px;
  scrollbar-gutter: stable;
}

.gt-list-top-hscroll--no-overflow {
  overflow-x: hidden;
  pointer-events: none;
}

.gt-list-top-hscroll--no-overflow .gt-list-top-hscroll-spacer {
  width: 100% !important;
}

.gt-list-top-hscroll-spacer {
  height: 8px;
}

/* Barra horizontal visible al hover (no solo mientras se arrastra el scroll; overlay macOS) */
.gt-list-top-hscroll,
.gt-list-bottom-hscroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) rgba(0, 0, 0, 0.06);
}

.gt-list-hscroll-wrap:not(:hover) .gt-list-top-hscroll,
.gt-list-hscroll-wrap:not(:hover) .gt-list-bottom-hscroll {
  scrollbar-color: transparent transparent;
}

.gt-list-hscroll-wrap:hover .gt-list-top-hscroll,
.gt-list-hscroll-wrap:hover .gt-list-bottom-hscroll {
  scrollbar-color: rgba(55, 55, 65, 0.55) rgba(0, 0, 0, 0.08);
}

.gt-list-top-hscroll::-webkit-scrollbar,
.gt-list-bottom-hscroll::-webkit-scrollbar {
  height: 11px;
}

.gt-list-top-hscroll::-webkit-scrollbar-track,
.gt-list-bottom-hscroll::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 6px;
}

.gt-list-top-hscroll::-webkit-scrollbar-thumb,
.gt-list-bottom-hscroll::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 6px;
  transition: background 0.15s ease;
}

.gt-list-hscroll-wrap:hover .gt-list-top-hscroll::-webkit-scrollbar-track,
.gt-list-hscroll-wrap:hover .gt-list-bottom-hscroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.06);
}

.gt-list-hscroll-wrap:hover .gt-list-top-hscroll::-webkit-scrollbar-thumb,
.gt-list-hscroll-wrap:hover .gt-list-bottom-hscroll::-webkit-scrollbar-thumb {
  background: rgba(55, 55, 65, 0.45);
}

.gt-list-hscroll-wrap:hover .gt-list-top-hscroll::-webkit-scrollbar-thumb:hover,
.gt-list-hscroll-wrap:hover .gt-list-bottom-hscroll::-webkit-scrollbar-thumb:hover {
  background: rgba(35, 35, 45, 0.65);
}

/* Estilos simples para mantener altura consistente y overflow con ellipsis - SOLO DESKTOP */
@media (min-width: 768px) {
  /* No aplicar altura fija / overflow a la columna Acciones (btn-group) */
  .table td:not(.gt-list-row-actions) {
    height: 30px;
    max-height: 30px;
    vertical-align: middle;
    padding: 8px;
  }

  .table td:not(.gt-list-row-actions) {
    max-width: none;
  }
  .table td:not(.gt-list-row-actions) > div {
    width: 100%;
    min-width: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    word-break: break-all;
  }

  /* Clip + botón: no heredar display:block del td > div (si no, el + cae abajo) */
  .table td:not(.gt-list-row-actions) > div.list-td-clip-view-more__row.is-clipped {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.3rem;
    overflow: hidden;
    white-space: nowrap;
    word-break: normal;
  }
  .table
    td:not(.gt-list-row-actions)
    > div.list-td-clip-view-more__row.is-clipped
    .list-td-clip-view-more__body {
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
    width: auto;
    max-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    word-break: normal;
  }
  .table
    td:not(.gt-list-row-actions)
    > div.list-td-clip-view-more__row.is-clipped
    .list-td-clip-view-more__btn {
    flex: 0 0 auto;
    display: inline-block;
    white-space: nowrap;
  }

  /* Celda abierta: en desktop la fila está capada a 30px y el div del td lleva
     nowrap. Los dos hay que soltarlos acá, o el texto no crece. */
  .table td:not(.gt-list-row-actions).list-td-clip-expanded {
    height: auto;
    max-height: none;
    vertical-align: top;
  }
  .table
    td:not(.gt-list-row-actions).list-td-clip-expanded
    > div.list-td-clip-view-more__row.is-expanded {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 0.3rem;
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
  }
  .table
    td:not(.gt-list-row-actions).list-td-clip-expanded
    > div.list-td-clip-view-more__row.is-expanded
    .list-td-clip-view-more__body {
    flex: 1 1 0;
    min-width: 0;
    max-width: none;
    width: auto;
    max-height: none;
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    display: block;
    word-break: break-word;
  }
  .table
    td:not(.gt-list-row-actions).list-td-clip-expanded
    > div.list-td-clip-view-more__row.is-expanded
    .list-td-clip-view-more__btn {
    flex: 0 0 auto;
    display: inline-block;
    white-space: nowrap;
  }

  /* Columna con «Ajustar texto»: hay que soltar el cap de 30px del td y el
     nowrap de su div, igual que con la celda abierta, o el texto no crece.
     La diferencia es que acá es el estado permanente de la columna. */
  .table td:not(.gt-list-row-actions).list-td-wrapped {
    height: auto;
    max-height: none;
    vertical-align: top;
  }
  .table
    td:not(.gt-list-row-actions).list-td-wrapped
    > div.list-td-clip-view-more__row.is-wrapped,
  .table
    td:not(.gt-list-row-actions).list-td-wrapped
    > div.list-td-clip-view-more__row.is-wrapped
    .list-td-clip-view-more__body {
    display: block;
    width: 100%;
    min-width: 0;
    max-width: none;
    max-height: none;
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
  }

  .table td.gt-list-row-actions {
    vertical-align: middle;
    padding: 6px 4px;
    height: auto;
    max-height: none;
  }
  .table td.gt-list-row-actions > div {
    overflow: visible;
    white-space: normal;
    max-height: none;
    height: auto;
  }

  /* Para imágenes mantener tamaño fijo */
  .table td .table-image {
    max-width: 50px;
    max-height: 30px;
    object-fit: contain;
  }

  .table th {
    vertical-align: middle;
    padding: 8px;
    background: #d4d4d4;
  }

  .table th:not(.gt-list-actions-col) {
    height: 35px;
    max-height: 30px;
  }

  .table-responsive {
    overflow: scroll !important;
  }

  .table-responsive.gt-list-bottom-hscroll {
    padding-top: 2px;
  }

  .table thead {
    position: relative;
    z-index: 4;
  }

  .table th > div {
    width: 100%;
    max-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    font-weight: bold;
    word-break: break-all;
  }

  /* Cabecera dinámica: flex + handle de resize fuera del overflow hidden */
  .table th.sortable-header:not(.list-col-pinned) {
    position: relative;
    overflow: visible;
    padding-right: 14px !important;
  }

  .table th.sortable-header.list-col-pinned {
    position: sticky !important;
    overflow: visible;
    padding-right: 14px !important;
  }

  .table th.sortable-header > .column-header-hover-toolbar {
    width: auto;
    max-height: none;
    overflow: visible;
    white-space: nowrap;
    display: inline-flex;
    word-break: normal;
  }

  .table th.sortable-header > .column-header-inner {
    display: flex !important;
    align-items: center;
    width: 100% !important;
    max-height: none !important;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: clip;
    font-weight: bold;
  }

  .table th.sortable-header > .resize-handle {
    position: absolute !important;
    top: 0;
    right: 0;
    bottom: 0;
    width: 14px !important;
    min-width: 14px;
    max-height: none !important;
    overflow: visible !important;
    white-space: normal !important;
    display: block !important;
    z-index: 10;
  }
}

/* Vista Papelera: resaltar para que se distinga */
.trash-view-page .trash-view-container {
  background: linear-gradient(
    135deg,
    rgba(255, 193, 7, 0.12) 0%,
    rgba(255, 152, 0, 0.08) 100%
  );
  border: 2px solid rgba(255, 193, 7, 0.5);
  border-radius: 8px;
  padding: 12px;
  margin: 0 -12px;
}
.trash-view-page .trash-view-container .table {
  background: rgba(255, 255, 255, 0.85);
}

/* Vista Archivados */
.archive-view-page .archive-view-container {
  background: linear-gradient(
    135deg,
    rgba(108, 117, 125, 0.12) 0%,
    rgba(73, 80, 87, 0.08) 100%
  );
  border: 2px solid rgba(108, 117, 125, 0.45);
  border-radius: 8px;
  padding: 12px;
  margin: 0 -12px;
}
.archive-view-page .archive-view-container .table {
  background: rgba(255, 255, 255, 0.85);
}

/* Cabecera fija al desplazar en listados dinámicos */
.gt-list-sticky-header-active.gt-list-bottom-hscroll {
  max-height: calc(100vh - 240px);
  min-height: 200px;
  overflow-y: auto !important;
}

.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-gutter
  .table
  thead
  tr.headerlist
  th {
  top: 0 !important;
  z-index: 45;
  overflow: visible !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-gutter
  .table
  thead
  tr.headerlist
  th::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 240px;
  background-color: inherit;
  background: inherit;
  z-index: -1;
  pointer-events: none;
}

/* Al scrollear con fila de grupos: tapar filas sin cambiar top acumulado. */
.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.report-column-group-row
  th,
.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.headerlist
  th {
  overflow: visible !important;
}

.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.report-column-group-row
  th::before,
.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.headerlist
  th::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 240px;
  background-color: inherit;
  background: inherit;
  z-index: -1;
  pointer-events: none;
}

.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.report-column-group-row
  th:not(.report-column-group-header--filled) {
  background-color: #fff !important;
  --bs-table-bg: #fff !important;
}

.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.report-column-group-row:has(+ tr.headerlist.shipping)
  th:not(.report-column-group-header--filled) {
  background-color: #3bb748 !important;
  --bs-table-bg: #3bb748 !important;
}

.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.report-column-group-row:has(+ tr.headerlist.proform)
  th:not(.report-column-group-header--filled) {
  background-color: #ff7c7c !important;
  --bs-table-bg: #ff7c7c !important;
}

.gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.headerlist
  th {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

html.dark-mode
  .gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.report-column-group-row
  th:not(.report-column-group-header--filled) {
  background-color: var(--dark-bg-secondary, #1a2332) !important;
  --bs-table-bg: var(--dark-bg-secondary, #1a2332) !important;
}

html.dark-mode
  .gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.report-column-group-row:has(+ tr.headerlist.shipping)
  th:not(.report-column-group-header--filled) {
  background-color: #3bb748 !important;
  --bs-table-bg: #3bb748 !important;
}

html.dark-mode
  .gt-list-sticky-header-active.gt-list-sticky-header-scrolled-groups
  .table
  thead
  tr.report-column-group-row:has(+ tr.headerlist.proform)
  th:not(.report-column-group-header--filled) {
  background-color: #ff7c7c !important;
  --bs-table-bg: #ff7c7c !important;
}

.gt-list-sticky-header-active .table thead tr.report-column-group-row th {
  position: sticky;
  top: 0;
  z-index: 41;
}

.gt-list-sticky-header-active .table thead tr.headerlist th {
  background-clip: padding-box;
}

.gt-list-sticky-header-active
  .table
  th.sortable-header:not(.list-col-pinned) {
  position: sticky !important;
}

.gt-list-sticky-header-active .table th.sortable-header.list-col-pinned {
  position: sticky !important;
}

.gt-list-sticky-header-active
  .table
  thead
  tr.headerlist
  th.sortable-header.list-col-pinned {
  background-clip: border-box;
}

.gt-list-sticky-header-active
  .table
  thead
  tr.headerlist
  th.sortable-header:hover,
.gt-list-sticky-header-active
  .table
  thead
  tr.headerlist
  th.sortable-header:focus-within {
  z-index: 80 !important;
}

.gt-list-sticky-header-active
  .table
  thead
  tr.headerlist
  th.sortable-header.list-col-pinned:hover,
.gt-list-sticky-header-active
  .table
  thead
  tr.headerlist
  th.sortable-header.list-col-pinned:focus-within {
  z-index: 130 !important;
}

html.dark-mode
  .gt-list-sticky-header-active
  .table
  thead
  tr.headerlist
  th:not(.report-column-in-group) {
  background-color: var(--dark-bg-secondary, #1a2332) !important;
  --bs-table-bg: var(--dark-bg-secondary, #1a2332) !important;
}

html.dark-mode
  .gt-list-sticky-header-active
  .table
  thead
  tr.headerlist.shipping
  th:not(.report-column-in-group) {
  background-color: #3bb748 !important;
  --bs-table-bg: #3bb748 !important;
}

html.dark-mode
  .gt-list-sticky-header-active
  .table
  thead
  tr.headerlist.proform
  th:not(.report-column-in-group) {
  background-color: #ff7c7c !important;
  --bs-table-bg: #ff7c7c !important;
}

html.dark-mode
  .gt-list-sticky-header-active.gt-list-sticky-header-scrolled-gutter
  .table
  thead
  tr.headerlist.proform
  th:not(.report-column-in-group) {
  background-color: #ff7c7c !important;
  --bs-table-bg: #ff7c7c !important;
}

html.dark-mode
  .gt-list-sticky-header-active.gt-list-sticky-header-scrolled-gutter
  .table
  thead
  tr.headerlist.shipping
  th:not(.report-column-in-group) {
  background-color: #3bb748 !important;
  --bs-table-bg: #3bb748 !important;
}

/* Color de grupo: demo.css y dark mode usan !important en thead th */
.table thead tr.report-column-group-row th.report-column-group-header--filled,
.table thead tr.headerlist th.sortable-header.report-column-in-group {
  background-color: var(--report-group-color) !important;
  --bs-table-bg: var(--report-group-color) !important;
  border-color: var(--report-group-color) !important;
  color: #212529 !important;
}
html.dark-mode .table thead tr.report-column-group-row th.report-column-group-header--filled,
html.dark-mode .table thead tr.headerlist th.sortable-header.report-column-in-group {
  background-color: var(--report-group-color) !important;
  --bs-table-bg: var(--report-group-color) !important;
  border-color: var(--report-group-color) !important;
  color: #212529 !important;
}
.table tbody td.report-column-cell-in-group {
  background-color: color-mix(
    in srgb,
    var(--report-group-color) 22%,
    transparent
  ) !important;
  --bs-table-bg: color-mix(
    in srgb,
    var(--report-group-color) 22%,
    white
  ) !important;
}

.table tbody td.report-column-emphasis,
.table tbody .report-column-emphasis {
  font-weight: 700 !important;
  color: #c62828 !important;
}
/* viewField usa font-weight: 500; hay que forzar en descendientes */
.table tbody td.report-column-emphasis ::v-deep *,
.table tbody .report-column-emphasis ::v-deep * {
  font-weight: 700 !important;
  color: #c62828 !important;
}
.table tbody td.report-column-emphasis ::v-deep a,
.table tbody .report-column-emphasis ::v-deep a {
  color: #b71c1c !important;
}

.table tbody tr.per-view-row-hidden > td,
.table tbody tr.per-view-row-hidden > td.report-column-cell-in-group,
.table tbody tr.per-view-row-hidden > td.list-col-pinned,
.table tbody tr.per-view-row-hidden > td.report-column-cell-in-group.list-col-pinned {
  background-color: #9b1b30 !important;
  --bs-table-bg: #9b1b30 !important;
  color: #fff !important;
  border-color: #7a1526 !important;
}
tr.per-view-row-hidden .text-muted,
tr.per-view-row-hidden .text-success,
tr.per-view-row-hidden .text-danger,
tr.per-view-row-hidden .text-primary,
tr.per-view-row-hidden .text-info {
  color: #fff !important;
}

/* ---------------------------------------------------------------------------
   Teléfono (< 768px): barra compacta y cada fila como tarjeta.
   Solo CSS bajo este media query (más data-label en las celdas): el escritorio no cambia.
   Las filas siguen siendo las mismas <tr>: el toque abre el registro y el checkbox y
   el menú de acciones funcionan igual. Colores: variables del sistema.
   --------------------------------------------------------------------------- */
@media (max-width: 767.98px) {
  /* Barra: título arriba, buscador ancho y los botones como íconos. */
  .gt-model-title-group {
    gap: 0.4rem;
  }
  .gt-model-title-group > h4 {
    width: 100%;
    margin-bottom: 0.15rem;
  }
  .gt-model-keyword-search {
    flex: 1 1 8rem;
    width: auto !important;
    max-width: none;
  }
  .gt-model-more-filters-btn,
  .gt-model-title-group > .newbutton,
  .gt-model-title-group > .gt-my-items-btn {
    flex: 0 0 auto;
    width: auto !important;
    font-size: 0;
    min-width: 2.5rem;
    min-height: 2.25rem;
    padding: 0.35rem 0.7rem;
    margin: 0 !important;
  }
  .gt-model-more-filters-btn i,
  .gt-model-title-group > .newbutton i,
  .gt-model-title-group > .gt-my-items-btn i {
    font-size: 0.95rem;
    margin: 0 !important;
  }
  .gt-model-more-filters-btn i + i {
    display: none;
  }

  /* Acciones: en una fila (shared-styles.css las apila a todo el ancho en mobile).
     Primero columnas/filtro/recargar, a la derecha «Más acciones»; lo que despliega va
     en botones compactos y «Delete all» al final, separado. */
  .gt-model-actions-toolbar {
    width: 100%;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 0.4rem;
    margin-top: 0.4rem;
  }
  .gt-model-actions-toolbar > .btn,
  .gt-model-actions-toolbar > button.btn {
    flex: 0 0 auto;
    width: auto !important;
    margin: 0 !important;
    min-height: 2.25rem;
  }
  .gt-model-actions-toolbar > .gt-model-fixed-actions {
    order: -1;
    width: auto !important;
    gap: 0.4rem;
  }
  .gt-model-actions-toolbar > .gt-model-fixed-actions > .btn {
    flex: 0 0 auto !important;
    min-width: 2.5rem;
    min-height: 2.25rem;
  }
  .gt-model-actions-toolbar > .gt-more-actions-toggle {
    margin-left: auto !important;
  }
  .gt-model-actions-toolbar > .btn-outline-danger {
    order: 99;
    margin-top: 0.4rem !important;
  }

  /* Menú «⋯» de la fila: la celda queda arriba a la derecha de la tarjeta, así que abre
     hacia la izquierda (en desktop abre hacia la derecha desde el borde izquierdo). */
  .gt-list-table .gt-list-actions-pop {
    left: auto;
    right: -4px;
    transform-origin: right center;
  }

  /* La barra de scroll horizontal de arriba no tiene sentido sin tabla ancha. */
  .gt-list-top-hscroll {
    display: none !important;
  }

  /* Tabla → tarjetas. */
  .gt-list-table {
    width: 100% !important;
    min-width: 0 !important;
    border: 0 !important;
    background: transparent !important;
  }
  .gt-list-table,
  .gt-list-table > tbody {
    display: block;
  }
  .gt-list-table > colgroup,
  .gt-list-table > thead {
    display: none;
  }
  .gt-list-table > tbody > tr {
    display: block;
    position: relative;
    margin-bottom: 0.6rem;
    padding: 0.6rem 2.75rem 0.6rem 0.8rem;
    background: var(--bs-body-bg);
    border: 1px solid var(--bs-border-color);
    border-radius: var(--bs-border-radius-lg);
    box-shadow: var(--bs-box-shadow-sm);
  }
  .gt-list-table > tbody > tr > td {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem;
    width: auto !important;
    max-width: none !important;
    min-width: 0 !important;
    padding: 0.15rem 0 !important;
    border: 0 !important;
    background: transparent !important;
    position: static !important;
    left: auto !important;
    text-align: right;
    word-break: break-word;
  }
  .gt-list-table > tbody > tr > td[data-label]::before {
    content: attr(data-label);
    flex-shrink: 0;
    max-width: 45%;
    text-align: left;
    font-size: 0.8rem;
    color: var(--bs-secondary-color);
  }
  /* Primer dato de la fila: título de la tarjeta. */
  .gt-list-table > tbody > tr > td.gt-list-row-actions + td[data-label] {
    display: block;
    text-align: left;
    font-weight: 600;
    font-size: 1rem;
    padding-bottom: 0.3rem !important;
  }
  .gt-list-table > tbody > tr > td.gt-list-row-actions + td[data-label]::before {
    display: none;
  }
  /* Hasta 6 datos por tarjeta; el resto se ve tocando la tarjeta. */
  .gt-list-table > tbody > tr > td[data-label]:nth-of-type(n + 8) {
    display: none;
  }
  /* Checkbox y menú de acciones arriba a la derecha. */
  .gt-list-table > tbody > tr > td.gt-list-row-actions {
    position: absolute !important;
    top: 0.55rem;
    right: 0.6rem;
    left: auto !important;
    display: block;
    padding: 0 !important;
  }
  /* Filas sin datos, encabezados de grupo y totales: a todo el ancho. */
  .gt-list-table > tbody > tr > td[colspan] {
    display: block;
    text-align: left;
  }
  .gt-list-table > tbody > tr.list-group-header-row {
    padding: 0.4rem 0.8rem;
    background: var(--bs-tertiary-bg);
    box-shadow: none;
  }
  .gt-list-table > tbody > tr.totals-row {
    padding-right: 0.8rem;
    background: var(--bs-tertiary-bg);
  }
  .gt-list-table > tbody > tr.totals-row > td[data-label]:nth-of-type(n + 8) {
    display: flex;
  }
}

/* ---------------------------------------------------------------------------
   Versión de teléfono del listado (useMobileList, piezas en components/mobile).
   Estas clases solo existen en esa versión: el escritorio no las renderiza.
   --------------------------------------------------------------------------- */
.m-list-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.35rem;
  padding: 0 0.75rem;
  height: 2.6rem;
  border: 1px solid var(--m-border);
  border-radius: 999px;
  background: var(--m-surface-2);
  color: var(--m-muted);
}
.m-list-search input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--m-text);
  font-size: 1rem; /* 16px: iOS no hace zoom al enfocar */
}
.m-list-search input::-webkit-search-cancel-button {
  display: none; /* ya hay un botón de limpiar propio */
}
.m-list-search button {
  border: 0;
  background: transparent;
  color: var(--m-muted);
  width: 2rem;
  height: 2rem;
}
.m-list {
  padding: 0.6rem 0 0;
}
.m-list-empty {
  margin: 2rem 0;
  text-align: center;
  color: var(--m-muted);
}
.m-list-group {
  margin: 0.9rem 0 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--m-muted);
}
.m-list-group span {
  font-weight: 400;
}
.m-list-line {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  min-width: 0;
  padding: 0.1rem 0;
}
.m-list-line__label {
  flex-shrink: 0;
  max-width: 42%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.m-list-line__label::after {
  content: ":";
}
.m-list-line__value {
  flex: 1;
  min-width: 0;
  color: var(--m-text);
  overflow-wrap: anywhere;
}
/* Sin float en el teléfono: si no, el bloque de la página no tiene alto y la barra
   superior (sticky) se despega enseguida. */
.gt-list-hscroll-wrap.m-no-float {
  float: none !important;
}
/* El contenedor de la tabla de escritorio (scroll horizontal) no recorta las tarjetas. */
.gt-list-bottom-hscroll.m-list-host {
  max-height: none;
  overflow: visible !important;
}
/* Filtros en pantalla completa (el mismo componente Filters). */
.model-list-filters.m-filters-screen {
  position: fixed;
  inset: 0;
  z-index: 1055;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  background: var(--m-surface);
  overflow: hidden;
}
.model-list-filters.m-filters-screen > :not(.m-filters-screen__head):not(.m-filters-screen__foot) {
  flex: 1;
  overflow-y: auto;
  padding: 0.75rem 1rem;
}
.m-filters-screen__head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  padding-top: calc(0.5rem + env(safe-area-inset-top));
  border-bottom: 1px solid var(--m-border);
}
.m-filters-screen__head h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
}
.m-filters-screen__close {
  width: 2.5rem;
  height: 2.5rem;
  border: 0;
  background: transparent;
  color: var(--m-text);
  font-size: 1.1rem;
}
.m-filters-screen__foot {
  padding: 0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom));
  border-top: 1px solid var(--m-border);
}
</style>

<style>
body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.9em;
  font-weight: initial;
}

.financial table {
  font-family: "Courier New", monospace;
}
</style>
